//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AgeingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param isCompleted (optional) Filter by completion status (true = completed, false = pending)
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getAgeingBatches(isCompleted: boolean | undefined, filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<AgeingBatchesResult> {
        let url_ = this.baseUrl + "/ageing?";
        if (isCompleted === null)
            throw new Error("The parameter 'isCompleted' cannot be null.");
        else if (isCompleted !== undefined)
            url_ += "isCompleted=" + encodeURIComponent("" + isCompleted) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgeingBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgeingBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgeingBatchesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgeingBatchesResult>;
        }));
    }

    protected processGetAgeingBatches(response: HttpResponseBase): Observable<AgeingBatchesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgeingBatchesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No ageing batches found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid request parameters", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @param periodId (optional) 
     * @param clientId (optional) 
     * @return Fetched Successfully
     */
    uploadAgeingFile(file: FileParameter | undefined, periodId: number | undefined, clientId: number | undefined): Observable<ImportCreateResult> {
        let url_ = this.baseUrl + "/ageing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (periodId === null || periodId === undefined)
            throw new Error("The parameter 'periodId' cannot be null.");
        else
            content_.append("periodId", periodId.toString());
        if (clientId === null || clientId === undefined)
            throw new Error("The parameter 'clientId' cannot be null.");
        else
            content_.append("clientId", clientId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAgeingFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAgeingFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportCreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportCreateResult>;
        }));
    }

    protected processUploadAgeingFile(response: HttpResponseBase): Observable<ImportCreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ImportCreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientId Id of associated client entity
     * @return Fetched Successfully
     */
    getUsedAgeingClientAreas(periodId: number, clientId: number): Observable<Anonymous> {
        let url_ = this.baseUrl + "/ageing/used-client-areas?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsedAgeingClientAreas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsedAgeingClientAreas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous>;
        }));
    }

    protected processGetUsedAgeingClientAreas(response: HttpResponseBase): Observable<Anonymous> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getAgeingBatch(id: number): Observable<AgeingBatchResult> {
        let url_ = this.baseUrl + "/ageing/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgeingBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgeingBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgeingBatchResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgeingBatchResult>;
        }));
    }

    protected processGetAgeingBatch(response: HttpResponseBase): Observable<AgeingBatchResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgeingBatchResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deleteAgeingDataByBatchId(id: number): Observable<void> {
        let url_ = this.baseUrl + "/ageing/{id}/data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAgeingDataByBatchId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAgeingDataByBatchId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAgeingDataByBatchId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientId Id of associated client entity
     * @return Fetched Successfully
     */
    getAgeingBatchByClientAndPeriod(periodId: number, clientId: number): Observable<AgeingBatchByPeriodAndClientResult> {
        let url_ = this.baseUrl + "/ageing/period/client?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgeingBatchByClientAndPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgeingBatchByClientAndPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgeingBatchByPeriodAndClientResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgeingBatchByPeriodAndClientResult>;
        }));
    }

    protected processGetAgeingBatchByClientAndPeriod(response: HttpResponseBase): Observable<AgeingBatchByPeriodAndClientResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgeingBatchByPeriodAndClientResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deletePendingAgeingBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/ageing/{id}/pending";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendingAgeingBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendingAgeingBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePendingAgeingBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Conflict Error", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deleteCompletedAgeingBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/ageing/{id}/completed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompletedAgeingBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompletedAgeingBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCompletedAgeingBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Conflict Error", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getAgeingWorksheetSelection(id: number): Observable<AgeingWorksheetSelectionResult> {
        let url_ = this.baseUrl + "/ageing/{id}/worksheets";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgeingWorksheetSelection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgeingWorksheetSelection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgeingWorksheetSelectionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgeingWorksheetSelectionResult>;
        }));
    }

    protected processGetAgeingWorksheetSelection(response: HttpResponseBase): Observable<AgeingWorksheetSelectionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgeingWorksheetSelectionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Created Successfully
     */
    createAgeingWorksheet(id: number, body: AgeingWorksheetInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/ageing/{id}/worksheets";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAgeingWorksheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAgeingWorksheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreateAgeingWorksheet(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getAgeingImportRangeMapping(id: number): Observable<AgeingRangeMappingResult[]> {
        let url_ = this.baseUrl + "/ageing/{id}/range-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgeingImportRangeMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgeingImportRangeMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgeingRangeMappingResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgeingRangeMappingResult[]>;
        }));
    }

    protected processGetAgeingImportRangeMapping(response: HttpResponseBase): Observable<AgeingRangeMappingResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgeingRangeMappingResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Created Successfully
     */
    createAgeingImportRangeMapping(id: number, body: Body[]): Observable<CreateResult> {
        let url_ = this.baseUrl + "/ageing/{id}/range-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAgeingImportRangeMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAgeingImportRangeMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreateAgeingImportRangeMapping(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getAgeingImportColumnMapping(id: number): Observable<GetColumnMappings> {
        let url_ = this.baseUrl + "/ageing/{id}/column-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgeingImportColumnMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgeingImportColumnMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetColumnMappings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetColumnMappings>;
        }));
    }

    protected processGetAgeingImportColumnMapping(response: HttpResponseBase): Observable<GetColumnMappings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetColumnMappings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Created Successfully
     */
    createAgeingColumnMapping(id: number, body: CreateColumnMappingInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/ageing/{id}/column-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAgeingColumnMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAgeingColumnMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreateAgeingColumnMapping(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Import completed successfully
     */
    importAgeingData(id: number): Observable<Anonymous2> {
        let url_ = this.baseUrl + "/ageing/{id}/import-data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportAgeingData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportAgeingData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous2>;
        }));
    }

    protected processImportAgeingData(response: HttpResponseBase): Observable<Anonymous2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Import results calculated
     */
    calculateAgeingTotals(id: number): Observable<AgeingTotalsResult> {
        let url_ = this.baseUrl + "/ageing/{id}/calculate-totals";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateAgeingTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateAgeingTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgeingTotalsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgeingTotalsResult>;
        }));
    }

    protected processCalculateAgeingTotals(response: HttpResponseBase): Observable<AgeingTotalsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgeingTotalsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Completion Started
     */
    completeAgeingBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/ageing/{id}/complete-batch";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteAgeingBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteAgeingBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompleteAgeingBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Status Retrieved
     */
    getAgeingCompletionStatus(id: number): Observable<void> {
        let url_ = this.baseUrl + "/ageing/{id}/completion-status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgeingCompletionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgeingCompletionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAgeingCompletionStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getAgeingData(id: number): Observable<AgeingDataResult> {
        let url_ = this.baseUrl + "/ageing/data/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgeingData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgeingData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgeingDataResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgeingDataResult>;
        }));
    }

    protected processGetAgeingData(response: HttpResponseBase): Observable<AgeingDataResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgeingDataResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Ageing data updated successfully
     */
    updateAgeingData(id: number, body: UpdateAgeingDataInput): Observable<void> {
        let url_ = this.baseUrl + "/ageing/data/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAgeingData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAgeingData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAgeingData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Ageing Data Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Fetched Successfully
     */
    createAgeingNote(body: CreateAgeingNoteInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/ageing/note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAgeingNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAgeingNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreateAgeingNote(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Sample data retrieved successfully
     */
    getAgeingSampleData(id: number): Observable<SampleAgeingDataResult> {
        let url_ = this.baseUrl + "/ageing/{id}/sample-data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgeingSampleData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgeingSampleData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SampleAgeingDataResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SampleAgeingDataResult>;
        }));
    }

    protected processGetAgeingSampleData(response: HttpResponseBase): Observable<SampleAgeingDataResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SampleAgeingDataResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AnnexureService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param isCompleted (optional) Filter by completion status (true = completed, false = pending)
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getAnnexureBatches(isCompleted: boolean | undefined, filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<AnnexureBatchesResult> {
        let url_ = this.baseUrl + "/annexure?";
        if (isCompleted === null)
            throw new Error("The parameter 'isCompleted' cannot be null.");
        else if (isCompleted !== undefined)
            url_ += "isCompleted=" + encodeURIComponent("" + isCompleted) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnexureBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnexureBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnnexureBatchesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnnexureBatchesResult>;
        }));
    }

    protected processGetAnnexureBatches(response: HttpResponseBase): Observable<AnnexureBatchesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnnexureBatchesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No annexure batches found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid request parameters", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @param periodId (optional) 
     * @param insurerId (optional) 
     * @param clientId (optional) Optional. Required only if the selected insurer has importAreaMandatory = true.
     * @param clientAreaId (optional) Optional. Required only if the selected insurer has importAreaMandatory = true.
     * @return Fetched Successfully
     */
    uploadAnnexureFile(file: FileParameter | undefined, periodId: number | undefined, insurerId: number | undefined, clientId: number | null | undefined, clientAreaId: number | null | undefined): Observable<ImportCreateResult> {
        let url_ = this.baseUrl + "/annexure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (periodId === null || periodId === undefined)
            throw new Error("The parameter 'periodId' cannot be null.");
        else
            content_.append("periodId", periodId.toString());
        if (insurerId === null || insurerId === undefined)
            throw new Error("The parameter 'insurerId' cannot be null.");
        else
            content_.append("insurerId", insurerId.toString());
        if (clientId !== null && clientId !== undefined)
            content_.append("clientId", clientId.toString());
        if (clientAreaId !== null && clientAreaId !== undefined)
            content_.append("clientAreaId", clientAreaId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAnnexureFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAnnexureFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportCreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportCreateResult>;
        }));
    }

    protected processUploadAnnexureFile(response: HttpResponseBase): Observable<ImportCreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ImportCreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Sample data retrieved successfully
     */
    getAnnexureSampleData(id: number): Observable<SampleAnnexureDataResult> {
        let url_ = this.baseUrl + "/annexure/{id}/sample-data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnexureSampleData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnexureSampleData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SampleAnnexureDataResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SampleAnnexureDataResult>;
        }));
    }

    protected processGetAnnexureSampleData(response: HttpResponseBase): Observable<SampleAnnexureDataResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SampleAnnexureDataResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getAnnexureBatch(id: number): Observable<AnnexureBatchResult> {
        let url_ = this.baseUrl + "/annexure/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnexureBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnexureBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnnexureBatchResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnnexureBatchResult>;
        }));
    }

    protected processGetAnnexureBatch(response: HttpResponseBase): Observable<AnnexureBatchResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnnexureBatchResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deletePendingAnnexureBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/annexure/{id}/pending";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendingAnnexureBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendingAnnexureBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePendingAnnexureBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Conflict Error", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deleteCompletedAnnexureBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/annexure/{id}/completed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompletedAnnexureBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompletedAnnexureBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCompletedAnnexureBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Conflict Error", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deleteAnnexureDataByBatchId(id: number): Observable<void> {
        let url_ = this.baseUrl + "/annexure/{id}/data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAnnexureDataByBatchId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAnnexureDataByBatchId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAnnexureDataByBatchId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getAnnexureImportRangeMapping(id: number): Observable<AnnexureRangeMappingResult> {
        let url_ = this.baseUrl + "/annexure/{id}/range-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnexureImportRangeMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnexureImportRangeMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnnexureRangeMappingResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnnexureRangeMappingResult>;
        }));
    }

    protected processGetAnnexureImportRangeMapping(response: HttpResponseBase): Observable<AnnexureRangeMappingResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnnexureRangeMappingResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Created Successfully
     */
    createAnnexureImportRangeMapping(id: number, body: AnnexureRangeMappingInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/annexure/{id}/range-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAnnexureImportRangeMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAnnexureImportRangeMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreateAnnexureImportRangeMapping(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getAnnexureImportColumnMapping(id: number): Observable<GetColumnMappings> {
        let url_ = this.baseUrl + "/annexure/{id}/column-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnexureImportColumnMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnexureImportColumnMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetColumnMappings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetColumnMappings>;
        }));
    }

    protected processGetAnnexureImportColumnMapping(response: HttpResponseBase): Observable<GetColumnMappings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetColumnMappings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Created Successfully
     */
    createAnnexureColumnMapping(id: number, body: CreateColumnMappingInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/annexure/{id}/column-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAnnexureColumnMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAnnexureColumnMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreateAnnexureColumnMapping(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Import completed successfully
     */
    importAnnexureData(id: number): Observable<Anonymous3> {
        let url_ = this.baseUrl + "/annexure/{id}/import-data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportAnnexureData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportAnnexureData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous3>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous3>;
        }));
    }

    protected processImportAnnexureData(response: HttpResponseBase): Observable<Anonymous3> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous3.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Import results calculated
     */
    calculateAnnexureTotals(id: number): Observable<AnnexureTotalsResult> {
        let url_ = this.baseUrl + "/annexure/{id}/calculate-totals";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateAnnexureTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateAnnexureTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnnexureTotalsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnnexureTotalsResult>;
        }));
    }

    protected processCalculateAnnexureTotals(response: HttpResponseBase): Observable<AnnexureTotalsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnnexureTotalsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Completion Started
     */
    completeAnnexureBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/annexure/{id}/complete-batch";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteAnnexureBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteAnnexureBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompleteAnnexureBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Status Retrieved
     */
    getAnnexureCompletionStatus(id: number): Observable<void> {
        let url_ = this.baseUrl + "/annexure/{id}/completion-status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnexureCompletionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnexureCompletionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAnnexureCompletionStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getAnnexureData(id: number): Observable<AnnexureDataResult> {
        let url_ = this.baseUrl + "/annexure/data/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnexureData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnexureData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnnexureDataResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnnexureDataResult>;
        }));
    }

    protected processGetAnnexureData(response: HttpResponseBase): Observable<AnnexureDataResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnnexureDataResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Annexure data updated successfully
     */
    updateAnnexureData(id: number, body: UpdateAnnexureDataInput): Observable<void> {
        let url_ = this.baseUrl + "/annexure/data/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAnnexureData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAnnexureData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAnnexureData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Annexure Data Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuditErrorService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @param requestId (optional) 
     * @return Fetched Successfully
     */
    getFilteredAuditErrors(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined, requestId: number | undefined): Observable<FilteredAuditErrorsResult> {
        let url_ = this.baseUrl + "/audit-error?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredAuditErrors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredAuditErrors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilteredAuditErrorsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilteredAuditErrorsResult>;
        }));
    }

    protected processGetFilteredAuditErrors(response: HttpResponseBase): Observable<FilteredAuditErrorsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredAuditErrorsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuditLogService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getFilteredAuditLogs(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<FilteredAuditLogsResult> {
        let url_ = this.baseUrl + "/audit-log?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredAuditLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredAuditLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilteredAuditLogsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilteredAuditLogsResult>;
        }));
    }

    protected processGetFilteredAuditLogs(response: HttpResponseBase): Observable<FilteredAuditLogsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredAuditLogsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuditRequestService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @param requestId (optional) 
     * @return Fetched Successfully
     */
    getFilteredAuditRequests(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined, requestId: number | undefined): Observable<FilteredAuditRequestsResult> {
        let url_ = this.baseUrl + "/audit-request?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredAuditRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredAuditRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilteredAuditRequestsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilteredAuditRequestsResult>;
        }));
    }

    protected processGetFilteredAuditRequests(response: HttpResponseBase): Observable<FilteredAuditRequestsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredAuditRequestsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuditResponseService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @param requestId (optional) 
     * @return Fetched Successfully
     */
    getFilteredAuditResponses(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined, requestId: number | undefined): Observable<FilteredAuditResponsesResult> {
        let url_ = this.baseUrl + "/audit-response?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredAuditResponses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredAuditResponses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilteredAuditResponsesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilteredAuditResponsesResult>;
        }));
    }

    protected processGetFilteredAuditResponses(response: HttpResponseBase): Observable<FilteredAuditResponsesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredAuditResponsesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClientAreaReportService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getAllReports(id: number): Observable<AllReportsResult> {
        let url_ = this.baseUrl + "/report-client-area/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllReportsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllReportsResult>;
        }));
    }

    protected processGetAllReports(response: HttpResponseBase): Observable<AllReportsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllReportsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClientAreaService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @return Fetched Successfully
     */
    getAllClientAreas(): Observable<AllClientAreasResult> {
        let url_ = this.baseUrl + "/client-area/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClientAreas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClientAreas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllClientAreasResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllClientAreasResult>;
        }));
    }

    protected processGetAllClientAreas(response: HttpResponseBase): Observable<AllClientAreasResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllClientAreasResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getClientAreasByClientAndInsurer(clientId: number, insurerId: number): Observable<AllClientAreasResult> {
        let url_ = this.baseUrl + "/client-area/client/{clientId}/insurer/{insurerId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (insurerId === undefined || insurerId === null)
            throw new Error("The parameter 'insurerId' must be defined.");
        url_ = url_.replace("{insurerId}", encodeURIComponent("" + insurerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientAreasByClientAndInsurer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientAreasByClientAndInsurer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllClientAreasResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllClientAreasResult>;
        }));
    }

    protected processGetClientAreasByClientAndInsurer(response: HttpResponseBase): Observable<AllClientAreasResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllClientAreasResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getClientAreaById(id: number): Observable<ClientAreaByIdResult> {
        let url_ = this.baseUrl + "/client-area/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientAreaById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientAreaById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientAreaByIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientAreaByIdResult>;
        }));
    }

    protected processGetClientAreaById(response: HttpResponseBase): Observable<ClientAreaByIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientAreaByIdResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Client area updated successfully
     */
    updateClientArea(id: number, body: UpdateClientAreaInput): Observable<void> {
        let url_ = this.baseUrl + "/client-area/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClientArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClientArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateClientArea(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Client Area Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deleteClientArea(id: number): Observable<void> {
        let url_ = this.baseUrl + "/client-area/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteClientArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteClientArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteClientArea(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Fetched Successfully
     */
    getClientAreaLookup(clientId: number): Observable<Anonymous4[]> {
        let url_ = this.baseUrl + "/client-area/lookup/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientAreaLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientAreaLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous4[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous4[]>;
        }));
    }

    protected processGetClientAreaLookup(response: HttpResponseBase): Observable<Anonymous4[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Anonymous4.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Client area created successfully
     */
    createClientArea(body: CreateClientAreaInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/client-area";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateClientArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateClientArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreateClientArea(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getEndorsementsByClientAreaId(id: number, filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<EndorsementsByClientAreaIdResult> {
        let url_ = this.baseUrl + "/client-area/{id}/endorsements?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEndorsementsByClientAreaId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEndorsementsByClientAreaId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EndorsementsByClientAreaIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EndorsementsByClientAreaIdResult>;
        }));
    }

    protected processGetEndorsementsByClientAreaId(response: HttpResponseBase): Observable<EndorsementsByClientAreaIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EndorsementsByClientAreaIdResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @param filter (optional) Filter text or values
     * @return Fetched Successfully
     */
    getOptionalReports(id: number, filter: string | undefined): Observable<OptionalReportsResult> {
        let url_ = this.baseUrl + "/client-area/{id}/optional-reports?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOptionalReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOptionalReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OptionalReportsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OptionalReportsResult>;
        }));
    }

    protected processGetOptionalReports(response: HttpResponseBase): Observable<OptionalReportsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionalReportsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getActiveReports(id: number, filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<ActiveReportsResult> {
        let url_ = this.baseUrl + "/client-area/{id}/active-reports?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveReportsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveReportsResult>;
        }));
    }

    protected processGetActiveReports(response: HttpResponseBase): Observable<ActiveReportsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActiveReportsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    updateClientAreaReports(id: number, body: UpdateClientAreaReportsInput): Observable<void> {
        let url_ = this.baseUrl + "/client-area/{id}/reports";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClientAreaReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClientAreaReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateClientAreaReports(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getPolicyGroupsForClientArea(id: number): Observable<Anonymous5> {
        let url_ = this.baseUrl + "/client-area/{id}/policy-groups";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicyGroupsForClientArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicyGroupsForClientArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous5>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous5>;
        }));
    }

    protected processGetPolicyGroupsForClientArea(response: HttpResponseBase): Observable<Anonymous5> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous5.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    updatePolicyGroupsForClientArea(id: number, body: UpdateClientAreaGroupsInput): Observable<void> {
        let url_ = this.baseUrl + "/client-area/{id}/policy-groups";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePolicyGroupsForClientArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePolicyGroupsForClientArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePolicyGroupsForClientArea(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClientService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @return Fetched Successfully
     */
    getAllClients(): Observable<AllClientsResult> {
        let url_ = this.baseUrl + "/client/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllClientsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllClientsResult>;
        }));
    }

    protected processGetAllClients(response: HttpResponseBase): Observable<AllClientsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllClientsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getFilteredClients(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<FilteredClientsResult> {
        let url_ = this.baseUrl + "/client?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilteredClientsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilteredClientsResult>;
        }));
    }

    protected processGetFilteredClients(response: HttpResponseBase): Observable<FilteredClientsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredClientsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Created Successfully
     */
    createClient(body: CreateClientInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreateClient(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getClientById(id: number): Observable<ClientByIdResult> {
        let url_ = this.baseUrl + "/client/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientByIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientByIdResult>;
        }));
    }

    protected processGetClientById(response: HttpResponseBase): Observable<ClientByIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientByIdResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Client updated successfully
     */
    updateClient(id: number, body: UpdateClientInput): Observable<void> {
        let url_ = this.baseUrl + "/client/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Client Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deleteClient(id: number): Observable<void> {
        let url_ = this.baseUrl + "/client/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getClientAreasByClientId(id: number, filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<ClientAreasByClientIdResult> {
        let url_ = this.baseUrl + "/client/{id}/client-areas?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientAreasByClientId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientAreasByClientId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientAreasByClientIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientAreasByClientIdResult>;
        }));
    }

    protected processGetClientAreasByClientId(response: HttpResponseBase): Observable<ClientAreasByClientIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientAreasByClientIdResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CountryService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @return Fetched Successfully
     */
    getAllCountries(): Observable<AllCountriesResult> {
        let url_ = this.baseUrl + "/country";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllCountriesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllCountriesResult>;
        }));
    }

    protected processGetAllCountries(response: HttpResponseBase): Observable<AllCountriesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllCountriesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CurrencyService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @return Fetched Successfully
     */
    getAllCurrencies(): Observable<AllCurrenciesResult> {
        let url_ = this.baseUrl + "/currency";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllCurrenciesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllCurrenciesResult>;
        }));
    }

    protected processGetAllCurrencies(response: HttpResponseBase): Observable<AllCurrenciesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllCurrenciesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DatabaseService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getFilteredDatabases(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<FilteredDatabasesResult> {
        let url_ = this.baseUrl + "/database?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredDatabases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredDatabases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilteredDatabasesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilteredDatabasesResult>;
        }));
    }

    protected processGetFilteredDatabases(response: HttpResponseBase): Observable<FilteredDatabasesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredDatabasesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Database already exists
     */
    createDatabase(body: CreateDatabaseInput): Observable<void> {
        let url_ = this.baseUrl + "/database";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DownloadService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    downloadAuditLogs(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/download/audit-logs?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAuditLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAuditLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadAuditLogs(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    downloadClients(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/download/clients?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadClients(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    downloadExchangeRates(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/download/exchange-rates?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadExchangeRates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadExchangeRates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadExchangeRates(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    downloadPolicyGroups(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/download/policy-groups?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPolicyGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPolicyGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadPolicyGroups(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    downloadTenants(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/download/tenants?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadTenants(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    downloadUsers(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/download/users?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadUsers(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    downloadUserRoles(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/download/user-roles?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadUserRoles(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EndorsementService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getFilteredEndorsements(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<FilteredEndorsementsResult> {
        let url_ = this.baseUrl + "/endorsement?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredEndorsements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredEndorsements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilteredEndorsementsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilteredEndorsementsResult>;
        }));
    }

    protected processGetFilteredEndorsements(response: HttpResponseBase): Observable<FilteredEndorsementsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredEndorsementsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Endorsement created successfully
     */
    createEndorsement(body: CreateEndorsementInput): Observable<void> {
        let url_ = this.baseUrl + "/endorsement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEndorsement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEndorsement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateEndorsement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Anonymous6.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Fetched Successfully
     */
    getAllEndorsementTypes(): Observable<AllEndorsementTypeResult> {
        let url_ = this.baseUrl + "/endorsement/all-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEndorsementTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEndorsementTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllEndorsementTypeResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllEndorsementTypeResult>;
        }));
    }

    protected processGetAllEndorsementTypes(response: HttpResponseBase): Observable<AllEndorsementTypeResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllEndorsementTypeResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Fetched Successfully
     */
    getAllEndorsementTypeValues(): Observable<AllEndorsementTypeValueResult> {
        let url_ = this.baseUrl + "/endorsement/all-type-values";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEndorsementTypeValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEndorsementTypeValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllEndorsementTypeValueResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllEndorsementTypeValueResult>;
        }));
    }

    protected processGetAllEndorsementTypeValues(response: HttpResponseBase): Observable<AllEndorsementTypeValueResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllEndorsementTypeValueResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param endorsementTypeId (optional) endorsement type ID
     * @return Filtered values fetched successfully
     */
    getFilteredEndorsementTypeValues(endorsementTypeId: number | undefined): Observable<AllEndorsementTypeValueResult> {
        let url_ = this.baseUrl + "/endorsement/type-values/filter?";
        if (endorsementTypeId === null)
            throw new Error("The parameter 'endorsementTypeId' cannot be null.");
        else if (endorsementTypeId !== undefined)
            url_ += "endorsementTypeId=" + encodeURIComponent("" + endorsementTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredEndorsementTypeValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredEndorsementTypeValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllEndorsementTypeValueResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllEndorsementTypeValueResult>;
        }));
    }

    protected processGetFilteredEndorsementTypeValues(response: HttpResponseBase): Observable<AllEndorsementTypeValueResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllEndorsementTypeValueResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getEndorsementById(id: number): Observable<EndorsementByIdResult> {
        let url_ = this.baseUrl + "/endorsement/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEndorsementById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEndorsementById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EndorsementByIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EndorsementByIdResult>;
        }));
    }

    protected processGetEndorsementById(response: HttpResponseBase): Observable<EndorsementByIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EndorsementByIdResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Endorsement updated successfully
     */
    updateEndorsement(id: number, body: UpdateEndorsementInput): Observable<void> {
        let url_ = this.baseUrl + "/endorsement/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEndorsement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEndorsement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEndorsement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Anonymous7.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Endorsement Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deleteEndorsement(id: number): Observable<void> {
        let url_ = this.baseUrl + "/endorsement/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEndorsement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEndorsement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEndorsement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExchangeRateService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getFilteredExchangeRates(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<FilteredExchangeRatesResult> {
        let url_ = this.baseUrl + "/exchange-rate?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredExchangeRates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredExchangeRates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilteredExchangeRatesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilteredExchangeRatesResult>;
        }));
    }

    protected processGetFilteredExchangeRates(response: HttpResponseBase): Observable<FilteredExchangeRatesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredExchangeRatesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Exchange rate created successfully
     */
    createExchangeRate(body: CreateExchangeRateInput): Observable<void> {
        let url_ = this.baseUrl + "/exchange-rate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExchangeRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExchangeRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateExchangeRate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getExchangeRateForCopy(id: number): Observable<CopyExchangeRateResult> {
        let url_ = this.baseUrl + "/exchange-rate/{id}/copy";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExchangeRateForCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExchangeRateForCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CopyExchangeRateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CopyExchangeRateResult>;
        }));
    }

    protected processGetExchangeRateForCopy(response: HttpResponseBase): Observable<CopyExchangeRateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CopyExchangeRateResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getExchangeRateById(id: number): Observable<ExchangeRateByIdResult> {
        let url_ = this.baseUrl + "/exchange-rate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExchangeRateById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExchangeRateById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExchangeRateByIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExchangeRateByIdResult>;
        }));
    }

    protected processGetExchangeRateById(response: HttpResponseBase): Observable<ExchangeRateByIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExchangeRateByIdResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Exchange rate updated successfully
     */
    updateExchangeRate(id: number, body: UpdateExchangeRateInput): Observable<void> {
        let url_ = this.baseUrl + "/exchange-rate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExchangeRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExchangeRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateExchangeRate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Exchange rate Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deleteExchangeRate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/exchange-rate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExchangeRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExchangeRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteExchangeRate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExportService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @return Export request created
     */
    createExportRequest(body: ExportRequestInput): Observable<ExportRequestResult> {
        let url_ = this.baseUrl + "/export/request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExportRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExportRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportRequestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportRequestResult>;
        }));
    }

    protected processCreateExportRequest(response: HttpResponseBase): Observable<ExportRequestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ExportRequestResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid request parameters", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Export request ID
     * @return Export status
     */
    getExportStatus(id: number): Observable<ExportStatusResult> {
        let url_ = this.baseUrl + "/export/status/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportStatusResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportStatusResult>;
        }));
    }

    protected processGetExportStatus(response: HttpResponseBase): Observable<ExportStatusResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportStatusResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Export request not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token Public download token from the completion email
     * @return Export file download
     */
    downloadExport(token: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/export/download/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Export not found or token invalid", status, _responseText, _headers);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Export file has expired and been deleted", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return List of pending exports
     */
    getPendingExports(): Observable<ExportStatusResult[]> {
        let url_ = this.baseUrl + "/export/pending";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingExports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingExports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportStatusResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportStatusResult[]>;
        }));
    }

    protected processGetPendingExports(response: HttpResponseBase): Observable<ExportStatusResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportStatusResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Export request ID
     * @return Export cancelled
     */
    cancelExport(id: number): Observable<void> {
        let url_ = this.baseUrl + "/export/cancel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Export cannot be cancelled (already processing or completed)", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Export request not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HealthService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * Comprehensive health check with memory tracking and diagnostics
     * @return Full health diagnostics including memory, handles, caches, schedulers, and tedious info
     */
    health(): Observable<void> {
        let url_ = this.baseUrl + "/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHealth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Minimal ping endpoint for keep-alive
     * @return Service is alive
     */
    ping(): Observable<string> {
        let url_ = this.baseUrl + "/health/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Detailed memory diagnostics
     * @return Memory diagnostics
     */
    memory(): Observable<void> {
        let url_ = this.baseUrl + "/health/memory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMemory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMemory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMemory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get latest audit log events (Internal Use)
     * @param password Internal access password
     * @return Audit log content
     */
    audit(password: string): Observable<void> {
        let url_ = this.baseUrl + "/health/audit?";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAudit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAudit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAudit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized - Invalid password", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No log files found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get recent email queue entries (Internal Use)
     * @param password Internal access password
     * @param limit (optional) 
     * @param minutes (optional) If provided, only return rows created within the last N minutes
     * @return Recent email queue entries
     */
    emailQueue(password: string, limit: number | undefined, minutes: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/health/email-queue?";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (minutes !== undefined && minutes !== null)
            url_ += "minutes=" + encodeURIComponent("" + minutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmailQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailQueue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmailQueue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized - Invalid password", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send test UserCreateNotification email (Internal Use)
     * @param password Internal password for authentication
     * @param to (optional) Optional email recipient (defaults to configured test email)
     * @return Email queued
     */
    userCreated(password: string, to: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/health/email-test/user-created?";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserCreated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserCreated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserCreated(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized - Invalid password", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send test ClientCreateNotification email (Internal Use)
     * @param password Internal password for authentication
     * @param to (optional) Optional email recipient (defaults to configured test email)
     * @return Email queued
     */
    clientCreated(password: string, to: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/health/email-test/client-created?";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientCreated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientCreated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClientCreated(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized - Invalid password", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send test ClientUpdateNotification email (Internal Use)
     * @param password Internal password for authentication
     * @param to (optional) Optional email recipient (defaults to configured test email)
     * @return Email queued
     */
    clientUpdated(password: string, to: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/health/email-test/client-updated?";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientUpdated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientUpdated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClientUpdated(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized - Invalid password", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send test PolicyCreateNotification email (Internal Use)
     * @param password Internal password for authentication
     * @param to (optional) Optional email recipient (defaults to configured test email)
     * @return Email queued
     */
    policyCreated(password: string, to: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/health/email-test/policy-created?";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPolicyCreated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPolicyCreated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPolicyCreated(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized - Invalid password", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send test PolicyUpdateNotification email (Internal Use)
     * @param password Internal password for authentication
     * @param to (optional) Optional email recipient (defaults to configured test email)
     * @return Email queued
     */
    policyUpdated(password: string, to: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/health/email-test/policy-updated?";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPolicyUpdated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPolicyUpdated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPolicyUpdated(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized - Invalid password", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send test AmendAnnexure email (Internal Use)
     * @param password Internal password for authentication
     * @param to (optional) Optional email recipient (defaults to configured test email)
     * @return Email queued
     */
    annexureUpdated(password: string, to: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/health/email-test/annexure-updated?";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAnnexureUpdated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAnnexureUpdated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAnnexureUpdated(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized - Invalid password", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send test ExportReady email (Internal Use)
     * @param password Internal password for authentication
     * @param to (optional) Optional email recipient (defaults to configured test email)
     * @return Email queued
     */
    exportReady(password: string, to: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/health/email-test/export-ready?";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportReady(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReady(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportReady(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized - Invalid password", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send test DeclarationReportPack email (Internal Use)
     * @param password Internal password for authentication
     * @param to (optional) Optional email recipient (defaults to configured test email)
     * @return Email queued
     */
    reportPackDeclaration(password: string, to: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/health/email-test/report-pack-declaration?";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportPackDeclaration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportPackDeclaration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReportPackDeclaration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized - Invalid password", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send test renewalReportPack email (Internal Use)
     * @param password Internal password for authentication
     * @param to (optional) Optional email recipient (defaults to configured test email)
     * @return Email queued
     */
    reportPackRenewal(password: string, to: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/health/email-test/report-pack-renewal?";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportPackRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportPackRenewal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReportPackRenewal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized - Invalid password", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ImportColumnMappingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @return Success
     */
    getImportColumnMappings(primaryId: number, importArea: string): Observable<GetColumnMappings> {
        let url_ = this.baseUrl + "/import-column-mapping/{id}?";
        if (primaryId === undefined || primaryId === null)
            throw new Error("The parameter 'primaryId' must be defined and cannot be null.");
        else
            url_ += "primaryId=" + encodeURIComponent("" + primaryId) + "&";
        if (importArea === undefined || importArea === null)
            throw new Error("The parameter 'importArea' must be defined and cannot be null.");
        else
            url_ += "importArea=" + encodeURIComponent("" + importArea) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImportColumnMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImportColumnMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetColumnMappings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetColumnMappings>;
        }));
    }

    protected processGetImportColumnMappings(response: HttpResponseBase): Observable<GetColumnMappings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetColumnMappings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Batch not found or no mappings", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ImportColumnService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param entityName The entity name to filter by (e.g., 'claim')
     * @return Fetched Successfully
     */
    getImportColumnsByEntityName(entityName: string): Observable<ImportColumnSimplifiedItem[]> {
        let url_ = this.baseUrl + "/import-column/ByEntityName?";
        if (entityName === undefined || entityName === null)
            throw new Error("The parameter 'entityName' must be defined and cannot be null.");
        else
            url_ += "entityName=" + encodeURIComponent("" + entityName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImportColumnsByEntityName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImportColumnsByEntityName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportColumnSimplifiedItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportColumnSimplifiedItem[]>;
        }));
    }

    protected processGetImportColumnsByEntityName(response: HttpResponseBase): Observable<ImportColumnSimplifiedItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImportColumnSimplifiedItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IndustryService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @return Fetched Successfully
     */
    getAllIndustries(): Observable<AllIndustriesResult> {
        let url_ = this.baseUrl + "/industry";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIndustries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIndustries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllIndustriesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllIndustriesResult>;
        }));
    }

    protected processGetAllIndustries(response: HttpResponseBase): Observable<AllIndustriesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllIndustriesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InsurerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @return Fetched Successfully
     */
    getAllInsurers(): Observable<AllInsurersResult> {
        let url_ = this.baseUrl + "/insurer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInsurers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInsurers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllInsurersResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllInsurersResult>;
        }));
    }

    protected processGetAllInsurers(response: HttpResponseBase): Observable<AllInsurersResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllInsurersResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MatchingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param isCompleted (optional) Filter by completion status (true = completed, false = pending)
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getMatchingBatches(isCompleted: boolean | undefined, filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<MatchingBatchesResult> {
        let url_ = this.baseUrl + "/matching?";
        if (isCompleted === null)
            throw new Error("The parameter 'isCompleted' cannot be null.");
        else if (isCompleted !== undefined)
            url_ += "isCompleted=" + encodeURIComponent("" + isCompleted) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchingBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchingBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MatchingBatchesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MatchingBatchesResult>;
        }));
    }

    protected processGetMatchingBatches(response: HttpResponseBase): Observable<MatchingBatchesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchingBatchesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Matching batch created successfully or existing batch returned
     */
    createMatchingBatch(body: CreateMatchingInput): Observable<MatchingCreateResult> {
        let url_ = this.baseUrl + "/matching";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMatchingBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMatchingBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MatchingCreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MatchingCreateResult>;
        }));
    }

    protected processCreateMatchingBatch(response: HttpResponseBase): Observable<MatchingCreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MatchingCreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getAnnexureMatchingData(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined, id: number): Observable<AnnexureMatchingResult> {
        let url_ = this.baseUrl + "/matching/{id}/annexure-data?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnexureMatchingData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnexureMatchingData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnnexureMatchingResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnnexureMatchingResult>;
        }));
    }

    protected processGetAnnexureMatchingData(response: HttpResponseBase): Observable<AnnexureMatchingResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnnexureMatchingResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No matching records found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid request parameters", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @param id Id of Entity
     * @param matched Determines whether to return matched or unmatched records.
     * @param franchiseLoss If true, includes records below the franchise loss threshold.
     * @param uncategorized If true, includes records that have no associated categorization.
     * @return Fetched Successfully
     */
    getAgeingMatchingData(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined, id: number, matched: boolean, franchiseLoss: boolean, uncategorized: boolean): Observable<AgeingMatchingResult> {
        let url_ = this.baseUrl + "/matching/{id}/ageing-data?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (matched === undefined || matched === null)
            throw new Error("The parameter 'matched' must be defined and cannot be null.");
        else
            url_ += "matched=" + encodeURIComponent("" + matched) + "&";
        if (franchiseLoss === undefined || franchiseLoss === null)
            throw new Error("The parameter 'franchiseLoss' must be defined and cannot be null.");
        else
            url_ += "franchiseLoss=" + encodeURIComponent("" + franchiseLoss) + "&";
        if (uncategorized === undefined || uncategorized === null)
            throw new Error("The parameter 'uncategorized' must be defined and cannot be null.");
        else
            url_ += "uncategorized=" + encodeURIComponent("" + uncategorized) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgeingMatchingData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgeingMatchingData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgeingMatchingResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgeingMatchingResult>;
        }));
    }

    protected processGetAgeingMatchingData(response: HttpResponseBase): Observable<AgeingMatchingResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgeingMatchingResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No matching records found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid request parameters", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Fetched Successfully
     */
    getMatchedData(annexureDataId: number, ageingDataId: number): Observable<MatchedDataResult> {
        let url_ = this.baseUrl + "/matching/matched?";
        if (annexureDataId === undefined || annexureDataId === null)
            throw new Error("The parameter 'annexureDataId' must be defined and cannot be null.");
        else
            url_ += "annexureDataId=" + encodeURIComponent("" + annexureDataId) + "&";
        if (ageingDataId === undefined || ageingDataId === null)
            throw new Error("The parameter 'ageingDataId' must be defined and cannot be null.");
        else
            url_ += "ageingDataId=" + encodeURIComponent("" + ageingDataId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchedData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchedData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MatchedDataResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MatchedDataResult>;
        }));
    }

    protected processGetMatchedData(response: HttpResponseBase): Observable<MatchedDataResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchedDataResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @param annexureDataId The annexure data ID to find matched ageings for
     * @return Fetched Successfully
     */
    getMatchedAgeingIds(id: number, annexureDataId: number): Observable<number[]> {
        let url_ = this.baseUrl + "/matching/{id}/matched-ageings/{annexureDataId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (annexureDataId === undefined || annexureDataId === null)
            throw new Error("The parameter 'annexureDataId' must be defined.");
        url_ = url_.replace("{annexureDataId}", encodeURIComponent("" + annexureDataId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchedAgeingIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchedAgeingIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetMatchedAgeingIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @param annexureDataId The annexure data ID to find matches for
     * @param ageingDataId The ageing data ID to locate
     * @param pageSize Number of records per page
     * @param search (optional) Search filter text
     * @param sortColumn (optional) Column to sort by
     * @param sortDirection (optional) Sort direction
     * @param matched (optional) Filter for matched records
     * @param franchiseLoss (optional) Filter for franchise loss records
     * @param uncategorized (optional) Filter for uncategorized records
     * @return Fetched Successfully
     */
    getMatchedAgeingPage(id: number, annexureDataId: number, ageingDataId: number, pageSize: number, search: string | undefined, sortColumn: string | undefined, sortDirection: SortDirection | undefined, matched: boolean | undefined, franchiseLoss: boolean | undefined, uncategorized: boolean | undefined): Observable<Anonymous8> {
        let url_ = this.baseUrl + "/matching/{id}/matched-ageing-page?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (annexureDataId === undefined || annexureDataId === null)
            throw new Error("The parameter 'annexureDataId' must be defined and cannot be null.");
        else
            url_ += "annexureDataId=" + encodeURIComponent("" + annexureDataId) + "&";
        if (ageingDataId === undefined || ageingDataId === null)
            throw new Error("The parameter 'ageingDataId' must be defined and cannot be null.");
        else
            url_ += "ageingDataId=" + encodeURIComponent("" + ageingDataId) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (matched === null)
            throw new Error("The parameter 'matched' cannot be null.");
        else if (matched !== undefined)
            url_ += "matched=" + encodeURIComponent("" + matched) + "&";
        if (franchiseLoss === null)
            throw new Error("The parameter 'franchiseLoss' cannot be null.");
        else if (franchiseLoss !== undefined)
            url_ += "franchiseLoss=" + encodeURIComponent("" + franchiseLoss) + "&";
        if (uncategorized === null)
            throw new Error("The parameter 'uncategorized' cannot be null.");
        else if (uncategorized !== undefined)
            url_ += "uncategorized=" + encodeURIComponent("" + uncategorized) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchedAgeingPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchedAgeingPage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous8>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous8>;
        }));
    }

    protected processGetMatchedAgeingPage(response: HttpResponseBase): Observable<Anonymous8> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous8.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Record not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @param ageingDataId The ageing data ID to find matched annexure for
     * @return Fetched Successfully
     */
    getMatchedAnnexureId(id: number, ageingDataId: number): Observable<number | null> {
        let url_ = this.baseUrl + "/matching/{id}/matched-annexure/{ageingDataId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (ageingDataId === undefined || ageingDataId === null)
            throw new Error("The parameter 'ageingDataId' must be defined.");
        url_ = url_.replace("{ageingDataId}", encodeURIComponent("" + ageingDataId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchedAnnexureId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchedAnnexureId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number | null>;
        }));
    }

    protected processGetMatchedAnnexureId(response: HttpResponseBase): Observable<number | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getMatchingBatch(id: number): Observable<MatchingBatchResult> {
        let url_ = this.baseUrl + "/matching/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchingBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchingBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MatchingBatchResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MatchingBatchResult>;
        }));
    }

    protected processGetMatchingBatch(response: HttpResponseBase): Observable<MatchingBatchResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchingBatchResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Matching batch updated successfully
     */
    updateMatchingBatch(id: number, body: UpdateMatchingInput): Observable<void> {
        let url_ = this.baseUrl + "/matching/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMatchingBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMatchingBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMatchingBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Matching batch not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getMatchingBatchDetails(id: number): Observable<MatchingBatchDetailsResult> {
        let url_ = this.baseUrl + "/matching/{id}/details";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchingBatchDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchingBatchDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MatchingBatchDetailsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MatchingBatchDetailsResult>;
        }));
    }

    protected processGetMatchingBatchDetails(response: HttpResponseBase): Observable<MatchingBatchDetailsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchingBatchDetailsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id The matching batch ID
     * @return Filter retrieved successfully
     */
    getMatchingFilter(id: number): Observable<any> {
        let url_ = this.baseUrl + "/matching/{id}/filter";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchingFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchingFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetMatchingFilter(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id The matching batch ID
     * @return Filter saved successfully
     */
    saveMatchingFilter(id: number, body: Body2): Observable<any> {
        let url_ = this.baseUrl + "/matching/{id}/filter";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMatchingFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMatchingFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSaveMatchingFilter(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param annexureDataId The annexure data ID to match.
     * @param ageingDataId The ageing data ID to match.
     * @return Updated Successfully
     */
    deleteMatchingData(annexureDataId: number, ageingDataId: number): Observable<void> {
        let url_ = this.baseUrl + "/matching/data?";
        if (annexureDataId === undefined || annexureDataId === null)
            throw new Error("The parameter 'annexureDataId' must be defined and cannot be null.");
        else
            url_ += "annexureDataId=" + encodeURIComponent("" + annexureDataId) + "&";
        if (ageingDataId === undefined || ageingDataId === null)
            throw new Error("The parameter 'ageingDataId' must be defined and cannot be null.");
        else
            url_ += "ageingDataId=" + encodeURIComponent("" + ageingDataId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMatchingData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMatchingData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMatchingData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Matching records created successfully.
     */
    createMatchingData(body: CreateMatchingDataInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/matching/data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMatchingData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMatchingData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreateMatchingData(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deletePendingMatchingBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/matching/{id}/pending";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendingMatchingBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendingMatchingBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePendingMatchingBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deleteCompletedMatchingBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/matching/{id}/completed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompletedMatchingBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompletedMatchingBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCompletedMatchingBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Updated Successfully
     */
    completeMatchingBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/matching/{id}/complete-batch";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteMatchingBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteMatchingBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompleteMatchingBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Auto-matching completed successfully
     */
    runAutoMatch(id: number): Observable<Anonymous9> {
        let url_ = this.baseUrl + "/matching/{id}/auto-match";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunAutoMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunAutoMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous9>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous9>;
        }));
    }

    protected processRunAutoMatch(response: HttpResponseBase): Observable<Anonymous9> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous9.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Matching batch ID
     * @param customerCode Customer code for the ageing record
     * @param clientAreaId Client area ID
     * @return Note fetched successfully
     */
    getAgeingNote(id: number, customerCode: string, clientAreaId: number): Observable<Anonymous10> {
        let url_ = this.baseUrl + "/matching/{id}/ageing-note?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (customerCode === undefined || customerCode === null)
            throw new Error("The parameter 'customerCode' must be defined and cannot be null.");
        else
            url_ += "customerCode=" + encodeURIComponent("" + customerCode) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgeingNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgeingNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous10>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous10>;
        }));
    }

    protected processGetAgeingNote(response: HttpResponseBase): Observable<Anonymous10> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous10.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NoteService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @return Fetched Successfully
     */
    getAllNotes(): Observable<AllNotesResult> {
        let url_ = this.baseUrl + "/note";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllNotesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllNotesResult>;
        }));
    }

    protected processGetAllNotes(response: HttpResponseBase): Observable<AllNotesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllNotesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PerformanceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param isCompleted (optional) Filter by completion status
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getPerformanceBatches(isCompleted: boolean | undefined, filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<PerformanceBatchesResult> {
        let url_ = this.baseUrl + "/performance?";
        if (isCompleted === null)
            throw new Error("The parameter 'isCompleted' cannot be null.");
        else if (isCompleted !== undefined)
            url_ += "isCompleted=" + encodeURIComponent("" + isCompleted) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerformanceBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerformanceBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PerformanceBatchesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PerformanceBatchesResult>;
        }));
    }

    protected processGetPerformanceBatches(response: HttpResponseBase): Observable<PerformanceBatchesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PerformanceBatchesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @param periodId (optional) 
     * @param insurerId (optional) 
     * @param clientId (optional) Optional. Required only if the selected insurer has importAreaMandatory = true.
     * @param clientAreaId (optional) Optional. Required only if the selected insurer has importAreaMandatory = true.
     * @return Fetched Successfully
     */
    uploadPerformanceFile(file: FileParameter | undefined, periodId: number | undefined, insurerId: number | undefined, clientId: number | null | undefined, clientAreaId: number | null | undefined): Observable<ImportCreateResult> {
        let url_ = this.baseUrl + "/performance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (periodId === null || periodId === undefined)
            throw new Error("The parameter 'periodId' cannot be null.");
        else
            content_.append("periodId", periodId.toString());
        if (insurerId === null || insurerId === undefined)
            throw new Error("The parameter 'insurerId' cannot be null.");
        else
            content_.append("insurerId", insurerId.toString());
        if (clientId !== null && clientId !== undefined)
            content_.append("clientId", clientId.toString());
        if (clientAreaId !== null && clientAreaId !== undefined)
            content_.append("clientAreaId", clientAreaId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPerformanceFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPerformanceFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportCreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportCreateResult>;
        }));
    }

    protected processUploadPerformanceFile(response: HttpResponseBase): Observable<ImportCreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ImportCreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Sample data retrieved successfully
     */
    getPerformanceSampleData(id: number): Observable<SamplePerformanceDataResult> {
        let url_ = this.baseUrl + "/performance/{id}/sample-data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerformanceSampleData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerformanceSampleData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SamplePerformanceDataResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SamplePerformanceDataResult>;
        }));
    }

    protected processGetPerformanceSampleData(response: HttpResponseBase): Observable<SamplePerformanceDataResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SamplePerformanceDataResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getPerformanceBatch(id: number): Observable<PerformanceBatchResult> {
        let url_ = this.baseUrl + "/performance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerformanceBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerformanceBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PerformanceBatchResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PerformanceBatchResult>;
        }));
    }

    protected processGetPerformanceBatch(response: HttpResponseBase): Observable<PerformanceBatchResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PerformanceBatchResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deletePerformanceDataByBatchId(id: number): Observable<void> {
        let url_ = this.baseUrl + "/performance/{id}/data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePerformanceDataByBatchId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePerformanceDataByBatchId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePerformanceDataByBatchId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deletePendingPerformanceBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/performance/{id}/pending";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendingPerformanceBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendingPerformanceBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePendingPerformanceBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deleteCompletedPerformanceBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/performance/{id}/completed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompletedPerformanceBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompletedPerformanceBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCompletedPerformanceBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getPerformanceImportRangeMapping(id: number): Observable<PerformanceRangeMappingResult> {
        let url_ = this.baseUrl + "/performance/{id}/range-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerformanceImportRangeMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerformanceImportRangeMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PerformanceRangeMappingResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PerformanceRangeMappingResult>;
        }));
    }

    protected processGetPerformanceImportRangeMapping(response: HttpResponseBase): Observable<PerformanceRangeMappingResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PerformanceRangeMappingResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Created Successfully
     */
    createPerformanceImportRangeMapping(id: number, body: PerformanceRangeMappingInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/performance/{id}/range-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePerformanceImportRangeMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePerformanceImportRangeMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreatePerformanceImportRangeMapping(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getPerformanceImportColumnMapping(id: number): Observable<GetColumnMappings> {
        let url_ = this.baseUrl + "/performance/{id}/column-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerformanceImportColumnMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerformanceImportColumnMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetColumnMappings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetColumnMappings>;
        }));
    }

    protected processGetPerformanceImportColumnMapping(response: HttpResponseBase): Observable<GetColumnMappings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetColumnMappings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Created Successfully
     */
    createPerformanceColumnMapping(id: number, body: CreateColumnMappingInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/performance/{id}/column-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePerformanceColumnMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePerformanceColumnMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreatePerformanceColumnMapping(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Import completed successfully
     */
    importPerformanceData(id: number): Observable<Anonymous11> {
        let url_ = this.baseUrl + "/performance/{id}/import-data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportPerformanceData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportPerformanceData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous11>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous11>;
        }));
    }

    protected processImportPerformanceData(response: HttpResponseBase): Observable<Anonymous11> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous11.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Import results calculated
     */
    calculatePerformanceImportTotals(id: number): Observable<PerformanceTotalsResult> {
        let url_ = this.baseUrl + "/performance/{id}/calculate-totals";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculatePerformanceImportTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculatePerformanceImportTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PerformanceTotalsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PerformanceTotalsResult>;
        }));
    }

    protected processCalculatePerformanceImportTotals(response: HttpResponseBase): Observable<PerformanceTotalsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PerformanceTotalsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id ID of the performance batch
     * @return Import results retrieved successfully
     */
    getImportResults(id: number): Observable<void> {
        let url_ = this.baseUrl + "/performance/import-results/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImportResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImportResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetImportResults(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Completion Started
     */
    completePerformanceBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/performance/{id}/complete-batch";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompletePerformanceBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletePerformanceBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompletePerformanceBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Status Retrieved
     */
    getPerformanceCompletionStatus(id: number): Observable<void> {
        let url_ = this.baseUrl + "/performance/{id}/completion-status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerformanceCompletionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerformanceCompletionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetPerformanceCompletionStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PeriodService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @return Fetched Successfully
     */
    getAllPeriods(): Observable<AllPeriodsResult> {
        let url_ = this.baseUrl + "/period";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPeriods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPeriods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllPeriodsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllPeriodsResult>;
        }));
    }

    protected processGetAllPeriods(response: HttpResponseBase): Observable<AllPeriodsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllPeriodsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getPeriodById(id: number): Observable<PeriodByIdResult> {
        let url_ = this.baseUrl + "/period/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPeriodById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeriodById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeriodByIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeriodByIdResult>;
        }));
    }

    protected processGetPeriodById(response: HttpResponseBase): Observable<PeriodByIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PeriodByIdResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PolicyGroupService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @return Fetched Successfully
     */
    getAllPolicyGroups(): Observable<AllPolicyGroupsResult> {
        let url_ = this.baseUrl + "/policy-group/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPolicyGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPolicyGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllPolicyGroupsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllPolicyGroupsResult>;
        }));
    }

    protected processGetAllPolicyGroups(response: HttpResponseBase): Observable<AllPolicyGroupsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllPolicyGroupsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getFilteredPolicyGroups(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<FilteredPolicyGroupsResult> {
        let url_ = this.baseUrl + "/policy-group?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredPolicyGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredPolicyGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilteredPolicyGroupsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilteredPolicyGroupsResult>;
        }));
    }

    protected processGetFilteredPolicyGroups(response: HttpResponseBase): Observable<FilteredPolicyGroupsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredPolicyGroupsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Fetched Successfully
     */
    createPolicyGroup(body: CreatePolicyGroupInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/policy-group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePolicyGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePolicyGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreatePolicyGroup(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getPolicyGroupById(id: number): Observable<PolicyGroupByIdResult> {
        let url_ = this.baseUrl + "/policy-group/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicyGroupById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicyGroupById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PolicyGroupByIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PolicyGroupByIdResult>;
        }));
    }

    protected processGetPolicyGroupById(response: HttpResponseBase): Observable<PolicyGroupByIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PolicyGroupByIdResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Successful
     */
    updatePolicyGroup(id: number, body: UpdatePolicyGroupInput): Observable<void> {
        let url_ = this.baseUrl + "/policy-group/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePolicyGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePolicyGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePolicyGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deletePolicyGroup(id: number): Observable<void> {
        let url_ = this.baseUrl + "/policy-group/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePolicyGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePolicyGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePolicyGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getPoliciesByPolicyGroupId(id: number, filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<PoliciesByGroupIdResult> {
        let url_ = this.baseUrl + "/policy-group/{id}/policies?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPoliciesByPolicyGroupId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPoliciesByPolicyGroupId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PoliciesByGroupIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PoliciesByGroupIdResult>;
        }));
    }

    protected processGetPoliciesByPolicyGroupId(response: HttpResponseBase): Observable<PoliciesByGroupIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PoliciesByGroupIdResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Policy added successfully
     */
    updatePoliciesOnGroup(id: number, body: UpdatePoliciesOnGroupInput): Observable<Anonymous12> {
        let url_ = this.baseUrl + "/policy-group/{id}/policies";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePoliciesOnGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePoliciesOnGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous12>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous12>;
        }));
    }

    protected processUpdatePoliciesOnGroup(response: HttpResponseBase): Observable<Anonymous12> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Anonymous12.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @param filter (optional) Filter text or values
     * @return Fetched Successfully
     */
    getAvailablePolicies(id: number, filter: string | undefined): Observable<AvailablePoliciesResult> {
        let url_ = this.baseUrl + "/policy-group/{id}/policies-available?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailablePolicies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailablePolicies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvailablePoliciesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvailablePoliciesResult>;
        }));
    }

    protected processGetAvailablePolicies(response: HttpResponseBase): Observable<AvailablePoliciesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailablePoliciesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PopiManagerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param term Term to search for
     * @param pageNo (optional) Page number
     * @param pageSize (optional) Page size
     * @param popiRefId (optional) Popi reference
     * @return Search results
     */
    searchPopiData(term: string, pageNo: number | undefined, pageSize: number | undefined, popiRefId: string | undefined): Observable<PopiSearchResult> {
        let url_ = this.baseUrl + "/popi-manager/search?";
        if (term === undefined || term === null)
            throw new Error("The parameter 'term' must be defined and cannot be null.");
        else
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (pageNo === null)
            throw new Error("The parameter 'pageNo' cannot be null.");
        else if (pageNo !== undefined)
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (popiRefId === null)
            throw new Error("The parameter 'popiRefId' cannot be null.");
        else if (popiRefId !== undefined)
            url_ += "popiRefId=" + encodeURIComponent("" + popiRefId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchPopiData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchPopiData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PopiSearchResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PopiSearchResult>;
        }));
    }

    protected processSearchPopiData(response: HttpResponseBase): Observable<PopiSearchResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PopiSearchResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return De-identification successful
     */
    deidentifyPopiRecord(body: PopiDeidentifyRequest): Observable<Anonymous13> {
        let url_ = this.baseUrl + "/popi-manager/deidentify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeidentifyPopiRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeidentifyPopiRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous13>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous13>;
        }));
    }

    protected processDeidentifyPopiRecord(response: HttpResponseBase): Observable<Anonymous13> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous13.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Missing or invalid input", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PowerBIService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @return Dashboard config retrieved successfully
     */
    getDashboardEmbedConfig(): Observable<Anonymous14> {
        let url_ = this.baseUrl + "/powerbi/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardEmbedConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardEmbedConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous14>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous14>;
        }));
    }

    protected processGetDashboardEmbedConfig(response: HttpResponseBase): Observable<Anonymous14> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous14.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Report config retrieved successfully
     */
    getReportEmbedConfig(): Observable<Anonymous15> {
        let url_ = this.baseUrl + "/powerbi/report";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportEmbedConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportEmbedConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous15>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous15>;
        }));
    }

    protected processGetReportEmbedConfig(response: HttpResponseBase): Observable<Anonymous15> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous15.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PremiumDataService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param isCompleted (optional) Filter by completion status
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getFilteredPremiumDataBatches(isCompleted: boolean | undefined, filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<PremiumDataBatchesResult> {
        let url_ = this.baseUrl + "/premium-data?";
        if (isCompleted === null)
            throw new Error("The parameter 'isCompleted' cannot be null.");
        else if (isCompleted !== undefined)
            url_ += "isCompleted=" + encodeURIComponent("" + isCompleted) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredPremiumDataBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredPremiumDataBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PremiumDataBatchesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PremiumDataBatchesResult>;
        }));
    }

    protected processGetFilteredPremiumDataBatches(response: HttpResponseBase): Observable<PremiumDataBatchesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PremiumDataBatchesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @param periodId (optional) 
     * @param insurerId (optional) 
     * @param clientId (optional) Optional. Required only if the selected insurer has importAreaMandatory = true.
     * @param clientAreaId (optional) Optional. Required only if the selected insurer has importAreaMandatory = true.
     * @return Created Successfully
     */
    uploadPremiumDataBatch(file: FileParameter | undefined, periodId: number | undefined, insurerId: number | undefined, clientId: number | null | undefined, clientAreaId: number | null | undefined): Observable<ImportCreateResult> {
        let url_ = this.baseUrl + "/premium-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (periodId === null || periodId === undefined)
            throw new Error("The parameter 'periodId' cannot be null.");
        else
            content_.append("periodId", periodId.toString());
        if (insurerId === null || insurerId === undefined)
            throw new Error("The parameter 'insurerId' cannot be null.");
        else
            content_.append("insurerId", insurerId.toString());
        if (clientId !== null && clientId !== undefined)
            content_.append("clientId", clientId.toString());
        if (clientAreaId !== null && clientAreaId !== undefined)
            content_.append("clientAreaId", clientAreaId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPremiumDataBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPremiumDataBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportCreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportCreateResult>;
        }));
    }

    protected processUploadPremiumDataBatch(response: HttpResponseBase): Observable<ImportCreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ImportCreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getPremiumDataBatchById(id: number): Observable<PremiumDataBatchResult> {
        let url_ = this.baseUrl + "/premium-data/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPremiumDataBatchById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPremiumDataBatchById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PremiumDataBatchResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PremiumDataBatchResult>;
        }));
    }

    protected processGetPremiumDataBatchById(response: HttpResponseBase): Observable<PremiumDataBatchResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PremiumDataBatchResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deletePremiumDataByBatchId(id: number): Observable<void> {
        let url_ = this.baseUrl + "/premium-data/{id}/data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePremiumDataByBatchId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePremiumDataByBatchId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePremiumDataByBatchId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deletePendingPremiumBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/premium-data/{id}/pending";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendingPremiumBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendingPremiumBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePendingPremiumBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deleteCompletedPremiumBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/premium-data/{id}/completed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompletedPremiumBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompletedPremiumBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCompletedPremiumBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getPremiumDataImportRangeMapping(id: number): Observable<PremiumDataRangeMappingResult> {
        let url_ = this.baseUrl + "/premium-data/{id}/range-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPremiumDataImportRangeMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPremiumDataImportRangeMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PremiumDataRangeMappingResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PremiumDataRangeMappingResult>;
        }));
    }

    protected processGetPremiumDataImportRangeMapping(response: HttpResponseBase): Observable<PremiumDataRangeMappingResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PremiumDataRangeMappingResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Created Successfully
     */
    createPremiumDataImportRangeMapping(id: number, body: PremiumDataRangeMappingInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/premium-data/{id}/range-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePremiumDataImportRangeMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePremiumDataImportRangeMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreatePremiumDataImportRangeMapping(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getPremiumDataImportColumnMapping(id: number): Observable<GetColumnMappings> {
        let url_ = this.baseUrl + "/premium-data/{id}/column-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPremiumDataImportColumnMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPremiumDataImportColumnMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetColumnMappings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetColumnMappings>;
        }));
    }

    protected processGetPremiumDataImportColumnMapping(response: HttpResponseBase): Observable<GetColumnMappings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetColumnMappings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Created Successfully
     */
    createPremiumDataColumnMapping(id: number, body: CreateColumnMappingInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/premium-data/{id}/column-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePremiumDataColumnMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePremiumDataColumnMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreatePremiumDataColumnMapping(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Import completed successfully
     */
    importPremiumDataData(id: number): Observable<Anonymous16> {
        let url_ = this.baseUrl + "/premium-data/{id}/import-data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportPremiumDataData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportPremiumDataData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous16>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous16>;
        }));
    }

    protected processImportPremiumDataData(response: HttpResponseBase): Observable<Anonymous16> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous16.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Import results calculated
     */
    calculatePremiumDataTotals(id: number): Observable<PremiumDataTotalsResult> {
        let url_ = this.baseUrl + "/premium-data/{id}/calculate-totals";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculatePremiumDataTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculatePremiumDataTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PremiumDataTotalsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PremiumDataTotalsResult>;
        }));
    }

    protected processCalculatePremiumDataTotals(response: HttpResponseBase): Observable<PremiumDataTotalsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PremiumDataTotalsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Updated Successfully
     */
    completePremiumDataBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/premium-data/{id}/complete-batch";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompletePremiumDataBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletePremiumDataBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompletePremiumDataBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Sample data retrieved successfully
     */
    getPremiumDataSampleData(id: number): Observable<SamplePremiumDataResult> {
        let url_ = this.baseUrl + "/premium-data/{id}/sample-data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPremiumDataSampleData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPremiumDataSampleData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SamplePremiumDataResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SamplePremiumDataResult>;
        }));
    }

    protected processGetPremiumDataSampleData(response: HttpResponseBase): Observable<SamplePremiumDataResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SamplePremiumDataResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RenewalClaimService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param isCompleted (optional) Filter by completion status
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getFilteredPendingRenewalClaimBatches(isCompleted: boolean | undefined, filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<FilteredPendingBatchesResult> {
        let url_ = this.baseUrl + "/renewal-claim?";
        if (isCompleted === null)
            throw new Error("The parameter 'isCompleted' cannot be null.");
        else if (isCompleted !== undefined)
            url_ += "isCompleted=" + encodeURIComponent("" + isCompleted) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredPendingRenewalClaimBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredPendingRenewalClaimBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilteredPendingBatchesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilteredPendingBatchesResult>;
        }));
    }

    protected processGetFilteredPendingRenewalClaimBatches(response: HttpResponseBase): Observable<FilteredPendingBatchesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredPendingBatchesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @param periodId (optional) 
     * @param insurerId (optional) 
     * @param clientAreaId (optional) Optional. Required only if the selected insurer has importAreaMandatory = true.
     * @return Fetched Successfully
     */
    uploadRenewalClaimBatch(file: FileParameter | undefined, periodId: number | undefined, insurerId: number | undefined, clientAreaId: number | null | undefined): Observable<ImportCreateResult> {
        let url_ = this.baseUrl + "/renewal-claim";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (periodId === null || periodId === undefined)
            throw new Error("The parameter 'periodId' cannot be null.");
        else
            content_.append("periodId", periodId.toString());
        if (insurerId === null || insurerId === undefined)
            throw new Error("The parameter 'insurerId' cannot be null.");
        else
            content_.append("insurerId", insurerId.toString());
        if (clientAreaId !== null && clientAreaId !== undefined)
            content_.append("clientAreaId", clientAreaId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadRenewalClaimBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadRenewalClaimBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportCreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportCreateResult>;
        }));
    }

    protected processUploadRenewalClaimBatch(response: HttpResponseBase): Observable<ImportCreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ImportCreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getRenewalClaimBatch(id: number): Observable<RenewalClaimBatchResult> {
        let url_ = this.baseUrl + "/renewal-claim/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRenewalClaimBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRenewalClaimBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RenewalClaimBatchResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RenewalClaimBatchResult>;
        }));
    }

    protected processGetRenewalClaimBatch(response: HttpResponseBase): Observable<RenewalClaimBatchResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RenewalClaimBatchResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deleteRenewalClaimDataByBatchId(id: number): Observable<void> {
        let url_ = this.baseUrl + "/renewal-claim/{id}/data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRenewalClaimDataByBatchId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRenewalClaimDataByBatchId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRenewalClaimDataByBatchId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Created Successfully
     */
    createRenewalClaimImportRangeMapping(id: number, body: RenewalClaimRangeMappingInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/renewal-claim/{id}/range-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRenewalClaimImportRangeMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRenewalClaimImportRangeMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreateRenewalClaimImportRangeMapping(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getRenewalClaimRangeMapping(id: number): Observable<RenewalClaimRangeMappingResult> {
        let url_ = this.baseUrl + "/renewal-claim/{id}/range-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRenewalClaimRangeMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRenewalClaimRangeMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RenewalClaimRangeMappingResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RenewalClaimRangeMappingResult>;
        }));
    }

    protected processGetRenewalClaimRangeMapping(response: HttpResponseBase): Observable<RenewalClaimRangeMappingResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RenewalClaimRangeMappingResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deletePendingRenewalClaimBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/renewal-claim/{id}/pending";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendingRenewalClaimBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendingRenewalClaimBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePendingRenewalClaimBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deleteCompletedRenewalClaimBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/renewal-claim/{id}/completed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompletedRenewalClaimBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompletedRenewalClaimBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCompletedRenewalClaimBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getRenewalClaimImportColumnMapping(id: number): Observable<GetColumnMappings> {
        let url_ = this.baseUrl + "/renewal-claim/{id}/column-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRenewalClaimImportColumnMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRenewalClaimImportColumnMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetColumnMappings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetColumnMappings>;
        }));
    }

    protected processGetRenewalClaimImportColumnMapping(response: HttpResponseBase): Observable<GetColumnMappings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetColumnMappings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Created Successfully
     */
    createRenewalClaimColumnMapping(id: number, body: CreateColumnMappingInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/renewal-claim/{id}/column-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRenewalClaimColumnMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRenewalClaimColumnMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreateRenewalClaimColumnMapping(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Sample data retrieved successfully
     */
    getRenewalClaimSampleData(id: number): Observable<SampleRenewalClaimDataResult> {
        let url_ = this.baseUrl + "/renewal-claim/{id}/sample-data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRenewalClaimSampleData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRenewalClaimSampleData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SampleRenewalClaimDataResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SampleRenewalClaimDataResult>;
        }));
    }

    protected processGetRenewalClaimSampleData(response: HttpResponseBase): Observable<SampleRenewalClaimDataResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SampleRenewalClaimDataResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Import results calculated
     */
    calculateRenewalClaimImportTotals(id: number): Observable<RenewalClaimTotalsResult> {
        let url_ = this.baseUrl + "/renewal-claim/{id}/calculate-totals";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateRenewalClaimImportTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateRenewalClaimImportTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RenewalClaimTotalsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RenewalClaimTotalsResult>;
        }));
    }

    protected processCalculateRenewalClaimImportTotals(response: HttpResponseBase): Observable<RenewalClaimTotalsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RenewalClaimTotalsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Completion Started
     */
    completeRenewalClaimBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/renewal-claim/{id}/complete-batch";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteRenewalClaimBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteRenewalClaimBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompleteRenewalClaimBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Status Retrieved
     */
    getRenewalClaimCompletionStatus(id: number): Observable<void> {
        let url_ = this.baseUrl + "/renewal-claim/{id}/completion-status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRenewalClaimCompletionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRenewalClaimCompletionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetRenewalClaimCompletionStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Import completed successfully
     */
    importRenewalClaimData(id: number): Observable<Anonymous17> {
        let url_ = this.baseUrl + "/renewal-claim/{id}/import-data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportRenewalClaimData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportRenewalClaimData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous17>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous17>;
        }));
    }

    protected processImportRenewalClaimData(response: HttpResponseBase): Observable<Anonymous17> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous17.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReportPackDeclarationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @return Fetched Successfully
     */
    createDeclarationReportPack(body: DeclarationReportPackInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/report-pack-declaration/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDeclarationReportPack(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDeclarationReportPack(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreateDeclarationReportPack(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReportPackRenewalService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @return Created successfully
     */
    createRenewalReportPack(body: RenewalReportPackInput): Observable<void> {
        let url_ = this.baseUrl + "/report-pack-renewal/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRenewalReportPack(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRenewalReportPack(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateRenewalReportPack(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid input", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReportService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param startPeriodId (optional) Start period ID for the report
     * @param endPeriodId (optional) End period ID for the report
     * @param insurerId (optional) Insurer ID for the report
     * @return Fetched Successfully
     */
    getAgeingExportData(startPeriodId: number | undefined, endPeriodId: number | undefined, insurerId: number | undefined): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/ageing-export?";
        if (startPeriodId === null)
            throw new Error("The parameter 'startPeriodId' cannot be null.");
        else if (startPeriodId !== undefined)
            url_ += "startPeriodId=" + encodeURIComponent("" + startPeriodId) + "&";
        if (endPeriodId === null)
            throw new Error("The parameter 'endPeriodId' cannot be null.");
        else if (endPeriodId !== undefined)
            url_ += "endPeriodId=" + encodeURIComponent("" + endPeriodId) + "&";
        if (insurerId === null)
            throw new Error("The parameter 'insurerId' cannot be null.");
        else if (insurerId !== undefined)
            url_ += "insurerId=" + encodeURIComponent("" + insurerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgeingExportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgeingExportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetAgeingExportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid request parameters", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startPeriodId (optional) Start period ID for the report
     * @param endPeriodId (optional) End period ID for the report
     * @param insurerId (optional) Insurer ID for the report
     * @return Fetched Successfully
     */
    getAnnexureExportReportData(startPeriodId: number | undefined, endPeriodId: number | undefined, insurerId: number | undefined): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/annexure-export?";
        if (startPeriodId === null)
            throw new Error("The parameter 'startPeriodId' cannot be null.");
        else if (startPeriodId !== undefined)
            url_ += "startPeriodId=" + encodeURIComponent("" + startPeriodId) + "&";
        if (endPeriodId === null)
            throw new Error("The parameter 'endPeriodId' cannot be null.");
        else if (endPeriodId !== undefined)
            url_ += "endPeriodId=" + encodeURIComponent("" + endPeriodId) + "&";
        if (insurerId === null)
            throw new Error("The parameter 'insurerId' cannot be null.");
        else if (insurerId !== undefined)
            url_ += "insurerId=" + encodeURIComponent("" + insurerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnexureExportReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnexureExportReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetAnnexureExportReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid request parameters", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientAreaId Id of accociated client area entity
     * @param periodId Id of period
     * @return Fetched Successfully
     */
    getApprovedVersusGrantedReportData(clientAreaId: number, periodId: number): Observable<ApprovedVersusGrantedReportResult> {
        let url_ = this.baseUrl + "/report/approved-versus-granted?";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovedVersusGrantedReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovedVersusGrantedReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprovedVersusGrantedReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprovedVersusGrantedReportResult>;
        }));
    }

    protected processGetApprovedVersusGrantedReportData(response: HttpResponseBase): Observable<ApprovedVersusGrantedReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovedVersusGrantedReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientAreaId Id of accociated client area entity
     * @param periodId Id of period
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadApprovedVersusGrantedReport(clientAreaId: number, periodId: number, exportType: ExportType): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/approved-versus-granted/download?";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadApprovedVersusGrantedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadApprovedVersusGrantedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadApprovedVersusGrantedReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate Start date for the report
     * @param endDate End date for the report
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getClaimsReportData(startDate: Date, endDate: Date, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/claims?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClaimsReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClaimsReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetClaimsReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate Start date for the report
     * @param endDate End date for the report
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadClaimsReport(startDate: Date, endDate: Date, clientAreaId: number, exportType: ExportType2): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/claims/download?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadClaimsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadClaimsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadClaimsReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getCompleteRecordsData(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/complete-records?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompleteRecordsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompleteRecordsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetCompleteRecordsData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadCompleteRecords(periodId: number, clientAreaId: number, exportType: ExportType3): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/complete-records/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadCompleteRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadCompleteRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadCompleteRecords(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientAreaId Id of accociated client area entity
     * @param periodId Id of period
     * @param clientId Id of associated client entity
     * @return Fetched Successfully
     */
    getDataStatusReportData(clientAreaId: number, periodId: number, clientId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/data-status?";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataStatusReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataStatusReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetDataStatusReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientAreaId Id of accociated client area entity
     * @param periodId Id of period
     * @param clientId Id of associated client entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadDataStatusReport(clientAreaId: number, periodId: number, clientId: number, exportType: ExportType4): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/data-status/download?";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDataStatusReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDataStatusReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDataStatusReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getDeclarationDetailReportData(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/declaration-detail?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeclarationDetailReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeclarationDetailReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetDeclarationDetailReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadDeclarationDetailReport(periodId: number, clientAreaId: number, exportType: ExportType5): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/declaration-detail/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDeclarationDetailReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDeclarationDetailReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDeclarationDetailReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getDeclarationSummaryReportData(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/declaration-summary?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeclarationSummaryReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeclarationSummaryReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetDeclarationSummaryReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadDeclarationSummaryReport(periodId: number, clientAreaId: number, exportType: ExportType6): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/declaration-summary/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDeclarationSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDeclarationSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDeclarationSummaryReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getDetailedTurnoverReportData(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/detailed-turnover?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailedTurnoverReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailedTurnoverReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetDetailedTurnoverReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadDetailedTurnoverReport(periodId: number, clientAreaId: number, exportType: ExportType7): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/detailed-turnover/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDetailedTurnoverReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDetailedTurnoverReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDetailedTurnoverReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientAreaId Id of accociated client area entity
     * @param periodId Id of period
     * @return Fetched Successfully
     */
    getDetailedTurnoverTotalsData(clientAreaId: number, periodId: number): Observable<DetailedTurnoverTotalsResult> {
        let url_ = this.baseUrl + "/report/detailed-turnover-totals?";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailedTurnoverTotalsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailedTurnoverTotalsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DetailedTurnoverTotalsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DetailedTurnoverTotalsResult>;
        }));
    }

    protected processGetDetailedTurnoverTotalsData(response: HttpResponseBase): Observable<DetailedTurnoverTotalsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DetailedTurnoverTotalsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientAreaId Id of accociated client area entity
     * @param periodId Id of period
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadDetailedTurnoverTotalsData(clientAreaId: number, periodId: number, exportType: ExportType8): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/detailed-turnover-totals/download?";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDetailedTurnoverTotalsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDetailedTurnoverTotalsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDetailedTurnoverTotalsData(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched successfully
     */
    getDivisionExposureReport(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/division-exposure?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDivisionExposureReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDivisionExposureReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetDivisionExposureReport(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadDivisionExposureReport(periodId: number, clientAreaId: number, exportType: ExportType9): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/division-exposure/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDivisionExposureReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDivisionExposureReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDivisionExposureReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getFranchiseLossReportData(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/franchise-loss?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFranchiseLossReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFranchiseLossReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetFranchiseLossReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadFranchiseLossReport(periodId: number, clientAreaId: number, exportType: ExportType10): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/franchise-loss/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFranchiseLossReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFranchiseLossReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadFranchiseLossReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getImportDetailsReportData(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/import-details?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImportDetailsReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImportDetailsReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetImportDetailsReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientAreaId Id of accociated client area entity
     * @param periodId Id of period
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadImportDetailsReport(clientAreaId: number, periodId: number, exportType: ExportType11): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/import-details/download?";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadImportDetailsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadImportDetailsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadImportDetailsReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getInsuredDebtorsReportData(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/insured-debtors?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInsuredDebtorsReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInsuredDebtorsReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetInsuredDebtorsReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadInsuredDebtorsReport(periodId: number, clientAreaId: number, exportType: ExportType12): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/insured-debtors/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadInsuredDebtorsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadInsuredDebtorsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadInsuredDebtorsReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate Start date for the report
     * @param endDate End date for the report
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getInsuredDebtorsGrantedLimitsVsExposuresReportData(startDate: Date, endDate: Date, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/insured-debtors-granted-limits-vs-exposures?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInsuredDebtorsGrantedLimitsVsExposuresReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInsuredDebtorsGrantedLimitsVsExposuresReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetInsuredDebtorsGrantedLimitsVsExposuresReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate Start date for the report
     * @param endDate End date for the report
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadInsuredDebtorsGrantedLimitsVsExposuresReport(startDate: Date, endDate: Date, clientAreaId: number, exportType: ExportType13): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/insured-debtors-granted-limits-vs-exposures/download?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadInsuredDebtorsGrantedLimitsVsExposuresReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadInsuredDebtorsGrantedLimitsVsExposuresReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadInsuredDebtorsGrantedLimitsVsExposuresReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getLimitValueChangesReportData(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/limit-value-changes?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLimitValueChangesReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLimitValueChangesReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetLimitValueChangesReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadLimitValueChangesReport(periodId: number, clientAreaId: number, exportType: ExportType14): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/limit-value-changes/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadLimitValueChangesReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadLimitValueChangesReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadLimitValueChangesReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate Start date for the report
     * @param endDate End date for the report
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getLimitsReportData(startDate: Date, endDate: Date, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/limits?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLimitsReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLimitsReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetLimitsReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate Start date for the report
     * @param endDate End date for the report
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadLimitsReport(startDate: Date, endDate: Date, clientAreaId: number, exportType: ExportType15): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/limits/download?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadLimitsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadLimitsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadLimitsReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getLinkedDebtorData(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/linked-debtor?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLinkedDebtorData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkedDebtorData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetLinkedDebtorData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadLinkedDebtor(periodId: number, clientAreaId: number, exportType: ExportType16): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/linked-debtor/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadLinkedDebtor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadLinkedDebtor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadLinkedDebtor(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getNegativeBalanceReportData(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/negative-balance?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNegativeBalanceReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNegativeBalanceReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetNegativeBalanceReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadNegativeBalanceReport(periodId: number, clientAreaId: number, exportType: ExportType17): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/negative-balance/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadNegativeBalanceReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadNegativeBalanceReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadNegativeBalanceReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getOverdueAccountsReportData(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/overdue-accounts?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverdueAccountsReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverdueAccountsReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetOverdueAccountsReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadOverdueAccountsReport(periodId: number, clientAreaId: number, exportType: ExportType18): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/overdue-accounts/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadOverdueAccountsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadOverdueAccountsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadOverdueAccountsReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getOverdueAccountsDetailedReportData(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/overdue-accounts-detailed?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverdueAccountsDetailedReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverdueAccountsDetailedReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetOverdueAccountsDetailedReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadOverdueAccountsDetailedReport(periodId: number, clientAreaId: number, exportType: ExportType19): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/overdue-accounts-detailed/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadOverdueAccountsDetailedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadOverdueAccountsDetailedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadOverdueAccountsDetailedReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getOvertradesReportContent(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/overtrades?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOvertradesReportContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOvertradesReportContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetOvertradesReportContent(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadOvertradesReport(periodId: number, clientAreaId: number, exportType: ExportType20): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/overtrades/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadOvertradesReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadOvertradesReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadOvertradesReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate Start date for the report
     * @param endDate End date for the report
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getPerformanceBonusReportData(startDate: Date, endDate: Date, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/performance-data?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerformanceBonusReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerformanceBonusReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetPerformanceBonusReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate Start date for the report
     * @param endDate End date for the report
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadPerformanceData(startDate: Date, endDate: Date, clientAreaId: number, exportType: ExportType21): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/performance-data/download?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPerformanceData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPerformanceData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadPerformanceData(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate Start date for the report
     * @param endDate End date for the report
     * @param clientId Id of associated client entity
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getPolicyScheduleReportData(startDate: Date, endDate: Date, clientId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/policy-schedule?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicyScheduleReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicyScheduleReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetPolicyScheduleReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate Start date for the report
     * @param endDate End date for the report
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadPolicyScheduleReport(startDate: Date, endDate: Date, clientAreaId: number, exportType: ExportType22): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/policy-schedule/download?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPolicyScheduleReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPolicyScheduleReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadPolicyScheduleReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate Start date for the report
     * @param endDate End date for the report
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getPremiumSummaryReport(startDate: Date, endDate: Date, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/premium-summary?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPremiumSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPremiumSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetPremiumSummaryReport(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate Start date for the report
     * @param endDate End date for the report
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadPremiumSummaryReport(startDate: Date, endDate: Date, clientAreaId: number, exportType: ExportType23): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/premium-summary/download?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPremiumSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPremiumSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadPremiumSummaryReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param policyGroupId (optional) Policy group ID for the report
     * @param periodId (optional) Period ID for the report
     * @return Fetched Successfully
     */
    getSharedDebtorByPolicyReportData(policyGroupId: number | undefined, periodId: number | undefined): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/shared-debtor-by-policy?";
        if (policyGroupId === null)
            throw new Error("The parameter 'policyGroupId' cannot be null.");
        else if (policyGroupId !== undefined)
            url_ += "policyGroupId=" + encodeURIComponent("" + policyGroupId) + "&";
        if (periodId === null)
            throw new Error("The parameter 'periodId' cannot be null.");
        else if (periodId !== undefined)
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSharedDebtorByPolicyReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSharedDebtorByPolicyReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetSharedDebtorByPolicyReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param policyGroupId (optional) Policy group ID for the report
     * @param periodId (optional) Period ID for the report
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadSharedDebtorByPolicyReport(policyGroupId: number | undefined, periodId: number | undefined, exportType: ExportType24): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/shared-debtor-by-policy/download?";
        if (policyGroupId === null)
            throw new Error("The parameter 'policyGroupId' cannot be null.");
        else if (policyGroupId !== undefined)
            url_ += "policyGroupId=" + encodeURIComponent("" + policyGroupId) + "&";
        if (periodId === null)
            throw new Error("The parameter 'periodId' cannot be null.");
        else if (periodId !== undefined)
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSharedDebtorByPolicyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSharedDebtorByPolicyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadSharedDebtorByPolicyReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getSpecialConditionsReportContent(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/special-conditions?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecialConditionsReportContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecialConditionsReportContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetSpecialConditionsReportContent(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadSpecialConditionsReport(periodId: number, clientAreaId: number, exportType: ExportType25): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/special-conditions/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSpecialConditionsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSpecialConditionsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadSpecialConditionsReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getTurnoverChecklistReportData(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/turnover-checklist?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTurnoverChecklistReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTurnoverChecklistReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetTurnoverChecklistReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadTurnoverChecklistReport(periodId: number, clientAreaId: number, exportType: ExportType26): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/turnover-checklist/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTurnoverChecklistReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTurnoverChecklistReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadTurnoverChecklistReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getTurnoverReportData(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/turnover?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTurnoverReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTurnoverReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetTurnoverReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadTurnoverReport(periodId: number, clientAreaId: number, exportType: ExportType27): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/turnover/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTurnoverReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTurnoverReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadTurnoverReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getTwelveMonthUtilizationReportData(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/twelve-month-utilization?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTwelveMonthUtilizationReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTwelveMonthUtilizationReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetTwelveMonthUtilizationReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadTwelveMonthUtilizationReport(periodId: number, clientAreaId: number, exportType: ExportType28): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/twelve-month-utilization/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTwelveMonthUtilizationReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTwelveMonthUtilizationReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadTwelveMonthUtilizationReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getUninsurableDebtorReportData(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/uninsurable-debtor?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUninsurableDebtorReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUninsurableDebtorReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetUninsurableDebtorReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadUninsurableDebtor(periodId: number, clientAreaId: number, exportType: ExportType29): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/uninsurable-debtor/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadUninsurableDebtor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadUninsurableDebtor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadUninsurableDebtor(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getUninsuredDebtorReportData(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/uninsured-debtor?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUninsuredDebtorReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUninsuredDebtorReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetUninsuredDebtorReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadUninsuredDebtorReport(periodId: number, clientAreaId: number, exportType: ExportType30): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/uninsured-debtor/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadUninsuredDebtorReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadUninsuredDebtorReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadUninsuredDebtorReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @return Fetched Successfully
     */
    getUnutilizedInsurerLimitsReportData(periodId: number, clientAreaId: number): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/unutilized-insurer-limits?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnutilizedInsurerLimitsReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnutilizedInsurerLimitsReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetUnutilizedInsurerLimitsReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param periodId Id of period
     * @param clientAreaId Id of accociated client area entity
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadUnutilizedInsurerLimitsReport(periodId: number, clientAreaId: number, exportType: ExportType31): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/unutilized-insurer-limits/download?";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined and cannot be null.");
        else
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        if (clientAreaId === undefined || clientAreaId === null)
            throw new Error("The parameter 'clientAreaId' must be defined and cannot be null.");
        else
            url_ += "clientAreaId=" + encodeURIComponent("" + clientAreaId) + "&";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadUnutilizedInsurerLimitsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadUnutilizedInsurerLimitsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadUnutilizedInsurerLimitsReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Fetched Successfully
     */
    getUserReportData(): Observable<ReportResult> {
        let url_ = this.baseUrl + "/report/user-report";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResult>;
        }));
    }

    protected processGetUserReportData(response: HttpResponseBase): Observable<ReportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param exportType The type of file to export ('pdf' or 'excel')
     * @return File generated successfully
     */
    downloadUserReport(exportType: ExportType32): Observable<FileResponse> {
        let url_ = this.baseUrl + "/report/user-report/download?";
        if (exportType === undefined || exportType === null)
            throw new Error("The parameter 'exportType' must be defined and cannot be null.");
        else
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadUserReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadUserReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadUserReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid export type", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SalesService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param isCompleted (optional) Filter by completion status (true = completed, false = pending)
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getSalesBatches(isCompleted: boolean | undefined, filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<SalesBatchesResult> {
        let url_ = this.baseUrl + "/sales?";
        if (isCompleted === null)
            throw new Error("The parameter 'isCompleted' cannot be null.");
        else if (isCompleted !== undefined)
            url_ += "isCompleted=" + encodeURIComponent("" + isCompleted) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesBatchesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesBatchesResult>;
        }));
    }

    protected processGetSalesBatches(response: HttpResponseBase): Observable<SalesBatchesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesBatchesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No sales batches found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid request parameters", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @param periodId (optional) 
     * @param clientId (optional) 
     * @return Fetched Successfully
     */
    uploadSalesFile(file: FileParameter | undefined, periodId: number | undefined, clientId: number | undefined): Observable<ImportCreateResult> {
        let url_ = this.baseUrl + "/sales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (periodId === null || periodId === undefined)
            throw new Error("The parameter 'periodId' cannot be null.");
        else
            content_.append("periodId", periodId.toString());
        if (clientId === null || clientId === undefined)
            throw new Error("The parameter 'clientId' cannot be null.");
        else
            content_.append("clientId", clientId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSalesFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSalesFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportCreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportCreateResult>;
        }));
    }

    protected processUploadSalesFile(response: HttpResponseBase): Observable<ImportCreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ImportCreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getSalesBatch(id: number): Observable<SalesBatchResult> {
        let url_ = this.baseUrl + "/sales/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesBatchResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesBatchResult>;
        }));
    }

    protected processGetSalesBatch(response: HttpResponseBase): Observable<SalesBatchResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesBatchResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deleteSalesDataByBatchId(id: number): Observable<void> {
        let url_ = this.baseUrl + "/sales/{id}/data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSalesDataByBatchId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSalesDataByBatchId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSalesDataByBatchId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deletePendingSalesBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/sales/{id}/pending";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendingSalesBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendingSalesBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePendingSalesBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deleteCompletedSalesBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/sales/{id}/completed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompletedSalesBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompletedSalesBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCompletedSalesBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getSalesWorksheetSelection(id: number): Observable<SalesWorksheetSelectionResult> {
        let url_ = this.baseUrl + "/sales/{id}/worksheets";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesWorksheetSelection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesWorksheetSelection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesWorksheetSelectionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesWorksheetSelectionResult>;
        }));
    }

    protected processGetSalesWorksheetSelection(response: HttpResponseBase): Observable<SalesWorksheetSelectionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesWorksheetSelectionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Created Successfully
     */
    createSalesWorksheet(id: number, body: SalesWorksheetInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/sales/{id}/worksheets";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSalesWorksheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSalesWorksheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreateSalesWorksheet(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getSalesImportRangeMapping(id: number): Observable<SalesRangeMappingResult[]> {
        let url_ = this.baseUrl + "/sales/{id}/range-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesImportRangeMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesImportRangeMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesRangeMappingResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesRangeMappingResult[]>;
        }));
    }

    protected processGetSalesImportRangeMapping(response: HttpResponseBase): Observable<SalesRangeMappingResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesRangeMappingResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Created Successfully
     */
    createSalesImportRangeMapping(id: number, body: Body3[]): Observable<CreateResult> {
        let url_ = this.baseUrl + "/sales/{id}/range-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSalesImportRangeMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSalesImportRangeMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreateSalesImportRangeMapping(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getSalesImportColumnMapping(id: number): Observable<GetColumnMappings> {
        let url_ = this.baseUrl + "/sales/{id}/column-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesImportColumnMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesImportColumnMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetColumnMappings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetColumnMappings>;
        }));
    }

    protected processGetSalesImportColumnMapping(response: HttpResponseBase): Observable<GetColumnMappings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetColumnMappings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Created Successfully
     */
    createSalesColumnMapping(id: number, body: CreateColumnMappingInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/sales/{id}/column-mapping";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSalesColumnMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSalesColumnMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreateSalesColumnMapping(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Import completed successfully
     */
    importSalesData(id: number): Observable<Anonymous18> {
        let url_ = this.baseUrl + "/sales/{id}/import-data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportSalesData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportSalesData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous18>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous18>;
        }));
    }

    protected processImportSalesData(response: HttpResponseBase): Observable<Anonymous18> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous18.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Import results calculated
     */
    calculateSalesTotals(id: number): Observable<SalesTotalsResult> {
        let url_ = this.baseUrl + "/sales/{id}/calculate-totals";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateSalesTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateSalesTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesTotalsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesTotalsResult>;
        }));
    }

    protected processCalculateSalesTotals(response: HttpResponseBase): Observable<SalesTotalsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesTotalsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Completion Started
     */
    completeSalesBatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/sales/{id}/complete-batch";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteSalesBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteSalesBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompleteSalesBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Status Retrieved
     */
    getSalesCompletionStatus(id: number): Observable<void> {
        let url_ = this.baseUrl + "/sales/{id}/completion-status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesCompletionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesCompletionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetSalesCompletionStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Sample data retrieved successfully
     */
    getSalesSampleData(id: number): Observable<SampleSalesDataResult> {
        let url_ = this.baseUrl + "/sales/{id}/sample-data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesSampleData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesSampleData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SampleSalesDataResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SampleSalesDataResult>;
        }));
    }

    protected processGetSalesSampleData(response: HttpResponseBase): Observable<SampleSalesDataResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SampleSalesDataResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getFilteredTenants(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<FilteredTenantsResult> {
        let url_ = this.baseUrl + "/tenant?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilteredTenantsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilteredTenantsResult>;
        }));
    }

    protected processGetFilteredTenants(response: HttpResponseBase): Observable<FilteredTenantsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredTenantsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Tenant created successfully
     */
    createTenant(body: CreateTenantInput): Observable<void> {
        let url_ = this.baseUrl + "/tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Fetched Successfully
     */
    getTenantById(id: number): Observable<TenantByIdResult> {
        let url_ = this.baseUrl + "/tenant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantByIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantByIdResult>;
        }));
    }

    protected processGetTenantById(response: HttpResponseBase): Observable<TenantByIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantByIdResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Tenant Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Tenant updated successfully
     */
    updateTenant(id: number, body: UpdateTenantInput): Observable<void> {
        let url_ = this.baseUrl + "/tenant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Tenant Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Tenant activated successfully
     */
    activateTenant(id: number): Observable<void> {
        let url_ = this.baseUrl + "/tenant/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Tenant Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Tenant deactivated successfully
     */
    deactivateTenant(id: number): Observable<void> {
        let url_ = this.baseUrl + "/tenant/{id}/deactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Tenant Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserRoleService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @return Fetched Successfully
     */
    getAllUserRoles(): Observable<AllUserRolesResult> {
        let url_ = this.baseUrl + "/user-role/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllUserRolesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllUserRolesResult>;
        }));
    }

    protected processGetAllUserRoles(response: HttpResponseBase): Observable<AllUserRolesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllUserRolesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getFilteredUserRoles(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<FilteredUserRolesResult> {
        let url_ = this.baseUrl + "/user-role?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilteredUserRolesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilteredUserRolesResult>;
        }));
    }

    protected processGetFilteredUserRoles(response: HttpResponseBase): Observable<FilteredUserRolesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredUserRolesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Created Successfully
     */
    createUserRole(body: CreateUserRoleInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/user-role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreateUserRole(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getUserRoleById(id: number): Observable<UserRoleByIdResult> {
        let url_ = this.baseUrl + "/user-role/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserRoleById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRoleById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleByIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleByIdResult>;
        }));
    }

    protected processGetUserRoleById(response: HttpResponseBase): Observable<UserRoleByIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRoleByIdResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Tenant Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    updateUserRole(id: number, body: UpdateUserRoleInput): Observable<void> {
        let url_ = this.baseUrl + "/user-role/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deleteUserRole(id: number): Observable<void> {
        let url_ = this.baseUrl + "/user-role/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUserRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getRolePermissionsById(id: number): Observable<Anonymous19[]> {
        let url_ = this.baseUrl + "/user-role/{id}/permissions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolePermissionsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolePermissionsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous19[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous19[]>;
        }));
    }

    protected processGetRolePermissionsById(response: HttpResponseBase): Observable<Anonymous19[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Anonymous19.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Role not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Created Successfully
     */
    saveRolePermissions(id: number, body: CreateUserRolePermissionsInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/user-role/{id}/permissions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveRolePermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRolePermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processSaveRolePermissions(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param filter (optional) Filter text or values
     * @param pageNo Page number
     * @param pageSize Results per page
     * @param sortDirection (optional) Direction to sort data in
     * @param sortColumn (optional) Column to use for sorting data
     * @return Fetched Successfully
     */
    getFilteredUsers(filter: string | undefined, pageNo: number, pageSize: number, sortDirection: string | undefined, sortColumn: string | undefined): Observable<FilteredUsersResult> {
        let url_ = this.baseUrl + "/user?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilteredUsersResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilteredUsersResult>;
        }));
    }

    protected processGetFilteredUsers(response: HttpResponseBase): Observable<FilteredUsersResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredUsersResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Created Successfully
     */
    createUser(body: CreateUserInput): Observable<CreateResult> {
        let url_ = this.baseUrl + "/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResult>;
        }));
    }

    protected processCreateUser(response: HttpResponseBase): Observable<CreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param excludeUserId (optional) User ID to exclude from results
     * @param search (optional) Search filter text
     * @return Fetched Successfully
     */
    getUsersForDropdown(excludeUserId: number | undefined, search: string | undefined): Observable<Anonymous20[]> {
        let url_ = this.baseUrl + "/user/dropdown?";
        if (excludeUserId === null)
            throw new Error("The parameter 'excludeUserId' cannot be null.");
        else if (excludeUserId !== undefined)
            url_ += "excludeUserId=" + encodeURIComponent("" + excludeUserId) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersForDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersForDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous20[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous20[]>;
        }));
    }

    protected processGetUsersForDropdown(response: HttpResponseBase): Observable<Anonymous20[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Anonymous20.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getUserById(id: number): Observable<UserByIdResult> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserByIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserByIdResult>;
        }));
    }

    protected processGetUserById(response: HttpResponseBase): Observable<UserByIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserByIdResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("User Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Exchange rate updated successfully
     */
    updateUser(id: number, body: UpdateUserInput): Observable<void> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Exchange rate Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Successful
     */
    deleteUser(id: number): Observable<void> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return User activated successfully
     */
    activateUser(id: number): Observable<void> {
        let url_ = this.baseUrl + "/user/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("User Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return User deactivated successfully
     */
    deactivateUser(id: number): Observable<void> {
        let url_ = this.baseUrl + "/user/{id}/deactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("User Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @param filter (optional) Filter text or values
     * @return Fetched Successfully
     */
    getUserTenants(id: number, filter: string | undefined): Observable<GetUserTenantsResult> {
        let url_ = this.baseUrl + "/user/{id}/tenants?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserTenantsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserTenantsResult>;
        }));
    }

    protected processGetUserTenants(response: HttpResponseBase): Observable<GetUserTenantsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserTenantsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("User Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id Id of Entity
     * @return Fetched Successfully
     */
    getUserRoles(id: number): Observable<GetUserRolesResult> {
        let url_ = this.baseUrl + "/user/{id}/roles";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserRolesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserRolesResult>;
        }));
    }

    protected processGetUserRoles(response: HttpResponseBase): Observable<GetUserRolesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserRolesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("User Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email email of user
     * @return Fetched Successfully
     */
    getUserPermissions(email: string): Observable<AuthorizationResult> {
        let url_ = this.baseUrl + "/user/permissions/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthorizationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthorizationResult>;
        }));
    }

    protected processGetUserPermissions(response: HttpResponseBase): Observable<AuthorizationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthorizationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("User Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email email of user
     * @return Fetched Successfully
     */
    getAssignedTenants(email: string): Observable<GetAssignedTenantsResult> {
        let url_ = this.baseUrl + "/user/tenants/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignedTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignedTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAssignedTenantsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAssignedTenantsResult>;
        }));
    }

    protected processGetAssignedTenants(response: HttpResponseBase): Observable<GetAssignedTenantsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssignedTenantsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("User Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email email of user
     * @param id Id of Entity
     * @return User deactivated successfully
     */
    updateEnabledTenant(email: string, id: number): Observable<void> {
        let url_ = this.baseUrl + "/user/tenants/{email}/{id}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEnabledTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEnabledTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEnabledTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("User Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VersionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @return Successful
     */
    getVersion(): Observable<void> {
        let url_ = this.baseUrl + "/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetVersion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkbookService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:3000";
    }

    /**
     * @param path Path to the workbook file
     * @return Fetched Successfully
     */
    getSheetNames(path: string): Observable<WorksheetsResult> {
        let url_ = this.baseUrl + "/workbook/sheet-names?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined and cannot be null.");
        else
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSheetNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSheetNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorksheetsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorksheetsResult>;
        }));
    }

    protected processGetSheetNames(response: HttpResponseBase): Observable<WorksheetsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorksheetsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Data Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param path Path to the workbook file
     * @param worksheet (optional) Name of the worksheet
     * @return Fetched Successfully
     */
    getSampleBySheetName(path: string, worksheet: string | undefined): Observable<WorksheetSampleResult> {
        let url_ = this.baseUrl + "/workbook/sample-by-sheet-name?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined and cannot be null.");
        else
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        if (worksheet === null)
            throw new Error("The parameter 'worksheet' cannot be null.");
        else if (worksheet !== undefined)
            url_ += "worksheet=" + encodeURIComponent("" + worksheet) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSampleBySheetName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSampleBySheetName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorksheetSampleResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorksheetSampleResult>;
        }));
    }

    protected processGetSampleBySheetName(response: HttpResponseBase): Observable<WorksheetSampleResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorksheetSampleResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param path Path to the workbook file
     * @param index Index of the worksheet (0-based)
     * @return Fetched Successfully
     */
    getSampleBySheetIndex(path: string, index: number): Observable<WorksheetSampleResult> {
        let url_ = this.baseUrl + "/workbook/sample-by-sheet-index?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined and cannot be null.");
        else
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        if (index === undefined || index === null)
            throw new Error("The parameter 'index' must be defined and cannot be null.");
        else
            url_ += "index=" + encodeURIComponent("" + index) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSampleBySheetIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSampleBySheetIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorksheetSampleResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorksheetSampleResult>;
        }));
    }

    protected processGetSampleBySheetIndex(response: HttpResponseBase): Observable<WorksheetSampleResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorksheetSampleResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param path Path to the workbook file
     * @param worksheet Name of the worksheet
     * @param headerRowIndex Row index where headers are found (1-based index)
     * @return Headers extracted
     */
    getColumnsBySheetName(path: string, worksheet: string, headerRowIndex: number): Observable<WorksheetHeaderResult> {
        let url_ = this.baseUrl + "/workbook/columns-by-sheet-name?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined and cannot be null.");
        else
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        if (worksheet === undefined || worksheet === null)
            throw new Error("The parameter 'worksheet' must be defined and cannot be null.");
        else
            url_ += "worksheet=" + encodeURIComponent("" + worksheet) + "&";
        if (headerRowIndex === undefined || headerRowIndex === null)
            throw new Error("The parameter 'headerRowIndex' must be defined and cannot be null.");
        else
            url_ += "headerRowIndex=" + encodeURIComponent("" + headerRowIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetColumnsBySheetName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetColumnsBySheetName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorksheetHeaderResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorksheetHeaderResult>;
        }));
    }

    protected processGetColumnsBySheetName(response: HttpResponseBase): Observable<WorksheetHeaderResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorksheetHeaderResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param path Path to the workbook file
     * @param index Index of the worksheet (0-based)
     * @param headerRowIndex Row index where headers are found (1-based index)
     * @return Headers extracted
     */
    getColumnsBySheetIndex(path: string, index: number, headerRowIndex: number): Observable<WorksheetHeaderResult> {
        let url_ = this.baseUrl + "/workbook/columns-by-sheet-index?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined and cannot be null.");
        else
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        if (index === undefined || index === null)
            throw new Error("The parameter 'index' must be defined and cannot be null.");
        else
            url_ += "index=" + encodeURIComponent("" + index) + "&";
        if (headerRowIndex === undefined || headerRowIndex === null)
            throw new Error("The parameter 'headerRowIndex' must be defined and cannot be null.");
        else
            url_ += "headerRowIndex=" + encodeURIComponent("" + headerRowIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetColumnsBySheetIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetColumnsBySheetIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorksheetHeaderResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorksheetHeaderResult>;
        }));
    }

    protected processGetColumnsBySheetIndex(response: HttpResponseBase): Observable<WorksheetHeaderResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorksheetHeaderResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param path Path to the workbook file.
     * @param worksheet Name of the worksheet (case-insensitive).
     * @param headerRow The row index where the header is located (1-based index).
     * @param startRow The row index to start calculations from (1-based index).
     * @param endRow The row index to stop calculations (1-based index).
     * @param includeEmpty (optional) Whether to include empty rows in calculations. Default: false.
     * @return Calculation results returned successfully as Rand currency.
     */
    calculateWorksheetData(path: string, worksheet: string, headerRow: number, startRow: number, endRow: number, includeEmpty: boolean | undefined): Observable<WorksheetCalculationResult> {
        let url_ = this.baseUrl + "/workbook/calculate?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined and cannot be null.");
        else
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        if (worksheet === undefined || worksheet === null)
            throw new Error("The parameter 'worksheet' must be defined and cannot be null.");
        else
            url_ += "worksheet=" + encodeURIComponent("" + worksheet) + "&";
        if (headerRow === undefined || headerRow === null)
            throw new Error("The parameter 'headerRow' must be defined and cannot be null.");
        else
            url_ += "headerRow=" + encodeURIComponent("" + headerRow) + "&";
        if (startRow === undefined || startRow === null)
            throw new Error("The parameter 'startRow' must be defined and cannot be null.");
        else
            url_ += "startRow=" + encodeURIComponent("" + startRow) + "&";
        if (endRow === undefined || endRow === null)
            throw new Error("The parameter 'endRow' must be defined and cannot be null.");
        else
            url_ += "endRow=" + encodeURIComponent("" + endRow) + "&";
        if (includeEmpty === null)
            throw new Error("The parameter 'includeEmpty' cannot be null.");
        else if (includeEmpty !== undefined)
            url_ += "includeEmpty=" + encodeURIComponent("" + includeEmpty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateWorksheetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateWorksheetData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorksheetCalculationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorksheetCalculationResult>;
        }));
    }

    protected processCalculateWorksheetData(response: HttpResponseBase): Observable<WorksheetCalculationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorksheetCalculationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

/** Represents the input required to mark an ageing batch as completed. */
export class CompleteAgeingBatchInput implements ICompleteAgeingBatchInput {
    /** The ID of the ageing batch to be completed. */
    batchId!: number;

    [key: string]: any;

    constructor(data?: ICompleteAgeingBatchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.batchId = _data["batchId"];
        }
    }

    static fromJS(data: any): CompleteAgeingBatchInput {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteAgeingBatchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["batchId"] = this.batchId;
        return data;
    }
}

/** Represents the input required to mark an ageing batch as completed. */
export interface ICompleteAgeingBatchInput {
    /** The ID of the ageing batch to be completed. */
    batchId: number;

    [key: string]: any;
}

export class CreateAgeingNoteInput implements ICreateAgeingNoteInput {
    noteId!: number;
    clientAreaId!: number;
    customerCode!: string;
    otherComments!: string;

    [key: string]: any;

    constructor(data?: ICreateAgeingNoteInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.noteId = _data["noteId"];
            this.clientAreaId = _data["clientAreaId"];
            this.customerCode = _data["customerCode"];
            this.otherComments = _data["otherComments"];
        }
    }

    static fromJS(data: any): CreateAgeingNoteInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAgeingNoteInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["noteId"] = this.noteId;
        data["clientAreaId"] = this.clientAreaId;
        data["customerCode"] = this.customerCode;
        data["otherComments"] = this.otherComments;
        return data;
    }
}

export interface ICreateAgeingNoteInput {
    noteId: number;
    clientAreaId: number;
    customerCode: string;
    otherComments: string;

    [key: string]: any;
}

export class AgeingRangeMappingInput implements IAgeingRangeMappingInput {
    headerIndex!: number;
    startIndex!: number;
    endIndex!: number;

    [key: string]: any;

    constructor(data?: IAgeingRangeMappingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.headerIndex = _data["headerIndex"];
            this.startIndex = _data["startIndex"];
            this.endIndex = _data["endIndex"];
        }
    }

    static fromJS(data: any): AgeingRangeMappingInput {
        data = typeof data === 'object' ? data : {};
        let result = new AgeingRangeMappingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["headerIndex"] = this.headerIndex;
        data["startIndex"] = this.startIndex;
        data["endIndex"] = this.endIndex;
        return data;
    }
}

export interface IAgeingRangeMappingInput {
    headerIndex: number;
    startIndex: number;
    endIndex: number;

    [key: string]: any;
}

export class AgeingWorksheetInput implements IAgeingWorksheetInput {
    clientAreaId!: number | undefined;
    importRangeMappingId!: number | undefined;
    worksheetName!: string;
    isSelected!: boolean;

    [key: string]: any;

    constructor(data?: IAgeingWorksheetInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.clientAreaId = _data["clientAreaId"];
            this.importRangeMappingId = _data["importRangeMappingId"];
            this.worksheetName = _data["worksheetName"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): AgeingWorksheetInput {
        data = typeof data === 'object' ? data : {};
        let result = new AgeingWorksheetInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["clientAreaId"] = this.clientAreaId;
        data["importRangeMappingId"] = this.importRangeMappingId;
        data["worksheetName"] = this.worksheetName;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IAgeingWorksheetInput {
    clientAreaId: number | undefined;
    importRangeMappingId: number | undefined;
    worksheetName: string;
    isSelected: boolean;

    [key: string]: any;
}

export class AgeingBatchByPeriodAndClientResult implements IAgeingBatchByPeriodAndClientResult {
    batchExists!: boolean;

    [key: string]: any;

    constructor(data?: IAgeingBatchByPeriodAndClientResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.batchExists = _data["batchExists"];
        }
    }

    static fromJS(data: any): AgeingBatchByPeriodAndClientResult {
        data = typeof data === 'object' ? data : {};
        let result = new AgeingBatchByPeriodAndClientResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["batchExists"] = this.batchExists;
        return data;
    }
}

export interface IAgeingBatchByPeriodAndClientResult {
    batchExists: boolean;

    [key: string]: any;
}

export class AgeingBatchResult implements IAgeingBatchResult {
    periodId!: number;
    clientId!: number;
    filePath!: string;
    fileName!: string;
    storedName!: string;
    isSpecializedImport!: boolean;
    isImported!: boolean;
    isCompleted!: boolean;

    [key: string]: any;

    constructor(data?: IAgeingBatchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.periodId = _data["periodId"];
            this.clientId = _data["clientId"];
            this.filePath = _data["filePath"];
            this.fileName = _data["fileName"];
            this.storedName = _data["storedName"];
            this.isSpecializedImport = _data["isSpecializedImport"];
            this.isImported = _data["isImported"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): AgeingBatchResult {
        data = typeof data === 'object' ? data : {};
        let result = new AgeingBatchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["periodId"] = this.periodId;
        data["clientId"] = this.clientId;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["storedName"] = this.storedName;
        data["isSpecializedImport"] = this.isSpecializedImport;
        data["isImported"] = this.isImported;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IAgeingBatchResult {
    periodId: number;
    clientId: number;
    filePath: string;
    fileName: string;
    storedName: string;
    isSpecializedImport: boolean;
    isImported: boolean;
    isCompleted: boolean;

    [key: string]: any;
}

export class PagingResult implements IPagingResult {
    pagingData!: PagingData;

    [key: string]: any;

    constructor(data?: IPagingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pagingData = _data["pagingData"] ? PagingData.fromJS(_data["pagingData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PagingResult {
        data = typeof data === 'object' ? data : {};
        let result = new PagingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pagingData"] = this.pagingData ? this.pagingData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagingResult {
    pagingData: PagingData;

    [key: string]: any;
}

export class AgeingBatchesResult extends PagingResult implements IAgeingBatchesResult {
    results!: AgeingBatchItem[];

    [key: string]: any;

    constructor(data?: IAgeingBatchesResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AgeingBatchItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AgeingBatchesResult {
        data = typeof data === 'object' ? data : {};
        let result = new AgeingBatchesResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAgeingBatchesResult extends IPagingResult {
    results: AgeingBatchItem[];

    [key: string]: any;
}

export class AgeingBatchItem implements IAgeingBatchItem {
    id!: number;
    createdAt!: string;
    fileName!: string;
    clientName!: string;
    period!: string;
    isCompleted!: boolean;

    [key: string]: any;

    constructor(data?: IAgeingBatchItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"];
            this.fileName = _data["fileName"];
            this.clientName = _data["clientName"];
            this.period = _data["period"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): AgeingBatchItem {
        data = typeof data === 'object' ? data : {};
        let result = new AgeingBatchItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt;
        data["fileName"] = this.fileName;
        data["clientName"] = this.clientName;
        data["period"] = this.period;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IAgeingBatchItem {
    id: number;
    createdAt: string;
    fileName: string;
    clientName: string;
    period: string;
    isCompleted: boolean;

    [key: string]: any;
}

export class AgeingDataResult implements IAgeingDataResult {
    id!: number;
    clientAreaId!: number;
    customerName!: string;
    customerCode!: string;
    customerRegistrationNumber!: string;
    note!: string;

    [key: string]: any;

    constructor(data?: IAgeingDataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.clientAreaId = _data["clientAreaId"];
            this.customerName = _data["customerName"];
            this.customerCode = _data["customerCode"];
            this.customerRegistrationNumber = _data["customerRegistrationNumber"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): AgeingDataResult {
        data = typeof data === 'object' ? data : {};
        let result = new AgeingDataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["clientAreaId"] = this.clientAreaId;
        data["customerName"] = this.customerName;
        data["customerCode"] = this.customerCode;
        data["customerRegistrationNumber"] = this.customerRegistrationNumber;
        data["note"] = this.note;
        return data;
    }
}

export interface IAgeingDataResult {
    id: number;
    clientAreaId: number;
    customerName: string;
    customerCode: string;
    customerRegistrationNumber: string;
    note: string;

    [key: string]: any;
}

export class AgeingRangeMappingResult implements IAgeingRangeMappingResult {
    worksheetName!: string;
    headerIndex!: number;
    startIndex!: number;
    endIndex!: number;

    [key: string]: any;

    constructor(data?: IAgeingRangeMappingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.worksheetName = _data["worksheetName"];
            this.headerIndex = _data["headerIndex"];
            this.startIndex = _data["startIndex"];
            this.endIndex = _data["endIndex"];
        }
    }

    static fromJS(data: any): AgeingRangeMappingResult {
        data = typeof data === 'object' ? data : {};
        let result = new AgeingRangeMappingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["worksheetName"] = this.worksheetName;
        data["headerIndex"] = this.headerIndex;
        data["startIndex"] = this.startIndex;
        data["endIndex"] = this.endIndex;
        return data;
    }
}

export interface IAgeingRangeMappingResult {
    worksheetName: string;
    headerIndex: number;
    startIndex: number;
    endIndex: number;

    [key: string]: any;
}

export class AgeingTotalsResult implements IAgeingTotalsResult {
    totalRowsImported!: number;
    balanceCurrent!: number;
    balance30Days!: number;
    balance60Days!: number;
    balance90Days!: number;
    balance120Days!: number;
    balance150Days!: number;
    balance180Days!: number;
    balanceOver180Days!: number;
    totalBalance!: number;
    clientAreaName!: string;

    [key: string]: any;

    constructor(data?: IAgeingTotalsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalRowsImported = _data["totalRowsImported"];
            this.balanceCurrent = _data["balanceCurrent"];
            this.balance30Days = _data["balance30Days"];
            this.balance60Days = _data["balance60Days"];
            this.balance90Days = _data["balance90Days"];
            this.balance120Days = _data["balance120Days"];
            this.balance150Days = _data["balance150Days"];
            this.balance180Days = _data["balance180Days"];
            this.balanceOver180Days = _data["balanceOver180Days"];
            this.totalBalance = _data["totalBalance"];
            this.clientAreaName = _data["clientAreaName"];
        }
    }

    static fromJS(data: any): AgeingTotalsResult {
        data = typeof data === 'object' ? data : {};
        let result = new AgeingTotalsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalRowsImported"] = this.totalRowsImported;
        data["balanceCurrent"] = this.balanceCurrent;
        data["balance30Days"] = this.balance30Days;
        data["balance60Days"] = this.balance60Days;
        data["balance90Days"] = this.balance90Days;
        data["balance120Days"] = this.balance120Days;
        data["balance150Days"] = this.balance150Days;
        data["balance180Days"] = this.balance180Days;
        data["balanceOver180Days"] = this.balanceOver180Days;
        data["totalBalance"] = this.totalBalance;
        data["clientAreaName"] = this.clientAreaName;
        return data;
    }
}

export interface IAgeingTotalsResult {
    totalRowsImported: number;
    balanceCurrent: number;
    balance30Days: number;
    balance60Days: number;
    balance90Days: number;
    balance120Days: number;
    balance150Days: number;
    balance180Days: number;
    balanceOver180Days: number;
    totalBalance: number;
    clientAreaName: string;

    [key: string]: any;
}

export class AgeingWorksheetSelectionResult implements IAgeingWorksheetSelectionResult {
    results!: AgeingWorksheetSelectionItem[];

    [key: string]: any;

    constructor(data?: IAgeingWorksheetSelectionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AgeingWorksheetSelectionItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgeingWorksheetSelectionResult {
        data = typeof data === 'object' ? data : {};
        let result = new AgeingWorksheetSelectionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgeingWorksheetSelectionResult {
    results: AgeingWorksheetSelectionItem[];

    [key: string]: any;
}

export class AgeingWorksheetSelectionItem implements IAgeingWorksheetSelectionItem {
    worksheet!: string;
    selected!: boolean;
    clientAreaId!: number | undefined;

    [key: string]: any;

    constructor(data?: IAgeingWorksheetSelectionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.worksheet = _data["worksheet"];
            this.selected = _data["selected"];
            this.clientAreaId = _data["clientAreaId"];
        }
    }

    static fromJS(data: any): AgeingWorksheetSelectionItem {
        data = typeof data === 'object' ? data : {};
        let result = new AgeingWorksheetSelectionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["worksheet"] = this.worksheet;
        data["selected"] = this.selected;
        data["clientAreaId"] = this.clientAreaId;
        return data;
    }
}

export interface IAgeingWorksheetSelectionItem {
    worksheet: string;
    selected: boolean;
    clientAreaId: number | undefined;

    [key: string]: any;
}

export class SampleAgeingDataResult implements ISampleAgeingDataResult {
    sampleRows!: SampleAgeingDataItem[];

    [key: string]: any;

    constructor(data?: ISampleAgeingDataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["sampleRows"])) {
                this.sampleRows = [] as any;
                for (let item of _data["sampleRows"])
                    this.sampleRows!.push(SampleAgeingDataItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SampleAgeingDataResult {
        data = typeof data === 'object' ? data : {};
        let result = new SampleAgeingDataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.sampleRows)) {
            data["sampleRows"] = [];
            for (let item of this.sampleRows)
                data["sampleRows"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISampleAgeingDataResult {
    sampleRows: SampleAgeingDataItem[];

    [key: string]: any;
}

export class SampleAgeingDataItem implements ISampleAgeingDataItem {
    id!: number;
    clientAreaId!: number;
    customerCode!: string;
    customerName!: string;
    customerRegistrationNumber!: string;
    policyReferenceNumber!: string;
    balance30Days!: number;
    balance60Days!: number;
    balance90Days!: number;
    balance120Days!: number;
    balance150Days!: number;
    balance180Days!: number;
    balanceOver180Days!: number;
    balanceCurrent!: number;
    total!: number;
    sales!: number;
    division!: string;
    noOfCustomers!: number;
    comment!: string;

    [key: string]: any;

    constructor(data?: ISampleAgeingDataItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.clientAreaId = _data["clientAreaId"];
            this.customerCode = _data["customerCode"];
            this.customerName = _data["customerName"];
            this.customerRegistrationNumber = _data["customerRegistrationNumber"];
            this.policyReferenceNumber = _data["policyReferenceNumber"];
            this.balance30Days = _data["balance30Days"];
            this.balance60Days = _data["balance60Days"];
            this.balance90Days = _data["balance90Days"];
            this.balance120Days = _data["balance120Days"];
            this.balance150Days = _data["balance150Days"];
            this.balance180Days = _data["balance180Days"];
            this.balanceOver180Days = _data["balanceOver180Days"];
            this.balanceCurrent = _data["balanceCurrent"];
            this.total = _data["total"];
            this.sales = _data["sales"];
            this.division = _data["division"];
            this.noOfCustomers = _data["noOfCustomers"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): SampleAgeingDataItem {
        data = typeof data === 'object' ? data : {};
        let result = new SampleAgeingDataItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["clientAreaId"] = this.clientAreaId;
        data["customerCode"] = this.customerCode;
        data["customerName"] = this.customerName;
        data["customerRegistrationNumber"] = this.customerRegistrationNumber;
        data["policyReferenceNumber"] = this.policyReferenceNumber;
        data["balance30Days"] = this.balance30Days;
        data["balance60Days"] = this.balance60Days;
        data["balance90Days"] = this.balance90Days;
        data["balance120Days"] = this.balance120Days;
        data["balance150Days"] = this.balance150Days;
        data["balance180Days"] = this.balance180Days;
        data["balanceOver180Days"] = this.balanceOver180Days;
        data["balanceCurrent"] = this.balanceCurrent;
        data["total"] = this.total;
        data["sales"] = this.sales;
        data["division"] = this.division;
        data["noOfCustomers"] = this.noOfCustomers;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ISampleAgeingDataItem {
    id: number;
    clientAreaId: number;
    customerCode: string;
    customerName: string;
    customerRegistrationNumber: string;
    policyReferenceNumber: string;
    balance30Days: number;
    balance60Days: number;
    balance90Days: number;
    balance120Days: number;
    balance150Days: number;
    balance180Days: number;
    balanceOver180Days: number;
    balanceCurrent: number;
    total: number;
    sales: number;
    division: string;
    noOfCustomers: number;
    comment: string;

    [key: string]: any;
}

export class UpdateAgeingDataInput implements IUpdateAgeingDataInput {
    customerName!: string;
    customerCode!: string;
    customerRegistrationNumber!: string;
    comment!: string;

    [key: string]: any;

    constructor(data?: IUpdateAgeingDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.customerName = _data["customerName"];
            this.customerCode = _data["customerCode"];
            this.customerRegistrationNumber = _data["customerRegistrationNumber"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UpdateAgeingDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAgeingDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["customerName"] = this.customerName;
        data["customerCode"] = this.customerCode;
        data["customerRegistrationNumber"] = this.customerRegistrationNumber;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpdateAgeingDataInput {
    customerName: string;
    customerCode: string;
    customerRegistrationNumber: string;
    comment: string;

    [key: string]: any;
}

/** Represents the input required to upload an ageing file. */
export class AgeingUploadFileInput implements IAgeingUploadFileInput {
    file!: string;
    periodId!: number;
    clientId!: number;

    [key: string]: any;

    constructor(data?: IAgeingUploadFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
            this.periodId = _data["periodId"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): AgeingUploadFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new AgeingUploadFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        data["periodId"] = this.periodId;
        data["clientId"] = this.clientId;
        return data;
    }
}

/** Represents the input required to upload an ageing file. */
export interface IAgeingUploadFileInput {
    file: string;
    periodId: number;
    clientId: number;

    [key: string]: any;
}

/** Represents the input required to mark an annexure batch as completed. */
export class CompleteAnnexureBatchInput implements ICompleteAnnexureBatchInput {
    /** The ID of the annexure batch to be completed. */
    batchId!: number;

    [key: string]: any;

    constructor(data?: ICompleteAnnexureBatchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.batchId = _data["batchId"];
        }
    }

    static fromJS(data: any): CompleteAnnexureBatchInput {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteAnnexureBatchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["batchId"] = this.batchId;
        return data;
    }
}

/** Represents the input required to mark an annexure batch as completed. */
export interface ICompleteAnnexureBatchInput {
    /** The ID of the annexure batch to be completed. */
    batchId: number;

    [key: string]: any;
}

export class AnnexureRangeMappingInput implements IAnnexureRangeMappingInput {
    headerIndex!: number;
    startIndex!: number;
    endIndex!: number;

    [key: string]: any;

    constructor(data?: IAnnexureRangeMappingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.headerIndex = _data["headerIndex"];
            this.startIndex = _data["startIndex"];
            this.endIndex = _data["endIndex"];
        }
    }

    static fromJS(data: any): AnnexureRangeMappingInput {
        data = typeof data === 'object' ? data : {};
        let result = new AnnexureRangeMappingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["headerIndex"] = this.headerIndex;
        data["startIndex"] = this.startIndex;
        data["endIndex"] = this.endIndex;
        return data;
    }
}

export interface IAnnexureRangeMappingInput {
    headerIndex: number;
    startIndex: number;
    endIndex: number;

    [key: string]: any;
}

export class AnnexureBatchResult implements IAnnexureBatchResult {
    periodId!: number;
    clientId!: number;
    clientAreaId!: number;
    insurerId!: number;
    filePath!: string;
    fileName!: string;
    storedName!: string;
    isImported!: boolean;
    isCompleted!: boolean;

    [key: string]: any;

    constructor(data?: IAnnexureBatchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.periodId = _data["periodId"];
            this.clientId = _data["clientId"];
            this.clientAreaId = _data["clientAreaId"];
            this.insurerId = _data["insurerId"];
            this.filePath = _data["filePath"];
            this.fileName = _data["fileName"];
            this.storedName = _data["storedName"];
            this.isImported = _data["isImported"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): AnnexureBatchResult {
        data = typeof data === 'object' ? data : {};
        let result = new AnnexureBatchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["periodId"] = this.periodId;
        data["clientId"] = this.clientId;
        data["clientAreaId"] = this.clientAreaId;
        data["insurerId"] = this.insurerId;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["storedName"] = this.storedName;
        data["isImported"] = this.isImported;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IAnnexureBatchResult {
    periodId: number;
    clientId: number;
    clientAreaId: number;
    insurerId: number;
    filePath: string;
    fileName: string;
    storedName: string;
    isImported: boolean;
    isCompleted: boolean;

    [key: string]: any;
}

export class AnnexureBatchesResult extends PagingResult implements IAnnexureBatchesResult {
    results!: AnnexureBatchesItem[];

    [key: string]: any;

    constructor(data?: IAnnexureBatchesResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AnnexureBatchesItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AnnexureBatchesResult {
        data = typeof data === 'object' ? data : {};
        let result = new AnnexureBatchesResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAnnexureBatchesResult extends IPagingResult {
    results: AnnexureBatchesItem[];

    [key: string]: any;
}

export class AnnexureBatchesItem implements IAnnexureBatchesItem {
    id!: number;
    createdAt!: string;
    updatedAt!: string;
    completedAt!: string;
    fileName!: string;
    clientName!: string;
    areaName!: string;
    insurerName!: string;
    period!: string;
    isCompleted!: boolean;

    [key: string]: any;

    constructor(data?: IAnnexureBatchesItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"];
            this.updatedAt = _data["updatedAt"];
            this.completedAt = _data["completedAt"];
            this.fileName = _data["fileName"];
            this.clientName = _data["clientName"];
            this.areaName = _data["areaName"];
            this.insurerName = _data["insurerName"];
            this.period = _data["period"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): AnnexureBatchesItem {
        data = typeof data === 'object' ? data : {};
        let result = new AnnexureBatchesItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt;
        data["updatedAt"] = this.updatedAt;
        data["completedAt"] = this.completedAt;
        data["fileName"] = this.fileName;
        data["clientName"] = this.clientName;
        data["areaName"] = this.areaName;
        data["insurerName"] = this.insurerName;
        data["period"] = this.period;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IAnnexureBatchesItem {
    id: number;
    createdAt: string;
    updatedAt: string;
    completedAt: string;
    fileName: string;
    clientName: string;
    areaName: string;
    insurerName: string;
    period: string;
    isCompleted: boolean;

    [key: string]: any;
}

export class AnnexureDataResult implements IAnnexureDataResult {
    id!: number;
    debtorName!: string;
    debtorCode!: string;
    policyReference!: string;
    debtorRegistrationNumber!: string;
    approvedLimit!: any;

    [key: string]: any;

    constructor(data?: IAnnexureDataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.debtorName = _data["debtorName"];
            this.debtorCode = _data["debtorCode"];
            this.policyReference = _data["policyReference"];
            this.debtorRegistrationNumber = _data["debtorRegistrationNumber"];
            this.approvedLimit = _data["approvedLimit"];
        }
    }

    static fromJS(data: any): AnnexureDataResult {
        data = typeof data === 'object' ? data : {};
        let result = new AnnexureDataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["debtorName"] = this.debtorName;
        data["debtorCode"] = this.debtorCode;
        data["policyReference"] = this.policyReference;
        data["debtorRegistrationNumber"] = this.debtorRegistrationNumber;
        data["approvedLimit"] = this.approvedLimit;
        return data;
    }
}

export interface IAnnexureDataResult {
    id: number;
    debtorName: string;
    debtorCode: string;
    policyReference: string;
    debtorRegistrationNumber: string;
    approvedLimit: any;

    [key: string]: any;
}

export class AnnexureRangeMappingResult implements IAnnexureRangeMappingResult {
    id!: number;
    headerIndex!: number;
    startIndex!: number;
    endIndex!: number;

    [key: string]: any;

    constructor(data?: IAnnexureRangeMappingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.headerIndex = _data["headerIndex"];
            this.startIndex = _data["startIndex"];
            this.endIndex = _data["endIndex"];
        }
    }

    static fromJS(data: any): AnnexureRangeMappingResult {
        data = typeof data === 'object' ? data : {};
        let result = new AnnexureRangeMappingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["headerIndex"] = this.headerIndex;
        data["startIndex"] = this.startIndex;
        data["endIndex"] = this.endIndex;
        return data;
    }
}

export interface IAnnexureRangeMappingResult {
    id: number;
    headerIndex: number;
    startIndex: number;
    endIndex: number;

    [key: string]: any;
}

export class AnnexureTotalsResult implements IAnnexureTotalsResult {
    totalRowsImported!: number;
    totalLimitRequested!: number;
    totalLimitApproved!: number;
    approvedPercentage!: any;

    [key: string]: any;

    constructor(data?: IAnnexureTotalsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalRowsImported = _data["totalRowsImported"];
            this.totalLimitRequested = _data["totalLimitRequested"];
            this.totalLimitApproved = _data["totalLimitApproved"];
            this.approvedPercentage = _data["approvedPercentage"];
        }
    }

    static fromJS(data: any): AnnexureTotalsResult {
        data = typeof data === 'object' ? data : {};
        let result = new AnnexureTotalsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalRowsImported"] = this.totalRowsImported;
        data["totalLimitRequested"] = this.totalLimitRequested;
        data["totalLimitApproved"] = this.totalLimitApproved;
        data["approvedPercentage"] = this.approvedPercentage;
        return data;
    }
}

export interface IAnnexureTotalsResult {
    totalRowsImported: number;
    totalLimitRequested: number;
    totalLimitApproved: number;
    approvedPercentage: any;

    [key: string]: any;
}

export class SampleAnnexureDataResult implements ISampleAnnexureDataResult {
    sampleRows!: SampleAnnexureDataItem[];

    [key: string]: any;

    constructor(data?: ISampleAnnexureDataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["sampleRows"])) {
                this.sampleRows = [] as any;
                for (let item of _data["sampleRows"])
                    this.sampleRows!.push(SampleAnnexureDataItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SampleAnnexureDataResult {
        data = typeof data === 'object' ? data : {};
        let result = new SampleAnnexureDataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.sampleRows)) {
            data["sampleRows"] = [];
            for (let item of this.sampleRows)
                data["sampleRows"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISampleAnnexureDataResult {
    sampleRows: SampleAnnexureDataItem[];

    [key: string]: any;
}

export class SampleAnnexureDataItem implements ISampleAnnexureDataItem {
    id!: number;
    clientId!: number;
    clientAreaId!: number;
    debtorCode!: string;
    debtorName!: string;
    debtorTradeName!: string;
    debtorCountry!: string;
    debtorRegistrationNumber!: string;
    requestedLimit!: number;
    approvedLimit!: number;
    annexure!: string;
    specialConditions!: string;
    paymentTerms!: string;
    policyReference!: string;
    policyNumber!: string;
    comments!: string;
    grantedDate!: string;
    inceptionDate!: string;
    noOfCustomers!: number;
    currency!: string;

    [key: string]: any;

    constructor(data?: ISampleAnnexureDataItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.clientAreaId = _data["clientAreaId"];
            this.debtorCode = _data["debtorCode"];
            this.debtorName = _data["debtorName"];
            this.debtorTradeName = _data["debtorTradeName"];
            this.debtorCountry = _data["debtorCountry"];
            this.debtorRegistrationNumber = _data["debtorRegistrationNumber"];
            this.requestedLimit = _data["requestedLimit"];
            this.approvedLimit = _data["approvedLimit"];
            this.annexure = _data["annexure"];
            this.specialConditions = _data["specialConditions"];
            this.paymentTerms = _data["paymentTerms"];
            this.policyReference = _data["policyReference"];
            this.policyNumber = _data["policyNumber"];
            this.comments = _data["comments"];
            this.grantedDate = _data["grantedDate"];
            this.inceptionDate = _data["inceptionDate"];
            this.noOfCustomers = _data["noOfCustomers"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): SampleAnnexureDataItem {
        data = typeof data === 'object' ? data : {};
        let result = new SampleAnnexureDataItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["clientAreaId"] = this.clientAreaId;
        data["debtorCode"] = this.debtorCode;
        data["debtorName"] = this.debtorName;
        data["debtorTradeName"] = this.debtorTradeName;
        data["debtorCountry"] = this.debtorCountry;
        data["debtorRegistrationNumber"] = this.debtorRegistrationNumber;
        data["requestedLimit"] = this.requestedLimit;
        data["approvedLimit"] = this.approvedLimit;
        data["annexure"] = this.annexure;
        data["specialConditions"] = this.specialConditions;
        data["paymentTerms"] = this.paymentTerms;
        data["policyReference"] = this.policyReference;
        data["policyNumber"] = this.policyNumber;
        data["comments"] = this.comments;
        data["grantedDate"] = this.grantedDate;
        data["inceptionDate"] = this.inceptionDate;
        data["noOfCustomers"] = this.noOfCustomers;
        data["currency"] = this.currency;
        return data;
    }
}

export interface ISampleAnnexureDataItem {
    id: number;
    clientId: number;
    clientAreaId: number;
    debtorCode: string;
    debtorName: string;
    debtorTradeName: string;
    debtorCountry: string;
    debtorRegistrationNumber: string;
    requestedLimit: number;
    approvedLimit: number;
    annexure: string;
    specialConditions: string;
    paymentTerms: string;
    policyReference: string;
    policyNumber: string;
    comments: string;
    grantedDate: string;
    inceptionDate: string;
    noOfCustomers: number;
    currency: string;

    [key: string]: any;
}

export class UpdateAnnexureDataInput implements IUpdateAnnexureDataInput {
    debtorName!: string;
    debtorCode!: string;
    policyReference!: string;
    debtorRegistrationNumber!: string;
    approvedLimit!: any;

    [key: string]: any;

    constructor(data?: IUpdateAnnexureDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.debtorName = _data["debtorName"];
            this.debtorCode = _data["debtorCode"];
            this.policyReference = _data["policyReference"];
            this.debtorRegistrationNumber = _data["debtorRegistrationNumber"];
            this.approvedLimit = _data["approvedLimit"];
        }
    }

    static fromJS(data: any): UpdateAnnexureDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAnnexureDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["debtorName"] = this.debtorName;
        data["debtorCode"] = this.debtorCode;
        data["policyReference"] = this.policyReference;
        data["debtorRegistrationNumber"] = this.debtorRegistrationNumber;
        data["approvedLimit"] = this.approvedLimit;
        return data;
    }
}

export interface IUpdateAnnexureDataInput {
    debtorName: string;
    debtorCode: string;
    policyReference: string;
    debtorRegistrationNumber: string;
    approvedLimit: any;

    [key: string]: any;
}

/** Represents the input required to upload an annexure file. */
export class AnnexureUploadFileInput implements IAnnexureUploadFileInput {
    file!: string;
    periodId!: number;
    insurerId!: number;
    /** Optional. Required only if the selected insurer has importAreaMandatory = true. */
    clientId!: number | undefined;
    /** Optional. Required only if the selected insurer has importAreaMandatory = true. */
    clientAreaId!: number | undefined;

    [key: string]: any;

    constructor(data?: IAnnexureUploadFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
            this.periodId = _data["periodId"];
            this.insurerId = _data["insurerId"];
            this.clientId = _data["clientId"];
            this.clientAreaId = _data["clientAreaId"];
        }
    }

    static fromJS(data: any): AnnexureUploadFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new AnnexureUploadFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        data["periodId"] = this.periodId;
        data["insurerId"] = this.insurerId;
        data["clientId"] = this.clientId;
        data["clientAreaId"] = this.clientAreaId;
        return data;
    }
}

/** Represents the input required to upload an annexure file. */
export interface IAnnexureUploadFileInput {
    file: string;
    periodId: number;
    insurerId: number;
    /** Optional. Required only if the selected insurer has importAreaMandatory = true. */
    clientId: number | undefined;
    /** Optional. Required only if the selected insurer has importAreaMandatory = true. */
    clientAreaId: number | undefined;

    [key: string]: any;
}

export class FilteredAuditErrorsResult extends PagingResult implements IFilteredAuditErrorsResult {
    results!: FilteredAuditErrorItem[];

    [key: string]: any;

    constructor(data?: IFilteredAuditErrorsResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FilteredAuditErrorItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FilteredAuditErrorsResult {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredAuditErrorsResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFilteredAuditErrorsResult extends IPagingResult {
    results: FilteredAuditErrorItem[];

    [key: string]: any;
}

export class FilteredAuditErrorItem implements IFilteredAuditErrorItem {
    requestId!: string;
    error!: string;
    createdAt!: string;

    [key: string]: any;

    constructor(data?: IFilteredAuditErrorItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.requestId = _data["requestId"];
            this.error = _data["error"];
            this.createdAt = _data["createdAt"];
        }
    }

    static fromJS(data: any): FilteredAuditErrorItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredAuditErrorItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["requestId"] = this.requestId;
        data["error"] = this.error;
        data["createdAt"] = this.createdAt;
        return data;
    }
}

export interface IFilteredAuditErrorItem {
    requestId: string;
    error: string;
    createdAt: string;

    [key: string]: any;
}

export class FilteredAuditLogsResult extends PagingResult implements IFilteredAuditLogsResult {
    results!: FilteredAuditLogItem[];

    [key: string]: any;

    constructor(data?: IFilteredAuditLogsResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FilteredAuditLogItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FilteredAuditLogsResult {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredAuditLogsResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFilteredAuditLogsResult extends IPagingResult {
    results: FilteredAuditLogItem[];

    [key: string]: any;
}

export class FilteredAuditLogItem implements IFilteredAuditLogItem {
    requestId!: string;
    requestEmail!: string;
    method!: string;
    requestedUrl!: string;
    refererUrl!: string;
    requestedAt!: string;
    responseTime!: number;
    numberOfErrors!: number;

    [key: string]: any;

    constructor(data?: IFilteredAuditLogItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.requestId = _data["requestId"];
            this.requestEmail = _data["requestEmail"];
            this.method = _data["method"];
            this.requestedUrl = _data["requestedUrl"];
            this.refererUrl = _data["refererUrl"];
            this.requestedAt = _data["requestedAt"];
            this.responseTime = _data["responseTime"];
            this.numberOfErrors = _data["numberOfErrors"];
        }
    }

    static fromJS(data: any): FilteredAuditLogItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredAuditLogItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["requestId"] = this.requestId;
        data["requestEmail"] = this.requestEmail;
        data["method"] = this.method;
        data["requestedUrl"] = this.requestedUrl;
        data["refererUrl"] = this.refererUrl;
        data["requestedAt"] = this.requestedAt;
        data["responseTime"] = this.responseTime;
        data["numberOfErrors"] = this.numberOfErrors;
        return data;
    }
}

export interface IFilteredAuditLogItem {
    requestId: string;
    requestEmail: string;
    method: string;
    requestedUrl: string;
    refererUrl: string;
    requestedAt: string;
    responseTime: number;
    numberOfErrors: number;

    [key: string]: any;
}

export class FilteredAuditRequestsResult extends PagingResult implements IFilteredAuditRequestsResult {
    results!: FilteredAuditRequestItem[];

    [key: string]: any;

    constructor(data?: IFilteredAuditRequestsResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FilteredAuditRequestItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FilteredAuditRequestsResult {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredAuditRequestsResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFilteredAuditRequestsResult extends IPagingResult {
    results: FilteredAuditRequestItem[];

    [key: string]: any;
}

export class FilteredAuditRequestItem implements IFilteredAuditRequestItem {
    requestId!: string;
    requestEmail!: string;
    requestedUrl!: string;
    refererUrl!: string;
    accepts!: string;
    createdAt!: string;

    [key: string]: any;

    constructor(data?: IFilteredAuditRequestItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.requestId = _data["requestId"];
            this.requestEmail = _data["requestEmail"];
            this.requestedUrl = _data["requestedUrl"];
            this.refererUrl = _data["refererUrl"];
            this.accepts = _data["accepts"];
            this.createdAt = _data["createdAt"];
        }
    }

    static fromJS(data: any): FilteredAuditRequestItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredAuditRequestItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["requestId"] = this.requestId;
        data["requestEmail"] = this.requestEmail;
        data["requestedUrl"] = this.requestedUrl;
        data["refererUrl"] = this.refererUrl;
        data["accepts"] = this.accepts;
        data["createdAt"] = this.createdAt;
        return data;
    }
}

export interface IFilteredAuditRequestItem {
    requestId: string;
    requestEmail: string;
    requestedUrl: string;
    refererUrl: string;
    accepts: string;
    createdAt: string;

    [key: string]: any;
}

export class FilteredAuditResponsesResult extends PagingResult implements IFilteredAuditResponsesResult {
    results!: FilteredAuditResponseItem[];

    [key: string]: any;

    constructor(data?: IFilteredAuditResponsesResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FilteredAuditResponseItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FilteredAuditResponsesResult {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredAuditResponsesResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFilteredAuditResponsesResult extends IPagingResult {
    results: FilteredAuditResponseItem[];

    [key: string]: any;
}

export class FilteredAuditResponseItem implements IFilteredAuditResponseItem {
    requestId!: string;
    status!: string;
    contentType!: string;
    createdAt!: string;

    [key: string]: any;

    constructor(data?: IFilteredAuditResponseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.requestId = _data["requestId"];
            this.status = _data["status"];
            this.contentType = _data["contentType"];
            this.createdAt = _data["createdAt"];
        }
    }

    static fromJS(data: any): FilteredAuditResponseItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredAuditResponseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["requestId"] = this.requestId;
        data["status"] = this.status;
        data["contentType"] = this.contentType;
        data["createdAt"] = this.createdAt;
        return data;
    }
}

export interface IFilteredAuditResponseItem {
    requestId: string;
    status: string;
    contentType: string;
    createdAt: string;

    [key: string]: any;
}

export class AllReportsResult implements IAllReportsResult {
    results!: AllReportItem[];

    [key: string]: any;

    constructor(data?: IAllReportsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AllReportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllReportsResult {
        data = typeof data === 'object' ? data : {};
        let result = new AllReportsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAllReportsResult {
    results: AllReportItem[];

    [key: string]: any;
}

export class AllReportItem implements IAllReportItem {
    id!: number;
    reportName!: string;
    isActive!: boolean;

    [key: string]: any;

    constructor(data?: IAllReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.reportName = _data["reportName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AllReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new AllReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["reportName"] = this.reportName;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IAllReportItem {
    id: number;
    reportName: string;
    isActive: boolean;

    [key: string]: any;
}

export class CreateClientAreaInput implements ICreateClientAreaInput {
    areaName!: string;
    policyNumber!: string;
    inceptionDate!: string;
    insurerId!: number;
    policyBase!: string;
    policyGroup!: string;
    industryId!: number;
    clientId!: number;
    isForeignCurrency!: boolean;
    allBuyersPrincipleApplicable!: boolean;
    buyersExcluded!: boolean;
    doDeclaration!: boolean;
    ageingIncludesVat!: boolean;
    salesIncludesVat!: boolean;

    [key: string]: any;

    constructor(data?: ICreateClientAreaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.areaName = _data["areaName"];
            this.policyNumber = _data["policyNumber"];
            this.inceptionDate = _data["inceptionDate"];
            this.insurerId = _data["insurerId"];
            this.policyBase = _data["policyBase"];
            this.policyGroup = _data["policyGroup"];
            this.industryId = _data["industryId"];
            this.clientId = _data["clientId"];
            this.isForeignCurrency = _data["isForeignCurrency"];
            this.allBuyersPrincipleApplicable = _data["allBuyersPrincipleApplicable"];
            this.buyersExcluded = _data["buyersExcluded"];
            this.doDeclaration = _data["doDeclaration"];
            this.ageingIncludesVat = _data["ageingIncludesVat"];
            this.salesIncludesVat = _data["salesIncludesVat"];
        }
    }

    static fromJS(data: any): CreateClientAreaInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientAreaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["areaName"] = this.areaName;
        data["policyNumber"] = this.policyNumber;
        data["inceptionDate"] = this.inceptionDate;
        data["insurerId"] = this.insurerId;
        data["policyBase"] = this.policyBase;
        data["policyGroup"] = this.policyGroup;
        data["industryId"] = this.industryId;
        data["clientId"] = this.clientId;
        data["isForeignCurrency"] = this.isForeignCurrency;
        data["allBuyersPrincipleApplicable"] = this.allBuyersPrincipleApplicable;
        data["buyersExcluded"] = this.buyersExcluded;
        data["doDeclaration"] = this.doDeclaration;
        data["ageingIncludesVat"] = this.ageingIncludesVat;
        data["salesIncludesVat"] = this.salesIncludesVat;
        return data;
    }
}

export interface ICreateClientAreaInput {
    areaName: string;
    policyNumber: string;
    inceptionDate: string;
    insurerId: number;
    policyBase: string;
    policyGroup: string;
    industryId: number;
    clientId: number;
    isForeignCurrency: boolean;
    allBuyersPrincipleApplicable: boolean;
    buyersExcluded: boolean;
    doDeclaration: boolean;
    ageingIncludesVat: boolean;
    salesIncludesVat: boolean;

    [key: string]: any;
}

export class AllClientAreasResult extends PagingResult implements IAllClientAreasResult {
    results!: AllClientAreaItem[];

    [key: string]: any;

    constructor(data?: IAllClientAreasResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AllClientAreaItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AllClientAreasResult {
        data = typeof data === 'object' ? data : {};
        let result = new AllClientAreasResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAllClientAreasResult extends IPagingResult {
    results: AllClientAreaItem[];

    [key: string]: any;
}

export class AllClientAreaItem implements IAllClientAreaItem {
    id!: number;
    areaName!: string;

    [key: string]: any;

    constructor(data?: IAllClientAreaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.areaName = _data["areaName"];
        }
    }

    static fromJS(data: any): AllClientAreaItem {
        data = typeof data === 'object' ? data : {};
        let result = new AllClientAreaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["areaName"] = this.areaName;
        return data;
    }
}

export interface IAllClientAreaItem {
    id: number;
    areaName: string;

    [key: string]: any;
}

export class OptionalReportsResult implements IOptionalReportsResult {
    results!: OptionalReportItem[];

    [key: string]: any;

    constructor(data?: IOptionalReportsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(OptionalReportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OptionalReportsResult {
        data = typeof data === 'object' ? data : {};
        let result = new OptionalReportsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOptionalReportsResult {
    results: OptionalReportItem[];

    [key: string]: any;
}

export class OptionalReportItem implements IOptionalReportItem {
    id!: number;
    reportName!: string;
    isSelected!: boolean;

    [key: string]: any;

    constructor(data?: IOptionalReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.reportName = _data["reportName"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): OptionalReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new OptionalReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["reportName"] = this.reportName;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IOptionalReportItem {
    id: number;
    reportName: string;
    isSelected: boolean;

    [key: string]: any;
}

export class ClientAreaByIdResult implements IClientAreaByIdResult {
    id!: number;
    clientId!: number;
    areaName!: string;
    policyNumber!: string;
    inceptionDate!: Date;
    insurerId!: number;
    policyBase!: string;
    policyGroup!: string;
    industryId!: string;
    ageingIncludesVat!: boolean;
    salesIncludesVat!: boolean;

    [key: string]: any;

    constructor(data?: IClientAreaByIdResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.areaName = _data["areaName"];
            this.policyNumber = _data["policyNumber"];
            this.inceptionDate = _data["inceptionDate"] ? new Date(_data["inceptionDate"].toString()) : <any>undefined;
            this.insurerId = _data["insurerId"];
            this.policyBase = _data["policyBase"];
            this.policyGroup = _data["policyGroup"];
            this.industryId = _data["industryId"];
            this.ageingIncludesVat = _data["ageingIncludesVat"];
            this.salesIncludesVat = _data["salesIncludesVat"];
        }
    }

    static fromJS(data: any): ClientAreaByIdResult {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAreaByIdResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["areaName"] = this.areaName;
        data["policyNumber"] = this.policyNumber;
        data["inceptionDate"] = this.inceptionDate ? this.inceptionDate.toISOString() : <any>undefined;
        data["insurerId"] = this.insurerId;
        data["policyBase"] = this.policyBase;
        data["policyGroup"] = this.policyGroup;
        data["industryId"] = this.industryId;
        data["ageingIncludesVat"] = this.ageingIncludesVat;
        data["salesIncludesVat"] = this.salesIncludesVat;
        return data;
    }
}

export interface IClientAreaByIdResult {
    id: number;
    clientId: number;
    areaName: string;
    policyNumber: string;
    inceptionDate: Date;
    insurerId: number;
    policyBase: string;
    policyGroup: string;
    industryId: string;
    ageingIncludesVat: boolean;
    salesIncludesVat: boolean;

    [key: string]: any;
}

export class ActiveReportsResult extends PagingResult implements IActiveReportsResult {
    results!: ActiveReportItem[];

    [key: string]: any;

    constructor(data?: IActiveReportsResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ActiveReportItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ActiveReportsResult {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveReportsResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IActiveReportsResult extends IPagingResult {
    results: ActiveReportItem[];

    [key: string]: any;
}

export class ActiveReportItem implements IActiveReportItem {
    id!: number;
    reportName!: string;
    linkName!: string;
    isRequired!: boolean;

    [key: string]: any;

    constructor(data?: IActiveReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.reportName = _data["reportName"];
            this.linkName = _data["linkName"];
            this.isRequired = _data["isRequired"];
        }
    }

    static fromJS(data: any): ActiveReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["reportName"] = this.reportName;
        data["linkName"] = this.linkName;
        data["isRequired"] = this.isRequired;
        return data;
    }
}

export interface IActiveReportItem {
    id: number;
    reportName: string;
    linkName: string;
    isRequired: boolean;

    [key: string]: any;
}

export class EndorsementsByClientAreaIdResult extends PagingResult implements IEndorsementsByClientAreaIdResult {
    results!: EndorsementByClientAreaIdItem[];

    [key: string]: any;

    constructor(data?: IEndorsementsByClientAreaIdResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(EndorsementByClientAreaIdItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EndorsementsByClientAreaIdResult {
        data = typeof data === 'object' ? data : {};
        let result = new EndorsementsByClientAreaIdResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEndorsementsByClientAreaIdResult extends IPagingResult {
    results: EndorsementByClientAreaIdItem[];

    [key: string]: any;
}

export class EndorsementByClientAreaIdItem implements IEndorsementByClientAreaIdItem {
    id!: number;
    endorsementType!: string;
    values!: string;
    effectiveDate!: string;
    expiryDate!: string;

    [key: string]: any;

    constructor(data?: IEndorsementByClientAreaIdItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.endorsementType = _data["endorsementType"];
            this.values = _data["values"];
            this.effectiveDate = _data["effectiveDate"];
            this.expiryDate = _data["expiryDate"];
        }
    }

    static fromJS(data: any): EndorsementByClientAreaIdItem {
        data = typeof data === 'object' ? data : {};
        let result = new EndorsementByClientAreaIdItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["endorsementType"] = this.endorsementType;
        data["values"] = this.values;
        data["effectiveDate"] = this.effectiveDate;
        data["expiryDate"] = this.expiryDate;
        return data;
    }
}

export interface IEndorsementByClientAreaIdItem {
    id: number;
    endorsementType: string;
    values: string;
    effectiveDate: string;
    expiryDate: string;

    [key: string]: any;
}

export class UpdateClientAreaGroupsInput implements IUpdateClientAreaGroupsInput {
    /** List of selected report IDs */
    reportIds!: number[];

    [key: string]: any;

    constructor(data?: IUpdateClientAreaGroupsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reportIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["reportIds"])) {
                this.reportIds = [] as any;
                for (let item of _data["reportIds"])
                    this.reportIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateClientAreaGroupsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientAreaGroupsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.reportIds)) {
            data["reportIds"] = [];
            for (let item of this.reportIds)
                data["reportIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateClientAreaGroupsInput {
    /** List of selected report IDs */
    reportIds: number[];

    [key: string]: any;
}

export class UpdateClientAreaInput implements IUpdateClientAreaInput {
    areaName!: string;
    policyNumber!: string;
    inceptionDate!: Date;
    insurerId!: number;
    policyBase!: string;
    policyGroup!: string;
    industryId!: number;
    clientId!: number;
    isForeignCurrency!: boolean;
    allBuyersPrincipleApplicable!: boolean;
    buyersExcluded!: boolean;
    doDeclaration!: boolean;
    ageingIncludesVat!: boolean;
    salesIncludesVat!: boolean;
    policyGroupId!: number;

    [key: string]: any;

    constructor(data?: IUpdateClientAreaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.areaName = _data["areaName"];
            this.policyNumber = _data["policyNumber"];
            this.inceptionDate = _data["inceptionDate"] ? new Date(_data["inceptionDate"].toString()) : <any>undefined;
            this.insurerId = _data["insurerId"];
            this.policyBase = _data["policyBase"];
            this.policyGroup = _data["policyGroup"];
            this.industryId = _data["industryId"];
            this.clientId = _data["clientId"];
            this.isForeignCurrency = _data["isForeignCurrency"];
            this.allBuyersPrincipleApplicable = _data["allBuyersPrincipleApplicable"];
            this.buyersExcluded = _data["buyersExcluded"];
            this.doDeclaration = _data["doDeclaration"];
            this.ageingIncludesVat = _data["ageingIncludesVat"];
            this.salesIncludesVat = _data["salesIncludesVat"];
            this.policyGroupId = _data["policyGroupId"];
        }
    }

    static fromJS(data: any): UpdateClientAreaInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientAreaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["areaName"] = this.areaName;
        data["policyNumber"] = this.policyNumber;
        data["inceptionDate"] = this.inceptionDate ? formatDate(this.inceptionDate) : <any>undefined;
        data["insurerId"] = this.insurerId;
        data["policyBase"] = this.policyBase;
        data["policyGroup"] = this.policyGroup;
        data["industryId"] = this.industryId;
        data["clientId"] = this.clientId;
        data["isForeignCurrency"] = this.isForeignCurrency;
        data["allBuyersPrincipleApplicable"] = this.allBuyersPrincipleApplicable;
        data["buyersExcluded"] = this.buyersExcluded;
        data["doDeclaration"] = this.doDeclaration;
        data["ageingIncludesVat"] = this.ageingIncludesVat;
        data["salesIncludesVat"] = this.salesIncludesVat;
        data["policyGroupId"] = this.policyGroupId;
        return data;
    }
}

export interface IUpdateClientAreaInput {
    areaName: string;
    policyNumber: string;
    inceptionDate: Date;
    insurerId: number;
    policyBase: string;
    policyGroup: string;
    industryId: number;
    clientId: number;
    isForeignCurrency: boolean;
    allBuyersPrincipleApplicable: boolean;
    buyersExcluded: boolean;
    doDeclaration: boolean;
    ageingIncludesVat: boolean;
    salesIncludesVat: boolean;
    policyGroupId: number;

    [key: string]: any;
}

export class UpdateClientAreaReportsInput implements IUpdateClientAreaReportsInput {
    /** List of selected report IDs */
    reportIds!: number[];

    [key: string]: any;

    constructor(data?: IUpdateClientAreaReportsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reportIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["reportIds"])) {
                this.reportIds = [] as any;
                for (let item of _data["reportIds"])
                    this.reportIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateClientAreaReportsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientAreaReportsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.reportIds)) {
            data["reportIds"] = [];
            for (let item of this.reportIds)
                data["reportIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateClientAreaReportsInput {
    /** List of selected report IDs */
    reportIds: number[];

    [key: string]: any;
}

export class CreateClientInput implements ICreateClientInput {
    clientName!: string;
    registrationNumber!: string;
    countryId!: number;

    [key: string]: any;

    constructor(data?: ICreateClientInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.clientName = _data["clientName"];
            this.registrationNumber = _data["registrationNumber"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): CreateClientInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["clientName"] = this.clientName;
        data["registrationNumber"] = this.registrationNumber;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface ICreateClientInput {
    clientName: string;
    registrationNumber: string;
    countryId: number;

    [key: string]: any;
}

export class AllClientsResult extends PagingResult implements IAllClientsResult {
    results!: AllClientItem[];

    [key: string]: any;

    constructor(data?: IAllClientsResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AllClientItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AllClientsResult {
        data = typeof data === 'object' ? data : {};
        let result = new AllClientsResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAllClientsResult extends IPagingResult {
    results: AllClientItem[];

    [key: string]: any;
}

export class AllClientItem implements IAllClientItem {
    id!: number;
    clientName!: string;

    [key: string]: any;

    constructor(data?: IAllClientItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.clientName = _data["clientName"];
        }
    }

    static fromJS(data: any): AllClientItem {
        data = typeof data === 'object' ? data : {};
        let result = new AllClientItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["clientName"] = this.clientName;
        return data;
    }
}

export interface IAllClientItem {
    id: number;
    clientName: string;

    [key: string]: any;
}

export class ClientAreasByClientIdResult extends PagingResult implements IClientAreasByClientIdResult {
    results!: ClientAreaByClientIdItem[];

    [key: string]: any;

    constructor(data?: IClientAreasByClientIdResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ClientAreaByClientIdItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ClientAreasByClientIdResult {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAreasByClientIdResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IClientAreasByClientIdResult extends IPagingResult {
    results: ClientAreaByClientIdItem[];

    [key: string]: any;
}

export class ClientAreaByClientIdItem implements IClientAreaByClientIdItem {
    id!: number;
    areaName!: string;
    policyNumber!: string;
    inceptionDate!: string;
    insurerId!: number;
    insurerName!: string;
    policyBase!: string;
    policyGroup!: string;
    industryId!: number;
    description!: string;
    ageingIncludesVat!: boolean;
    salesIncludesVat!: boolean;

    [key: string]: any;

    constructor(data?: IClientAreaByClientIdItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.areaName = _data["areaName"];
            this.policyNumber = _data["policyNumber"];
            this.inceptionDate = _data["inceptionDate"];
            this.insurerId = _data["insurerId"];
            this.insurerName = _data["insurerName"];
            this.policyBase = _data["policyBase"];
            this.policyGroup = _data["policyGroup"];
            this.industryId = _data["industryId"];
            this.description = _data["description"];
            this.ageingIncludesVat = _data["ageingIncludesVat"];
            this.salesIncludesVat = _data["salesIncludesVat"];
        }
    }

    static fromJS(data: any): ClientAreaByClientIdItem {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAreaByClientIdItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["areaName"] = this.areaName;
        data["policyNumber"] = this.policyNumber;
        data["inceptionDate"] = this.inceptionDate;
        data["insurerId"] = this.insurerId;
        data["insurerName"] = this.insurerName;
        data["policyBase"] = this.policyBase;
        data["policyGroup"] = this.policyGroup;
        data["industryId"] = this.industryId;
        data["description"] = this.description;
        data["ageingIncludesVat"] = this.ageingIncludesVat;
        data["salesIncludesVat"] = this.salesIncludesVat;
        return data;
    }
}

export interface IClientAreaByClientIdItem {
    id: number;
    areaName: string;
    policyNumber: string;
    inceptionDate: string;
    insurerId: number;
    insurerName: string;
    policyBase: string;
    policyGroup: string;
    industryId: number;
    description: string;
    ageingIncludesVat: boolean;
    salesIncludesVat: boolean;

    [key: string]: any;
}

export class ClientByIdResult implements IClientByIdResult {
    id!: number;
    country!: number;
    clientName!: string;
    tradingName!: string;
    telephoneNumber!: string;
    contactPerson!: string;
    clientEmail!: string;
    consultantEmail!: string;
    registrationNumber!: string;

    [key: string]: any;

    constructor(data?: IClientByIdResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.country = _data["country"];
            this.clientName = _data["clientName"];
            this.tradingName = _data["tradingName"];
            this.telephoneNumber = _data["telephoneNumber"];
            this.contactPerson = _data["contactPerson"];
            this.clientEmail = _data["clientEmail"];
            this.consultantEmail = _data["consultantEmail"];
            this.registrationNumber = _data["registrationNumber"];
        }
    }

    static fromJS(data: any): ClientByIdResult {
        data = typeof data === 'object' ? data : {};
        let result = new ClientByIdResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["country"] = this.country;
        data["clientName"] = this.clientName;
        data["tradingName"] = this.tradingName;
        data["telephoneNumber"] = this.telephoneNumber;
        data["contactPerson"] = this.contactPerson;
        data["clientEmail"] = this.clientEmail;
        data["consultantEmail"] = this.consultantEmail;
        data["registrationNumber"] = this.registrationNumber;
        return data;
    }
}

export interface IClientByIdResult {
    id: number;
    country: number;
    clientName: string;
    tradingName: string;
    telephoneNumber: string;
    contactPerson: string;
    clientEmail: string;
    consultantEmail: string;
    registrationNumber: string;

    [key: string]: any;
}

export class FilteredClientAreasResult extends PagingResult implements IFilteredClientAreasResult {
    results!: FilteredClientAreaItem[];

    [key: string]: any;

    constructor(data?: IFilteredClientAreasResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FilteredClientAreaItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FilteredClientAreasResult {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredClientAreasResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFilteredClientAreasResult extends IPagingResult {
    results: FilteredClientAreaItem[];

    [key: string]: any;
}

export class FilteredClientAreaItem implements IFilteredClientAreaItem {
    id!: number;
    areaName!: string;
    policyNumber!: string;
    inceptionDate!: string;
    insurerId!: number;
    policyBase!: string;
    policyGroup!: string;
    industryId!: number;
    ageingIncludesVat!: boolean;
    salesIncludesVat!: boolean;

    [key: string]: any;

    constructor(data?: IFilteredClientAreaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.areaName = _data["areaName"];
            this.policyNumber = _data["policyNumber"];
            this.inceptionDate = _data["inceptionDate"];
            this.insurerId = _data["insurerId"];
            this.policyBase = _data["policyBase"];
            this.policyGroup = _data["policyGroup"];
            this.industryId = _data["industryId"];
            this.ageingIncludesVat = _data["ageingIncludesVat"];
            this.salesIncludesVat = _data["salesIncludesVat"];
        }
    }

    static fromJS(data: any): FilteredClientAreaItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredClientAreaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["areaName"] = this.areaName;
        data["policyNumber"] = this.policyNumber;
        data["inceptionDate"] = this.inceptionDate;
        data["insurerId"] = this.insurerId;
        data["policyBase"] = this.policyBase;
        data["policyGroup"] = this.policyGroup;
        data["industryId"] = this.industryId;
        data["ageingIncludesVat"] = this.ageingIncludesVat;
        data["salesIncludesVat"] = this.salesIncludesVat;
        return data;
    }
}

export interface IFilteredClientAreaItem {
    id: number;
    areaName: string;
    policyNumber: string;
    inceptionDate: string;
    insurerId: number;
    policyBase: string;
    policyGroup: string;
    industryId: number;
    ageingIncludesVat: boolean;
    salesIncludesVat: boolean;

    [key: string]: any;
}

export class FilteredClientsResult extends PagingResult implements IFilteredClientsResult {
    results!: FilteredClientItem[];

    [key: string]: any;

    constructor(data?: IFilteredClientsResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FilteredClientItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FilteredClientsResult {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredClientsResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFilteredClientsResult extends IPagingResult {
    results: FilteredClientItem[];

    [key: string]: any;
}

export class FilteredClientItem implements IFilteredClientItem {
    id!: number;
    clientName!: string;
    tradingName!: string;
    countryName!: string;
    contactPerson!: string;
    clientEmail!: string;

    [key: string]: any;

    constructor(data?: IFilteredClientItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.clientName = _data["clientName"];
            this.tradingName = _data["tradingName"];
            this.countryName = _data["countryName"];
            this.contactPerson = _data["contactPerson"];
            this.clientEmail = _data["clientEmail"];
        }
    }

    static fromJS(data: any): FilteredClientItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredClientItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["clientName"] = this.clientName;
        data["tradingName"] = this.tradingName;
        data["countryName"] = this.countryName;
        data["contactPerson"] = this.contactPerson;
        data["clientEmail"] = this.clientEmail;
        return data;
    }
}

export interface IFilteredClientItem {
    id: number;
    clientName: string;
    tradingName: string;
    countryName: string;
    contactPerson: string;
    clientEmail: string;

    [key: string]: any;
}

export class UpdateClientInput implements IUpdateClientInput {
    clientName!: string;
    registrationNumber!: string;
    countryId!: number;

    [key: string]: any;

    constructor(data?: IUpdateClientInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.clientName = _data["clientName"];
            this.registrationNumber = _data["registrationNumber"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): UpdateClientInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["clientName"] = this.clientName;
        data["registrationNumber"] = this.registrationNumber;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface IUpdateClientInput {
    clientName: string;
    registrationNumber: string;
    countryId: number;

    [key: string]: any;
}

export class AllCountriesResult implements IAllCountriesResult {
    results!: AllCountryItem[];

    [key: string]: any;

    constructor(data?: IAllCountriesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AllCountryItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllCountriesResult {
        data = typeof data === 'object' ? data : {};
        let result = new AllCountriesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAllCountriesResult {
    results: AllCountryItem[];

    [key: string]: any;
}

export class AllCountryItem implements IAllCountryItem {
    id!: number;
    countryName!: string;
    isNeighbouringCountry!: boolean;

    [key: string]: any;

    constructor(data?: IAllCountryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.countryName = _data["countryName"];
            this.isNeighbouringCountry = _data["isNeighbouringCountry"];
        }
    }

    static fromJS(data: any): AllCountryItem {
        data = typeof data === 'object' ? data : {};
        let result = new AllCountryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["countryName"] = this.countryName;
        data["isNeighbouringCountry"] = this.isNeighbouringCountry;
        return data;
    }
}

export interface IAllCountryItem {
    id: number;
    countryName: string;
    isNeighbouringCountry: boolean;

    [key: string]: any;
}

export class AllCurrenciesResult implements IAllCurrenciesResult {
    results!: AllCurrencyItem[];

    [key: string]: any;

    constructor(data?: IAllCurrenciesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AllCurrencyItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllCurrenciesResult {
        data = typeof data === 'object' ? data : {};
        let result = new AllCurrenciesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAllCurrenciesResult {
    results: AllCurrencyItem[];

    [key: string]: any;
}

export class AllCurrencyItem implements IAllCurrencyItem {
    id!: number;
    name!: string;
    symbol!: string;

    [key: string]: any;

    constructor(data?: IAllCurrencyItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.symbol = _data["symbol"];
        }
    }

    static fromJS(data: any): AllCurrencyItem {
        data = typeof data === 'object' ? data : {};
        let result = new AllCurrencyItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["symbol"] = this.symbol;
        return data;
    }
}

export interface IAllCurrencyItem {
    id: number;
    name: string;
    symbol: string;

    [key: string]: any;
}

export class CreateDatabaseInput implements ICreateDatabaseInput {
    /** Database host (e.g., localhost, 127.0.0.1) */
    host!: string;
    /** Database port */
    port!: number;
    /** Database catalog name */
    catalog!: string;
    /** Database username (required if integrated security is false) */
    username!: string;
    /** Database password (required if integrated security is false) */
    password!: string;
    /** Whether to trust the database's SSL certificate */
    trustCertificate!: boolean;
    /** Whether to use integrated security */
    integratedSecurity!: boolean;

    [key: string]: any;

    constructor(data?: ICreateDatabaseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.host = _data["host"];
            this.port = _data["port"];
            this.catalog = _data["catalog"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.trustCertificate = _data["trustCertificate"];
            this.integratedSecurity = _data["integratedSecurity"];
        }
    }

    static fromJS(data: any): CreateDatabaseInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDatabaseInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["host"] = this.host;
        data["port"] = this.port;
        data["catalog"] = this.catalog;
        data["username"] = this.username;
        data["password"] = this.password;
        data["trustCertificate"] = this.trustCertificate;
        data["integratedSecurity"] = this.integratedSecurity;
        return data;
    }
}

export interface ICreateDatabaseInput {
    /** Database host (e.g., localhost, 127.0.0.1) */
    host: string;
    /** Database port */
    port: number;
    /** Database catalog name */
    catalog: string;
    /** Database username (required if integrated security is false) */
    username: string;
    /** Database password (required if integrated security is false) */
    password: string;
    /** Whether to trust the database's SSL certificate */
    trustCertificate: boolean;
    /** Whether to use integrated security */
    integratedSecurity: boolean;

    [key: string]: any;
}

export class FilteredDatabasesResult extends PagingResult implements IFilteredDatabasesResult {
    results!: FilteredDatabaseItem[];

    [key: string]: any;

    constructor(data?: IFilteredDatabasesResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FilteredDatabaseItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FilteredDatabasesResult {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredDatabasesResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFilteredDatabasesResult extends IPagingResult {
    results: FilteredDatabaseItem[];

    [key: string]: any;
}

export class FilteredDatabaseItem implements IFilteredDatabaseItem {
    id!: number;
    host!: string;
    port!: number;
    catalog!: string;
    username!: string;
    trustCertificate!: boolean;
    integratedSecurity!: boolean;

    [key: string]: any;

    constructor(data?: IFilteredDatabaseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.host = _data["host"];
            this.port = _data["port"];
            this.catalog = _data["catalog"];
            this.username = _data["username"];
            this.trustCertificate = _data["trustCertificate"];
            this.integratedSecurity = _data["integratedSecurity"];
        }
    }

    static fromJS(data: any): FilteredDatabaseItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredDatabaseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["host"] = this.host;
        data["port"] = this.port;
        data["catalog"] = this.catalog;
        data["username"] = this.username;
        data["trustCertificate"] = this.trustCertificate;
        data["integratedSecurity"] = this.integratedSecurity;
        return data;
    }
}

export interface IFilteredDatabaseItem {
    id: number;
    host: string;
    port: number;
    catalog: string;
    username: string;
    trustCertificate: boolean;
    integratedSecurity: boolean;

    [key: string]: any;
}

export class CreateEndorsementInput implements ICreateEndorsementInput {
    endorsementType!: string;
    values!: string;
    effectiveDate!: string;
    expiryDate!: string;
    clientAreaId!: number;

    [key: string]: any;

    constructor(data?: ICreateEndorsementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.endorsementType = _data["endorsementType"];
            this.values = _data["values"];
            this.effectiveDate = _data["effectiveDate"];
            this.expiryDate = _data["expiryDate"];
            this.clientAreaId = _data["clientAreaId"];
        }
    }

    static fromJS(data: any): CreateEndorsementInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEndorsementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["endorsementType"] = this.endorsementType;
        data["values"] = this.values;
        data["effectiveDate"] = this.effectiveDate;
        data["expiryDate"] = this.expiryDate;
        data["clientAreaId"] = this.clientAreaId;
        return data;
    }
}

export interface ICreateEndorsementInput {
    endorsementType: string;
    values: string;
    effectiveDate: string;
    expiryDate: string;
    clientAreaId: number;

    [key: string]: any;
}

export class AllEndorsementTypeValueResult implements IAllEndorsementTypeValueResult {
    results!: AllEndorsementTypeValueItem[];

    [key: string]: any;

    constructor(data?: IAllEndorsementTypeValueResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AllEndorsementTypeValueItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllEndorsementTypeValueResult {
        data = typeof data === 'object' ? data : {};
        let result = new AllEndorsementTypeValueResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAllEndorsementTypeValueResult {
    results: AllEndorsementTypeValueItem[];

    [key: string]: any;
}

export class AllEndorsementTypeValueItem implements IAllEndorsementTypeValueItem {
    id!: number;
    code!: string;
    endorsementTypeId!: number;
    description!: string;

    [key: string]: any;

    constructor(data?: IAllEndorsementTypeValueItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.code = _data["code"];
            this.endorsementTypeId = _data["endorsementTypeId"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AllEndorsementTypeValueItem {
        data = typeof data === 'object' ? data : {};
        let result = new AllEndorsementTypeValueItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["code"] = this.code;
        data["endorsementTypeId"] = this.endorsementTypeId;
        data["description"] = this.description;
        return data;
    }
}

export interface IAllEndorsementTypeValueItem {
    id: number;
    code: string;
    endorsementTypeId: number;
    description: string;

    [key: string]: any;
}

export class AllEndorsementTypeResult implements IAllEndorsementTypeResult {
    results!: AllEndorsementTypeItem[];

    [key: string]: any;

    constructor(data?: IAllEndorsementTypeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AllEndorsementTypeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllEndorsementTypeResult {
        data = typeof data === 'object' ? data : {};
        let result = new AllEndorsementTypeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAllEndorsementTypeResult {
    results: AllEndorsementTypeItem[];

    [key: string]: any;
}

export class AllEndorsementTypeItem implements IAllEndorsementTypeItem {
    id!: number;
    code!: string;
    description!: string;

    [key: string]: any;

    constructor(data?: IAllEndorsementTypeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AllEndorsementTypeItem {
        data = typeof data === 'object' ? data : {};
        let result = new AllEndorsementTypeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IAllEndorsementTypeItem {
    id: number;
    code: string;
    description: string;

    [key: string]: any;
}

export class EndorsementByIdResult implements IEndorsementByIdResult {
    id!: number;
    clientAreaId!: number;
    endorsementType!: string;
    values!: string;
    effectiveDate!: string;
    expiryDate!: string;

    [key: string]: any;

    constructor(data?: IEndorsementByIdResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.clientAreaId = _data["clientAreaId"];
            this.endorsementType = _data["endorsementType"];
            this.values = _data["values"];
            this.effectiveDate = _data["effectiveDate"];
            this.expiryDate = _data["expiryDate"];
        }
    }

    static fromJS(data: any): EndorsementByIdResult {
        data = typeof data === 'object' ? data : {};
        let result = new EndorsementByIdResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["clientAreaId"] = this.clientAreaId;
        data["endorsementType"] = this.endorsementType;
        data["values"] = this.values;
        data["effectiveDate"] = this.effectiveDate;
        data["expiryDate"] = this.expiryDate;
        return data;
    }
}

export interface IEndorsementByIdResult {
    id: number;
    clientAreaId: number;
    endorsementType: string;
    values: string;
    effectiveDate: string;
    expiryDate: string;

    [key: string]: any;
}

export class FilteredEndorsementsResult extends PagingResult implements IFilteredEndorsementsResult {
    results!: FilteredEndorsementItem[];

    [key: string]: any;

    constructor(data?: IFilteredEndorsementsResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FilteredEndorsementItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FilteredEndorsementsResult {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredEndorsementsResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFilteredEndorsementsResult extends IPagingResult {
    results: FilteredEndorsementItem[];

    [key: string]: any;
}

export class FilteredEndorsementItem implements IFilteredEndorsementItem {
    id!: number;
    endorsementType!: string;
    values!: string;
    effectiveDate!: string;
    expiryDate!: string;
    isExpired!: boolean;

    [key: string]: any;

    constructor(data?: IFilteredEndorsementItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.endorsementType = _data["endorsementType"];
            this.values = _data["values"];
            this.effectiveDate = _data["effectiveDate"];
            this.expiryDate = _data["expiryDate"];
            this.isExpired = _data["isExpired"];
        }
    }

    static fromJS(data: any): FilteredEndorsementItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredEndorsementItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["endorsementType"] = this.endorsementType;
        data["values"] = this.values;
        data["effectiveDate"] = this.effectiveDate;
        data["expiryDate"] = this.expiryDate;
        data["isExpired"] = this.isExpired;
        return data;
    }
}

export interface IFilteredEndorsementItem {
    id: number;
    endorsementType: string;
    values: string;
    effectiveDate: string;
    expiryDate: string;
    isExpired: boolean;

    [key: string]: any;
}

export class UpdateEndorsementInput implements IUpdateEndorsementInput {
    endorsementType!: string;
    values!: string;
    effectiveDate!: string;
    expiryDate!: string;
    clientAreaId!: number;

    [key: string]: any;

    constructor(data?: IUpdateEndorsementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.endorsementType = _data["endorsementType"];
            this.values = _data["values"];
            this.effectiveDate = _data["effectiveDate"];
            this.expiryDate = _data["expiryDate"];
            this.clientAreaId = _data["clientAreaId"];
        }
    }

    static fromJS(data: any): UpdateEndorsementInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEndorsementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["endorsementType"] = this.endorsementType;
        data["values"] = this.values;
        data["effectiveDate"] = this.effectiveDate;
        data["expiryDate"] = this.expiryDate;
        data["clientAreaId"] = this.clientAreaId;
        return data;
    }
}

export interface IUpdateEndorsementInput {
    endorsementType: string;
    values: string;
    effectiveDate: string;
    expiryDate: string;
    clientAreaId: number;

    [key: string]: any;
}

export class CopyExchangeRateResult implements ICopyExchangeRateResult {
    currencyId!: number;
    currencyName!: string;
    value!: number;

    [key: string]: any;

    constructor(data?: ICopyExchangeRateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.currencyId = _data["currencyId"];
            this.currencyName = _data["currencyName"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CopyExchangeRateResult {
        data = typeof data === 'object' ? data : {};
        let result = new CopyExchangeRateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["currencyId"] = this.currencyId;
        data["currencyName"] = this.currencyName;
        data["value"] = this.value;
        return data;
    }
}

export interface ICopyExchangeRateResult {
    currencyId: number;
    currencyName: string;
    value: number;

    [key: string]: any;
}

export class CreateExchangeRateInput implements ICreateExchangeRateInput {
    /** The currency id */
    currencyId!: number;
    /** The date and time */
    date!: string;
    /** Value of the exchange rate */
    value!: number;

    [key: string]: any;

    constructor(data?: ICreateExchangeRateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.currencyId = _data["currencyId"];
            this.date = _data["date"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CreateExchangeRateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExchangeRateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["currencyId"] = this.currencyId;
        data["date"] = this.date;
        data["value"] = this.value;
        return data;
    }
}

export interface ICreateExchangeRateInput {
    /** The currency id */
    currencyId: number;
    /** The date and time */
    date: string;
    /** Value of the exchange rate */
    value: number;

    [key: string]: any;
}

export class ExchangeRateByIdResult implements IExchangeRateByIdResult {
    id!: number;
    date!: Date;
    exchangeRate!: number;
    currencyName!: number;

    [key: string]: any;

    constructor(data?: IExchangeRateByIdResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.exchangeRate = _data["exchangeRate"];
            this.currencyName = _data["currencyName"];
        }
    }

    static fromJS(data: any): ExchangeRateByIdResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExchangeRateByIdResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["exchangeRate"] = this.exchangeRate;
        data["currencyName"] = this.currencyName;
        return data;
    }
}

export interface IExchangeRateByIdResult {
    id: number;
    date: Date;
    exchangeRate: number;
    currencyName: number;

    [key: string]: any;
}

export class FilteredExchangeRatesResult extends PagingResult implements IFilteredExchangeRatesResult {
    results!: FilteredExchangeRateItem[];

    [key: string]: any;

    constructor(data?: IFilteredExchangeRatesResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FilteredExchangeRateItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FilteredExchangeRatesResult {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredExchangeRatesResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFilteredExchangeRatesResult extends IPagingResult {
    results: FilteredExchangeRateItem[];

    [key: string]: any;
}

export class FilteredExchangeRateItem implements IFilteredExchangeRateItem {
    id!: number;
    date!: string;
    exchangeRate!: number;
    currency!: string;

    [key: string]: any;

    constructor(data?: IFilteredExchangeRateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.date = _data["date"];
            this.exchangeRate = _data["exchangeRate"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): FilteredExchangeRateItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredExchangeRateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["date"] = this.date;
        data["exchangeRate"] = this.exchangeRate;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IFilteredExchangeRateItem {
    id: number;
    date: string;
    exchangeRate: number;
    currency: string;

    [key: string]: any;
}

export class UpdateExchangeRateInput implements IUpdateExchangeRateInput {
    currencyId!: number;
    date!: string;
    value!: number;

    [key: string]: any;

    constructor(data?: IUpdateExchangeRateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.currencyId = _data["currencyId"];
            this.date = _data["date"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateExchangeRateInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExchangeRateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["currencyId"] = this.currencyId;
        data["date"] = this.date;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateExchangeRateInput {
    currencyId: number;
    date: string;
    value: number;

    [key: string]: any;
}

/** Input for creating a new export request */
export class ExportRequestInput implements IExportRequestInput {
    /** The type of export to create */
    exportType!: ExportRequestInputExportType;
    /** Resolved from the authenticated session user (not user-provided) */
    emailAddress!: string | undefined;
    /** Insurer ID (required for both export types) */
    insurerId!: number;
    /** Start period ID for the export */
    startPeriodId!: number;
    /** End period ID for the export */
    endPeriodId!: number;

    [key: string]: any;

    constructor(data?: IExportRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.exportType = _data["exportType"];
            this.emailAddress = _data["emailAddress"];
            this.insurerId = _data["insurerId"];
            this.startPeriodId = _data["startPeriodId"];
            this.endPeriodId = _data["endPeriodId"];
        }
    }

    static fromJS(data: any): ExportRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExportRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["exportType"] = this.exportType;
        data["emailAddress"] = this.emailAddress;
        data["insurerId"] = this.insurerId;
        data["startPeriodId"] = this.startPeriodId;
        data["endPeriodId"] = this.endPeriodId;
        return data;
    }
}

/** Input for creating a new export request */
export interface IExportRequestInput {
    /** The type of export to create */
    exportType: ExportRequestInputExportType;
    /** Resolved from the authenticated session user (not user-provided) */
    emailAddress: string | undefined;
    /** Insurer ID (required for both export types) */
    insurerId: number;
    /** Start period ID for the export */
    startPeriodId: number;
    /** End period ID for the export */
    endPeriodId: number;

    [key: string]: any;
}

/** Result of creating an export request */
export class ExportRequestResult implements IExportRequestResult {
    /** The ID of the created export request */
    id!: number;
    /** The type of export */
    exportType!: string;
    /** Current status of the export */
    status!: ExportRequestResultStatus;
    /** When the request was created */
    createdAt!: Date;
    /** Status message */
    message!: string;

    [key: string]: any;

    constructor(data?: IExportRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.exportType = _data["exportType"];
            this.status = _data["status"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ExportRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExportRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["exportType"] = this.exportType;
        data["status"] = this.status;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

/** Result of creating an export request */
export interface IExportRequestResult {
    /** The ID of the created export request */
    id: number;
    /** The type of export */
    exportType: string;
    /** Current status of the export */
    status: ExportRequestResultStatus;
    /** When the request was created */
    createdAt: Date;
    /** Status message */
    message: string;

    [key: string]: any;
}

/** Status of an export request */
export class ExportStatusResult implements IExportStatusResult {
    /** The ID of the export request */
    id!: number;
    /** The type of export */
    exportType!: string;
    /** Current status of the export */
    status!: ExportStatusResultStatus;
    /** Progress percentage (0-100) */
    progress!: number;
    /** When the request was created */
    createdAt!: Date;
    /** When the export completed (if applicable) */
    completedAt!: Date;
    /** URL to download the export (if completed) */
    downloadUrl!: string;
    /** Number of rows exported (if completed) */
    rowCount!: number;
    /** Error message (if failed) */
    errorMessage!: string;

    [key: string]: any;

    constructor(data?: IExportStatusResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.exportType = _data["exportType"];
            this.status = _data["status"];
            this.progress = _data["progress"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : <any>undefined;
            this.downloadUrl = _data["downloadUrl"];
            this.rowCount = _data["rowCount"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ExportStatusResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExportStatusResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["exportType"] = this.exportType;
        data["status"] = this.status;
        data["progress"] = this.progress;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        data["downloadUrl"] = this.downloadUrl;
        data["rowCount"] = this.rowCount;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

/** Status of an export request */
export interface IExportStatusResult {
    /** The ID of the export request */
    id: number;
    /** The type of export */
    exportType: string;
    /** Current status of the export */
    status: ExportStatusResultStatus;
    /** Progress percentage (0-100) */
    progress: number;
    /** When the request was created */
    createdAt: Date;
    /** When the export completed (if applicable) */
    completedAt: Date;
    /** URL to download the export (if completed) */
    downloadUrl: string;
    /** Number of rows exported (if completed) */
    rowCount: number;
    /** Error message (if failed) */
    errorMessage: string;

    [key: string]: any;
}

export class ColumnMapping implements IColumnMapping {
    columnIndex!: number;
    mappedPropertyName!: string;
    primaryId!: number;
    importArea!: string;
    regex!: string;
    formatString!: string;

    [key: string]: any;

    constructor(data?: IColumnMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.columnIndex = _data["columnIndex"];
            this.mappedPropertyName = _data["mappedPropertyName"];
            this.primaryId = _data["primaryId"];
            this.importArea = _data["importArea"];
            this.regex = _data["regex"];
            this.formatString = _data["formatString"];
        }
    }

    static fromJS(data: any): ColumnMapping {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["columnIndex"] = this.columnIndex;
        data["mappedPropertyName"] = this.mappedPropertyName;
        data["primaryId"] = this.primaryId;
        data["importArea"] = this.importArea;
        data["regex"] = this.regex;
        data["formatString"] = this.formatString;
        return data;
    }
}

export interface IColumnMapping {
    columnIndex: number;
    mappedPropertyName: string;
    primaryId: number;
    importArea: string;
    regex: string;
    formatString: string;

    [key: string]: any;
}

export class CreateColumnMappingInput implements ICreateColumnMappingInput {
    mappings!: ColumnMapping[];

    [key: string]: any;

    constructor(data?: ICreateColumnMappingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.mappings = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["mappings"])) {
                this.mappings = [] as any;
                for (let item of _data["mappings"])
                    this.mappings!.push(ColumnMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateColumnMappingInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateColumnMappingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.mappings)) {
            data["mappings"] = [];
            for (let item of this.mappings)
                data["mappings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateColumnMappingInput {
    mappings: ColumnMapping[];

    [key: string]: any;
}

export class GetColumnMappings implements IGetColumnMappings {
    mappings!: ColumnMapping[];

    [key: string]: any;

    constructor(data?: IGetColumnMappings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.mappings = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["mappings"])) {
                this.mappings = [] as any;
                for (let item of _data["mappings"])
                    this.mappings!.push(ColumnMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetColumnMappings {
        data = typeof data === 'object' ? data : {};
        let result = new GetColumnMappings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.mappings)) {
            data["mappings"] = [];
            for (let item of this.mappings)
                data["mappings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetColumnMappings {
    mappings: ColumnMapping[];

    [key: string]: any;
}

export class AllIndustriesResult implements IAllIndustriesResult {
    results!: AllIndustryItem[];

    [key: string]: any;

    constructor(data?: IAllIndustriesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AllIndustryItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllIndustriesResult {
        data = typeof data === 'object' ? data : {};
        let result = new AllIndustriesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAllIndustriesResult {
    results: AllIndustryItem[];

    [key: string]: any;
}

export class AllIndustryItem implements IAllIndustryItem {
    id!: number;
    description!: string;

    [key: string]: any;

    constructor(data?: IAllIndustryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AllIndustryItem {
        data = typeof data === 'object' ? data : {};
        let result = new AllIndustryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface IAllIndustryItem {
    id: number;
    description: string;

    [key: string]: any;
}

export class AllInsurersResult implements IAllInsurersResult {
    results!: any[];

    [key: string]: any;

    constructor(data?: IAllInsurersResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
        }
    }

    static fromJS(data: any): AllInsurersResult {
        data = typeof data === 'object' ? data : {};
        let result = new AllInsurersResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        return data;
    }
}

export interface IAllInsurersResult {
    results: any[];

    [key: string]: any;
}

export class AllInsurerItem implements IAllInsurerItem {
    id!: number;
    insurerName!: string;
    importAreaMandatory!: boolean;

    [key: string]: any;

    constructor(data?: IAllInsurerItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.insurerName = _data["insurerName"];
            this.importAreaMandatory = _data["importAreaMandatory"];
        }
    }

    static fromJS(data: any): AllInsurerItem {
        data = typeof data === 'object' ? data : {};
        let result = new AllInsurerItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["insurerName"] = this.insurerName;
        data["importAreaMandatory"] = this.importAreaMandatory;
        return data;
    }
}

export interface IAllInsurerItem {
    id: number;
    insurerName: string;
    importAreaMandatory: boolean;

    [key: string]: any;
}

export class CreateMatchingDataInput implements ICreateMatchingDataInput {
    annexureDataId!: number;
    matchingBatchId!: number;
    ageingDataIds!: number[];

    [key: string]: any;

    constructor(data?: ICreateMatchingDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ageingDataIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.annexureDataId = _data["annexureDataId"];
            this.matchingBatchId = _data["matchingBatchId"];
            if (Array.isArray(_data["ageingDataIds"])) {
                this.ageingDataIds = [] as any;
                for (let item of _data["ageingDataIds"])
                    this.ageingDataIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateMatchingDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMatchingDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["annexureDataId"] = this.annexureDataId;
        data["matchingBatchId"] = this.matchingBatchId;
        if (Array.isArray(this.ageingDataIds)) {
            data["ageingDataIds"] = [];
            for (let item of this.ageingDataIds)
                data["ageingDataIds"].push(item);
        }
        return data;
    }
}

export interface ICreateMatchingDataInput {
    annexureDataId: number;
    matchingBatchId: number;
    ageingDataIds: number[];

    [key: string]: any;
}

/** Input model for creating a new matching batch. The system will validate that both completed annexure and ageing batches are available for the specified client, client area, and period before creating the matching batch. */
export class CreateMatchingInput implements ICreateMatchingInput {
    /** The period ID for which to create the matching batch */
    periodId!: number;
    /** The client ID for which to create the matching batch */
    clientId!: number;
    /** The client area (policy) ID for which to create the matching batch */
    clientAreaId!: number;

    [key: string]: any;

    constructor(data?: ICreateMatchingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.periodId = _data["periodId"];
            this.clientId = _data["clientId"];
            this.clientAreaId = _data["clientAreaId"];
        }
    }

    static fromJS(data: any): CreateMatchingInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMatchingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["periodId"] = this.periodId;
        data["clientId"] = this.clientId;
        data["clientAreaId"] = this.clientAreaId;
        return data;
    }
}

/** Input model for creating a new matching batch. The system will validate that both completed annexure and ageing batches are available for the specified client, client area, and period before creating the matching batch. */
export interface ICreateMatchingInput {
    /** The period ID for which to create the matching batch */
    periodId: number;
    /** The client ID for which to create the matching batch */
    clientId: number;
    /** The client area (policy) ID for which to create the matching batch */
    clientAreaId: number;

    [key: string]: any;
}

/** Represents the input required to mark a matching batch as completed. */
export class CompleteMatchingBatchInput implements ICompleteMatchingBatchInput {
    /** The ID of the matching batch to be completed. */
    batchId!: number;

    [key: string]: any;

    constructor(data?: ICompleteMatchingBatchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.batchId = _data["batchId"];
        }
    }

    static fromJS(data: any): CompleteMatchingBatchInput {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteMatchingBatchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["batchId"] = this.batchId;
        return data;
    }
}

/** Represents the input required to mark a matching batch as completed. */
export interface ICompleteMatchingBatchInput {
    /** The ID of the matching batch to be completed. */
    batchId: number;

    [key: string]: any;
}

export class MatchedDataResult implements IMatchedDataResult {
    isMatched!: boolean;

    [key: string]: any;

    constructor(data?: IMatchedDataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.isMatched = _data["isMatched"];
        }
    }

    static fromJS(data: any): MatchedDataResult {
        data = typeof data === 'object' ? data : {};
        let result = new MatchedDataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["isMatched"] = this.isMatched;
        return data;
    }
}

export interface IMatchedDataResult {
    isMatched: boolean;

    [key: string]: any;
}

export class AgeingMatchingResult extends PagingResult implements IAgeingMatchingResult {
    results!: AgeingMatchingItem[];

    [key: string]: any;

    constructor(data?: IAgeingMatchingResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AgeingMatchingItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AgeingMatchingResult {
        data = typeof data === 'object' ? data : {};
        let result = new AgeingMatchingResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAgeingMatchingResult extends IPagingResult {
    results: AgeingMatchingItem[];

    [key: string]: any;
}

export class AgeingMatchingItem implements IAgeingMatchingItem {
    id!: number;
    customerName!: string;
    customerCode!: string;
    policyReferenceNumber!: string;
    customerRegistrationNumber!: string;
    total!: any;

    [key: string]: any;

    constructor(data?: IAgeingMatchingItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.customerName = _data["customerName"];
            this.customerCode = _data["customerCode"];
            this.policyReferenceNumber = _data["policyReferenceNumber"];
            this.customerRegistrationNumber = _data["customerRegistrationNumber"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): AgeingMatchingItem {
        data = typeof data === 'object' ? data : {};
        let result = new AgeingMatchingItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["customerName"] = this.customerName;
        data["customerCode"] = this.customerCode;
        data["policyReferenceNumber"] = this.policyReferenceNumber;
        data["customerRegistrationNumber"] = this.customerRegistrationNumber;
        data["total"] = this.total;
        return data;
    }
}

export interface IAgeingMatchingItem {
    id: number;
    customerName: string;
    customerCode: string;
    policyReferenceNumber: string;
    customerRegistrationNumber: string;
    total: any;

    [key: string]: any;
}

export class AnnexureMatchingResult extends PagingResult implements IAnnexureMatchingResult {
    results!: AnnexureMatchingItem[];

    [key: string]: any;

    constructor(data?: IAnnexureMatchingResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AnnexureMatchingItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AnnexureMatchingResult {
        data = typeof data === 'object' ? data : {};
        let result = new AnnexureMatchingResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAnnexureMatchingResult extends IPagingResult {
    results: AnnexureMatchingItem[];

    [key: string]: any;
}

export class AnnexureMatchingItem implements IAnnexureMatchingItem {
    id!: number;
    debtorName!: string;
    debtorCode!: string;
    policyReference!: string;
    debtorRegistrationNumber!: string;
    approvedLimit!: any;

    [key: string]: any;

    constructor(data?: IAnnexureMatchingItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.debtorName = _data["debtorName"];
            this.debtorCode = _data["debtorCode"];
            this.policyReference = _data["policyReference"];
            this.debtorRegistrationNumber = _data["debtorRegistrationNumber"];
            this.approvedLimit = _data["approvedLimit"];
        }
    }

    static fromJS(data: any): AnnexureMatchingItem {
        data = typeof data === 'object' ? data : {};
        let result = new AnnexureMatchingItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["debtorName"] = this.debtorName;
        data["debtorCode"] = this.debtorCode;
        data["policyReference"] = this.policyReference;
        data["debtorRegistrationNumber"] = this.debtorRegistrationNumber;
        data["approvedLimit"] = this.approvedLimit;
        return data;
    }
}

export interface IAnnexureMatchingItem {
    id: number;
    debtorName: string;
    debtorCode: string;
    policyReference: string;
    debtorRegistrationNumber: string;
    approvedLimit: any;

    [key: string]: any;
}

export class MatchingBatchDetailsResult implements IMatchingBatchDetailsResult {
    period!: string;
    client!: string;
    clientArea!: string;

    [key: string]: any;

    constructor(data?: IMatchingBatchDetailsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.period = _data["period"];
            this.client = _data["client"];
            this.clientArea = _data["clientArea"];
        }
    }

    static fromJS(data: any): MatchingBatchDetailsResult {
        data = typeof data === 'object' ? data : {};
        let result = new MatchingBatchDetailsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["period"] = this.period;
        data["client"] = this.client;
        data["clientArea"] = this.clientArea;
        return data;
    }
}

export interface IMatchingBatchDetailsResult {
    period: string;
    client: string;
    clientArea: string;

    [key: string]: any;
}

export class MatchingBatchResult implements IMatchingBatchResult {
    periodId!: number;
    clientId!: number;
    clientAreaId!: number;

    [key: string]: any;

    constructor(data?: IMatchingBatchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.periodId = _data["periodId"];
            this.clientId = _data["clientId"];
            this.clientAreaId = _data["clientAreaId"];
        }
    }

    static fromJS(data: any): MatchingBatchResult {
        data = typeof data === 'object' ? data : {};
        let result = new MatchingBatchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["periodId"] = this.periodId;
        data["clientId"] = this.clientId;
        data["clientAreaId"] = this.clientAreaId;
        return data;
    }
}

export interface IMatchingBatchResult {
    periodId: number;
    clientId: number;
    clientAreaId: number;

    [key: string]: any;
}

export class MatchingBatchesResult extends PagingResult implements IMatchingBatchesResult {
    results!: MatchingBatchesItem[];

    [key: string]: any;

    constructor(data?: IMatchingBatchesResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(MatchingBatchesItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): MatchingBatchesResult {
        data = typeof data === 'object' ? data : {};
        let result = new MatchingBatchesResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMatchingBatchesResult extends IPagingResult {
    results: MatchingBatchesItem[];

    [key: string]: any;
}

export class MatchingBatchesItem implements IMatchingBatchesItem {
    id!: number;
    createdAt!: string;
    clientName!: string;
    areaName!: string;
    period!: string;

    [key: string]: any;

    constructor(data?: IMatchingBatchesItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"];
            this.clientName = _data["clientName"];
            this.areaName = _data["areaName"];
            this.period = _data["period"];
        }
    }

    static fromJS(data: any): MatchingBatchesItem {
        data = typeof data === 'object' ? data : {};
        let result = new MatchingBatchesItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt;
        data["clientName"] = this.clientName;
        data["areaName"] = this.areaName;
        data["period"] = this.period;
        return data;
    }
}

export interface IMatchingBatchesItem {
    id: number;
    createdAt: string;
    clientName: string;
    areaName: string;
    period: string;

    [key: string]: any;
}

/** Input model for updating an existing matching batch's basic information. This is typically used for correcting batch configuration before completion. */
export class UpdateMatchingInput implements IUpdateMatchingInput {
    /** The period ID for the matching batch */
    periodId!: number;
    /** The client ID for the matching batch */
    clientId!: number;
    /** The client area (policy) ID for the matching batch */
    clientAreaId!: number;

    [key: string]: any;

    constructor(data?: IUpdateMatchingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.periodId = _data["periodId"];
            this.clientId = _data["clientId"];
            this.clientAreaId = _data["clientAreaId"];
        }
    }

    static fromJS(data: any): UpdateMatchingInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMatchingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["periodId"] = this.periodId;
        data["clientId"] = this.clientId;
        data["clientAreaId"] = this.clientAreaId;
        return data;
    }
}

/** Input model for updating an existing matching batch's basic information. This is typically used for correcting batch configuration before completion. */
export interface IUpdateMatchingInput {
    /** The period ID for the matching batch */
    periodId: number;
    /** The client ID for the matching batch */
    clientId: number;
    /** The client area (policy) ID for the matching batch */
    clientAreaId: number;

    [key: string]: any;
}

export class AllNotesResult implements IAllNotesResult {
    results!: AllNoteItem[];

    [key: string]: any;

    constructor(data?: IAllNotesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AllNoteItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllNotesResult {
        data = typeof data === 'object' ? data : {};
        let result = new AllNotesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAllNotesResult {
    results: AllNoteItem[];

    [key: string]: any;
}

export class AllNoteItem implements IAllNoteItem {
    id!: number;
    description!: string;
    showOther!: boolean;

    [key: string]: any;

    constructor(data?: IAllNoteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.description = _data["description"];
            this.showOther = _data["showOther"];
        }
    }

    static fromJS(data: any): AllNoteItem {
        data = typeof data === 'object' ? data : {};
        let result = new AllNoteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["description"] = this.description;
        data["showOther"] = this.showOther;
        return data;
    }
}

export interface IAllNoteItem {
    id: number;
    description: string;
    showOther: boolean;

    [key: string]: any;
}

/** Represents the input required to mark an performance batch as completed. */
export class CompletePerformanceBatchInput implements ICompletePerformanceBatchInput {
    /** The ID of the performance batch to be completed. */
    batchId!: number;

    [key: string]: any;

    constructor(data?: ICompletePerformanceBatchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.batchId = _data["batchId"];
        }
    }

    static fromJS(data: any): CompletePerformanceBatchInput {
        data = typeof data === 'object' ? data : {};
        let result = new CompletePerformanceBatchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["batchId"] = this.batchId;
        return data;
    }
}

/** Represents the input required to mark an performance batch as completed. */
export interface ICompletePerformanceBatchInput {
    /** The ID of the performance batch to be completed. */
    batchId: number;

    [key: string]: any;
}

export class PerformanceRangeMappingInput implements IPerformanceRangeMappingInput {
    headerIndex!: number;
    startIndex!: number;
    endIndex!: number;

    [key: string]: any;

    constructor(data?: IPerformanceRangeMappingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.headerIndex = _data["headerIndex"];
            this.startIndex = _data["startIndex"];
            this.endIndex = _data["endIndex"];
        }
    }

    static fromJS(data: any): PerformanceRangeMappingInput {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceRangeMappingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["headerIndex"] = this.headerIndex;
        data["startIndex"] = this.startIndex;
        data["endIndex"] = this.endIndex;
        return data;
    }
}

export interface IPerformanceRangeMappingInput {
    headerIndex: number;
    startIndex: number;
    endIndex: number;

    [key: string]: any;
}

export class PerformanceBatchResult implements IPerformanceBatchResult {
    periodId!: number;
    clientId!: number;
    clientAreaId!: number;
    insurerId!: number;
    filePath!: string;
    fileName!: string;
    storedName!: string;
    isImported!: boolean;
    isCompleted!: boolean;

    [key: string]: any;

    constructor(data?: IPerformanceBatchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.periodId = _data["periodId"];
            this.clientId = _data["clientId"];
            this.clientAreaId = _data["clientAreaId"];
            this.insurerId = _data["insurerId"];
            this.filePath = _data["filePath"];
            this.fileName = _data["fileName"];
            this.storedName = _data["storedName"];
            this.isImported = _data["isImported"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): PerformanceBatchResult {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceBatchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["periodId"] = this.periodId;
        data["clientId"] = this.clientId;
        data["clientAreaId"] = this.clientAreaId;
        data["insurerId"] = this.insurerId;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["storedName"] = this.storedName;
        data["isImported"] = this.isImported;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IPerformanceBatchResult {
    periodId: number;
    clientId: number;
    clientAreaId: number;
    insurerId: number;
    filePath: string;
    fileName: string;
    storedName: string;
    isImported: boolean;
    isCompleted: boolean;

    [key: string]: any;
}

export class PerformanceBatchesResult extends PagingResult implements IPerformanceBatchesResult {
    results!: PerformanceBatchesItem[];

    [key: string]: any;

    constructor(data?: IPerformanceBatchesResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PerformanceBatchesItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PerformanceBatchesResult {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceBatchesResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPerformanceBatchesResult extends IPagingResult {
    results: PerformanceBatchesItem[];

    [key: string]: any;
}

export class PerformanceBatchesItem implements IPerformanceBatchesItem {
    id!: number;
    createdAt!: string;
    completedAt!: string;
    fileName!: string;
    clientName!: string;
    areaName!: string;
    insurerName!: string;
    period!: string;

    [key: string]: any;

    constructor(data?: IPerformanceBatchesItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"];
            this.completedAt = _data["completedAt"];
            this.fileName = _data["fileName"];
            this.clientName = _data["clientName"];
            this.areaName = _data["areaName"];
            this.insurerName = _data["insurerName"];
            this.period = _data["period"];
        }
    }

    static fromJS(data: any): PerformanceBatchesItem {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceBatchesItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt;
        data["completedAt"] = this.completedAt;
        data["fileName"] = this.fileName;
        data["clientName"] = this.clientName;
        data["areaName"] = this.areaName;
        data["insurerName"] = this.insurerName;
        data["period"] = this.period;
        return data;
    }
}

export interface IPerformanceBatchesItem {
    id: number;
    createdAt: string;
    completedAt: string;
    fileName: string;
    clientName: string;
    areaName: string;
    insurerName: string;
    period: string;

    [key: string]: any;
}

export class PerformanceRangeMappingResult implements IPerformanceRangeMappingResult {
    id!: number;
    headerIndex!: number;
    startIndex!: number;
    endIndex!: number;

    [key: string]: any;

    constructor(data?: IPerformanceRangeMappingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.headerIndex = _data["headerIndex"];
            this.startIndex = _data["startIndex"];
            this.endIndex = _data["endIndex"];
        }
    }

    static fromJS(data: any): PerformanceRangeMappingResult {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceRangeMappingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["headerIndex"] = this.headerIndex;
        data["startIndex"] = this.startIndex;
        data["endIndex"] = this.endIndex;
        return data;
    }
}

export interface IPerformanceRangeMappingResult {
    id: number;
    headerIndex: number;
    startIndex: number;
    endIndex: number;

    [key: string]: any;
}

export class SamplePerformanceDataResult implements ISamplePerformanceDataResult {
    sampleRows!: SamplePerformanceDataItem[];

    [key: string]: any;

    constructor(data?: ISamplePerformanceDataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["sampleRows"])) {
                this.sampleRows = [] as any;
                for (let item of _data["sampleRows"])
                    this.sampleRows!.push(SamplePerformanceDataItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SamplePerformanceDataResult {
        data = typeof data === 'object' ? data : {};
        let result = new SamplePerformanceDataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.sampleRows)) {
            data["sampleRows"] = [];
            for (let item of this.sampleRows)
                data["sampleRows"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISamplePerformanceDataResult {
    sampleRows: SamplePerformanceDataItem[];

    [key: string]: any;
}

export class SamplePerformanceDataItem implements ISamplePerformanceDataItem {
    id!: number;
    clientId!: number;
    clientAreaId!: number;
    performance!: string;
    policyNumber!: string;
    startDate!: string;
    endDate!: string;
    datePaid!: string;
    nettPremiums!: number;
    nettClaims!: number;
    performanceBonusPercentage!: number;
    performancebonusAmountPaid!: number;

    [key: string]: any;

    constructor(data?: ISamplePerformanceDataItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.clientAreaId = _data["clientAreaId"];
            this.performance = _data["performance"];
            this.policyNumber = _data["policyNumber"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.datePaid = _data["datePaid"];
            this.nettPremiums = _data["nettPremiums"];
            this.nettClaims = _data["nettClaims"];
            this.performanceBonusPercentage = _data["performanceBonusPercentage"];
            this.performancebonusAmountPaid = _data["performancebonusAmountPaid"];
        }
    }

    static fromJS(data: any): SamplePerformanceDataItem {
        data = typeof data === 'object' ? data : {};
        let result = new SamplePerformanceDataItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["clientAreaId"] = this.clientAreaId;
        data["performance"] = this.performance;
        data["policyNumber"] = this.policyNumber;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["datePaid"] = this.datePaid;
        data["nettPremiums"] = this.nettPremiums;
        data["nettClaims"] = this.nettClaims;
        data["performanceBonusPercentage"] = this.performanceBonusPercentage;
        data["performancebonusAmountPaid"] = this.performancebonusAmountPaid;
        return data;
    }
}

export interface ISamplePerformanceDataItem {
    id: number;
    clientId: number;
    clientAreaId: number;
    performance: string;
    policyNumber: string;
    startDate: string;
    endDate: string;
    datePaid: string;
    nettPremiums: number;
    nettClaims: number;
    performanceBonusPercentage: number;
    performancebonusAmountPaid: number;

    [key: string]: any;
}

export class PerformanceTotalsResult implements IPerformanceTotalsResult {
    totalRowsImported!: number;

    [key: string]: any;

    constructor(data?: IPerformanceTotalsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalRowsImported = _data["totalRowsImported"];
        }
    }

    static fromJS(data: any): PerformanceTotalsResult {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceTotalsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalRowsImported"] = this.totalRowsImported;
        return data;
    }
}

export interface IPerformanceTotalsResult {
    totalRowsImported: number;

    [key: string]: any;
}

/** Represents the input required to upload an Performance file. */
export class PerformanceUploadFileInput implements IPerformanceUploadFileInput {
    file!: string;
    periodId!: number;
    insurerId!: number;
    /** Optional. Required only if the selected insurer has importAreaMandatory = true. */
    clientId!: number | undefined;
    /** Optional. Required only if the selected insurer has importAreaMandatory = true. */
    clientAreaId!: number | undefined;

    [key: string]: any;

    constructor(data?: IPerformanceUploadFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
            this.periodId = _data["periodId"];
            this.insurerId = _data["insurerId"];
            this.clientId = _data["clientId"];
            this.clientAreaId = _data["clientAreaId"];
        }
    }

    static fromJS(data: any): PerformanceUploadFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceUploadFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        data["periodId"] = this.periodId;
        data["insurerId"] = this.insurerId;
        data["clientId"] = this.clientId;
        data["clientAreaId"] = this.clientAreaId;
        return data;
    }
}

/** Represents the input required to upload an Performance file. */
export interface IPerformanceUploadFileInput {
    file: string;
    periodId: number;
    insurerId: number;
    /** Optional. Required only if the selected insurer has importAreaMandatory = true. */
    clientId: number | undefined;
    /** Optional. Required only if the selected insurer has importAreaMandatory = true. */
    clientAreaId: number | undefined;

    [key: string]: any;
}

export class AllPeriodsResult implements IAllPeriodsResult {
    results!: AllPeriodItem[];

    [key: string]: any;

    constructor(data?: IAllPeriodsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AllPeriodItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllPeriodsResult {
        data = typeof data === 'object' ? data : {};
        let result = new AllPeriodsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAllPeriodsResult {
    results: AllPeriodItem[];

    [key: string]: any;
}

export class AllPeriodItem implements IAllPeriodItem {
    id!: number;
    year!: number;
    month!: number;

    [key: string]: any;

    constructor(data?: IAllPeriodItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.year = _data["year"];
            this.month = _data["month"];
        }
    }

    static fromJS(data: any): AllPeriodItem {
        data = typeof data === 'object' ? data : {};
        let result = new AllPeriodItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["year"] = this.year;
        data["month"] = this.month;
        return data;
    }
}

export interface IAllPeriodItem {
    id: number;
    year: number;
    month: number;

    [key: string]: any;
}

export class PeriodByIdResult implements IPeriodByIdResult {
    id!: number;
    month!: number;
    year!: number;

    [key: string]: any;

    constructor(data?: IPeriodByIdResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.month = _data["month"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): PeriodByIdResult {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodByIdResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }
}

export interface IPeriodByIdResult {
    id: number;
    month: number;
    year: number;

    [key: string]: any;
}

export class CreatePolicyGroupInput implements ICreatePolicyGroupInput {
    name!: string;

    [key: string]: any;

    constructor(data?: ICreatePolicyGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreatePolicyGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePolicyGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        return data;
    }
}

export interface ICreatePolicyGroupInput {
    name: string;

    [key: string]: any;
}

export class AllPolicyGroupsResult implements IAllPolicyGroupsResult {
    results!: AllPolicyGroupItem[];

    [key: string]: any;

    constructor(data?: IAllPolicyGroupsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AllPolicyGroupItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllPolicyGroupsResult {
        data = typeof data === 'object' ? data : {};
        let result = new AllPolicyGroupsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAllPolicyGroupsResult {
    results: AllPolicyGroupItem[];

    [key: string]: any;
}

export class AllPolicyGroupItem implements IAllPolicyGroupItem {
    id!: number;
    name!: string;

    [key: string]: any;

    constructor(data?: IAllPolicyGroupItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AllPolicyGroupItem {
        data = typeof data === 'object' ? data : {};
        let result = new AllPolicyGroupItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAllPolicyGroupItem {
    id: number;
    name: string;

    [key: string]: any;
}

export class AvailablePoliciesResult implements IAvailablePoliciesResult {
    results!: AvailablePolicyItem[];

    [key: string]: any;

    constructor(data?: IAvailablePoliciesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AvailablePolicyItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AvailablePoliciesResult {
        data = typeof data === 'object' ? data : {};
        let result = new AvailablePoliciesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAvailablePoliciesResult {
    results: AvailablePolicyItem[];

    [key: string]: any;
}

export class AvailablePolicyItem implements IAvailablePolicyItem {
    id!: number;
    clientName!: string;
    areaName!: string;
    policyNumber!: string;
    isSelected!: boolean;

    [key: string]: any;

    constructor(data?: IAvailablePolicyItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.clientName = _data["clientName"];
            this.areaName = _data["areaName"];
            this.policyNumber = _data["policyNumber"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): AvailablePolicyItem {
        data = typeof data === 'object' ? data : {};
        let result = new AvailablePolicyItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["clientName"] = this.clientName;
        data["areaName"] = this.areaName;
        data["policyNumber"] = this.policyNumber;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IAvailablePolicyItem {
    id: number;
    clientName: string;
    areaName: string;
    policyNumber: string;
    isSelected: boolean;

    [key: string]: any;
}

export class PoliciesByGroupIdResult extends PagingResult implements IPoliciesByGroupIdResult {
    results!: PoliciesByGroupIdItem[];

    [key: string]: any;

    constructor(data?: IPoliciesByGroupIdResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PoliciesByGroupIdItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PoliciesByGroupIdResult {
        data = typeof data === 'object' ? data : {};
        let result = new PoliciesByGroupIdResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPoliciesByGroupIdResult extends IPagingResult {
    results: PoliciesByGroupIdItem[];

    [key: string]: any;
}

export class PoliciesByGroupIdItem implements IPoliciesByGroupIdItem {
    id!: number;
    clientName!: string;
    areaName!: string;
    policyNumber!: string;

    [key: string]: any;

    constructor(data?: IPoliciesByGroupIdItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.clientName = _data["clientName"];
            this.areaName = _data["areaName"];
            this.policyNumber = _data["policyNumber"];
        }
    }

    static fromJS(data: any): PoliciesByGroupIdItem {
        data = typeof data === 'object' ? data : {};
        let result = new PoliciesByGroupIdItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["clientName"] = this.clientName;
        data["areaName"] = this.areaName;
        data["policyNumber"] = this.policyNumber;
        return data;
    }
}

export interface IPoliciesByGroupIdItem {
    id: number;
    clientName: string;
    areaName: string;
    policyNumber: string;

    [key: string]: any;
}

export class PolicyGroupByIdResult implements IPolicyGroupByIdResult {
    name!: string;

    [key: string]: any;

    constructor(data?: IPolicyGroupByIdResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PolicyGroupByIdResult {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyGroupByIdResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        return data;
    }
}

export interface IPolicyGroupByIdResult {
    name: string;

    [key: string]: any;
}

export class FilteredPolicyGroupsResult extends PagingResult implements IFilteredPolicyGroupsResult {
    results!: FilteredPolicyGroupItem[];

    [key: string]: any;

    constructor(data?: IFilteredPolicyGroupsResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FilteredPolicyGroupItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FilteredPolicyGroupsResult {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredPolicyGroupsResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFilteredPolicyGroupsResult extends IPagingResult {
    results: FilteredPolicyGroupItem[];

    [key: string]: any;
}

export class FilteredPolicyGroupItem implements IFilteredPolicyGroupItem {
    id!: number;
    name!: string;

    [key: string]: any;

    constructor(data?: IFilteredPolicyGroupItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FilteredPolicyGroupItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredPolicyGroupItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IFilteredPolicyGroupItem {
    id: number;
    name: string;

    [key: string]: any;
}

export class UpdatePoliciesOnGroupInput implements IUpdatePoliciesOnGroupInput {
    policies!: number[];

    [key: string]: any;

    constructor(data?: IUpdatePoliciesOnGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.policies = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdatePoliciesOnGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePoliciesOnGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item);
        }
        return data;
    }
}

export interface IUpdatePoliciesOnGroupInput {
    policies: number[];

    [key: string]: any;
}

export class UpdatePolicyGroupInput implements IUpdatePolicyGroupInput {
    name!: string;

    [key: string]: any;

    constructor(data?: IUpdatePolicyGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdatePolicyGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePolicyGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdatePolicyGroupInput {
    name: string;

    [key: string]: any;
}

export class PopiSearchItem implements IPopiSearchItem {
    dbName!: string;
    table!: string;
    entityDisplayName!: string;
    record!: any;
    matchedField!: string;
    matchedValue!: string;
    children!: PopiSearchItem[];

    [key: string]: any;

    constructor(data?: IPopiSearchItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.dbName = _data["dbName"];
            this.table = _data["table"];
            this.entityDisplayName = _data["entityDisplayName"];
            this.record = _data["record"];
            this.matchedField = _data["matchedField"];
            this.matchedValue = _data["matchedValue"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(PopiSearchItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PopiSearchItem {
        data = typeof data === 'object' ? data : {};
        let result = new PopiSearchItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["dbName"] = this.dbName;
        data["table"] = this.table;
        data["entityDisplayName"] = this.entityDisplayName;
        data["record"] = this.record;
        data["matchedField"] = this.matchedField;
        data["matchedValue"] = this.matchedValue;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPopiSearchItem {
    dbName: string;
    table: string;
    entityDisplayName: string;
    record: any;
    matchedField: string;
    matchedValue: string;
    children: PopiSearchItem[];

    [key: string]: any;
}

export class PopiSearchResult implements IPopiSearchResult {
    pagingData!: PagingData;
    totalCount!: number;
    results!: PopiSearchItem[];

    [key: string]: any;

    constructor(data?: IPopiSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pagingData = _data["pagingData"] ? PagingData.fromJS(_data["pagingData"]) : <any>undefined;
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PopiSearchItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PopiSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new PopiSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pagingData"] = this.pagingData ? this.pagingData.toJSON() : <any>undefined;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPopiSearchResult {
    pagingData: PagingData;
    totalCount: number;
    results: PopiSearchItem[];

    [key: string]: any;
}

export class PopiGroupedSearchItem implements IPopiGroupedSearchItem {
    dbName!: string;
    table!: string;
    entityDisplayName!: string;
    records!: any[];
    matchedFields!: string[];
    matchedValues!: string[];
    children!: PopiGroupedSearchItem[];

    [key: string]: any;

    constructor(data?: IPopiGroupedSearchItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.dbName = _data["dbName"];
            this.table = _data["table"];
            this.entityDisplayName = _data["entityDisplayName"];
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(item);
            }
            if (Array.isArray(_data["matchedFields"])) {
                this.matchedFields = [] as any;
                for (let item of _data["matchedFields"])
                    this.matchedFields!.push(item);
            }
            if (Array.isArray(_data["matchedValues"])) {
                this.matchedValues = [] as any;
                for (let item of _data["matchedValues"])
                    this.matchedValues!.push(item);
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(PopiGroupedSearchItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PopiGroupedSearchItem {
        data = typeof data === 'object' ? data : {};
        let result = new PopiGroupedSearchItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["dbName"] = this.dbName;
        data["table"] = this.table;
        data["entityDisplayName"] = this.entityDisplayName;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item);
        }
        if (Array.isArray(this.matchedFields)) {
            data["matchedFields"] = [];
            for (let item of this.matchedFields)
                data["matchedFields"].push(item);
        }
        if (Array.isArray(this.matchedValues)) {
            data["matchedValues"] = [];
            for (let item of this.matchedValues)
                data["matchedValues"].push(item);
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPopiGroupedSearchItem {
    dbName: string;
    table: string;
    entityDisplayName: string;
    records: any[];
    matchedFields: string[];
    matchedValues: string[];
    children: PopiGroupedSearchItem[];

    [key: string]: any;
}

export class PopiGroupedSearchResult implements IPopiGroupedSearchResult {
    pagingData!: PagingData;
    totalCount!: number;
    results!: PopiGroupedSearchItem[];
    errors!: string[];

    [key: string]: any;

    constructor(data?: IPopiGroupedSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pagingData = _data["pagingData"] ? PagingData.fromJS(_data["pagingData"]) : <any>undefined;
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PopiGroupedSearchItem.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): PopiGroupedSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new PopiGroupedSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pagingData"] = this.pagingData ? this.pagingData.toJSON() : <any>undefined;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IPopiGroupedSearchResult {
    pagingData: PagingData;
    totalCount: number;
    results: PopiGroupedSearchItem[];
    errors: string[];

    [key: string]: any;
}

export class EntityFieldMapping implements IEntityFieldMapping {
    id!: string;
    entityId!: string;
    fieldName!: string;
    displayName!: string;
    replaceValue!: string;
    search!: boolean;
    piField!: boolean;

    [key: string]: any;

    constructor(data?: IEntityFieldMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.entityId = _data["entityId"];
            this.fieldName = _data["fieldName"];
            this.displayName = _data["displayName"];
            this.replaceValue = _data["replaceValue"];
            this.search = _data["search"];
            this.piField = _data["piField"];
        }
    }

    static fromJS(data: any): EntityFieldMapping {
        data = typeof data === 'object' ? data : {};
        let result = new EntityFieldMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["entityId"] = this.entityId;
        data["fieldName"] = this.fieldName;
        data["displayName"] = this.displayName;
        data["replaceValue"] = this.replaceValue;
        data["search"] = this.search;
        data["piField"] = this.piField;
        return data;
    }
}

export interface IEntityFieldMapping {
    id: string;
    entityId: string;
    fieldName: string;
    displayName: string;
    replaceValue: string;
    search: boolean;
    piField: boolean;

    [key: string]: any;
}

export class EntityMapping implements IEntityMapping {
    id!: string;
    displayName!: string;
    dbName!: string;
    tableName!: string;
    parentTableName!: string;
    parentIdColumn!: string;
    identifierColumn!: string;
    isValidMapping!: boolean;
    fields!: EntityFieldMapping[];

    [key: string]: any;

    constructor(data?: IEntityMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.dbName = _data["dbName"];
            this.tableName = _data["tableName"];
            this.parentTableName = _data["parentTableName"];
            this.parentIdColumn = _data["parentIdColumn"];
            this.identifierColumn = _data["identifierColumn"];
            this.isValidMapping = _data["isValidMapping"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(EntityFieldMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityMapping {
        data = typeof data === 'object' ? data : {};
        let result = new EntityMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["dbName"] = this.dbName;
        data["tableName"] = this.tableName;
        data["parentTableName"] = this.parentTableName;
        data["parentIdColumn"] = this.parentIdColumn;
        data["identifierColumn"] = this.identifierColumn;
        data["isValidMapping"] = this.isValidMapping;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEntityMapping {
    id: string;
    displayName: string;
    dbName: string;
    tableName: string;
    parentTableName: string;
    parentIdColumn: string;
    identifierColumn: string;
    isValidMapping: boolean;
    fields: EntityFieldMapping[];

    [key: string]: any;
}

export class SaveEntityMappingRequest implements ISaveEntityMappingRequest {
    displayName!: string;
    dbName!: string;
    tableName!: string;
    parentTableName!: string;
    parentIdColumn!: string;
    identifierColumn!: string;
    fields!: EntityFieldMapping[];

    [key: string]: any;

    constructor(data?: ISaveEntityMappingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.displayName = _data["displayName"];
            this.dbName = _data["dbName"];
            this.tableName = _data["tableName"];
            this.parentTableName = _data["parentTableName"];
            this.parentIdColumn = _data["parentIdColumn"];
            this.identifierColumn = _data["identifierColumn"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(EntityFieldMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveEntityMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveEntityMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["displayName"] = this.displayName;
        data["dbName"] = this.dbName;
        data["tableName"] = this.tableName;
        data["parentTableName"] = this.parentTableName;
        data["parentIdColumn"] = this.parentIdColumn;
        data["identifierColumn"] = this.identifierColumn;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveEntityMappingRequest {
    displayName: string;
    dbName: string;
    tableName: string;
    parentTableName: string;
    parentIdColumn: string;
    identifierColumn: string;
    fields: EntityFieldMapping[];

    [key: string]: any;
}

export class SaveEntityMappingResult implements ISaveEntityMappingResult {
    success!: boolean;
    entityId!: string;
    message!: string;

    [key: string]: any;

    constructor(data?: ISaveEntityMappingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.success = _data["success"];
            this.entityId = _data["entityId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SaveEntityMappingResult {
        data = typeof data === 'object' ? data : {};
        let result = new SaveEntityMappingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["success"] = this.success;
        data["entityId"] = this.entityId;
        data["message"] = this.message;
        return data;
    }
}

export interface ISaveEntityMappingResult {
    success: boolean;
    entityId: string;
    message: string;

    [key: string]: any;
}

export class SchemaSummaryResult implements ISchemaSummaryResult {
    summaries!: SchemaSummaryItem[];

    [key: string]: any;

    constructor(data?: ISchemaSummaryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["summaries"])) {
                this.summaries = [] as any;
                for (let item of _data["summaries"])
                    this.summaries!.push(SchemaSummaryItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SchemaSummaryResult {
        data = typeof data === 'object' ? data : {};
        let result = new SchemaSummaryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.summaries)) {
            data["summaries"] = [];
            for (let item of this.summaries)
                data["summaries"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISchemaSummaryResult {
    summaries: SchemaSummaryItem[];

    [key: string]: any;
}

export class SchemaSummaryItem implements ISchemaSummaryItem {
    dbName!: string;
    host!: string;
    tables!: SchemaTableItem[];

    [key: string]: any;

    constructor(data?: ISchemaSummaryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.dbName = _data["dbName"];
            this.host = _data["host"];
            if (Array.isArray(_data["tables"])) {
                this.tables = [] as any;
                for (let item of _data["tables"])
                    this.tables!.push(SchemaTableItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SchemaSummaryItem {
        data = typeof data === 'object' ? data : {};
        let result = new SchemaSummaryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["dbName"] = this.dbName;
        data["host"] = this.host;
        if (Array.isArray(this.tables)) {
            data["tables"] = [];
            for (let item of this.tables)
                data["tables"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISchemaSummaryItem {
    dbName: string;
    host: string;
    tables: SchemaTableItem[];

    [key: string]: any;
}

export class SchemaTableItem implements ISchemaTableItem {
    tableName!: string;
    fields!: SchemaFieldItem[];

    [key: string]: any;

    constructor(data?: ISchemaTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.tableName = _data["tableName"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(SchemaFieldItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SchemaTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new SchemaTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["tableName"] = this.tableName;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISchemaTableItem {
    tableName: string;
    fields: SchemaFieldItem[];

    [key: string]: any;
}

export class SchemaFieldItem implements ISchemaFieldItem {
    name!: string;
    type!: string;

    [key: string]: any;

    constructor(data?: ISchemaFieldItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SchemaFieldItem {
        data = typeof data === 'object' ? data : {};
        let result = new SchemaFieldItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface ISchemaFieldItem {
    name: string;
    type: string;

    [key: string]: any;
}

export class PopiDeidentifyRequest implements IPopiDeidentifyRequest {
    tableName!: string;
    recordId!: string;
    popiReferenceId!: string;
    dbName!: string;

    [key: string]: any;

    constructor(data?: IPopiDeidentifyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.tableName = _data["tableName"];
            this.recordId = _data["recordId"];
            this.popiReferenceId = _data["popiReferenceId"];
            this.dbName = _data["dbName"];
        }
    }

    static fromJS(data: any): PopiDeidentifyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PopiDeidentifyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["tableName"] = this.tableName;
        data["recordId"] = this.recordId;
        data["popiReferenceId"] = this.popiReferenceId;
        data["dbName"] = this.dbName;
        return data;
    }
}

export interface IPopiDeidentifyRequest {
    tableName: string;
    recordId: string;
    popiReferenceId: string;
    dbName: string;

    [key: string]: any;
}

export class VerifyMappingsResult implements IVerifyMappingsResult {
    isValid!: boolean;
    message!: string;
    errors!: string[];

    [key: string]: any;

    constructor(data?: IVerifyMappingsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.isValid = _data["isValid"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): VerifyMappingsResult {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyMappingsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["isValid"] = this.isValid;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IVerifyMappingsResult {
    isValid: boolean;
    message: string;
    errors: string[];

    [key: string]: any;
}

/** Represents the input required to mark a premium data batch as completed. */
export class CompletePremiumDataBatchInput implements ICompletePremiumDataBatchInput {
    /** The ID of the premium data batch to be completed. */
    batchId!: number;

    [key: string]: any;

    constructor(data?: ICompletePremiumDataBatchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.batchId = _data["batchId"];
        }
    }

    static fromJS(data: any): CompletePremiumDataBatchInput {
        data = typeof data === 'object' ? data : {};
        let result = new CompletePremiumDataBatchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["batchId"] = this.batchId;
        return data;
    }
}

/** Represents the input required to mark a premium data batch as completed. */
export interface ICompletePremiumDataBatchInput {
    /** The ID of the premium data batch to be completed. */
    batchId: number;

    [key: string]: any;
}

export class PremiumDataRangeMappingInput implements IPremiumDataRangeMappingInput {
    headerIndex!: number;
    startIndex!: number;
    endIndex!: number;

    [key: string]: any;

    constructor(data?: IPremiumDataRangeMappingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.headerIndex = _data["headerIndex"];
            this.startIndex = _data["startIndex"];
            this.endIndex = _data["endIndex"];
        }
    }

    static fromJS(data: any): PremiumDataRangeMappingInput {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumDataRangeMappingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["headerIndex"] = this.headerIndex;
        data["startIndex"] = this.startIndex;
        data["endIndex"] = this.endIndex;
        return data;
    }
}

export interface IPremiumDataRangeMappingInput {
    headerIndex: number;
    startIndex: number;
    endIndex: number;

    [key: string]: any;
}

export class PremiumDataBatchResult implements IPremiumDataBatchResult {
    periodId!: number;
    clientId!: number;
    clientAreaId!: number;
    insurerId!: number;
    filePath!: string;
    fileName!: string;
    storedName!: string;
    isImported!: boolean;
    isCompleted!: boolean;
    isClosed!: boolean;

    [key: string]: any;

    constructor(data?: IPremiumDataBatchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.periodId = _data["periodId"];
            this.clientId = _data["clientId"];
            this.clientAreaId = _data["clientAreaId"];
            this.insurerId = _data["insurerId"];
            this.filePath = _data["filePath"];
            this.fileName = _data["fileName"];
            this.storedName = _data["storedName"];
            this.isImported = _data["isImported"];
            this.isCompleted = _data["isCompleted"];
            this.isClosed = _data["isClosed"];
        }
    }

    static fromJS(data: any): PremiumDataBatchResult {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumDataBatchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["periodId"] = this.periodId;
        data["clientId"] = this.clientId;
        data["clientAreaId"] = this.clientAreaId;
        data["insurerId"] = this.insurerId;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["storedName"] = this.storedName;
        data["isImported"] = this.isImported;
        data["isCompleted"] = this.isCompleted;
        data["isClosed"] = this.isClosed;
        return data;
    }
}

export interface IPremiumDataBatchResult {
    periodId: number;
    clientId: number;
    clientAreaId: number;
    insurerId: number;
    filePath: string;
    fileName: string;
    storedName: string;
    isImported: boolean;
    isCompleted: boolean;
    isClosed: boolean;

    [key: string]: any;
}

export class PremiumDataBatchesResult extends PagingResult implements IPremiumDataBatchesResult {
    results!: PremiumDataBatchesItem[];

    [key: string]: any;

    constructor(data?: IPremiumDataBatchesResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PremiumDataBatchesItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PremiumDataBatchesResult {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumDataBatchesResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPremiumDataBatchesResult extends IPagingResult {
    results: PremiumDataBatchesItem[];

    [key: string]: any;
}

export class PremiumDataBatchesItem implements IPremiumDataBatchesItem {
    id!: number;
    createdAt!: string;
    completedAt!: string;
    updatedAt!: string;
    fileName!: string;
    clientName!: string;
    areaName!: string;
    insurerName!: string;
    period!: string;
    isCompleted!: boolean;

    [key: string]: any;

    constructor(data?: IPremiumDataBatchesItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"];
            this.completedAt = _data["completedAt"];
            this.updatedAt = _data["updatedAt"];
            this.fileName = _data["fileName"];
            this.clientName = _data["clientName"];
            this.areaName = _data["areaName"];
            this.insurerName = _data["insurerName"];
            this.period = _data["period"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): PremiumDataBatchesItem {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumDataBatchesItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt;
        data["completedAt"] = this.completedAt;
        data["updatedAt"] = this.updatedAt;
        data["fileName"] = this.fileName;
        data["clientName"] = this.clientName;
        data["areaName"] = this.areaName;
        data["insurerName"] = this.insurerName;
        data["period"] = this.period;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IPremiumDataBatchesItem {
    id: number;
    createdAt: string;
    completedAt: string;
    updatedAt: string;
    fileName: string;
    clientName: string;
    areaName: string;
    insurerName: string;
    period: string;
    isCompleted: boolean;

    [key: string]: any;
}

export class PremiumDataRangeMappingResult implements IPremiumDataRangeMappingResult {
    id!: number;
    headerIndex!: number;
    startIndex!: number;
    endIndex!: number;

    [key: string]: any;

    constructor(data?: IPremiumDataRangeMappingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.headerIndex = _data["headerIndex"];
            this.startIndex = _data["startIndex"];
            this.endIndex = _data["endIndex"];
        }
    }

    static fromJS(data: any): PremiumDataRangeMappingResult {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumDataRangeMappingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["headerIndex"] = this.headerIndex;
        data["startIndex"] = this.startIndex;
        data["endIndex"] = this.endIndex;
        return data;
    }
}

export interface IPremiumDataRangeMappingResult {
    id: number;
    headerIndex: number;
    startIndex: number;
    endIndex: number;

    [key: string]: any;
}

export class PremiumDataTotalsResult implements IPremiumDataTotalsResult {
    totalRowsImported!: number;
    totalCiPtPremium!: any;

    [key: string]: any;

    constructor(data?: IPremiumDataTotalsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalRowsImported = _data["totalRowsImported"];
            this.totalCiPtPremium = _data["totalCiPtPremium"];
        }
    }

    static fromJS(data: any): PremiumDataTotalsResult {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumDataTotalsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalRowsImported"] = this.totalRowsImported;
        data["totalCiPtPremium"] = this.totalCiPtPremium;
        return data;
    }
}

export interface IPremiumDataTotalsResult {
    totalRowsImported: number;
    totalCiPtPremium: any;

    [key: string]: any;
}

export class SamplePremiumDataResult implements ISamplePremiumDataResult {
    sampleRows!: SamplePremiumDataItem[];

    [key: string]: any;

    constructor(data?: ISamplePremiumDataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["sampleRows"])) {
                this.sampleRows = [] as any;
                for (let item of _data["sampleRows"])
                    this.sampleRows!.push(SamplePremiumDataItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SamplePremiumDataResult {
        data = typeof data === 'object' ? data : {};
        let result = new SamplePremiumDataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.sampleRows)) {
            data["sampleRows"] = [];
            for (let item of this.sampleRows)
                data["sampleRows"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISamplePremiumDataResult {
    sampleRows: SamplePremiumDataItem[];

    [key: string]: any;
}

export class SamplePremiumDataItem implements ISamplePremiumDataItem {
    id!: number;
    clientId!: number;
    clientAreaId!: number;
    premium!: string;
    policyNumber!: string;
    declarationDate!: string;
    declarationAmount!: any;
    ciPremium!: any;
    ptPremium!: any;
    totalImportCipt!: any;
    creditLimitFees!: any;
    rapidResponseFees!: any;

    [key: string]: any;

    constructor(data?: ISamplePremiumDataItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.clientAreaId = _data["clientAreaId"];
            this.premium = _data["premium"];
            this.policyNumber = _data["policyNumber"];
            this.declarationDate = _data["declarationDate"];
            this.declarationAmount = _data["declarationAmount"];
            this.ciPremium = _data["ciPremium"];
            this.ptPremium = _data["ptPremium"];
            this.totalImportCipt = _data["totalImportCipt"];
            this.creditLimitFees = _data["creditLimitFees"];
            this.rapidResponseFees = _data["rapidResponseFees"];
        }
    }

    static fromJS(data: any): SamplePremiumDataItem {
        data = typeof data === 'object' ? data : {};
        let result = new SamplePremiumDataItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["clientAreaId"] = this.clientAreaId;
        data["premium"] = this.premium;
        data["policyNumber"] = this.policyNumber;
        data["declarationDate"] = this.declarationDate;
        data["declarationAmount"] = this.declarationAmount;
        data["ciPremium"] = this.ciPremium;
        data["ptPremium"] = this.ptPremium;
        data["totalImportCipt"] = this.totalImportCipt;
        data["creditLimitFees"] = this.creditLimitFees;
        data["rapidResponseFees"] = this.rapidResponseFees;
        return data;
    }
}

export interface ISamplePremiumDataItem {
    id: number;
    clientId: number;
    clientAreaId: number;
    premium: string;
    policyNumber: string;
    declarationDate: string;
    declarationAmount: any;
    ciPremium: any;
    ptPremium: any;
    totalImportCipt: any;
    creditLimitFees: any;
    rapidResponseFees: any;

    [key: string]: any;
}

/** Represents the input required to upload a premium data file. */
export class PremiumDataUploadFileInput implements IPremiumDataUploadFileInput {
    file!: string;
    periodId!: number;
    insurerId!: number;

    [key: string]: any;

    constructor(data?: IPremiumDataUploadFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
            this.periodId = _data["periodId"];
            this.insurerId = _data["insurerId"];
        }
    }

    static fromJS(data: any): PremiumDataUploadFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumDataUploadFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        data["periodId"] = this.periodId;
        data["insurerId"] = this.insurerId;
        return data;
    }
}

/** Represents the input required to upload a premium data file. */
export interface IPremiumDataUploadFileInput {
    file: string;
    periodId: number;
    insurerId: number;

    [key: string]: any;
}

export class RenewalClaimRangeMappingInput implements IRenewalClaimRangeMappingInput {
    headerIndex!: number;
    startIndex!: number;
    endIndex!: number;

    [key: string]: any;

    constructor(data?: IRenewalClaimRangeMappingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.headerIndex = _data["headerIndex"];
            this.startIndex = _data["startIndex"];
            this.endIndex = _data["endIndex"];
        }
    }

    static fromJS(data: any): RenewalClaimRangeMappingInput {
        data = typeof data === 'object' ? data : {};
        let result = new RenewalClaimRangeMappingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["headerIndex"] = this.headerIndex;
        data["startIndex"] = this.startIndex;
        data["endIndex"] = this.endIndex;
        return data;
    }
}

export interface IRenewalClaimRangeMappingInput {
    headerIndex: number;
    startIndex: number;
    endIndex: number;

    [key: string]: any;
}

export class FilteredPendingBatchesResult extends PagingResult implements IFilteredPendingBatchesResult {
    results!: FilteredPendingBatchItem[];

    [key: string]: any;

    constructor(data?: IFilteredPendingBatchesResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FilteredPendingBatchItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FilteredPendingBatchesResult {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredPendingBatchesResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFilteredPendingBatchesResult extends IPagingResult {
    results: FilteredPendingBatchItem[];

    [key: string]: any;
}

export class FilteredPendingBatchItem implements IFilteredPendingBatchItem {
    id!: number;
    createdAt!: string;
    completedAt!: string;
    updatedAt!: string;
    fileName!: string;
    clientName!: string;
    areaName!: string;
    insurerName!: string;
    period!: string;

    [key: string]: any;

    constructor(data?: IFilteredPendingBatchItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"];
            this.completedAt = _data["completedAt"];
            this.updatedAt = _data["updatedAt"];
            this.fileName = _data["fileName"];
            this.clientName = _data["clientName"];
            this.areaName = _data["areaName"];
            this.insurerName = _data["insurerName"];
            this.period = _data["period"];
        }
    }

    static fromJS(data: any): FilteredPendingBatchItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredPendingBatchItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt;
        data["completedAt"] = this.completedAt;
        data["updatedAt"] = this.updatedAt;
        data["fileName"] = this.fileName;
        data["clientName"] = this.clientName;
        data["areaName"] = this.areaName;
        data["insurerName"] = this.insurerName;
        data["period"] = this.period;
        return data;
    }
}

export interface IFilteredPendingBatchItem {
    id: number;
    createdAt: string;
    completedAt: string;
    updatedAt: string;
    fileName: string;
    clientName: string;
    areaName: string;
    insurerName: string;
    period: string;

    [key: string]: any;
}

export class RenewalClaimBatchResult implements IRenewalClaimBatchResult {
    periodId!: number;
    clientId!: number;
    clientAreaId!: number;
    insurerId!: number;
    filePath!: string;
    fileName!: string;
    storedName!: string;
    isImported!: boolean;
    isCompleted!: boolean;

    [key: string]: any;

    constructor(data?: IRenewalClaimBatchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.periodId = _data["periodId"];
            this.clientId = _data["clientId"];
            this.clientAreaId = _data["clientAreaId"];
            this.insurerId = _data["insurerId"];
            this.filePath = _data["filePath"];
            this.fileName = _data["fileName"];
            this.storedName = _data["storedName"];
            this.isImported = _data["isImported"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): RenewalClaimBatchResult {
        data = typeof data === 'object' ? data : {};
        let result = new RenewalClaimBatchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["periodId"] = this.periodId;
        data["clientId"] = this.clientId;
        data["clientAreaId"] = this.clientAreaId;
        data["insurerId"] = this.insurerId;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["storedName"] = this.storedName;
        data["isImported"] = this.isImported;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IRenewalClaimBatchResult {
    periodId: number;
    clientId: number;
    clientAreaId: number;
    insurerId: number;
    filePath: string;
    fileName: string;
    storedName: string;
    isImported: boolean;
    isCompleted: boolean;

    [key: string]: any;
}

export class RenewalClaimRangeMappingResult implements IRenewalClaimRangeMappingResult {
    id!: number;
    headerIndex!: number;
    startIndex!: number;
    endIndex!: number;

    [key: string]: any;

    constructor(data?: IRenewalClaimRangeMappingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.headerIndex = _data["headerIndex"];
            this.startIndex = _data["startIndex"];
            this.endIndex = _data["endIndex"];
        }
    }

    static fromJS(data: any): RenewalClaimRangeMappingResult {
        data = typeof data === 'object' ? data : {};
        let result = new RenewalClaimRangeMappingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["headerIndex"] = this.headerIndex;
        data["startIndex"] = this.startIndex;
        data["endIndex"] = this.endIndex;
        return data;
    }
}

export interface IRenewalClaimRangeMappingResult {
    id: number;
    headerIndex: number;
    startIndex: number;
    endIndex: number;

    [key: string]: any;
}

export class SampleRenewalClaimDataResult implements ISampleRenewalClaimDataResult {
    sampleRows!: SampleRenewalClaimDataItem[];

    [key: string]: any;

    constructor(data?: ISampleRenewalClaimDataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["sampleRows"])) {
                this.sampleRows = [] as any;
                for (let item of _data["sampleRows"])
                    this.sampleRows!.push(SampleRenewalClaimDataItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SampleRenewalClaimDataResult {
        data = typeof data === 'object' ? data : {};
        let result = new SampleRenewalClaimDataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.sampleRows)) {
            data["sampleRows"] = [];
            for (let item of this.sampleRows)
                data["sampleRows"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISampleRenewalClaimDataResult {
    sampleRows: SampleRenewalClaimDataItem[];

    [key: string]: any;
}

export class SampleRenewalClaimDataItem implements ISampleRenewalClaimDataItem {
    id!: number;
    policyNumber!: string;
    claimNumber!: string;
    debtorName!: string;
    dateClaimReceived!: string;
    status!: string;
    grossClaimAmount!: number;
    causeOfLoss!: string;
    dateDueForPayment!: string;
    datePaid!: string;
    indemnityAmount!: number;
    totalLegalFees!: number;
    totalSalvages!: number;

    [key: string]: any;

    constructor(data?: ISampleRenewalClaimDataItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.policyNumber = _data["policyNumber"];
            this.claimNumber = _data["claimNumber"];
            this.debtorName = _data["debtorName"];
            this.dateClaimReceived = _data["dateClaimReceived"];
            this.status = _data["status"];
            this.grossClaimAmount = _data["grossClaimAmount"];
            this.causeOfLoss = _data["causeOfLoss"];
            this.dateDueForPayment = _data["dateDueForPayment"];
            this.datePaid = _data["datePaid"];
            this.indemnityAmount = _data["indemnityAmount"];
            this.totalLegalFees = _data["totalLegalFees"];
            this.totalSalvages = _data["totalSalvages"];
        }
    }

    static fromJS(data: any): SampleRenewalClaimDataItem {
        data = typeof data === 'object' ? data : {};
        let result = new SampleRenewalClaimDataItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["policyNumber"] = this.policyNumber;
        data["claimNumber"] = this.claimNumber;
        data["debtorName"] = this.debtorName;
        data["dateClaimReceived"] = this.dateClaimReceived;
        data["status"] = this.status;
        data["grossClaimAmount"] = this.grossClaimAmount;
        data["causeOfLoss"] = this.causeOfLoss;
        data["dateDueForPayment"] = this.dateDueForPayment;
        data["datePaid"] = this.datePaid;
        data["indemnityAmount"] = this.indemnityAmount;
        data["totalLegalFees"] = this.totalLegalFees;
        data["totalSalvages"] = this.totalSalvages;
        return data;
    }
}

export interface ISampleRenewalClaimDataItem {
    id: number;
    policyNumber: string;
    claimNumber: string;
    debtorName: string;
    dateClaimReceived: string;
    status: string;
    grossClaimAmount: number;
    causeOfLoss: string;
    dateDueForPayment: string;
    datePaid: string;
    indemnityAmount: number;
    totalLegalFees: number;
    totalSalvages: number;

    [key: string]: any;
}

export class RenewalClaimTotalsResult implements IRenewalClaimTotalsResult {
    totalRowsImported!: number;

    [key: string]: any;

    constructor(data?: IRenewalClaimTotalsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalRowsImported = _data["totalRowsImported"];
        }
    }

    static fromJS(data: any): RenewalClaimTotalsResult {
        data = typeof data === 'object' ? data : {};
        let result = new RenewalClaimTotalsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalRowsImported"] = this.totalRowsImported;
        return data;
    }
}

export interface IRenewalClaimTotalsResult {
    totalRowsImported: number;

    [key: string]: any;
}

export class DeclarationReportPackInput implements IDeclarationReportPackInput {
    clientId!: number;
    clientAreaId!: number;
    periodId!: number;
    emailAddress!: string | undefined;
    dateSent!: string | undefined;
    reportStatus!: string | undefined;

    [key: string]: any;

    constructor(data?: IDeclarationReportPackInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.clientId = _data["clientId"];
            this.clientAreaId = _data["clientAreaId"];
            this.periodId = _data["periodId"];
            this.emailAddress = _data["emailAddress"];
            this.dateSent = _data["dateSent"];
            this.reportStatus = _data["reportStatus"];
        }
    }

    static fromJS(data: any): DeclarationReportPackInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationReportPackInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["clientId"] = this.clientId;
        data["clientAreaId"] = this.clientAreaId;
        data["periodId"] = this.periodId;
        data["emailAddress"] = this.emailAddress;
        data["dateSent"] = this.dateSent;
        data["reportStatus"] = this.reportStatus;
        return data;
    }
}

export interface IDeclarationReportPackInput {
    clientId: number;
    clientAreaId: number;
    periodId: number;
    emailAddress: string | undefined;
    dateSent: string | undefined;
    reportStatus: string | undefined;

    [key: string]: any;
}

export class RenewalReportPackInput implements IRenewalReportPackInput {
    clientId!: number;
    clientAreaId!: number;
    startDate!: Date;
    endDate!: Date;
    emailAddress!: string | undefined;
    dateSent!: Date | undefined;
    reportStatus!: string | undefined;
    createdAt!: Date;
    updatedAt!: Date | undefined;
    deletedAt!: Date | undefined;

    [key: string]: any;

    constructor(data?: IRenewalReportPackInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.clientId = _data["clientId"];
            this.clientAreaId = _data["clientAreaId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.dateSent = _data["dateSent"] ? new Date(_data["dateSent"].toString()) : <any>undefined;
            this.reportStatus = _data["reportStatus"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RenewalReportPackInput {
        data = typeof data === 'object' ? data : {};
        let result = new RenewalReportPackInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["clientId"] = this.clientId;
        data["clientAreaId"] = this.clientAreaId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["dateSent"] = this.dateSent ? this.dateSent.toISOString() : <any>undefined;
        data["reportStatus"] = this.reportStatus;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRenewalReportPackInput {
    clientId: number;
    clientAreaId: number;
    startDate: Date;
    endDate: Date;
    emailAddress: string | undefined;
    dateSent: Date | undefined;
    reportStatus: string | undefined;
    createdAt: Date;
    updatedAt: Date | undefined;
    deletedAt: Date | undefined;

    [key: string]: any;
}

export class AgeingExportReportResult implements IAgeingExportReportResult {
    results!: any[];
    /** Total number of records available */
    totalCount!: number;
    /** Whether this is a preview (limited rows) */
    isPreview!: boolean;

    [key: string]: any;

    constructor(data?: IAgeingExportReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
            this.totalCount = _data["totalCount"];
            this.isPreview = _data["isPreview"];
        }
    }

    static fromJS(data: any): AgeingExportReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new AgeingExportReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        data["totalCount"] = this.totalCount;
        data["isPreview"] = this.isPreview;
        return data;
    }
}

export interface IAgeingExportReportResult {
    results: any[];
    /** Total number of records available */
    totalCount: number;
    /** Whether this is a preview (limited rows) */
    isPreview: boolean;

    [key: string]: any;
}

export class AgeingExportReportItem implements IAgeingExportReportItem {
    id!: number;
    customerName!: string;
    customerCompanyRegistrationNumber!: string;
    annexurePolicyNumber!: string;
    annexurePolicyReference!: string;
    ageingPolicyReference!: string;
    customerCode!: string;
    paymentTerms!: string;
    currentMonth!: number;
    insurerName!: string;
    total!: any;
    balanceCurrent!: any;
    balance30Days!: any;
    balance60Days!: any;
    balance90Days!: any;
    balance120Days!: any;
    balance150Days!: any;
    balance180Days!: any;
    balanceOver180Days!: any;

    [key: string]: any;

    constructor(data?: IAgeingExportReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.customerName = _data["customerName"];
            this.customerCompanyRegistrationNumber = _data["customerCompanyRegistrationNumber"];
            this.annexurePolicyNumber = _data["annexurePolicyNumber"];
            this.annexurePolicyReference = _data["annexurePolicyReference"];
            this.ageingPolicyReference = _data["ageingPolicyReference"];
            this.customerCode = _data["customerCode"];
            this.paymentTerms = _data["paymentTerms"];
            this.currentMonth = _data["currentMonth"];
            this.insurerName = _data["insurerName"];
            this.total = _data["total"];
            this.balanceCurrent = _data["balanceCurrent"];
            this.balance30Days = _data["balance30Days"];
            this.balance60Days = _data["balance60Days"];
            this.balance90Days = _data["balance90Days"];
            this.balance120Days = _data["balance120Days"];
            this.balance150Days = _data["balance150Days"];
            this.balance180Days = _data["balance180Days"];
            this.balanceOver180Days = _data["balanceOver180Days"];
        }
    }

    static fromJS(data: any): AgeingExportReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new AgeingExportReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["customerName"] = this.customerName;
        data["customerCompanyRegistrationNumber"] = this.customerCompanyRegistrationNumber;
        data["annexurePolicyNumber"] = this.annexurePolicyNumber;
        data["annexurePolicyReference"] = this.annexurePolicyReference;
        data["ageingPolicyReference"] = this.ageingPolicyReference;
        data["customerCode"] = this.customerCode;
        data["paymentTerms"] = this.paymentTerms;
        data["currentMonth"] = this.currentMonth;
        data["insurerName"] = this.insurerName;
        data["total"] = this.total;
        data["balanceCurrent"] = this.balanceCurrent;
        data["balance30Days"] = this.balance30Days;
        data["balance60Days"] = this.balance60Days;
        data["balance90Days"] = this.balance90Days;
        data["balance120Days"] = this.balance120Days;
        data["balance150Days"] = this.balance150Days;
        data["balance180Days"] = this.balance180Days;
        data["balanceOver180Days"] = this.balanceOver180Days;
        return data;
    }
}

export interface IAgeingExportReportItem {
    id: number;
    customerName: string;
    customerCompanyRegistrationNumber: string;
    annexurePolicyNumber: string;
    annexurePolicyReference: string;
    ageingPolicyReference: string;
    customerCode: string;
    paymentTerms: string;
    currentMonth: number;
    insurerName: string;
    total: any;
    balanceCurrent: any;
    balance30Days: any;
    balance60Days: any;
    balance90Days: any;
    balance120Days: any;
    balance150Days: any;
    balance180Days: any;
    balanceOver180Days: any;

    [key: string]: any;
}

export class AnnexureExportReportResult implements IAnnexureExportReportResult {
    results!: any[];
    /** Total number of records available */
    totalCount!: number;
    /** Whether this is a preview (limited rows) */
    isPreview!: boolean;

    [key: string]: any;

    constructor(data?: IAnnexureExportReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
            this.totalCount = _data["totalCount"];
            this.isPreview = _data["isPreview"];
        }
    }

    static fromJS(data: any): AnnexureExportReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new AnnexureExportReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        data["totalCount"] = this.totalCount;
        data["isPreview"] = this.isPreview;
        return data;
    }
}

export interface IAnnexureExportReportResult {
    results: any[];
    /** Total number of records available */
    totalCount: number;
    /** Whether this is a preview (limited rows) */
    isPreview: boolean;

    [key: string]: any;
}

export class AnnexureExportReportItem implements IAnnexureExportReportItem {
    id!: number;
    policyNumber!: string;
    buyerName!: string;
    currency!: string;
    country!: string;
    period!: Date;
    inceptionDate!: Date;
    requestedLimit!: any;
    approvedLimit!: any;

    [key: string]: any;

    constructor(data?: IAnnexureExportReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.policyNumber = _data["policyNumber"];
            this.buyerName = _data["buyerName"];
            this.currency = _data["currency"];
            this.country = _data["country"];
            this.period = _data["period"] ? new Date(_data["period"].toString()) : <any>undefined;
            this.inceptionDate = _data["inceptionDate"] ? new Date(_data["inceptionDate"].toString()) : <any>undefined;
            this.requestedLimit = _data["requestedLimit"];
            this.approvedLimit = _data["approvedLimit"];
        }
    }

    static fromJS(data: any): AnnexureExportReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new AnnexureExportReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["policyNumber"] = this.policyNumber;
        data["buyerName"] = this.buyerName;
        data["currency"] = this.currency;
        data["country"] = this.country;
        data["period"] = this.period ? formatDate(this.period) : <any>undefined;
        data["inceptionDate"] = this.inceptionDate ? formatDate(this.inceptionDate) : <any>undefined;
        data["requestedLimit"] = this.requestedLimit;
        data["approvedLimit"] = this.approvedLimit;
        return data;
    }
}

export interface IAnnexureExportReportItem {
    id: number;
    policyNumber: string;
    buyerName: string;
    currency: string;
    country: string;
    period: Date;
    inceptionDate: Date;
    requestedLimit: any;
    approvedLimit: any;

    [key: string]: any;
}

export class ApprovedVersusGrantedReportResult implements IApprovedVersusGrantedReportResult {
    results!: ApprovedVersusGrantedReportItem[];

    [key: string]: any;

    constructor(data?: IApprovedVersusGrantedReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ApprovedVersusGrantedReportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApprovedVersusGrantedReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovedVersusGrantedReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApprovedVersusGrantedReportResult {
    results: ApprovedVersusGrantedReportItem[];

    [key: string]: any;
}

export class ApprovedVersusGrantedReportItem implements IApprovedVersusGrantedReportItem {
    clientName!: string;
    clientAreaName!: string;
    policyNumber!: number;
    requestedLimit!: number;
    approvedLimit!: number;
    delta!: number;
    period!: string;

    [key: string]: any;

    constructor(data?: IApprovedVersusGrantedReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.clientName = _data["clientName"];
            this.clientAreaName = _data["clientAreaName"];
            this.policyNumber = _data["policyNumber"];
            this.requestedLimit = _data["requestedLimit"];
            this.approvedLimit = _data["approvedLimit"];
            this.delta = _data["delta"];
            this.period = _data["period"];
        }
    }

    static fromJS(data: any): ApprovedVersusGrantedReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovedVersusGrantedReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["clientName"] = this.clientName;
        data["clientAreaName"] = this.clientAreaName;
        data["policyNumber"] = this.policyNumber;
        data["requestedLimit"] = this.requestedLimit;
        data["approvedLimit"] = this.approvedLimit;
        data["delta"] = this.delta;
        data["period"] = this.period;
        return data;
    }
}

export interface IApprovedVersusGrantedReportItem {
    clientName: string;
    clientAreaName: string;
    policyNumber: number;
    requestedLimit: number;
    approvedLimit: number;
    delta: number;
    period: string;

    [key: string]: any;
}

export class LastTwelveMonthsClaimsResult implements ILastTwelveMonthsClaimsResult {
    results!: LastTwelveMonthsClaimItem[];

    [key: string]: any;

    constructor(data?: ILastTwelveMonthsClaimsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(LastTwelveMonthsClaimItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LastTwelveMonthsClaimsResult {
        data = typeof data === 'object' ? data : {};
        let result = new LastTwelveMonthsClaimsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILastTwelveMonthsClaimsResult {
    results: LastTwelveMonthsClaimItem[];

    [key: string]: any;
}

export class LastTwelveMonthsClaimItem implements ILastTwelveMonthsClaimItem {
    /** yyyy/MM/dd (as returned by SQL FORMAT) */
    claimReceived!: string;
    buyerName!: string;
    status!: string | undefined;
    /** Formatted amount e.g. "71,626,500.00" */
    grossAmount!: string;
    /** Formatted amount e.g. "0.00" */
    indemnityAmount!: string;
    /** yyyy/MM/dd (as returned by SQL FORMAT) */
    claimDueForPayment!: string;
    /** Formatted percentage e.g. "78.28%" */
    exposurePercentage!: string;

    [key: string]: any;

    constructor(data?: ILastTwelveMonthsClaimItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.claimReceived = _data["claimReceived"];
            this.buyerName = _data["buyerName"];
            this.status = _data["status"];
            this.grossAmount = _data["grossAmount"];
            this.indemnityAmount = _data["indemnityAmount"];
            this.claimDueForPayment = _data["claimDueForPayment"];
            this.exposurePercentage = _data["exposurePercentage"];
        }
    }

    static fromJS(data: any): LastTwelveMonthsClaimItem {
        data = typeof data === 'object' ? data : {};
        let result = new LastTwelveMonthsClaimItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["claimReceived"] = this.claimReceived;
        data["buyerName"] = this.buyerName;
        data["status"] = this.status;
        data["grossAmount"] = this.grossAmount;
        data["indemnityAmount"] = this.indemnityAmount;
        data["claimDueForPayment"] = this.claimDueForPayment;
        data["exposurePercentage"] = this.exposurePercentage;
        return data;
    }
}

export interface ILastTwelveMonthsClaimItem {
    /** yyyy/MM/dd (as returned by SQL FORMAT) */
    claimReceived: string;
    buyerName: string;
    status: string | undefined;
    /** Formatted amount e.g. "71,626,500.00" */
    grossAmount: string;
    /** Formatted amount e.g. "0.00" */
    indemnityAmount: string;
    /** yyyy/MM/dd (as returned by SQL FORMAT) */
    claimDueForPayment: string;
    /** Formatted percentage e.g. "78.28%" */
    exposurePercentage: string;

    [key: string]: any;
}

export class ClaimReportResult implements IClaimReportResult {
    results!: ClaimReportItem[];

    [key: string]: any;

    constructor(data?: IClaimReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ClaimReportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClaimReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClaimReportResult {
    results: ClaimReportItem[];

    [key: string]: any;
}

export class ClaimReportItem implements IClaimReportItem {
    buyerName!: string;
    period!: string;
    status!: string;
    grossAmount!: number;
    datePaid!: string;
    totalSalvages!: number;
    totalLegalFees!: number;
    idemnityAmount!: number;
    paidCount!: number;
    claimCount!: number;

    [key: string]: any;

    constructor(data?: IClaimReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buyerName = _data["buyerName"];
            this.period = _data["period"];
            this.status = _data["status"];
            this.grossAmount = _data["grossAmount"];
            this.datePaid = _data["datePaid"];
            this.totalSalvages = _data["totalSalvages"];
            this.totalLegalFees = _data["totalLegalFees"];
            this.idemnityAmount = _data["idemnityAmount"];
            this.paidCount = _data["paidCount"];
            this.claimCount = _data["claimCount"];
        }
    }

    static fromJS(data: any): ClaimReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buyerName"] = this.buyerName;
        data["period"] = this.period;
        data["status"] = this.status;
        data["grossAmount"] = this.grossAmount;
        data["datePaid"] = this.datePaid;
        data["totalSalvages"] = this.totalSalvages;
        data["totalLegalFees"] = this.totalLegalFees;
        data["idemnityAmount"] = this.idemnityAmount;
        data["paidCount"] = this.paidCount;
        data["claimCount"] = this.claimCount;
        return data;
    }
}

export interface IClaimReportItem {
    buyerName: string;
    period: string;
    status: string;
    grossAmount: number;
    datePaid: string;
    totalSalvages: number;
    totalLegalFees: number;
    idemnityAmount: number;
    paidCount: number;
    claimCount: number;

    [key: string]: any;
}

export class CompleteRecordsReportResult implements ICompleteRecordsReportResult {
    results!: CompleteRecordsReportItem[];
    totalBalance!: any;
    totalLimit!: any;
    totalVat!: any;

    [key: string]: any;

    constructor(data?: ICompleteRecordsReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CompleteRecordsReportItem.fromJS(item));
            }
            this.totalBalance = _data["totalBalance"];
            this.totalLimit = _data["totalLimit"];
            this.totalVat = _data["totalVat"];
        }
    }

    static fromJS(data: any): CompleteRecordsReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteRecordsReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["totalBalance"] = this.totalBalance;
        data["totalLimit"] = this.totalLimit;
        data["totalVat"] = this.totalVat;
        return data;
    }
}

export interface ICompleteRecordsReportResult {
    results: CompleteRecordsReportItem[];
    totalBalance: any;
    totalLimit: any;
    totalVat: any;

    [key: string]: any;
}

export class CompleteRecordsReportItem implements ICompleteRecordsReportItem {
    buyerCode!: string;
    buyerName!: string;
    debtorCode!: string;
    debtorName!: string;
    limit!: number;
    balance!: number;
    totalVATPortion!: number;
    sales!: string;
    country!: string;
    policyNumber!: string;
    group!: string;
    buyerCount!: number;

    [key: string]: any;

    constructor(data?: ICompleteRecordsReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buyerCode = _data["buyerCode"];
            this.buyerName = _data["buyerName"];
            this.debtorCode = _data["debtorCode"];
            this.debtorName = _data["debtorName"];
            this.limit = _data["limit"];
            this.balance = _data["balance"];
            this.totalVATPortion = _data["totalVATPortion"];
            this.sales = _data["sales"];
            this.country = _data["country"];
            this.policyNumber = _data["policyNumber"];
            this.group = _data["group"];
            this.buyerCount = _data["buyerCount"];
        }
    }

    static fromJS(data: any): CompleteRecordsReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteRecordsReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buyerCode"] = this.buyerCode;
        data["buyerName"] = this.buyerName;
        data["debtorCode"] = this.debtorCode;
        data["debtorName"] = this.debtorName;
        data["limit"] = this.limit;
        data["balance"] = this.balance;
        data["totalVATPortion"] = this.totalVATPortion;
        data["sales"] = this.sales;
        data["country"] = this.country;
        data["policyNumber"] = this.policyNumber;
        data["group"] = this.group;
        data["buyerCount"] = this.buyerCount;
        return data;
    }
}

export interface ICompleteRecordsReportItem {
    buyerCode: string;
    buyerName: string;
    debtorCode: string;
    debtorName: string;
    limit: number;
    balance: number;
    totalVATPortion: number;
    sales: string;
    country: string;
    policyNumber: string;
    group: string;
    buyerCount: number;

    [key: string]: any;
}

export class DashboardChecklistReportResult implements IDashboardChecklistReportResult {
    results!: DashboardChecklistReportItem[];

    [key: string]: any;

    constructor(data?: IDashboardChecklistReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DashboardChecklistReportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardChecklistReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardChecklistReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDashboardChecklistReportResult {
    results: DashboardChecklistReportItem[];

    [key: string]: any;
}

export class DashboardChecklistReportItem implements IDashboardChecklistReportItem {
    p0_Period!: string;
    p1_Period!: string;
    p0_TotalCompleteRec!: number;
    p1_TotalCompleteRec!: number;
    var_totalCompleteRec!: number;
    p0_InsuredDebtors!: number;
    p1_InsuredDebtors!: number;
    var_InsuredDebtors!: number;
    p0_NoCover!: number;
    p1_NoCover!: number;
    var_NoCover!: number;
    p0_NilLimits!: number;
    p1_NilLimits!: number;
    var_NilLimits!: number;
    p0_ValExcludedBuyers!: number;
    p1_ValExcludedBuyers!: number;
    var_ValExcludedBuyers!: number;
    p0_Uninsurable!: number;
    p1_Uninsurable!: number;
    var_Uninsurable!: number;
    p0_Uninsurable_Intercompany!: number;
    p1_Uninsurable_Intercompany!: number;
    var_Uninsurable_Intercompany!: number;
    p0_Uninsurable_Cash!: number;
    p1_Uninsurable_Cash!: number;
    var_Uninsurable_Cash!: number;
    p0_Uninsurable_Government!: number;
    p1_Uninsurable_Government!: number;
    var_Uninsurable_Government!: number;
    p0_UninsuredOther!: number;
    p1_UninsuredOther!: number;
    var_UninsuredOther!: number;
    p0_ValDebtorsOver90days!: number;
    p1_ValDebtorsOver90days!: number;
    var_ValDebtorsOver90days!: number;
    p0_ValDebtorsUninsured!: number;
    p1_ValDebtorsUninsured!: number;
    var_ValDebtorsUninsured!: number;
    p0_ValOvertradedLimits!: number;
    p1_ValOvertradedLimits!: number;
    var_ValOvertradedLimits!: number;
    p0_ValDebtorsFranchiseLoss!: number;
    p1_ValDebtorsFranchiseLoss!: number;
    var_ValDebtorsFranchiseLoss!: number;
    p0_ValUnutilizedCredit!: number;
    p1_ValUnutilizedCredit!: number;
    var_ValUnutilizedCredit!: number;
    p0_ValDeclinedByInsurer!: number;
    p1_ValDeclinedByInsurer!: number;
    var_ValDeclinedByInsurer!: number;
    p0_ValInsuredCreditLimit!: number;
    p1_ValInsuredCreditLimit!: number;
    var_ValInsuredCreditLimit!: number;
    p0_ValNegativeBalance!: number;
    p1_ValNegativeBalance!: number;
    var_ValNegativeBalance!: number;
    p0_Uninsurable_Other!: number;
    p1_Uninsurable_Other!: number;
    var_Uninsurable_Other!: number;

    [key: string]: any;

    constructor(data?: IDashboardChecklistReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.p0_Period = _data["p0_Period"];
            this.p1_Period = _data["p1_Period"];
            this.p0_TotalCompleteRec = _data["p0_TotalCompleteRec"];
            this.p1_TotalCompleteRec = _data["p1_TotalCompleteRec"];
            this.var_totalCompleteRec = _data["var_totalCompleteRec"];
            this.p0_InsuredDebtors = _data["p0_InsuredDebtors"];
            this.p1_InsuredDebtors = _data["p1_InsuredDebtors"];
            this.var_InsuredDebtors = _data["var_InsuredDebtors"];
            this.p0_NoCover = _data["p0_NoCover"];
            this.p1_NoCover = _data["p1_NoCover"];
            this.var_NoCover = _data["var_NoCover"];
            this.p0_NilLimits = _data["p0_NilLimits"];
            this.p1_NilLimits = _data["p1_NilLimits"];
            this.var_NilLimits = _data["var_NilLimits"];
            this.p0_ValExcludedBuyers = _data["p0_ValExcludedBuyers"];
            this.p1_ValExcludedBuyers = _data["p1_ValExcludedBuyers"];
            this.var_ValExcludedBuyers = _data["var_ValExcludedBuyers"];
            this.p0_Uninsurable = _data["p0_Uninsurable"];
            this.p1_Uninsurable = _data["p1_Uninsurable"];
            this.var_Uninsurable = _data["var_Uninsurable"];
            this.p0_Uninsurable_Intercompany = _data["p0_Uninsurable_Intercompany"];
            this.p1_Uninsurable_Intercompany = _data["p1_Uninsurable_Intercompany"];
            this.var_Uninsurable_Intercompany = _data["var_Uninsurable_Intercompany"];
            this.p0_Uninsurable_Cash = _data["p0_Uninsurable_Cash"];
            this.p1_Uninsurable_Cash = _data["p1_Uninsurable_Cash"];
            this.var_Uninsurable_Cash = _data["var_Uninsurable_Cash"];
            this.p0_Uninsurable_Government = _data["p0_Uninsurable_Government"];
            this.p1_Uninsurable_Government = _data["p1_Uninsurable_Government"];
            this.var_Uninsurable_Government = _data["var_Uninsurable_Government"];
            this.p0_UninsuredOther = _data["p0_UninsuredOther"];
            this.p1_UninsuredOther = _data["p1_UninsuredOther"];
            this.var_UninsuredOther = _data["var_UninsuredOther"];
            this.p0_ValDebtorsOver90days = _data["p0_ValDebtorsOver90days"];
            this.p1_ValDebtorsOver90days = _data["p1_ValDebtorsOver90days"];
            this.var_ValDebtorsOver90days = _data["var_ValDebtorsOver90days"];
            this.p0_ValDebtorsUninsured = _data["p0_ValDebtorsUninsured"];
            this.p1_ValDebtorsUninsured = _data["p1_ValDebtorsUninsured"];
            this.var_ValDebtorsUninsured = _data["var_ValDebtorsUninsured"];
            this.p0_ValOvertradedLimits = _data["p0_ValOvertradedLimits"];
            this.p1_ValOvertradedLimits = _data["p1_ValOvertradedLimits"];
            this.var_ValOvertradedLimits = _data["var_ValOvertradedLimits"];
            this.p0_ValDebtorsFranchiseLoss = _data["p0_ValDebtorsFranchiseLoss"];
            this.p1_ValDebtorsFranchiseLoss = _data["p1_ValDebtorsFranchiseLoss"];
            this.var_ValDebtorsFranchiseLoss = _data["var_ValDebtorsFranchiseLoss"];
            this.p0_ValUnutilizedCredit = _data["p0_ValUnutilizedCredit"];
            this.p1_ValUnutilizedCredit = _data["p1_ValUnutilizedCredit"];
            this.var_ValUnutilizedCredit = _data["var_ValUnutilizedCredit"];
            this.p0_ValDeclinedByInsurer = _data["p0_ValDeclinedByInsurer"];
            this.p1_ValDeclinedByInsurer = _data["p1_ValDeclinedByInsurer"];
            this.var_ValDeclinedByInsurer = _data["var_ValDeclinedByInsurer"];
            this.p0_ValInsuredCreditLimit = _data["p0_ValInsuredCreditLimit"];
            this.p1_ValInsuredCreditLimit = _data["p1_ValInsuredCreditLimit"];
            this.var_ValInsuredCreditLimit = _data["var_ValInsuredCreditLimit"];
            this.p0_ValNegativeBalance = _data["p0_ValNegativeBalance"];
            this.p1_ValNegativeBalance = _data["p1_ValNegativeBalance"];
            this.var_ValNegativeBalance = _data["var_ValNegativeBalance"];
            this.p0_Uninsurable_Other = _data["p0_Uninsurable_Other"];
            this.p1_Uninsurable_Other = _data["p1_Uninsurable_Other"];
            this.var_Uninsurable_Other = _data["var_Uninsurable_Other"];
        }
    }

    static fromJS(data: any): DashboardChecklistReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardChecklistReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["p0_Period"] = this.p0_Period;
        data["p1_Period"] = this.p1_Period;
        data["p0_TotalCompleteRec"] = this.p0_TotalCompleteRec;
        data["p1_TotalCompleteRec"] = this.p1_TotalCompleteRec;
        data["var_totalCompleteRec"] = this.var_totalCompleteRec;
        data["p0_InsuredDebtors"] = this.p0_InsuredDebtors;
        data["p1_InsuredDebtors"] = this.p1_InsuredDebtors;
        data["var_InsuredDebtors"] = this.var_InsuredDebtors;
        data["p0_NoCover"] = this.p0_NoCover;
        data["p1_NoCover"] = this.p1_NoCover;
        data["var_NoCover"] = this.var_NoCover;
        data["p0_NilLimits"] = this.p0_NilLimits;
        data["p1_NilLimits"] = this.p1_NilLimits;
        data["var_NilLimits"] = this.var_NilLimits;
        data["p0_ValExcludedBuyers"] = this.p0_ValExcludedBuyers;
        data["p1_ValExcludedBuyers"] = this.p1_ValExcludedBuyers;
        data["var_ValExcludedBuyers"] = this.var_ValExcludedBuyers;
        data["p0_Uninsurable"] = this.p0_Uninsurable;
        data["p1_Uninsurable"] = this.p1_Uninsurable;
        data["var_Uninsurable"] = this.var_Uninsurable;
        data["p0_Uninsurable_Intercompany"] = this.p0_Uninsurable_Intercompany;
        data["p1_Uninsurable_Intercompany"] = this.p1_Uninsurable_Intercompany;
        data["var_Uninsurable_Intercompany"] = this.var_Uninsurable_Intercompany;
        data["p0_Uninsurable_Cash"] = this.p0_Uninsurable_Cash;
        data["p1_Uninsurable_Cash"] = this.p1_Uninsurable_Cash;
        data["var_Uninsurable_Cash"] = this.var_Uninsurable_Cash;
        data["p0_Uninsurable_Government"] = this.p0_Uninsurable_Government;
        data["p1_Uninsurable_Government"] = this.p1_Uninsurable_Government;
        data["var_Uninsurable_Government"] = this.var_Uninsurable_Government;
        data["p0_UninsuredOther"] = this.p0_UninsuredOther;
        data["p1_UninsuredOther"] = this.p1_UninsuredOther;
        data["var_UninsuredOther"] = this.var_UninsuredOther;
        data["p0_ValDebtorsOver90days"] = this.p0_ValDebtorsOver90days;
        data["p1_ValDebtorsOver90days"] = this.p1_ValDebtorsOver90days;
        data["var_ValDebtorsOver90days"] = this.var_ValDebtorsOver90days;
        data["p0_ValDebtorsUninsured"] = this.p0_ValDebtorsUninsured;
        data["p1_ValDebtorsUninsured"] = this.p1_ValDebtorsUninsured;
        data["var_ValDebtorsUninsured"] = this.var_ValDebtorsUninsured;
        data["p0_ValOvertradedLimits"] = this.p0_ValOvertradedLimits;
        data["p1_ValOvertradedLimits"] = this.p1_ValOvertradedLimits;
        data["var_ValOvertradedLimits"] = this.var_ValOvertradedLimits;
        data["p0_ValDebtorsFranchiseLoss"] = this.p0_ValDebtorsFranchiseLoss;
        data["p1_ValDebtorsFranchiseLoss"] = this.p1_ValDebtorsFranchiseLoss;
        data["var_ValDebtorsFranchiseLoss"] = this.var_ValDebtorsFranchiseLoss;
        data["p0_ValUnutilizedCredit"] = this.p0_ValUnutilizedCredit;
        data["p1_ValUnutilizedCredit"] = this.p1_ValUnutilizedCredit;
        data["var_ValUnutilizedCredit"] = this.var_ValUnutilizedCredit;
        data["p0_ValDeclinedByInsurer"] = this.p0_ValDeclinedByInsurer;
        data["p1_ValDeclinedByInsurer"] = this.p1_ValDeclinedByInsurer;
        data["var_ValDeclinedByInsurer"] = this.var_ValDeclinedByInsurer;
        data["p0_ValInsuredCreditLimit"] = this.p0_ValInsuredCreditLimit;
        data["p1_ValInsuredCreditLimit"] = this.p1_ValInsuredCreditLimit;
        data["var_ValInsuredCreditLimit"] = this.var_ValInsuredCreditLimit;
        data["p0_ValNegativeBalance"] = this.p0_ValNegativeBalance;
        data["p1_ValNegativeBalance"] = this.p1_ValNegativeBalance;
        data["var_ValNegativeBalance"] = this.var_ValNegativeBalance;
        data["p0_Uninsurable_Other"] = this.p0_Uninsurable_Other;
        data["p1_Uninsurable_Other"] = this.p1_Uninsurable_Other;
        data["var_Uninsurable_Other"] = this.var_Uninsurable_Other;
        return data;
    }
}

export interface IDashboardChecklistReportItem {
    p0_Period: string;
    p1_Period: string;
    p0_TotalCompleteRec: number;
    p1_TotalCompleteRec: number;
    var_totalCompleteRec: number;
    p0_InsuredDebtors: number;
    p1_InsuredDebtors: number;
    var_InsuredDebtors: number;
    p0_NoCover: number;
    p1_NoCover: number;
    var_NoCover: number;
    p0_NilLimits: number;
    p1_NilLimits: number;
    var_NilLimits: number;
    p0_ValExcludedBuyers: number;
    p1_ValExcludedBuyers: number;
    var_ValExcludedBuyers: number;
    p0_Uninsurable: number;
    p1_Uninsurable: number;
    var_Uninsurable: number;
    p0_Uninsurable_Intercompany: number;
    p1_Uninsurable_Intercompany: number;
    var_Uninsurable_Intercompany: number;
    p0_Uninsurable_Cash: number;
    p1_Uninsurable_Cash: number;
    var_Uninsurable_Cash: number;
    p0_Uninsurable_Government: number;
    p1_Uninsurable_Government: number;
    var_Uninsurable_Government: number;
    p0_UninsuredOther: number;
    p1_UninsuredOther: number;
    var_UninsuredOther: number;
    p0_ValDebtorsOver90days: number;
    p1_ValDebtorsOver90days: number;
    var_ValDebtorsOver90days: number;
    p0_ValDebtorsUninsured: number;
    p1_ValDebtorsUninsured: number;
    var_ValDebtorsUninsured: number;
    p0_ValOvertradedLimits: number;
    p1_ValOvertradedLimits: number;
    var_ValOvertradedLimits: number;
    p0_ValDebtorsFranchiseLoss: number;
    p1_ValDebtorsFranchiseLoss: number;
    var_ValDebtorsFranchiseLoss: number;
    p0_ValUnutilizedCredit: number;
    p1_ValUnutilizedCredit: number;
    var_ValUnutilizedCredit: number;
    p0_ValDeclinedByInsurer: number;
    p1_ValDeclinedByInsurer: number;
    var_ValDeclinedByInsurer: number;
    p0_ValInsuredCreditLimit: number;
    p1_ValInsuredCreditLimit: number;
    var_ValInsuredCreditLimit: number;
    p0_ValNegativeBalance: number;
    p1_ValNegativeBalance: number;
    var_ValNegativeBalance: number;
    p0_Uninsurable_Other: number;
    p1_Uninsurable_Other: number;
    var_Uninsurable_Other: number;

    [key: string]: any;
}

export class DataStatusReportResult implements IDataStatusReportResult {
    results!: DataStatusReportItem[];

    [key: string]: any;

    constructor(data?: IDataStatusReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DataStatusReportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataStatusReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new DataStatusReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDataStatusReportResult {
    results: DataStatusReportItem[];

    [key: string]: any;
}

export class DataStatusReportItem implements IDataStatusReportItem {
    clientName!: string;
    areaName!: string;
    ageingStatus!: string;
    salesStatus!: string;
    annexureStatus!: string;
    matchingStatus!: string;

    [key: string]: any;

    constructor(data?: IDataStatusReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.clientName = _data["clientName"];
            this.areaName = _data["areaName"];
            this.ageingStatus = _data["ageingStatus"];
            this.salesStatus = _data["salesStatus"];
            this.annexureStatus = _data["annexureStatus"];
            this.matchingStatus = _data["matchingStatus"];
        }
    }

    static fromJS(data: any): DataStatusReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new DataStatusReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["clientName"] = this.clientName;
        data["areaName"] = this.areaName;
        data["ageingStatus"] = this.ageingStatus;
        data["salesStatus"] = this.salesStatus;
        data["annexureStatus"] = this.annexureStatus;
        data["matchingStatus"] = this.matchingStatus;
        return data;
    }
}

export interface IDataStatusReportItem {
    clientName: string;
    areaName: string;
    ageingStatus: string;
    salesStatus: string;
    annexureStatus: string;
    matchingStatus: string;

    [key: string]: any;
}

export class DeclarationDetailReportResult implements IDeclarationDetailReportResult {
    results!: any[];

    [key: string]: any;

    constructor(data?: IDeclarationDetailReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
        }
    }

    static fromJS(data: any): DeclarationDetailReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationDetailReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        return data;
    }
}

export interface IDeclarationDetailReportResult {
    results: any[];

    [key: string]: any;
}

export class DeclarationDetailReportItem implements IDeclarationDetailReportItem {
    buyerCode!: string;
    buyerName!: string;
    noOfLinkedDebtors!: number;
    limit!: any;
    balanceOutstanding!: any;
    insuredAmount!: any;
    policyNumber!: string;
    overtrades!: any;
    overdues!: any;
    toDeclare!: any;

    [key: string]: any;

    constructor(data?: IDeclarationDetailReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buyerCode = _data["buyerCode"];
            this.buyerName = _data["buyerName"];
            this.noOfLinkedDebtors = _data["noOfLinkedDebtors"];
            this.limit = _data["limit"];
            this.balanceOutstanding = _data["balanceOutstanding"];
            this.insuredAmount = _data["insuredAmount"];
            this.policyNumber = _data["policyNumber"];
            this.overtrades = _data["overtrades"];
            this.overdues = _data["overdues"];
            this.toDeclare = _data["toDeclare"];
        }
    }

    static fromJS(data: any): DeclarationDetailReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationDetailReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buyerCode"] = this.buyerCode;
        data["buyerName"] = this.buyerName;
        data["noOfLinkedDebtors"] = this.noOfLinkedDebtors;
        data["limit"] = this.limit;
        data["balanceOutstanding"] = this.balanceOutstanding;
        data["insuredAmount"] = this.insuredAmount;
        data["policyNumber"] = this.policyNumber;
        data["overtrades"] = this.overtrades;
        data["overdues"] = this.overdues;
        data["toDeclare"] = this.toDeclare;
        return data;
    }
}

export interface IDeclarationDetailReportItem {
    buyerCode: string;
    buyerName: string;
    noOfLinkedDebtors: number;
    limit: any;
    balanceOutstanding: any;
    insuredAmount: any;
    policyNumber: string;
    overtrades: any;
    overdues: any;
    toDeclare: any;

    [key: string]: any;
}

export class DeclarationSummaryReportResult implements IDeclarationSummaryReportResult {
    results!: any[];

    [key: string]: any;

    constructor(data?: IDeclarationSummaryReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
        }
    }

    static fromJS(data: any): DeclarationSummaryReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationSummaryReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        return data;
    }
}

export interface IDeclarationSummaryReportResult {
    results: any[];

    [key: string]: any;
}

export class DeclarationSummaryReportItem implements IDeclarationSummaryReportItem {
    totalAgeing!: any;
    creditBalances!: any;
    neighbourVAT!: any;
    totalUninsuredDebtors!: any;
    totalCreditLimitExceeded!: any;
    totalDebtorsWithBalanceFranchiseLoss!: any;
    owingThreeMonthsOrMoreOverduePayment!: any;
    policyNumber!: string;
    declaredTotal!: any;

    [key: string]: any;

    constructor(data?: IDeclarationSummaryReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalAgeing = _data["totalAgeing"];
            this.creditBalances = _data["creditBalances"];
            this.neighbourVAT = _data["neighbourVAT"];
            this.totalUninsuredDebtors = _data["totalUninsuredDebtors"];
            this.totalCreditLimitExceeded = _data["totalCreditLimitExceeded"];
            this.totalDebtorsWithBalanceFranchiseLoss = _data["totalDebtorsWithBalanceFranchiseLoss"];
            this.owingThreeMonthsOrMoreOverduePayment = _data["owingThreeMonthsOrMoreOverduePayment"];
            this.policyNumber = _data["policyNumber"];
            this.declaredTotal = _data["declaredTotal"];
        }
    }

    static fromJS(data: any): DeclarationSummaryReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationSummaryReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalAgeing"] = this.totalAgeing;
        data["creditBalances"] = this.creditBalances;
        data["neighbourVAT"] = this.neighbourVAT;
        data["totalUninsuredDebtors"] = this.totalUninsuredDebtors;
        data["totalCreditLimitExceeded"] = this.totalCreditLimitExceeded;
        data["totalDebtorsWithBalanceFranchiseLoss"] = this.totalDebtorsWithBalanceFranchiseLoss;
        data["owingThreeMonthsOrMoreOverduePayment"] = this.owingThreeMonthsOrMoreOverduePayment;
        data["policyNumber"] = this.policyNumber;
        data["declaredTotal"] = this.declaredTotal;
        return data;
    }
}

export interface IDeclarationSummaryReportItem {
    totalAgeing: any;
    creditBalances: any;
    neighbourVAT: any;
    totalUninsuredDebtors: any;
    totalCreditLimitExceeded: any;
    totalDebtorsWithBalanceFranchiseLoss: any;
    owingThreeMonthsOrMoreOverduePayment: any;
    policyNumber: string;
    declaredTotal: any;

    [key: string]: any;
}

export class DetailedTurnoverReportResult implements IDetailedTurnoverReportResult {
    results!: DetailedTurnoverReportItem[];
    grandTotals!: DetailedTurnoverTotalsResult;
    divisionTotals!: DivisionTotalsItem[];

    [key: string]: any;

    constructor(data?: IDetailedTurnoverReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DetailedTurnoverReportItem.fromJS(item));
            }
            this.grandTotals = _data["grandTotals"] ? DetailedTurnoverTotalsResult.fromJS(_data["grandTotals"]) : <any>undefined;
            if (Array.isArray(_data["divisionTotals"])) {
                this.divisionTotals = [] as any;
                for (let item of _data["divisionTotals"])
                    this.divisionTotals!.push(DivisionTotalsItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DetailedTurnoverReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new DetailedTurnoverReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["grandTotals"] = this.grandTotals ? this.grandTotals.toJSON() : <any>undefined;
        if (Array.isArray(this.divisionTotals)) {
            data["divisionTotals"] = [];
            for (let item of this.divisionTotals)
                data["divisionTotals"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDetailedTurnoverReportResult {
    results: DetailedTurnoverReportItem[];
    grandTotals: DetailedTurnoverTotalsResult;
    divisionTotals: DivisionTotalsItem[];

    [key: string]: any;
}

export class DetailedTurnoverTotalsResult implements IDetailedTurnoverTotalsResult {
    grandTotalLimit!: number;
    grandTotalSales!: number;
    grandTotalOutstanding!: number;
    grandTotalDeclarationValue!: number;
    grandTotalAccountSales!: number;
    grandTotalCombinedSales!: number;

    [key: string]: any;

    constructor(data?: IDetailedTurnoverTotalsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.grandTotalLimit = _data["grandTotalLimit"];
            this.grandTotalSales = _data["grandTotalSales"];
            this.grandTotalOutstanding = _data["grandTotalOutstanding"];
            this.grandTotalDeclarationValue = _data["grandTotalDeclarationValue"];
            this.grandTotalAccountSales = _data["grandTotalAccountSales"];
            this.grandTotalCombinedSales = _data["grandTotalCombinedSales"];
        }
    }

    static fromJS(data: any): DetailedTurnoverTotalsResult {
        data = typeof data === 'object' ? data : {};
        let result = new DetailedTurnoverTotalsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["grandTotalLimit"] = this.grandTotalLimit;
        data["grandTotalSales"] = this.grandTotalSales;
        data["grandTotalOutstanding"] = this.grandTotalOutstanding;
        data["grandTotalDeclarationValue"] = this.grandTotalDeclarationValue;
        data["grandTotalAccountSales"] = this.grandTotalAccountSales;
        data["grandTotalCombinedSales"] = this.grandTotalCombinedSales;
        return data;
    }
}

export interface IDetailedTurnoverTotalsResult {
    grandTotalLimit: number;
    grandTotalSales: number;
    grandTotalOutstanding: number;
    grandTotalDeclarationValue: number;
    grandTotalAccountSales: number;
    grandTotalCombinedSales: number;

    [key: string]: any;
}

export class DetailedTurnoverReportItem implements IDetailedTurnoverReportItem {
    buyerCode!: string;
    debtorName!: string;
    franchiseLoss!: number;
    terms!: string;
    limit!: number;
    combinedSales!: number;
    outstanding!: number;
    country!: string;
    policyNumber!: string;
    declarationValue!: number;
    account!: string;
    accountSales!: number;
    division!: string;
    divisionSales!: number;

    [key: string]: any;

    constructor(data?: IDetailedTurnoverReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buyerCode = _data["buyerCode"];
            this.debtorName = _data["debtorName"];
            this.franchiseLoss = _data["franchiseLoss"];
            this.terms = _data["terms"];
            this.limit = _data["limit"];
            this.combinedSales = _data["combinedSales"];
            this.outstanding = _data["outstanding"];
            this.country = _data["country"];
            this.policyNumber = _data["policyNumber"];
            this.declarationValue = _data["declarationValue"];
            this.account = _data["account"];
            this.accountSales = _data["accountSales"];
            this.division = _data["division"];
            this.divisionSales = _data["divisionSales"];
        }
    }

    static fromJS(data: any): DetailedTurnoverReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new DetailedTurnoverReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buyerCode"] = this.buyerCode;
        data["debtorName"] = this.debtorName;
        data["franchiseLoss"] = this.franchiseLoss;
        data["terms"] = this.terms;
        data["limit"] = this.limit;
        data["combinedSales"] = this.combinedSales;
        data["outstanding"] = this.outstanding;
        data["country"] = this.country;
        data["policyNumber"] = this.policyNumber;
        data["declarationValue"] = this.declarationValue;
        data["account"] = this.account;
        data["accountSales"] = this.accountSales;
        data["division"] = this.division;
        data["divisionSales"] = this.divisionSales;
        return data;
    }
}

export interface IDetailedTurnoverReportItem {
    buyerCode: string;
    debtorName: string;
    franchiseLoss: number;
    terms: string;
    limit: number;
    combinedSales: number;
    outstanding: number;
    country: string;
    policyNumber: string;
    declarationValue: number;
    account: string;
    accountSales: number;
    division: string;
    divisionSales: number;

    [key: string]: any;
}

export class DivisionExposureHeaderResult implements IDivisionExposureHeaderResult {
    /** Map of column number (as string) → division label */
    labels!: { [key: string]: string; };
    /** How many division labels are present (1..30) */
    count!: number;

    [key: string]: any;

    constructor(data?: IDivisionExposureHeaderResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["labels"]) {
                this.labels = {} as any;
                for (let key in _data["labels"]) {
                    if (_data["labels"].hasOwnProperty(key))
                        (<any>this.labels)![key] = _data["labels"][key];
                }
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): DivisionExposureHeaderResult {
        data = typeof data === 'object' ? data : {};
        let result = new DivisionExposureHeaderResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.labels) {
            data["labels"] = {};
            for (let key in this.labels) {
                if (this.labels.hasOwnProperty(key))
                    (<any>data["labels"])[key] = (<any>this.labels)[key];
            }
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IDivisionExposureHeaderResult {
    /** Map of column number (as string) → division label */
    labels: { [key: string]: string; };
    /** How many division labels are present (1..30) */
    count: number;

    [key: string]: any;
}

export class DivisionExposureReportResult implements IDivisionExposureReportResult {
    results!: DivisionExposureReportItem[];

    [key: string]: any;

    constructor(data?: IDivisionExposureReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DivisionExposureReportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DivisionExposureReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new DivisionExposureReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDivisionExposureReportResult {
    results: DivisionExposureReportItem[];

    [key: string]: any;
}

export class DivisionExposureReportItem implements IDivisionExposureReportItem {
    _1!: number | undefined;
    _2!: number | undefined;
    _3!: number | undefined;
    _4!: number | undefined;
    _5!: number | undefined;
    _6!: number | undefined;
    _7!: number | undefined;
    _8!: number | undefined;
    _9!: number | undefined;
    _10!: number | undefined;
    _11!: number | undefined;
    _12!: number | undefined;
    _13!: number | undefined;
    _14!: number | undefined;
    _15!: number | undefined;
    _16!: number | undefined;
    _17!: number | undefined;
    _18!: number | undefined;
    _19!: number | undefined;
    _20!: number | undefined;
    _21!: number | undefined;
    _22!: number | undefined;
    _23!: number | undefined;
    _24!: number | undefined;
    _25!: number | undefined;
    _26!: number | undefined;
    _27!: number | undefined;
    _28!: number | undefined;
    _29!: number | undefined;
    _30!: number | undefined;
    buyerCode!: string;
    buyerName!: string;
    /** 1 = values row, 2 = utilisation row */
    rowType!: number;
    creditLimit!: number;
    exposureRemaining!: number | undefined;
    /** Formatted percent e.g. '91.62%' */
    availableExposurePc!: string | undefined;
    /** Formatted percent e.g. '8.38%' */
    exposureUtilizedPc!: string | undefined;

    [key: string]: any;

    constructor(data?: IDivisionExposureReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this._1 = _data["1"];
            this._2 = _data["2"];
            this._3 = _data["3"];
            this._4 = _data["4"];
            this._5 = _data["5"];
            this._6 = _data["6"];
            this._7 = _data["7"];
            this._8 = _data["8"];
            this._9 = _data["9"];
            this._10 = _data["10"];
            this._11 = _data["11"];
            this._12 = _data["12"];
            this._13 = _data["13"];
            this._14 = _data["14"];
            this._15 = _data["15"];
            this._16 = _data["16"];
            this._17 = _data["17"];
            this._18 = _data["18"];
            this._19 = _data["19"];
            this._20 = _data["20"];
            this._21 = _data["21"];
            this._22 = _data["22"];
            this._23 = _data["23"];
            this._24 = _data["24"];
            this._25 = _data["25"];
            this._26 = _data["26"];
            this._27 = _data["27"];
            this._28 = _data["28"];
            this._29 = _data["29"];
            this._30 = _data["30"];
            this.buyerCode = _data["buyerCode"];
            this.buyerName = _data["buyerName"];
            this.rowType = _data["rowType"];
            this.creditLimit = _data["creditLimit"];
            this.exposureRemaining = _data["exposureRemaining"];
            this.availableExposurePc = _data["availableExposurePc"];
            this.exposureUtilizedPc = _data["exposureUtilizedPc"];
        }
    }

    static fromJS(data: any): DivisionExposureReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new DivisionExposureReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["1"] = this._1;
        data["2"] = this._2;
        data["3"] = this._3;
        data["4"] = this._4;
        data["5"] = this._5;
        data["6"] = this._6;
        data["7"] = this._7;
        data["8"] = this._8;
        data["9"] = this._9;
        data["10"] = this._10;
        data["11"] = this._11;
        data["12"] = this._12;
        data["13"] = this._13;
        data["14"] = this._14;
        data["15"] = this._15;
        data["16"] = this._16;
        data["17"] = this._17;
        data["18"] = this._18;
        data["19"] = this._19;
        data["20"] = this._20;
        data["21"] = this._21;
        data["22"] = this._22;
        data["23"] = this._23;
        data["24"] = this._24;
        data["25"] = this._25;
        data["26"] = this._26;
        data["27"] = this._27;
        data["28"] = this._28;
        data["29"] = this._29;
        data["30"] = this._30;
        data["buyerCode"] = this.buyerCode;
        data["buyerName"] = this.buyerName;
        data["rowType"] = this.rowType;
        data["creditLimit"] = this.creditLimit;
        data["exposureRemaining"] = this.exposureRemaining;
        data["availableExposurePc"] = this.availableExposurePc;
        data["exposureUtilizedPc"] = this.exposureUtilizedPc;
        return data;
    }
}

export interface IDivisionExposureReportItem {
    _1: number | undefined;
    _2: number | undefined;
    _3: number | undefined;
    _4: number | undefined;
    _5: number | undefined;
    _6: number | undefined;
    _7: number | undefined;
    _8: number | undefined;
    _9: number | undefined;
    _10: number | undefined;
    _11: number | undefined;
    _12: number | undefined;
    _13: number | undefined;
    _14: number | undefined;
    _15: number | undefined;
    _16: number | undefined;
    _17: number | undefined;
    _18: number | undefined;
    _19: number | undefined;
    _20: number | undefined;
    _21: number | undefined;
    _22: number | undefined;
    _23: number | undefined;
    _24: number | undefined;
    _25: number | undefined;
    _26: number | undefined;
    _27: number | undefined;
    _28: number | undefined;
    _29: number | undefined;
    _30: number | undefined;
    buyerCode: string;
    buyerName: string;
    /** 1 = values row, 2 = utilisation row */
    rowType: number;
    creditLimit: number;
    exposureRemaining: number | undefined;
    /** Formatted percent e.g. '91.62%' */
    availableExposurePc: string | undefined;
    /** Formatted percent e.g. '8.38%' */
    exposureUtilizedPc: string | undefined;

    [key: string]: any;
}

export class DivisionTotalsResult implements IDivisionTotalsResult {
    results!: DivisionTotalsItem[];

    [key: string]: any;

    constructor(data?: IDivisionTotalsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DivisionTotalsItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DivisionTotalsResult {
        data = typeof data === 'object' ? data : {};
        let result = new DivisionTotalsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDivisionTotalsResult {
    results: DivisionTotalsItem[];

    [key: string]: any;
}

export class DivisionTotalsItem implements IDivisionTotalsItem {
    division!: string;
    outstanding!: number;
    declarationValue!: number;

    [key: string]: any;

    constructor(data?: IDivisionTotalsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.division = _data["division"];
            this.outstanding = _data["outstanding"];
            this.declarationValue = _data["declarationValue"];
        }
    }

    static fromJS(data: any): DivisionTotalsItem {
        data = typeof data === 'object' ? data : {};
        let result = new DivisionTotalsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["division"] = this.division;
        data["outstanding"] = this.outstanding;
        data["declarationValue"] = this.declarationValue;
        return data;
    }
}

export interface IDivisionTotalsItem {
    division: string;
    outstanding: number;
    declarationValue: number;

    [key: string]: any;
}

export class FranchiseLossLimitsReportResult implements IFranchiseLossLimitsReportResult {
    results!: any[];

    [key: string]: any;

    constructor(data?: IFranchiseLossLimitsReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
        }
    }

    static fromJS(data: any): FranchiseLossLimitsReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new FranchiseLossLimitsReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        return data;
    }
}

export interface IFranchiseLossLimitsReportResult {
    results: any[];

    [key: string]: any;
}

export class FranchiseLossLimitsReportItem implements IFranchiseLossLimitsReportItem {
    buyerCode!: string;
    buyerNames!: string;
    franchiseLoss!: any;
    totalOutstandingAmount!: any;
    policyNumber!: string;

    [key: string]: any;

    constructor(data?: IFranchiseLossLimitsReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buyerCode = _data["buyerCode"];
            this.buyerNames = _data["buyerNames"];
            this.franchiseLoss = _data["franchiseLoss"];
            this.totalOutstandingAmount = _data["totalOutstandingAmount"];
            this.policyNumber = _data["policyNumber"];
        }
    }

    static fromJS(data: any): FranchiseLossLimitsReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new FranchiseLossLimitsReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buyerCode"] = this.buyerCode;
        data["buyerNames"] = this.buyerNames;
        data["franchiseLoss"] = this.franchiseLoss;
        data["totalOutstandingAmount"] = this.totalOutstandingAmount;
        data["policyNumber"] = this.policyNumber;
        return data;
    }
}

export interface IFranchiseLossLimitsReportItem {
    buyerCode: string;
    buyerNames: string;
    franchiseLoss: any;
    totalOutstandingAmount: any;
    policyNumber: string;

    [key: string]: any;
}

export class ImportDetailsReportResult implements IImportDetailsReportResult {
    results!: any[];
    totalAmount!: any;
    totalConvertedAmount!: any;

    [key: string]: any;

    constructor(data?: IImportDetailsReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
            this.totalAmount = _data["totalAmount"];
            this.totalConvertedAmount = _data["totalConvertedAmount"];
        }
    }

    static fromJS(data: any): ImportDetailsReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDetailsReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        data["totalAmount"] = this.totalAmount;
        data["totalConvertedAmount"] = this.totalConvertedAmount;
        return data;
    }
}

export interface IImportDetailsReportResult {
    results: any[];
    totalAmount: any;
    totalConvertedAmount: any;

    [key: string]: any;
}

export class ImportDetailsReportItem implements IImportDetailsReportItem {
    buyerCode!: string;
    buyerName!: string;
    invoiceNo!: string;
    invoiceDate!: Date;
    exchangeRate!: any;
    amount!: any;
    convertedAmount!: any;
    policyNumber!: string;

    [key: string]: any;

    constructor(data?: IImportDetailsReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buyerCode = _data["buyerCode"];
            this.buyerName = _data["buyerName"];
            this.invoiceNo = _data["invoiceNo"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            this.exchangeRate = _data["exchangeRate"];
            this.amount = _data["amount"];
            this.convertedAmount = _data["convertedAmount"];
            this.policyNumber = _data["policyNumber"];
        }
    }

    static fromJS(data: any): ImportDetailsReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDetailsReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buyerCode"] = this.buyerCode;
        data["buyerName"] = this.buyerName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? formatDate(this.invoiceDate) : <any>undefined;
        data["exchangeRate"] = this.exchangeRate;
        data["amount"] = this.amount;
        data["convertedAmount"] = this.convertedAmount;
        data["policyNumber"] = this.policyNumber;
        return data;
    }
}

export interface IImportDetailsReportItem {
    buyerCode: string;
    buyerName: string;
    invoiceNo: string;
    invoiceDate: Date;
    exchangeRate: any;
    amount: any;
    convertedAmount: any;
    policyNumber: string;

    [key: string]: any;
}

export class InsuredDebtorsGrantedLimitsVsExposuresReportResult implements IInsuredDebtorsGrantedLimitsVsExposuresReportResult {
    results!: InsuredDebtorsGrantedLimitsVsExposuresReportItem[];

    [key: string]: any;

    constructor(data?: IInsuredDebtorsGrantedLimitsVsExposuresReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(InsuredDebtorsGrantedLimitsVsExposuresReportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsuredDebtorsGrantedLimitsVsExposuresReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new InsuredDebtorsGrantedLimitsVsExposuresReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInsuredDebtorsGrantedLimitsVsExposuresReportResult {
    results: InsuredDebtorsGrantedLimitsVsExposuresReportItem[];

    [key: string]: any;
}

export class InsuredDebtorsGrantedLimitsVsExposuresReportItem implements IInsuredDebtorsGrantedLimitsVsExposuresReportItem {
    buyerCode!: string;
    buyerName!: string;
    approvedLimit!: number;
    amountOutstanding!: number;
    period!: number;
    policyNumber!: string;

    [key: string]: any;

    constructor(data?: IInsuredDebtorsGrantedLimitsVsExposuresReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buyerCode = _data["buyerCode"];
            this.buyerName = _data["buyerName"];
            this.approvedLimit = _data["approvedLimit"];
            this.amountOutstanding = _data["amountOutstanding"];
            this.period = _data["period"];
            this.policyNumber = _data["policyNumber"];
        }
    }

    static fromJS(data: any): InsuredDebtorsGrantedLimitsVsExposuresReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new InsuredDebtorsGrantedLimitsVsExposuresReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buyerCode"] = this.buyerCode;
        data["buyerName"] = this.buyerName;
        data["approvedLimit"] = this.approvedLimit;
        data["amountOutstanding"] = this.amountOutstanding;
        data["period"] = this.period;
        data["policyNumber"] = this.policyNumber;
        return data;
    }
}

export interface IInsuredDebtorsGrantedLimitsVsExposuresReportItem {
    buyerCode: string;
    buyerName: string;
    approvedLimit: number;
    amountOutstanding: number;
    period: number;
    policyNumber: string;

    [key: string]: any;
}

export class InsuredDebtorsReportResult implements IInsuredDebtorsReportResult {
    results!: InsuredDebtorsReportItem[];

    [key: string]: any;

    constructor(data?: IInsuredDebtorsReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(InsuredDebtorsReportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsuredDebtorsReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new InsuredDebtorsReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInsuredDebtorsReportResult {
    results: InsuredDebtorsReportItem[];

    [key: string]: any;
}

export class InsuredDebtorsReportItem implements IInsuredDebtorsReportItem {
    buyerCode!: string;
    buyerName!: string;
    noOfLinkedDebtors!: number;
    limit!: number;
    balanceOutstanding!: number;
    insuredAmount!: number;
    policyNumber!: string;

    [key: string]: any;

    constructor(data?: IInsuredDebtorsReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buyerCode = _data["buyerCode"];
            this.buyerName = _data["buyerName"];
            this.noOfLinkedDebtors = _data["noOfLinkedDebtors"];
            this.limit = _data["limit"];
            this.balanceOutstanding = _data["balanceOutstanding"];
            this.insuredAmount = _data["insuredAmount"];
            this.policyNumber = _data["policyNumber"];
        }
    }

    static fromJS(data: any): InsuredDebtorsReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new InsuredDebtorsReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buyerCode"] = this.buyerCode;
        data["buyerName"] = this.buyerName;
        data["noOfLinkedDebtors"] = this.noOfLinkedDebtors;
        data["limit"] = this.limit;
        data["balanceOutstanding"] = this.balanceOutstanding;
        data["insuredAmount"] = this.insuredAmount;
        data["policyNumber"] = this.policyNumber;
        return data;
    }
}

export interface IInsuredDebtorsReportItem {
    buyerCode: string;
    buyerName: string;
    noOfLinkedDebtors: number;
    limit: number;
    balanceOutstanding: number;
    insuredAmount: number;
    policyNumber: string;

    [key: string]: any;
}

export class LimitValueChangesReportResult implements ILimitValueChangesReportResult {
    results!: any[];
    currentLimitTotal!: any;
    previousLimitTotal!: any;

    [key: string]: any;

    constructor(data?: ILimitValueChangesReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
            this.currentLimitTotal = _data["currentLimitTotal"];
            this.previousLimitTotal = _data["previousLimitTotal"];
        }
    }

    static fromJS(data: any): LimitValueChangesReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new LimitValueChangesReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        data["currentLimitTotal"] = this.currentLimitTotal;
        data["previousLimitTotal"] = this.previousLimitTotal;
        return data;
    }
}

export interface ILimitValueChangesReportResult {
    results: any[];
    currentLimitTotal: any;
    previousLimitTotal: any;

    [key: string]: any;
}

export class LimitValueChangesReportItem implements ILimitValueChangesReportItem {
    debtorCode!: string;
    debtorName!: string;
    currentLimit!: number;
    previousLimit!: number;

    [key: string]: any;

    constructor(data?: ILimitValueChangesReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.debtorCode = _data["debtorCode"];
            this.debtorName = _data["debtorName"];
            this.currentLimit = _data["currentLimit"];
            this.previousLimit = _data["previousLimit"];
        }
    }

    static fromJS(data: any): LimitValueChangesReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new LimitValueChangesReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["debtorCode"] = this.debtorCode;
        data["debtorName"] = this.debtorName;
        data["currentLimit"] = this.currentLimit;
        data["previousLimit"] = this.previousLimit;
        return data;
    }
}

export interface ILimitValueChangesReportItem {
    debtorCode: string;
    debtorName: string;
    currentLimit: number;
    previousLimit: number;

    [key: string]: any;
}

export class LimitsNilApprovedResult implements ILimitsNilApprovedResult {
    results!: LimitsNilApprovedItem[];

    [key: string]: any;

    constructor(data?: ILimitsNilApprovedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(LimitsNilApprovedItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LimitsNilApprovedResult {
        data = typeof data === 'object' ? data : {};
        let result = new LimitsNilApprovedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILimitsNilApprovedResult {
    results: LimitsNilApprovedItem[];

    [key: string]: any;
}

export class LimitsNilApprovedItem implements ILimitsNilApprovedItem {
    division!: string;
    outstanding!: number;
    declarationValue!: number;

    [key: string]: any;

    constructor(data?: ILimitsNilApprovedItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.division = _data["division"];
            this.outstanding = _data["outstanding"];
            this.declarationValue = _data["declarationValue"];
        }
    }

    static fromJS(data: any): LimitsNilApprovedItem {
        data = typeof data === 'object' ? data : {};
        let result = new LimitsNilApprovedItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["division"] = this.division;
        data["outstanding"] = this.outstanding;
        data["declarationValue"] = this.declarationValue;
        return data;
    }
}

export interface ILimitsNilApprovedItem {
    division: string;
    outstanding: number;
    declarationValue: number;

    [key: string]: any;
}

export class LimitsReportResult implements ILimitsReportResult {
    results!: LimitsReportItem[];

    [key: string]: any;

    constructor(data?: ILimitsReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(LimitsReportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LimitsReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new LimitsReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILimitsReportResult {
    results: LimitsReportItem[];

    [key: string]: any;
}

export class LimitsReportItem implements ILimitsReportItem {
    period!: Date;
    buyerName!: string;
    totalRequestedLimit!: number;
    totalApprovedLimit!: number;
    activeLimitCount!: number;
    totalCreditLimit!: number;
    approvalRatio!: number;
    totalRapidResponseFees!: number;

    [key: string]: any;

    constructor(data?: ILimitsReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.period = _data["period"] ? new Date(_data["period"].toString()) : <any>undefined;
            this.buyerName = _data["buyerName"];
            this.totalRequestedLimit = _data["TotalRequestedLimit"];
            this.totalApprovedLimit = _data["TotalApprovedLimit"];
            this.activeLimitCount = _data["ActiveLimitCount"];
            this.totalCreditLimit = _data["TotalCreditLimit"];
            this.approvalRatio = _data["ApprovalRatio"];
            this.totalRapidResponseFees = _data["TotalRapidResponseFees"];
        }
    }

    static fromJS(data: any): LimitsReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new LimitsReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["period"] = this.period ? formatDate(this.period) : <any>undefined;
        data["buyerName"] = this.buyerName;
        data["TotalRequestedLimit"] = this.totalRequestedLimit;
        data["TotalApprovedLimit"] = this.totalApprovedLimit;
        data["ActiveLimitCount"] = this.activeLimitCount;
        data["TotalCreditLimit"] = this.totalCreditLimit;
        data["ApprovalRatio"] = this.approvalRatio;
        data["TotalRapidResponseFees"] = this.totalRapidResponseFees;
        return data;
    }
}

export interface ILimitsReportItem {
    period: Date;
    buyerName: string;
    totalRequestedLimit: number;
    totalApprovedLimit: number;
    activeLimitCount: number;
    totalCreditLimit: number;
    approvalRatio: number;
    totalRapidResponseFees: number;

    [key: string]: any;
}

export class LimitsTop10Result implements ILimitsTop10Result {
    results!: LimitsTop10Item[];

    [key: string]: any;

    constructor(data?: ILimitsTop10Result) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(LimitsTop10Item.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LimitsTop10Result {
        data = typeof data === 'object' ? data : {};
        let result = new LimitsTop10Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILimitsTop10Result {
    results: LimitsTop10Item[];

    [key: string]: any;
}

export class LimitsTop10Item implements ILimitsTop10Item {
    debtorName!: string;
    limitGranted!: number;

    [key: string]: any;

    constructor(data?: ILimitsTop10Item) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.debtorName = _data["debtorName"];
            this.limitGranted = _data["limitGranted"];
        }
    }

    static fromJS(data: any): LimitsTop10Item {
        data = typeof data === 'object' ? data : {};
        let result = new LimitsTop10Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["debtorName"] = this.debtorName;
        data["limitGranted"] = this.limitGranted;
        return data;
    }
}

export interface ILimitsTop10Item {
    debtorName: string;
    limitGranted: number;

    [key: string]: any;
}

export class LinkedDebtorReportResult implements ILinkedDebtorReportResult {
    results!: any[];

    [key: string]: any;

    constructor(data?: ILinkedDebtorReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
        }
    }

    static fromJS(data: any): LinkedDebtorReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedDebtorReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        return data;
    }
}

export interface ILinkedDebtorReportResult {
    results: any[];

    [key: string]: any;
}

export class LinkedDebtorReportItem implements ILinkedDebtorReportItem {
    buyerCode!: string;
    buyerName!: string;
    debtorCode!: string;
    debtorName!: string;
    limit!: any;
    balance!: any;
    policyNumber!: string;

    [key: string]: any;

    constructor(data?: ILinkedDebtorReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buyerCode = _data["buyerCode"];
            this.buyerName = _data["buyerName"];
            this.debtorCode = _data["debtorCode"];
            this.debtorName = _data["debtorName"];
            this.limit = _data["Limit"];
            this.balance = _data["Balance"];
            this.policyNumber = _data["policyNumber"];
        }
    }

    static fromJS(data: any): LinkedDebtorReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedDebtorReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buyerCode"] = this.buyerCode;
        data["buyerName"] = this.buyerName;
        data["debtorCode"] = this.debtorCode;
        data["debtorName"] = this.debtorName;
        data["Limit"] = this.limit;
        data["Balance"] = this.balance;
        data["policyNumber"] = this.policyNumber;
        return data;
    }
}

export interface ILinkedDebtorReportItem {
    buyerCode: string;
    buyerName: string;
    debtorCode: string;
    debtorName: string;
    limit: any;
    balance: any;
    policyNumber: string;

    [key: string]: any;
}

export class NegativeBalanceReportResult implements INegativeBalanceReportResult {
    results!: any[];
    totalBalance!: any;

    [key: string]: any;

    constructor(data?: INegativeBalanceReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
            this.totalBalance = _data["totalBalance"];
        }
    }

    static fromJS(data: any): NegativeBalanceReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new NegativeBalanceReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        data["totalBalance"] = this.totalBalance;
        return data;
    }
}

export interface INegativeBalanceReportResult {
    results: any[];
    totalBalance: any;

    [key: string]: any;
}

export class NegativeBalanceReportItem implements INegativeBalanceReportItem {
    debtorCode!: string;
    debtorName!: string;
    balance!: any;

    [key: string]: any;

    constructor(data?: INegativeBalanceReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.debtorCode = _data["debtorCode"];
            this.debtorName = _data["debtorName"];
            this.balance = _data["balance"];
        }
    }

    static fromJS(data: any): NegativeBalanceReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new NegativeBalanceReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["debtorCode"] = this.debtorCode;
        data["debtorName"] = this.debtorName;
        data["balance"] = this.balance;
        return data;
    }
}

export interface INegativeBalanceReportItem {
    debtorCode: string;
    debtorName: string;
    balance: any;

    [key: string]: any;
}

export class OverdueAccountsDetailedReportResult implements IOverdueAccountsDetailedReportResult {
    results!: OverdueAccountsDetailedReportItem[];

    [key: string]: any;

    constructor(data?: IOverdueAccountsDetailedReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(OverdueAccountsDetailedReportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OverdueAccountsDetailedReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new OverdueAccountsDetailedReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOverdueAccountsDetailedReportResult {
    results: OverdueAccountsDetailedReportItem[];

    [key: string]: any;
}

export class OverdueAccountsDetailedReportItem implements IOverdueAccountsDetailedReportItem {
    buyerCode!: string;
    buyerName!: string;
    division!: string;
    ageingComment!: string;
    terms!: string;
    specialConditions!: string;
    approvedLimit!: number;
    balanceOutstanding!: number;
    balanceCurrent!: number;
    balance30Days!: number;
    balance60Days!: number;
    balance90Days!: number;
    balance120Days!: number;
    balance150Days!: number;
    balance180Days!: number;
    balanceOver180Days!: number;
    policyNumber!: string;
    outstandingTotal!: number;
    clientAccountNumber!: string;

    [key: string]: any;

    constructor(data?: IOverdueAccountsDetailedReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buyerCode = _data["buyerCode"];
            this.buyerName = _data["buyerName"];
            this.division = _data["division"];
            this.ageingComment = _data["ageingComment"];
            this.terms = _data["terms"];
            this.specialConditions = _data["specialConditions"];
            this.approvedLimit = _data["approvedLimit"];
            this.balanceOutstanding = _data["balanceOutstanding"];
            this.balanceCurrent = _data["balanceCurrent"];
            this.balance30Days = _data["balance30Days"];
            this.balance60Days = _data["balance60Days"];
            this.balance90Days = _data["balance90Days"];
            this.balance120Days = _data["balance120Days"];
            this.balance150Days = _data["balance150Days"];
            this.balance180Days = _data["balance180Days"];
            this.balanceOver180Days = _data["balanceOver180Days"];
            this.policyNumber = _data["policyNumber"];
            this.outstandingTotal = _data["outstandingTotal"];
            this.clientAccountNumber = _data["clientAccountNumber"];
        }
    }

    static fromJS(data: any): OverdueAccountsDetailedReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new OverdueAccountsDetailedReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buyerCode"] = this.buyerCode;
        data["buyerName"] = this.buyerName;
        data["division"] = this.division;
        data["ageingComment"] = this.ageingComment;
        data["terms"] = this.terms;
        data["specialConditions"] = this.specialConditions;
        data["approvedLimit"] = this.approvedLimit;
        data["balanceOutstanding"] = this.balanceOutstanding;
        data["balanceCurrent"] = this.balanceCurrent;
        data["balance30Days"] = this.balance30Days;
        data["balance60Days"] = this.balance60Days;
        data["balance90Days"] = this.balance90Days;
        data["balance120Days"] = this.balance120Days;
        data["balance150Days"] = this.balance150Days;
        data["balance180Days"] = this.balance180Days;
        data["balanceOver180Days"] = this.balanceOver180Days;
        data["policyNumber"] = this.policyNumber;
        data["outstandingTotal"] = this.outstandingTotal;
        data["clientAccountNumber"] = this.clientAccountNumber;
        return data;
    }
}

export interface IOverdueAccountsDetailedReportItem {
    buyerCode: string;
    buyerName: string;
    division: string;
    ageingComment: string;
    terms: string;
    specialConditions: string;
    approvedLimit: number;
    balanceOutstanding: number;
    balanceCurrent: number;
    balance30Days: number;
    balance60Days: number;
    balance90Days: number;
    balance120Days: number;
    balance150Days: number;
    balance180Days: number;
    balanceOver180Days: number;
    policyNumber: string;
    outstandingTotal: number;
    clientAccountNumber: string;

    [key: string]: any;
}

export class OverdueAccountsReportResult implements IOverdueAccountsReportResult {
    results!: any[];
    totalApprovedLimit!: any;
    totalBalanceOutstanding!: any;
    totalBalanceCurrent!: any;
    totalBalance30Days!: any;
    totalBalance60Days!: any;
    totalBalance90Days!: any;
    totalBalance120Days!: any;
    totalBalance150Days!: any;
    totalBalance180Days!: any;
    totalBalanceOver180Days!: any;

    [key: string]: any;

    constructor(data?: IOverdueAccountsReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
            this.totalApprovedLimit = _data["totalApprovedLimit"];
            this.totalBalanceOutstanding = _data["totalBalanceOutstanding"];
            this.totalBalanceCurrent = _data["totalBalanceCurrent"];
            this.totalBalance30Days = _data["totalBalance30Days"];
            this.totalBalance60Days = _data["totalBalance60Days"];
            this.totalBalance90Days = _data["totalBalance90Days"];
            this.totalBalance120Days = _data["totalBalance120Days"];
            this.totalBalance150Days = _data["totalBalance150Days"];
            this.totalBalance180Days = _data["totalBalance180Days"];
            this.totalBalanceOver180Days = _data["totalBalanceOver180Days"];
        }
    }

    static fromJS(data: any): OverdueAccountsReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new OverdueAccountsReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        data["totalApprovedLimit"] = this.totalApprovedLimit;
        data["totalBalanceOutstanding"] = this.totalBalanceOutstanding;
        data["totalBalanceCurrent"] = this.totalBalanceCurrent;
        data["totalBalance30Days"] = this.totalBalance30Days;
        data["totalBalance60Days"] = this.totalBalance60Days;
        data["totalBalance90Days"] = this.totalBalance90Days;
        data["totalBalance120Days"] = this.totalBalance120Days;
        data["totalBalance150Days"] = this.totalBalance150Days;
        data["totalBalance180Days"] = this.totalBalance180Days;
        data["totalBalanceOver180Days"] = this.totalBalanceOver180Days;
        return data;
    }
}

export interface IOverdueAccountsReportResult {
    results: any[];
    totalApprovedLimit: any;
    totalBalanceOutstanding: any;
    totalBalanceCurrent: any;
    totalBalance30Days: any;
    totalBalance60Days: any;
    totalBalance90Days: any;
    totalBalance120Days: any;
    totalBalance150Days: any;
    totalBalance180Days: any;
    totalBalanceOver180Days: any;

    [key: string]: any;
}

export class OverdueAccountsReportItem implements IOverdueAccountsReportItem {
    buyerCode!: string;
    buyerName!: string;
    accountsLinked!: string;
    division!: string;
    ageingComment!: string;
    terms!: string;
    specialConditions!: string;
    approvedLimit!: any;
    balanceOutstanding!: any;
    balanceCurrent!: any;
    balance30Days!: any;
    balance60Days!: any;
    balance90Days!: any;
    balance120Days!: any;
    balance150Days!: any;
    balance180Days!: any;
    balanceOver180Days!: any;
    outstandingTotal!: any;
    franchiseLoss!: any;

    [key: string]: any;

    constructor(data?: IOverdueAccountsReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buyerCode = _data["buyerCode"];
            this.buyerName = _data["buyerName"];
            this.accountsLinked = _data["accountsLinked"];
            this.division = _data["division"];
            this.ageingComment = _data["ageingComment"];
            this.terms = _data["terms"];
            this.specialConditions = _data["specialConditions"];
            this.approvedLimit = _data["approvedLimit"];
            this.balanceOutstanding = _data["balanceOutstanding"];
            this.balanceCurrent = _data["balanceCurrent"];
            this.balance30Days = _data["balance30Days"];
            this.balance60Days = _data["balance60Days"];
            this.balance90Days = _data["balance90Days"];
            this.balance120Days = _data["balance120Days"];
            this.balance150Days = _data["balance150Days"];
            this.balance180Days = _data["balance180Days"];
            this.balanceOver180Days = _data["balanceOver180Days"];
            this.outstandingTotal = _data["outstandingTotal"];
            this.franchiseLoss = _data["franchiseLoss"];
        }
    }

    static fromJS(data: any): OverdueAccountsReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new OverdueAccountsReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buyerCode"] = this.buyerCode;
        data["buyerName"] = this.buyerName;
        data["accountsLinked"] = this.accountsLinked;
        data["division"] = this.division;
        data["ageingComment"] = this.ageingComment;
        data["terms"] = this.terms;
        data["specialConditions"] = this.specialConditions;
        data["approvedLimit"] = this.approvedLimit;
        data["balanceOutstanding"] = this.balanceOutstanding;
        data["balanceCurrent"] = this.balanceCurrent;
        data["balance30Days"] = this.balance30Days;
        data["balance60Days"] = this.balance60Days;
        data["balance90Days"] = this.balance90Days;
        data["balance120Days"] = this.balance120Days;
        data["balance150Days"] = this.balance150Days;
        data["balance180Days"] = this.balance180Days;
        data["balanceOver180Days"] = this.balanceOver180Days;
        data["outstandingTotal"] = this.outstandingTotal;
        data["franchiseLoss"] = this.franchiseLoss;
        return data;
    }
}

export interface IOverdueAccountsReportItem {
    buyerCode: string;
    buyerName: string;
    accountsLinked: string;
    division: string;
    ageingComment: string;
    terms: string;
    specialConditions: string;
    approvedLimit: any;
    balanceOutstanding: any;
    balanceCurrent: any;
    balance30Days: any;
    balance60Days: any;
    balance90Days: any;
    balance120Days: any;
    balance150Days: any;
    balance180Days: any;
    balanceOver180Days: any;
    outstandingTotal: any;
    franchiseLoss: any;

    [key: string]: any;
}

export class OvertradesReportResult implements IOvertradesReportResult {
    results!: any[];
    totalDebtorCount!: number;
    totalLimit!: number;
    totalOutstanding!: number;
    totalOutstandingOverLimit!: number;

    [key: string]: any;

    constructor(data?: IOvertradesReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
            this.totalDebtorCount = _data["totalDebtorCount"];
            this.totalLimit = _data["totalLimit"];
            this.totalOutstanding = _data["totalOutstanding"];
            this.totalOutstandingOverLimit = _data["totalOutstandingOverLimit"];
        }
    }

    static fromJS(data: any): OvertradesReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new OvertradesReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        data["totalDebtorCount"] = this.totalDebtorCount;
        data["totalLimit"] = this.totalLimit;
        data["totalOutstanding"] = this.totalOutstanding;
        data["totalOutstandingOverLimit"] = this.totalOutstandingOverLimit;
        return data;
    }
}

export interface IOvertradesReportResult {
    results: any[];
    totalDebtorCount: number;
    totalLimit: number;
    totalOutstanding: number;
    totalOutstandingOverLimit: number;

    [key: string]: any;
}

export class OvertradesReportItem implements IOvertradesReportItem {
    buyerCode!: string;
    buyerName!: string;
    debtorCount!: number;
    policyNumber!: string;
    limit!: number;
    totalOutstandingAmount!: any;

    [key: string]: any;

    constructor(data?: IOvertradesReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buyerCode = _data["buyerCode"];
            this.buyerName = _data["buyerName"];
            this.debtorCount = _data["debtorCount"];
            this.policyNumber = _data["policyNumber"];
            this.limit = _data["limit"];
            this.totalOutstandingAmount = _data["totalOutstandingAmount"];
        }
    }

    static fromJS(data: any): OvertradesReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new OvertradesReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buyerCode"] = this.buyerCode;
        data["buyerName"] = this.buyerName;
        data["debtorCount"] = this.debtorCount;
        data["policyNumber"] = this.policyNumber;
        data["limit"] = this.limit;
        data["totalOutstandingAmount"] = this.totalOutstandingAmount;
        return data;
    }
}

export interface IOvertradesReportItem {
    buyerCode: string;
    buyerName: string;
    debtorCount: number;
    policyNumber: string;
    limit: number;
    totalOutstandingAmount: any;

    [key: string]: any;
}

export class PerformanceDataReportResult implements IPerformanceDataReportResult {
    results!: PerformanceDataReportItem[];

    [key: string]: any;

    constructor(data?: IPerformanceDataReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PerformanceDataReportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PerformanceDataReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceDataReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPerformanceDataReportResult {
    results: PerformanceDataReportItem[];

    [key: string]: any;
}

export class PerformanceDataReportItem implements IPerformanceDataReportItem {
    startDate!: string;
    endDate!: string;
    datePaid!: string;
    nettPremiums!: number;
    nettClaims!: number;
    performanceBonusPercentage!: number;
    bonusAmountPaid!: number;

    [key: string]: any;

    constructor(data?: IPerformanceDataReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.datePaid = _data["datePaid"];
            this.nettPremiums = _data["nettPremiums"];
            this.nettClaims = _data["nettClaims"];
            this.performanceBonusPercentage = _data["performanceBonusPercentage"];
            this.bonusAmountPaid = _data["bonusAmountPaid"];
        }
    }

    static fromJS(data: any): PerformanceDataReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceDataReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["datePaid"] = this.datePaid;
        data["nettPremiums"] = this.nettPremiums;
        data["nettClaims"] = this.nettClaims;
        data["performanceBonusPercentage"] = this.performanceBonusPercentage;
        data["bonusAmountPaid"] = this.bonusAmountPaid;
        return data;
    }
}

export interface IPerformanceDataReportItem {
    startDate: string;
    endDate: string;
    datePaid: string;
    nettPremiums: number;
    nettClaims: number;
    performanceBonusPercentage: number;
    bonusAmountPaid: number;

    [key: string]: any;
}

export class PolicyChangesReportResult implements IPolicyChangesReportResult {
    results!: PolicyChangesReportItem[];

    [key: string]: any;

    constructor(data?: IPolicyChangesReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PolicyChangesReportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PolicyChangesReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyChangesReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPolicyChangesReportResult {
    results: PolicyChangesReportItem[];

    [key: string]: any;
}

export class PolicyChangesReportItem implements IPolicyChangesReportItem {
    period!: string;
    premiumRate!: string;
    insuredPercentage!: string;
    aggregateValue!: string;

    [key: string]: any;

    constructor(data?: IPolicyChangesReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.period = _data["period"];
            this.premiumRate = _data["premiumRate"];
            this.insuredPercentage = _data["insuredPercentage"];
            this.aggregateValue = _data["aggregateValue"];
        }
    }

    static fromJS(data: any): PolicyChangesReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyChangesReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["period"] = this.period;
        data["premiumRate"] = this.premiumRate;
        data["insuredPercentage"] = this.insuredPercentage;
        data["aggregateValue"] = this.aggregateValue;
        return data;
    }
}

export interface IPolicyChangesReportItem {
    period: string;
    premiumRate: string;
    insuredPercentage: string;
    aggregateValue: string;

    [key: string]: any;
}

export class PolicyEndorsementReportResult implements IPolicyEndorsementReportResult {
    results!: PolicyEndorsementReportItem[];

    [key: string]: any;

    constructor(data?: IPolicyEndorsementReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PolicyEndorsementReportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PolicyEndorsementReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyEndorsementReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPolicyEndorsementReportResult {
    results: PolicyEndorsementReportItem[];

    [key: string]: any;
}

export class PolicyEndorsementReportItem implements IPolicyEndorsementReportItem {
    endorsementType!: string;
    values!: string;

    [key: string]: any;

    constructor(data?: IPolicyEndorsementReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.endorsementType = _data["endorsementType"];
            this.values = _data["values"];
        }
    }

    static fromJS(data: any): PolicyEndorsementReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyEndorsementReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["endorsementType"] = this.endorsementType;
        data["values"] = this.values;
        return data;
    }
}

export interface IPolicyEndorsementReportItem {
    endorsementType: string;
    values: string;

    [key: string]: any;
}

export class PolicyScheduleReportResult implements IPolicyScheduleReportResult {
    results!: PolicyScheduleReportItem[];

    [key: string]: any;

    constructor(data?: IPolicyScheduleReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PolicyScheduleReportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PolicyScheduleReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyScheduleReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPolicyScheduleReportResult {
    results: PolicyScheduleReportItem[];

    [key: string]: any;
}

export class PolicyScheduleReportItem implements IPolicyScheduleReportItem {
    policyType!: string;
    clientName!: string;
    insurerName!: string;
    inceptionDate!: string;
    coInsured!: string;

    [key: string]: any;

    constructor(data?: IPolicyScheduleReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.policyType = _data["policyType"];
            this.clientName = _data["clientName"];
            this.insurerName = _data["insurerName"];
            this.inceptionDate = _data["inceptionDate"];
            this.coInsured = _data["coInsured"];
        }
    }

    static fromJS(data: any): PolicyScheduleReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyScheduleReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["policyType"] = this.policyType;
        data["clientName"] = this.clientName;
        data["insurerName"] = this.insurerName;
        data["inceptionDate"] = this.inceptionDate;
        data["coInsured"] = this.coInsured;
        return data;
    }
}

export interface IPolicyScheduleReportItem {
    policyType: string;
    clientName: string;
    insurerName: string;
    inceptionDate: string;
    coInsured: string;

    [key: string]: any;
}

export class PremiumLastTwelveMonthReportResult implements IPremiumLastTwelveMonthReportResult {
    results!: any[];

    [key: string]: any;

    constructor(data?: IPremiumLastTwelveMonthReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
        }
    }

    static fromJS(data: any): PremiumLastTwelveMonthReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumLastTwelveMonthReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        return data;
    }
}

export interface IPremiumLastTwelveMonthReportResult {
    results: any[];

    [key: string]: any;
}

export class PremiumLastTwelveMonthReportItem implements IPremiumLastTwelveMonthReportItem {
    month!: string;
    declaration!: any;
    premiums!: any;
    grossExposure!: any;
    exposurePercentage!: string;

    [key: string]: any;

    constructor(data?: IPremiumLastTwelveMonthReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.month = _data["month"];
            this.declaration = _data["declaration"];
            this.premiums = _data["premiums"];
            this.grossExposure = _data["grossExposure"];
            this.exposurePercentage = _data["exposurePercentage"];
        }
    }

    static fromJS(data: any): PremiumLastTwelveMonthReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumLastTwelveMonthReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["month"] = this.month;
        data["declaration"] = this.declaration;
        data["premiums"] = this.premiums;
        data["grossExposure"] = this.grossExposure;
        data["exposurePercentage"] = this.exposurePercentage;
        return data;
    }
}

export interface IPremiumLastTwelveMonthReportItem {
    month: string;
    declaration: any;
    premiums: any;
    grossExposure: any;
    exposurePercentage: string;

    [key: string]: any;
}

export class PremiumSummaryReportResult implements IPremiumSummaryReportResult {
    results!: any[];

    [key: string]: any;

    constructor(data?: IPremiumSummaryReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
        }
    }

    static fromJS(data: any): PremiumSummaryReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumSummaryReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        return data;
    }
}

export interface IPremiumSummaryReportResult {
    results: any[];

    [key: string]: any;
}

export class PremiumSummaryReportItem implements IPremiumSummaryReportItem {
    period!: string;
    declaration!: number;
    premiums!: number;

    [key: string]: any;

    constructor(data?: IPremiumSummaryReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.period = _data["period"];
            this.declaration = _data["declaration"];
            this.premiums = _data["premiums"];
        }
    }

    static fromJS(data: any): PremiumSummaryReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumSummaryReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["period"] = this.period;
        data["declaration"] = this.declaration;
        data["premiums"] = this.premiums;
        return data;
    }
}

export interface IPremiumSummaryReportItem {
    period: string;
    declaration: number;
    premiums: number;

    [key: string]: any;
}

export class ReportResult implements IReportResult {
    /** Rendered HTML content */
    htmlContent!: string;

    [key: string]: any;

    constructor(data?: IReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.htmlContent = _data["htmlContent"];
        }
    }

    static fromJS(data: any): ReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new ReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["htmlContent"] = this.htmlContent;
        return data;
    }
}

export interface IReportResult {
    /** Rendered HTML content */
    htmlContent: string;

    [key: string]: any;
}

export class SharedDebtorByPolicyReportResult implements ISharedDebtorByPolicyReportResult {
    results!: any[];

    [key: string]: any;

    constructor(data?: ISharedDebtorByPolicyReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
        }
    }

    static fromJS(data: any): SharedDebtorByPolicyReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new SharedDebtorByPolicyReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        return data;
    }
}

export interface ISharedDebtorByPolicyReportResult {
    results: any[];

    [key: string]: any;
}

export class SharedDebtorByPolicyReportItem implements ISharedDebtorByPolicyReportItem {
    buyerCode!: string;
    buyerName!: string;
    policy!: string;
    creditLimit!: any;
    balancesOutstanding!: any;
    exposureAvailable!: any;

    [key: string]: any;

    constructor(data?: ISharedDebtorByPolicyReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buyerCode = _data["buyerCode"];
            this.buyerName = _data["buyerName"];
            this.policy = _data["policy"];
            this.creditLimit = _data["creditLimit"];
            this.balancesOutstanding = _data["balancesOutstanding"];
            this.exposureAvailable = _data["exposureAvailable"];
        }
    }

    static fromJS(data: any): SharedDebtorByPolicyReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new SharedDebtorByPolicyReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buyerCode"] = this.buyerCode;
        data["buyerName"] = this.buyerName;
        data["policy"] = this.policy;
        data["creditLimit"] = this.creditLimit;
        data["balancesOutstanding"] = this.balancesOutstanding;
        data["exposureAvailable"] = this.exposureAvailable;
        return data;
    }
}

export interface ISharedDebtorByPolicyReportItem {
    buyerCode: string;
    buyerName: string;
    policy: string;
    creditLimit: any;
    balancesOutstanding: any;
    exposureAvailable: any;

    [key: string]: any;
}

export class SpecialConditionsReportResult implements ISpecialConditionsReportResult {
    results!: any[];

    [key: string]: any;

    constructor(data?: ISpecialConditionsReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
        }
    }

    static fromJS(data: any): SpecialConditionsReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialConditionsReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        return data;
    }
}

export interface ISpecialConditionsReportResult {
    results: any[];

    [key: string]: any;
}

export class SpecialConditionsReportItem implements ISpecialConditionsReportItem {
    buyerNumber!: string;
    buyerName!: string;
    limitRequested!: any;
    limitGranted!: any;
    dateGranted!: Date;
    termsOfPayment!: string;
    specialConditions!: string;
    description!: string;

    [key: string]: any;

    constructor(data?: ISpecialConditionsReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buyerNumber = _data["buyerNumber"];
            this.buyerName = _data["buyerName"];
            this.limitRequested = _data["limitRequested"];
            this.limitGranted = _data["limitGranted"];
            this.dateGranted = _data["dateGranted"] ? new Date(_data["dateGranted"].toString()) : <any>undefined;
            this.termsOfPayment = _data["termsOfPayment"];
            this.specialConditions = _data["specialConditions"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SpecialConditionsReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialConditionsReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buyerNumber"] = this.buyerNumber;
        data["buyerName"] = this.buyerName;
        data["limitRequested"] = this.limitRequested;
        data["limitGranted"] = this.limitGranted;
        data["dateGranted"] = this.dateGranted ? formatDate(this.dateGranted) : <any>undefined;
        data["termsOfPayment"] = this.termsOfPayment;
        data["specialConditions"] = this.specialConditions;
        data["description"] = this.description;
        return data;
    }
}

export interface ISpecialConditionsReportItem {
    buyerNumber: string;
    buyerName: string;
    limitRequested: any;
    limitGranted: any;
    dateGranted: Date;
    termsOfPayment: string;
    specialConditions: string;
    description: string;

    [key: string]: any;
}

export class TurnoverChecklistReportResult implements ITurnoverChecklistReportResult {
    results!: TurnoverChecklistReportItem[];

    [key: string]: any;

    constructor(data?: ITurnoverChecklistReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TurnoverChecklistReportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TurnoverChecklistReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoverChecklistReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITurnoverChecklistReportResult {
    results: TurnoverChecklistReportItem[];

    [key: string]: any;
}

export class TurnoverChecklistReportItem implements ITurnoverChecklistReportItem {
    p0_Period!: string;
    p1_Period!: string;
    p0_TotalCompleteRec!: number;
    p1_TotalCompleteRec!: number;
    var_totalCompleteRec!: number;
    p0_numDebtorsOver120days!: number;
    p1_numDebtorsOver120days!: number;
    var_numDebtorsOver120days!: number;
    p0_valDebtorsOver120days!: number;
    p1_valDebtorsOver120days!: number;
    var_valDebtorsOver120days!: number;
    p0_numDebtorsUninsured!: number;
    p1_numDebtorsUninsured!: number;
    var_numDebtorsUninsured!: number;
    p0_valDebtorsUninsured!: number;
    p1_valDebtorsUninsured!: number;
    var_valDebtorsUninsured!: number;
    p0_numOvertradedLimits!: number;
    p1_numOvertradedLimits!: number;
    var_numOvertradedLimits!: number;
    p0_valOvertradedLimits!: number;
    p1_valOvertradedLimits!: number;
    var_valOvertradedLimits!: number;
    p0_numDebtorsFranchiseLoss!: number;
    p1_numDebtorsFranchiseLoss!: number;
    var_numDebtorsFranchiseLoss!: number;
    p0_valDebtorsFranchiseLoss!: number;
    p1_valDebtorsFranchiseLoss!: number;
    var_valDebtorsFranchiseLoss!: number;
    p0_numUnutilizedCredit!: number;
    p1_numUnutilizedCredit!: number;
    var_numUnutilizedCredit!: number;
    p0_valUnutilizedCredit!: number;
    p1_valUnutilizedCredit!: number;
    var_valUnutilizedCredit!: number;
    p0_valDeclared!: number;
    p1_valDeclared!: number;
    var_valDeclared!: number;

    [key: string]: any;

    constructor(data?: ITurnoverChecklistReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.p0_Period = _data["p0_Period"];
            this.p1_Period = _data["p1_Period"];
            this.p0_TotalCompleteRec = _data["p0_TotalCompleteRec"];
            this.p1_TotalCompleteRec = _data["p1_TotalCompleteRec"];
            this.var_totalCompleteRec = _data["var_totalCompleteRec"];
            this.p0_numDebtorsOver120days = _data["p0_numDebtorsOver120days"];
            this.p1_numDebtorsOver120days = _data["p1_numDebtorsOver120days"];
            this.var_numDebtorsOver120days = _data["var_numDebtorsOver120days"];
            this.p0_valDebtorsOver120days = _data["p0_valDebtorsOver120days"];
            this.p1_valDebtorsOver120days = _data["p1_valDebtorsOver120days"];
            this.var_valDebtorsOver120days = _data["var_valDebtorsOver120days"];
            this.p0_numDebtorsUninsured = _data["p0_numDebtorsUninsured"];
            this.p1_numDebtorsUninsured = _data["p1_numDebtorsUninsured"];
            this.var_numDebtorsUninsured = _data["var_numDebtorsUninsured"];
            this.p0_valDebtorsUninsured = _data["p0_valDebtorsUninsured"];
            this.p1_valDebtorsUninsured = _data["p1_valDebtorsUninsured"];
            this.var_valDebtorsUninsured = _data["var_valDebtorsUninsured"];
            this.p0_numOvertradedLimits = _data["p0_numOvertradedLimits"];
            this.p1_numOvertradedLimits = _data["p1_numOvertradedLimits"];
            this.var_numOvertradedLimits = _data["var_numOvertradedLimits"];
            this.p0_valOvertradedLimits = _data["p0_valOvertradedLimits"];
            this.p1_valOvertradedLimits = _data["p1_valOvertradedLimits"];
            this.var_valOvertradedLimits = _data["var_valOvertradedLimits"];
            this.p0_numDebtorsFranchiseLoss = _data["p0_numDebtorsFranchiseLoss"];
            this.p1_numDebtorsFranchiseLoss = _data["p1_numDebtorsFranchiseLoss"];
            this.var_numDebtorsFranchiseLoss = _data["var_numDebtorsFranchiseLoss"];
            this.p0_valDebtorsFranchiseLoss = _data["p0_valDebtorsFranchiseLoss"];
            this.p1_valDebtorsFranchiseLoss = _data["p1_valDebtorsFranchiseLoss"];
            this.var_valDebtorsFranchiseLoss = _data["var_valDebtorsFranchiseLoss"];
            this.p0_numUnutilizedCredit = _data["p0_numUnutilizedCredit"];
            this.p1_numUnutilizedCredit = _data["p1_numUnutilizedCredit"];
            this.var_numUnutilizedCredit = _data["var_numUnutilizedCredit"];
            this.p0_valUnutilizedCredit = _data["p0_valUnutilizedCredit"];
            this.p1_valUnutilizedCredit = _data["p1_valUnutilizedCredit"];
            this.var_valUnutilizedCredit = _data["var_valUnutilizedCredit"];
            this.p0_valDeclared = _data["p0_valDeclared"];
            this.p1_valDeclared = _data["p1_valDeclared"];
            this.var_valDeclared = _data["var_valDeclared"];
        }
    }

    static fromJS(data: any): TurnoverChecklistReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoverChecklistReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["p0_Period"] = this.p0_Period;
        data["p1_Period"] = this.p1_Period;
        data["p0_TotalCompleteRec"] = this.p0_TotalCompleteRec;
        data["p1_TotalCompleteRec"] = this.p1_TotalCompleteRec;
        data["var_totalCompleteRec"] = this.var_totalCompleteRec;
        data["p0_numDebtorsOver120days"] = this.p0_numDebtorsOver120days;
        data["p1_numDebtorsOver120days"] = this.p1_numDebtorsOver120days;
        data["var_numDebtorsOver120days"] = this.var_numDebtorsOver120days;
        data["p0_valDebtorsOver120days"] = this.p0_valDebtorsOver120days;
        data["p1_valDebtorsOver120days"] = this.p1_valDebtorsOver120days;
        data["var_valDebtorsOver120days"] = this.var_valDebtorsOver120days;
        data["p0_numDebtorsUninsured"] = this.p0_numDebtorsUninsured;
        data["p1_numDebtorsUninsured"] = this.p1_numDebtorsUninsured;
        data["var_numDebtorsUninsured"] = this.var_numDebtorsUninsured;
        data["p0_valDebtorsUninsured"] = this.p0_valDebtorsUninsured;
        data["p1_valDebtorsUninsured"] = this.p1_valDebtorsUninsured;
        data["var_valDebtorsUninsured"] = this.var_valDebtorsUninsured;
        data["p0_numOvertradedLimits"] = this.p0_numOvertradedLimits;
        data["p1_numOvertradedLimits"] = this.p1_numOvertradedLimits;
        data["var_numOvertradedLimits"] = this.var_numOvertradedLimits;
        data["p0_valOvertradedLimits"] = this.p0_valOvertradedLimits;
        data["p1_valOvertradedLimits"] = this.p1_valOvertradedLimits;
        data["var_valOvertradedLimits"] = this.var_valOvertradedLimits;
        data["p0_numDebtorsFranchiseLoss"] = this.p0_numDebtorsFranchiseLoss;
        data["p1_numDebtorsFranchiseLoss"] = this.p1_numDebtorsFranchiseLoss;
        data["var_numDebtorsFranchiseLoss"] = this.var_numDebtorsFranchiseLoss;
        data["p0_valDebtorsFranchiseLoss"] = this.p0_valDebtorsFranchiseLoss;
        data["p1_valDebtorsFranchiseLoss"] = this.p1_valDebtorsFranchiseLoss;
        data["var_valDebtorsFranchiseLoss"] = this.var_valDebtorsFranchiseLoss;
        data["p0_numUnutilizedCredit"] = this.p0_numUnutilizedCredit;
        data["p1_numUnutilizedCredit"] = this.p1_numUnutilizedCredit;
        data["var_numUnutilizedCredit"] = this.var_numUnutilizedCredit;
        data["p0_valUnutilizedCredit"] = this.p0_valUnutilizedCredit;
        data["p1_valUnutilizedCredit"] = this.p1_valUnutilizedCredit;
        data["var_valUnutilizedCredit"] = this.var_valUnutilizedCredit;
        data["p0_valDeclared"] = this.p0_valDeclared;
        data["p1_valDeclared"] = this.p1_valDeclared;
        data["var_valDeclared"] = this.var_valDeclared;
        return data;
    }
}

export interface ITurnoverChecklistReportItem {
    p0_Period: string;
    p1_Period: string;
    p0_TotalCompleteRec: number;
    p1_TotalCompleteRec: number;
    var_totalCompleteRec: number;
    p0_numDebtorsOver120days: number;
    p1_numDebtorsOver120days: number;
    var_numDebtorsOver120days: number;
    p0_valDebtorsOver120days: number;
    p1_valDebtorsOver120days: number;
    var_valDebtorsOver120days: number;
    p0_numDebtorsUninsured: number;
    p1_numDebtorsUninsured: number;
    var_numDebtorsUninsured: number;
    p0_valDebtorsUninsured: number;
    p1_valDebtorsUninsured: number;
    var_valDebtorsUninsured: number;
    p0_numOvertradedLimits: number;
    p1_numOvertradedLimits: number;
    var_numOvertradedLimits: number;
    p0_valOvertradedLimits: number;
    p1_valOvertradedLimits: number;
    var_valOvertradedLimits: number;
    p0_numDebtorsFranchiseLoss: number;
    p1_numDebtorsFranchiseLoss: number;
    var_numDebtorsFranchiseLoss: number;
    p0_valDebtorsFranchiseLoss: number;
    p1_valDebtorsFranchiseLoss: number;
    var_valDebtorsFranchiseLoss: number;
    p0_numUnutilizedCredit: number;
    p1_numUnutilizedCredit: number;
    var_numUnutilizedCredit: number;
    p0_valUnutilizedCredit: number;
    p1_valUnutilizedCredit: number;
    var_valUnutilizedCredit: number;
    p0_valDeclared: number;
    p1_valDeclared: number;
    var_valDeclared: number;

    [key: string]: any;
}

export class TurnoverReportResult implements ITurnoverReportResult {
    results!: TurnoverReportItem[];

    [key: string]: any;

    constructor(data?: ITurnoverReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TurnoverReportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TurnoverReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoverReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITurnoverReportResult {
    results: TurnoverReportItem[];

    [key: string]: any;
}

export class TurnoverReportItem implements ITurnoverReportItem {
    buyerCode!: string;
    debtorName!: string;
    terms!: string;
    country!: string;
    policyNumber!: string;
    limit!: any;
    sales!: any;
    outstanding!: any;
    declarationValue!: any;
    franchiseLoss!: any;

    [key: string]: any;

    constructor(data?: ITurnoverReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buyerCode = _data["buyerCode"];
            this.debtorName = _data["debtorName"];
            this.terms = _data["terms"];
            this.country = _data["country"];
            this.policyNumber = _data["policyNumber"];
            this.limit = _data["limit"];
            this.sales = _data["sales"];
            this.outstanding = _data["outstanding"];
            this.declarationValue = _data["declarationValue"];
            this.franchiseLoss = _data["franchiseLoss"];
        }
    }

    static fromJS(data: any): TurnoverReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoverReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buyerCode"] = this.buyerCode;
        data["debtorName"] = this.debtorName;
        data["terms"] = this.terms;
        data["country"] = this.country;
        data["policyNumber"] = this.policyNumber;
        data["limit"] = this.limit;
        data["sales"] = this.sales;
        data["outstanding"] = this.outstanding;
        data["declarationValue"] = this.declarationValue;
        data["franchiseLoss"] = this.franchiseLoss;
        return data;
    }
}

export interface ITurnoverReportItem {
    buyerCode: string;
    debtorName: string;
    terms: string;
    country: string;
    policyNumber: string;
    limit: any;
    sales: any;
    outstanding: any;
    declarationValue: any;
    franchiseLoss: any;

    [key: string]: any;
}

export class TwelveMonthUtilizationReportResult implements ITwelveMonthUtilizationReportResult {
    results!: any[];

    [key: string]: any;

    constructor(data?: ITwelveMonthUtilizationReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
        }
    }

    static fromJS(data: any): TwelveMonthUtilizationReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new TwelveMonthUtilizationReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        return data;
    }
}

export interface ITwelveMonthUtilizationReportResult {
    results: any[];

    [key: string]: any;
}

export class TwelveMonthUtilizationReportItem implements ITwelveMonthUtilizationReportItem {
    buyerCode!: string;
    buyerName!: string;
    rowType!: string;
    rowOrder!: string;
    valuePStart!: string;
    showValuePStart!: string;
    valuePMin11!: string;
    showValuePMin11!: string;
    valuePMin10!: string;
    showValuePMin10!: string;
    valuePMin09!: string;
    showValuePMin09!: string;
    valuePMin08!: string;
    showValuePMin08!: string;
    valuePMin07!: string;
    showValuePMin07!: string;
    valuePMin06!: string;
    showValuePMin06!: string;
    valuePMin05!: string;
    showValuePMin05!: string;
    valuePMin04!: string;
    showValuePMin04!: string;
    valuePMin03!: string;
    showValuePMin03!: string;
    valuePMin02!: string;
    showValuePMin02!: string;
    valuePEnd!: string;
    showValuePEnd!: string;
    averageUtilization!: string;

    [key: string]: any;

    constructor(data?: ITwelveMonthUtilizationReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buyerCode = _data["buyerCode"];
            this.buyerName = _data["buyerName"];
            this.rowType = _data["rowType"];
            this.rowOrder = _data["rowOrder"];
            this.valuePStart = _data["valuePStart"];
            this.showValuePStart = _data["showValuePStart"];
            this.valuePMin11 = _data["valuePMin11"];
            this.showValuePMin11 = _data["showValuePMin11"];
            this.valuePMin10 = _data["valuePMin10"];
            this.showValuePMin10 = _data["showValuePMin10"];
            this.valuePMin09 = _data["valuePMin09"];
            this.showValuePMin09 = _data["showValuePMin09"];
            this.valuePMin08 = _data["valuePMin08"];
            this.showValuePMin08 = _data["showValuePMin08"];
            this.valuePMin07 = _data["valuePMin07"];
            this.showValuePMin07 = _data["showValuePMin07"];
            this.valuePMin06 = _data["valuePMin06"];
            this.showValuePMin06 = _data["showValuePMin06"];
            this.valuePMin05 = _data["valuePMin05"];
            this.showValuePMin05 = _data["showValuePMin05"];
            this.valuePMin04 = _data["valuePMin04"];
            this.showValuePMin04 = _data["showValuePMin04"];
            this.valuePMin03 = _data["valuePMin03"];
            this.showValuePMin03 = _data["showValuePMin03"];
            this.valuePMin02 = _data["valuePMin02"];
            this.showValuePMin02 = _data["showValuePMin02"];
            this.valuePEnd = _data["valuePEnd"];
            this.showValuePEnd = _data["showValuePEnd"];
            this.averageUtilization = _data["averageUtilization"];
        }
    }

    static fromJS(data: any): TwelveMonthUtilizationReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new TwelveMonthUtilizationReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buyerCode"] = this.buyerCode;
        data["buyerName"] = this.buyerName;
        data["rowType"] = this.rowType;
        data["rowOrder"] = this.rowOrder;
        data["valuePStart"] = this.valuePStart;
        data["showValuePStart"] = this.showValuePStart;
        data["valuePMin11"] = this.valuePMin11;
        data["showValuePMin11"] = this.showValuePMin11;
        data["valuePMin10"] = this.valuePMin10;
        data["showValuePMin10"] = this.showValuePMin10;
        data["valuePMin09"] = this.valuePMin09;
        data["showValuePMin09"] = this.showValuePMin09;
        data["valuePMin08"] = this.valuePMin08;
        data["showValuePMin08"] = this.showValuePMin08;
        data["valuePMin07"] = this.valuePMin07;
        data["showValuePMin07"] = this.showValuePMin07;
        data["valuePMin06"] = this.valuePMin06;
        data["showValuePMin06"] = this.showValuePMin06;
        data["valuePMin05"] = this.valuePMin05;
        data["showValuePMin05"] = this.showValuePMin05;
        data["valuePMin04"] = this.valuePMin04;
        data["showValuePMin04"] = this.showValuePMin04;
        data["valuePMin03"] = this.valuePMin03;
        data["showValuePMin03"] = this.showValuePMin03;
        data["valuePMin02"] = this.valuePMin02;
        data["showValuePMin02"] = this.showValuePMin02;
        data["valuePEnd"] = this.valuePEnd;
        data["showValuePEnd"] = this.showValuePEnd;
        data["averageUtilization"] = this.averageUtilization;
        return data;
    }
}

export interface ITwelveMonthUtilizationReportItem {
    buyerCode: string;
    buyerName: string;
    rowType: string;
    rowOrder: string;
    valuePStart: string;
    showValuePStart: string;
    valuePMin11: string;
    showValuePMin11: string;
    valuePMin10: string;
    showValuePMin10: string;
    valuePMin09: string;
    showValuePMin09: string;
    valuePMin08: string;
    showValuePMin08: string;
    valuePMin07: string;
    showValuePMin07: string;
    valuePMin06: string;
    showValuePMin06: string;
    valuePMin05: string;
    showValuePMin05: string;
    valuePMin04: string;
    showValuePMin04: string;
    valuePMin03: string;
    showValuePMin03: string;
    valuePMin02: string;
    showValuePMin02: string;
    valuePEnd: string;
    showValuePEnd: string;
    averageUtilization: string;

    [key: string]: any;
}

export class UninsurableDebtorReportResult implements IUninsurableDebtorReportResult {
    results!: any[];
    totalBalance!: any;

    [key: string]: any;

    constructor(data?: IUninsurableDebtorReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
            this.totalBalance = _data["totalBalance"];
        }
    }

    static fromJS(data: any): UninsurableDebtorReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new UninsurableDebtorReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        data["totalBalance"] = this.totalBalance;
        return data;
    }
}

export interface IUninsurableDebtorReportResult {
    results: any[];
    totalBalance: any;

    [key: string]: any;
}

export class UninsurableDebtorReportItem implements IUninsurableDebtorReportItem {
    clientAreaId!: number;
    debtorCode!: string;
    debtorName!: string;
    balanceOutstanding!: any;
    comments!: string;
    policyNumber!: string;
    franchiseLoss!: any;

    [key: string]: any;

    constructor(data?: IUninsurableDebtorReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.clientAreaId = _data["clientAreaId"];
            this.debtorCode = _data["debtorCode"];
            this.debtorName = _data["debtorName"];
            this.balanceOutstanding = _data["balanceOutstanding"];
            this.comments = _data["comments"];
            this.policyNumber = _data["policyNumber"];
            this.franchiseLoss = _data["franchiseLoss"];
        }
    }

    static fromJS(data: any): UninsurableDebtorReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new UninsurableDebtorReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["clientAreaId"] = this.clientAreaId;
        data["debtorCode"] = this.debtorCode;
        data["debtorName"] = this.debtorName;
        data["balanceOutstanding"] = this.balanceOutstanding;
        data["comments"] = this.comments;
        data["policyNumber"] = this.policyNumber;
        data["franchiseLoss"] = this.franchiseLoss;
        return data;
    }
}

export interface IUninsurableDebtorReportItem {
    clientAreaId: number;
    debtorCode: string;
    debtorName: string;
    balanceOutstanding: any;
    comments: string;
    policyNumber: string;
    franchiseLoss: any;

    [key: string]: any;
}

export class UninsuredDebtorReportResult implements IUninsuredDebtorReportResult {
    results!: any[];
    totalBalance!: any;

    [key: string]: any;

    constructor(data?: IUninsuredDebtorReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
            this.totalBalance = _data["totalBalance"];
        }
    }

    static fromJS(data: any): UninsuredDebtorReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new UninsuredDebtorReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        data["totalBalance"] = this.totalBalance;
        return data;
    }
}

export interface IUninsuredDebtorReportResult {
    results: any[];
    totalBalance: any;

    [key: string]: any;
}

export class UninsuredDebtorReportItem implements IUninsuredDebtorReportItem {
    debtorCode!: string;
    debtorName!: string;
    balanceOutstanding!: any;
    comments!: string;
    policyNumber!: string;
    debtorCount!: string;

    [key: string]: any;

    constructor(data?: IUninsuredDebtorReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.debtorCode = _data["debtorCode"];
            this.debtorName = _data["debtorName"];
            this.balanceOutstanding = _data["balanceOutstanding"];
            this.comments = _data["comments"];
            this.policyNumber = _data["policyNumber"];
            this.debtorCount = _data["debtorCount"];
        }
    }

    static fromJS(data: any): UninsuredDebtorReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new UninsuredDebtorReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["debtorCode"] = this.debtorCode;
        data["debtorName"] = this.debtorName;
        data["balanceOutstanding"] = this.balanceOutstanding;
        data["comments"] = this.comments;
        data["policyNumber"] = this.policyNumber;
        data["debtorCount"] = this.debtorCount;
        return data;
    }
}

export interface IUninsuredDebtorReportItem {
    debtorCode: string;
    debtorName: string;
    balanceOutstanding: any;
    comments: string;
    policyNumber: string;
    debtorCount: string;

    [key: string]: any;
}

export class UnutilizedInsurerLimitsReportResult implements IUnutilizedInsurerLimitsReportResult {
    results!: UnutilizedInsurerLimitsReportItem[];
    limitTotal!: any;

    [key: string]: any;

    constructor(data?: IUnutilizedInsurerLimitsReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UnutilizedInsurerLimitsReportItem.fromJS(item));
            }
            this.limitTotal = _data["limitTotal"];
        }
    }

    static fromJS(data: any): UnutilizedInsurerLimitsReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new UnutilizedInsurerLimitsReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["limitTotal"] = this.limitTotal;
        return data;
    }
}

export interface IUnutilizedInsurerLimitsReportResult {
    results: UnutilizedInsurerLimitsReportItem[];
    limitTotal: any;

    [key: string]: any;
}

export class UnutilizedInsurerLimitsReportItem implements IUnutilizedInsurerLimitsReportItem {
    buyerCode!: string;
    buyerName!: string;
    limit!: number;
    policyNumber!: string;

    [key: string]: any;

    constructor(data?: IUnutilizedInsurerLimitsReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buyerCode = _data["buyerCode"];
            this.buyerName = _data["buyerName"];
            this.limit = _data["limit"];
            this.policyNumber = _data["policyNumber"];
        }
    }

    static fromJS(data: any): UnutilizedInsurerLimitsReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new UnutilizedInsurerLimitsReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buyerCode"] = this.buyerCode;
        data["buyerName"] = this.buyerName;
        data["limit"] = this.limit;
        data["policyNumber"] = this.policyNumber;
        return data;
    }
}

export interface IUnutilizedInsurerLimitsReportItem {
    buyerCode: string;
    buyerName: string;
    limit: number;
    policyNumber: string;

    [key: string]: any;
}

export class UserReportResult implements IUserReportResult {
    results!: any[];

    [key: string]: any;

    constructor(data?: IUserReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
        }
    }

    static fromJS(data: any): UserReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        return data;
    }
}

export interface IUserReportResult {
    results: any[];

    [key: string]: any;
}

export class UserReportItem implements IUserReportItem {
    userName!: string;
    userSurname!: string;
    employeeId!: string;
    reviewer!: number;
    domainName!: string;
    emailAddress!: string;
    tenantName!: string;
    userProfile!: number;
    lastLogin!: Date;
    status!: string;
    dateCreated!: Date;
    dateEnabledChanged!: number;

    [key: string]: any;

    constructor(data?: IUserReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.userName = _data["userName"];
            this.userSurname = _data["userSurname"];
            this.employeeId = _data["employeeId"];
            this.reviewer = _data["reviewer"];
            this.domainName = _data["domainName"];
            this.emailAddress = _data["emailAddress"];
            this.tenantName = _data["tenantName"];
            this.userProfile = _data["userProfile"];
            this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateEnabledChanged = _data["dateEnabledChanged"];
        }
    }

    static fromJS(data: any): UserReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["userName"] = this.userName;
        data["userSurname"] = this.userSurname;
        data["employeeId"] = this.employeeId;
        data["reviewer"] = this.reviewer;
        data["domainName"] = this.domainName;
        data["emailAddress"] = this.emailAddress;
        data["tenantName"] = this.tenantName;
        data["userProfile"] = this.userProfile;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateEnabledChanged"] = this.dateEnabledChanged;
        return data;
    }
}

export interface IUserReportItem {
    userName: string;
    userSurname: string;
    employeeId: string;
    reviewer: number;
    domainName: string;
    emailAddress: string;
    tenantName: string;
    userProfile: number;
    lastLogin: Date;
    status: string;
    dateCreated: Date;
    dateEnabledChanged: number;

    [key: string]: any;
}

export class Utilisation12MonthHeaderResult implements IUtilisation12MonthHeaderResult {
    pStart!: string;
    pMin11!: string;
    pMin10!: string;
    pMin09!: string;
    pMin08!: string;
    pMin07!: string;
    pMin06!: string;
    pMin05!: string;
    pMin04!: string;
    pMin03!: string;
    pMin02!: string;
    pEnd!: string;

    [key: string]: any;

    constructor(data?: IUtilisation12MonthHeaderResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pStart = _data["pStart"];
            this.pMin11 = _data["pMin11"];
            this.pMin10 = _data["pMin10"];
            this.pMin09 = _data["pMin09"];
            this.pMin08 = _data["pMin08"];
            this.pMin07 = _data["pMin07"];
            this.pMin06 = _data["pMin06"];
            this.pMin05 = _data["pMin05"];
            this.pMin04 = _data["pMin04"];
            this.pMin03 = _data["pMin03"];
            this.pMin02 = _data["pMin02"];
            this.pEnd = _data["pEnd"];
        }
    }

    static fromJS(data: any): Utilisation12MonthHeaderResult {
        data = typeof data === 'object' ? data : {};
        let result = new Utilisation12MonthHeaderResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pStart"] = this.pStart;
        data["pMin11"] = this.pMin11;
        data["pMin10"] = this.pMin10;
        data["pMin09"] = this.pMin09;
        data["pMin08"] = this.pMin08;
        data["pMin07"] = this.pMin07;
        data["pMin06"] = this.pMin06;
        data["pMin05"] = this.pMin05;
        data["pMin04"] = this.pMin04;
        data["pMin03"] = this.pMin03;
        data["pMin02"] = this.pMin02;
        data["pEnd"] = this.pEnd;
        return data;
    }
}

export interface IUtilisation12MonthHeaderResult {
    pStart: string;
    pMin11: string;
    pMin10: string;
    pMin09: string;
    pMin08: string;
    pMin07: string;
    pMin06: string;
    pMin05: string;
    pMin04: string;
    pMin03: string;
    pMin02: string;
    pEnd: string;

    [key: string]: any;
}

export class Utilisation12MonthValuesResult implements IUtilisation12MonthValuesResult {
    results!: Utilisation12MonthValuesItem[];

    [key: string]: any;

    constructor(data?: IUtilisation12MonthValuesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Utilisation12MonthValuesItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Utilisation12MonthValuesResult {
        data = typeof data === 'object' ? data : {};
        let result = new Utilisation12MonthValuesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUtilisation12MonthValuesResult {
    results: Utilisation12MonthValuesItem[];

    [key: string]: any;
}

export class Utilisation12MonthValuesItem implements IUtilisation12MonthValuesItem {
    buyerCode!: string;
    buyerName!: string;
    rowType!: string;
    rowOrder!: number;
    valuePStart!: number;
    showValuePStart!: number;
    valuePMin11!: number;
    showValuePMin11!: number;
    valuePMin10!: number;
    showValuePMin10!: number;
    valuePMin09!: number;
    showValuePMin09!: number;
    valuePMin08!: number;
    showValuePMin08!: number;
    valuePMin07!: number;
    showValuePMin07!: number;
    valuePMin06!: number;
    showValuePMin06!: number;
    valuePMin05!: number;
    showValuePMin05!: number;
    valuePMin04!: number;
    showValuePMin04!: number;
    valuePMin03!: number;
    showValuePMin03!: number;
    valuePMin02!: number;
    showValuePMin02!: number;
    valuePEnd!: number;
    showValuePEnd!: number;
    averageUtilization!: number;

    [key: string]: any;

    constructor(data?: IUtilisation12MonthValuesItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buyerCode = _data["buyerCode"];
            this.buyerName = _data["buyerName"];
            this.rowType = _data["rowType"];
            this.rowOrder = _data["rowOrder"];
            this.valuePStart = _data["valuePStart"];
            this.showValuePStart = _data["showValuePStart"];
            this.valuePMin11 = _data["valuePMin11"];
            this.showValuePMin11 = _data["showValuePMin11"];
            this.valuePMin10 = _data["valuePMin10"];
            this.showValuePMin10 = _data["showValuePMin10"];
            this.valuePMin09 = _data["valuePMin09"];
            this.showValuePMin09 = _data["showValuePMin09"];
            this.valuePMin08 = _data["valuePMin08"];
            this.showValuePMin08 = _data["showValuePMin08"];
            this.valuePMin07 = _data["valuePMin07"];
            this.showValuePMin07 = _data["showValuePMin07"];
            this.valuePMin06 = _data["valuePMin06"];
            this.showValuePMin06 = _data["showValuePMin06"];
            this.valuePMin05 = _data["valuePMin05"];
            this.showValuePMin05 = _data["showValuePMin05"];
            this.valuePMin04 = _data["valuePMin04"];
            this.showValuePMin04 = _data["showValuePMin04"];
            this.valuePMin03 = _data["valuePMin03"];
            this.showValuePMin03 = _data["showValuePMin03"];
            this.valuePMin02 = _data["valuePMin02"];
            this.showValuePMin02 = _data["showValuePMin02"];
            this.valuePEnd = _data["valuePEnd"];
            this.showValuePEnd = _data["showValuePEnd"];
            this.averageUtilization = _data["averageUtilization"];
        }
    }

    static fromJS(data: any): Utilisation12MonthValuesItem {
        data = typeof data === 'object' ? data : {};
        let result = new Utilisation12MonthValuesItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buyerCode"] = this.buyerCode;
        data["buyerName"] = this.buyerName;
        data["rowType"] = this.rowType;
        data["rowOrder"] = this.rowOrder;
        data["valuePStart"] = this.valuePStart;
        data["showValuePStart"] = this.showValuePStart;
        data["valuePMin11"] = this.valuePMin11;
        data["showValuePMin11"] = this.showValuePMin11;
        data["valuePMin10"] = this.valuePMin10;
        data["showValuePMin10"] = this.showValuePMin10;
        data["valuePMin09"] = this.valuePMin09;
        data["showValuePMin09"] = this.showValuePMin09;
        data["valuePMin08"] = this.valuePMin08;
        data["showValuePMin08"] = this.showValuePMin08;
        data["valuePMin07"] = this.valuePMin07;
        data["showValuePMin07"] = this.showValuePMin07;
        data["valuePMin06"] = this.valuePMin06;
        data["showValuePMin06"] = this.showValuePMin06;
        data["valuePMin05"] = this.valuePMin05;
        data["showValuePMin05"] = this.showValuePMin05;
        data["valuePMin04"] = this.valuePMin04;
        data["showValuePMin04"] = this.showValuePMin04;
        data["valuePMin03"] = this.valuePMin03;
        data["showValuePMin03"] = this.showValuePMin03;
        data["valuePMin02"] = this.valuePMin02;
        data["showValuePMin02"] = this.showValuePMin02;
        data["valuePEnd"] = this.valuePEnd;
        data["showValuePEnd"] = this.showValuePEnd;
        data["averageUtilization"] = this.averageUtilization;
        return data;
    }
}

export interface IUtilisation12MonthValuesItem {
    buyerCode: string;
    buyerName: string;
    rowType: string;
    rowOrder: number;
    valuePStart: number;
    showValuePStart: number;
    valuePMin11: number;
    showValuePMin11: number;
    valuePMin10: number;
    showValuePMin10: number;
    valuePMin09: number;
    showValuePMin09: number;
    valuePMin08: number;
    showValuePMin08: number;
    valuePMin07: number;
    showValuePMin07: number;
    valuePMin06: number;
    showValuePMin06: number;
    valuePMin05: number;
    showValuePMin05: number;
    valuePMin04: number;
    showValuePMin04: number;
    valuePMin03: number;
    showValuePMin03: number;
    valuePMin02: number;
    showValuePMin02: number;
    valuePEnd: number;
    showValuePEnd: number;
    averageUtilization: number;

    [key: string]: any;
}

/** Represents the input required to mark an sales batch as completed. */
export class CompleteSalesBatchInput implements ICompleteSalesBatchInput {
    /** The ID of the sales batch to be completed. */
    batchId!: number;

    [key: string]: any;

    constructor(data?: ICompleteSalesBatchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.batchId = _data["batchId"];
        }
    }

    static fromJS(data: any): CompleteSalesBatchInput {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteSalesBatchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["batchId"] = this.batchId;
        return data;
    }
}

/** Represents the input required to mark an sales batch as completed. */
export interface ICompleteSalesBatchInput {
    /** The ID of the sales batch to be completed. */
    batchId: number;

    [key: string]: any;
}

export class SalesRangeMappingInput implements ISalesRangeMappingInput {
    headerIndex!: number;
    startIndex!: number;
    endIndex!: number;

    [key: string]: any;

    constructor(data?: ISalesRangeMappingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.headerIndex = _data["headerIndex"];
            this.startIndex = _data["startIndex"];
            this.endIndex = _data["endIndex"];
        }
    }

    static fromJS(data: any): SalesRangeMappingInput {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRangeMappingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["headerIndex"] = this.headerIndex;
        data["startIndex"] = this.startIndex;
        data["endIndex"] = this.endIndex;
        return data;
    }
}

export interface ISalesRangeMappingInput {
    headerIndex: number;
    startIndex: number;
    endIndex: number;

    [key: string]: any;
}

export class SalesWorksheetInput implements ISalesWorksheetInput {
    clientAreaId!: number | undefined;
    importRangeMappingId!: number | undefined;
    worksheetName!: string;
    isSelected!: boolean;

    [key: string]: any;

    constructor(data?: ISalesWorksheetInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.clientAreaId = _data["clientAreaId"];
            this.importRangeMappingId = _data["importRangeMappingId"];
            this.worksheetName = _data["worksheetName"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): SalesWorksheetInput {
        data = typeof data === 'object' ? data : {};
        let result = new SalesWorksheetInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["clientAreaId"] = this.clientAreaId;
        data["importRangeMappingId"] = this.importRangeMappingId;
        data["worksheetName"] = this.worksheetName;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface ISalesWorksheetInput {
    clientAreaId: number | undefined;
    importRangeMappingId: number | undefined;
    worksheetName: string;
    isSelected: boolean;

    [key: string]: any;
}

export class SalesBatchResult implements ISalesBatchResult {
    periodId!: number;
    clientId!: number;
    filePath!: string;
    fileName!: string;
    storedName!: string;
    isSpecializedImport!: boolean;
    isImported!: boolean;
    isCompleted!: boolean;

    [key: string]: any;

    constructor(data?: ISalesBatchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.periodId = _data["periodId"];
            this.clientId = _data["clientId"];
            this.filePath = _data["filePath"];
            this.fileName = _data["fileName"];
            this.storedName = _data["storedName"];
            this.isSpecializedImport = _data["isSpecializedImport"];
            this.isImported = _data["isImported"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): SalesBatchResult {
        data = typeof data === 'object' ? data : {};
        let result = new SalesBatchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["periodId"] = this.periodId;
        data["clientId"] = this.clientId;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["storedName"] = this.storedName;
        data["isSpecializedImport"] = this.isSpecializedImport;
        data["isImported"] = this.isImported;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface ISalesBatchResult {
    periodId: number;
    clientId: number;
    filePath: string;
    fileName: string;
    storedName: string;
    isSpecializedImport: boolean;
    isImported: boolean;
    isCompleted: boolean;

    [key: string]: any;
}

export class SalesBatchesResult extends PagingResult implements ISalesBatchesResult {
    results!: SalesBatchItem[];

    [key: string]: any;

    constructor(data?: ISalesBatchesResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SalesBatchItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SalesBatchesResult {
        data = typeof data === 'object' ? data : {};
        let result = new SalesBatchesResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISalesBatchesResult extends IPagingResult {
    results: SalesBatchItem[];

    [key: string]: any;
}

export class SalesBatchItem implements ISalesBatchItem {
    id!: number;
    createdAt!: string;
    fileName!: string;
    clientName!: string;
    period!: string;
    isCompleted!: boolean;

    [key: string]: any;

    constructor(data?: ISalesBatchItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"];
            this.fileName = _data["fileName"];
            this.clientName = _data["clientName"];
            this.period = _data["period"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): SalesBatchItem {
        data = typeof data === 'object' ? data : {};
        let result = new SalesBatchItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt;
        data["fileName"] = this.fileName;
        data["clientName"] = this.clientName;
        data["period"] = this.period;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface ISalesBatchItem {
    id: number;
    createdAt: string;
    fileName: string;
    clientName: string;
    period: string;
    isCompleted: boolean;

    [key: string]: any;
}

export class SalesRangeMappingResult implements ISalesRangeMappingResult {
    worksheetName!: string;
    headerIndex!: number;
    startIndex!: number;
    endIndex!: number;

    [key: string]: any;

    constructor(data?: ISalesRangeMappingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.worksheetName = _data["worksheetName"];
            this.headerIndex = _data["headerIndex"];
            this.startIndex = _data["startIndex"];
            this.endIndex = _data["endIndex"];
        }
    }

    static fromJS(data: any): SalesRangeMappingResult {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRangeMappingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["worksheetName"] = this.worksheetName;
        data["headerIndex"] = this.headerIndex;
        data["startIndex"] = this.startIndex;
        data["endIndex"] = this.endIndex;
        return data;
    }
}

export interface ISalesRangeMappingResult {
    worksheetName: string;
    headerIndex: number;
    startIndex: number;
    endIndex: number;

    [key: string]: any;
}

export class SalesTotalsResult implements ISalesTotalsResult {
    totalRowsImported!: number;
    salesAmount!: number;
    clientAreaName!: string;

    [key: string]: any;

    constructor(data?: ISalesTotalsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalRowsImported = _data["totalRowsImported"];
            this.salesAmount = _data["salesAmount"];
            this.clientAreaName = _data["clientAreaName"];
        }
    }

    static fromJS(data: any): SalesTotalsResult {
        data = typeof data === 'object' ? data : {};
        let result = new SalesTotalsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalRowsImported"] = this.totalRowsImported;
        data["salesAmount"] = this.salesAmount;
        data["clientAreaName"] = this.clientAreaName;
        return data;
    }
}

export interface ISalesTotalsResult {
    totalRowsImported: number;
    salesAmount: number;
    clientAreaName: string;

    [key: string]: any;
}

export class SalesWorksheetSelectionResult implements ISalesWorksheetSelectionResult {
    results!: SalesWorksheetSelectionItem[];

    [key: string]: any;

    constructor(data?: ISalesWorksheetSelectionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SalesWorksheetSelectionItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesWorksheetSelectionResult {
        data = typeof data === 'object' ? data : {};
        let result = new SalesWorksheetSelectionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISalesWorksheetSelectionResult {
    results: SalesWorksheetSelectionItem[];

    [key: string]: any;
}

export class SalesWorksheetSelectionItem implements ISalesWorksheetSelectionItem {
    worksheet!: string;
    selected!: boolean;
    clientAreaId!: number | undefined;

    [key: string]: any;

    constructor(data?: ISalesWorksheetSelectionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.worksheet = _data["worksheet"];
            this.selected = _data["selected"];
            this.clientAreaId = _data["clientAreaId"];
        }
    }

    static fromJS(data: any): SalesWorksheetSelectionItem {
        data = typeof data === 'object' ? data : {};
        let result = new SalesWorksheetSelectionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["worksheet"] = this.worksheet;
        data["selected"] = this.selected;
        data["clientAreaId"] = this.clientAreaId;
        return data;
    }
}

export interface ISalesWorksheetSelectionItem {
    worksheet: string;
    selected: boolean;
    clientAreaId: number | undefined;

    [key: string]: any;
}

export class SampleSalesDataResult implements ISampleSalesDataResult {
    sampleRows!: SampleSalesDataItem[];

    [key: string]: any;

    constructor(data?: ISampleSalesDataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["sampleRows"])) {
                this.sampleRows = [] as any;
                for (let item of _data["sampleRows"])
                    this.sampleRows!.push(SampleSalesDataItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SampleSalesDataResult {
        data = typeof data === 'object' ? data : {};
        let result = new SampleSalesDataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.sampleRows)) {
            data["sampleRows"] = [];
            for (let item of this.sampleRows)
                data["sampleRows"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISampleSalesDataResult {
    sampleRows: SampleSalesDataItem[];

    [key: string]: any;
}

export class SampleSalesDataItem implements ISampleSalesDataItem {
    id!: number;
    clientAreaId!: number;
    customerCode!: string;
    customerName!: string;
    customerRegistrationNumber!: string;
    policyReferenceNumber!: string;
    balance30Days!: number;
    balance60Days!: number;
    balance90Days!: number;
    balance120Days!: number;
    balance150Days!: number;
    balance180Days!: number;
    balanceOver180Days!: number;
    balanceCurrent!: number;
    total!: number;
    sales!: number;
    division!: string;
    noOfCustomers!: number;
    comment!: string;

    [key: string]: any;

    constructor(data?: ISampleSalesDataItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.clientAreaId = _data["clientAreaId"];
            this.customerCode = _data["customerCode"];
            this.customerName = _data["customerName"];
            this.customerRegistrationNumber = _data["customerRegistrationNumber"];
            this.policyReferenceNumber = _data["policyReferenceNumber"];
            this.balance30Days = _data["balance30Days"];
            this.balance60Days = _data["balance60Days"];
            this.balance90Days = _data["balance90Days"];
            this.balance120Days = _data["balance120Days"];
            this.balance150Days = _data["balance150Days"];
            this.balance180Days = _data["balance180Days"];
            this.balanceOver180Days = _data["balanceOver180Days"];
            this.balanceCurrent = _data["balanceCurrent"];
            this.total = _data["total"];
            this.sales = _data["sales"];
            this.division = _data["division"];
            this.noOfCustomers = _data["noOfCustomers"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): SampleSalesDataItem {
        data = typeof data === 'object' ? data : {};
        let result = new SampleSalesDataItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["clientAreaId"] = this.clientAreaId;
        data["customerCode"] = this.customerCode;
        data["customerName"] = this.customerName;
        data["customerRegistrationNumber"] = this.customerRegistrationNumber;
        data["policyReferenceNumber"] = this.policyReferenceNumber;
        data["balance30Days"] = this.balance30Days;
        data["balance60Days"] = this.balance60Days;
        data["balance90Days"] = this.balance90Days;
        data["balance120Days"] = this.balance120Days;
        data["balance150Days"] = this.balance150Days;
        data["balance180Days"] = this.balance180Days;
        data["balanceOver180Days"] = this.balanceOver180Days;
        data["balanceCurrent"] = this.balanceCurrent;
        data["total"] = this.total;
        data["sales"] = this.sales;
        data["division"] = this.division;
        data["noOfCustomers"] = this.noOfCustomers;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ISampleSalesDataItem {
    id: number;
    clientAreaId: number;
    customerCode: string;
    customerName: string;
    customerRegistrationNumber: string;
    policyReferenceNumber: string;
    balance30Days: number;
    balance60Days: number;
    balance90Days: number;
    balance120Days: number;
    balance150Days: number;
    balance180Days: number;
    balanceOver180Days: number;
    balanceCurrent: number;
    total: number;
    sales: number;
    division: string;
    noOfCustomers: number;
    comment: string;

    [key: string]: any;
}

/** Represents the input required to upload an sales file. */
export class SalesUploadFileInput implements ISalesUploadFileInput {
    file!: string;
    periodId!: number;
    clientId!: number;

    [key: string]: any;

    constructor(data?: ISalesUploadFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
            this.periodId = _data["periodId"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): SalesUploadFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new SalesUploadFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        data["periodId"] = this.periodId;
        data["clientId"] = this.clientId;
        return data;
    }
}

/** Represents the input required to upload an sales file. */
export interface ISalesUploadFileInput {
    file: string;
    periodId: number;
    clientId: number;

    [key: string]: any;
}

/** Represents a lookup item for column import mapping. */
export class ImportColumnLookupItem implements IImportColumnLookupItem {
    /** Unique identifier of the import column. */
    id!: number;
    /** Unique code representing the column. */
    code!: string;
    /** Descriptive name of the column. */
    description!: string;
    /** Area or context this column belongs to. */
    area!: string;

    [key: string]: any;

    constructor(data?: IImportColumnLookupItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.area = _data["area"];
        }
    }

    static fromJS(data: any): ImportColumnLookupItem {
        data = typeof data === 'object' ? data : {};
        let result = new ImportColumnLookupItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["area"] = this.area;
        return data;
    }
}

/** Represents a lookup item for column import mapping. */
export interface IImportColumnLookupItem {
    /** Unique identifier of the import column. */
    id: number;
    /** Unique code representing the column. */
    code: string;
    /** Descriptive name of the column. */
    description: string;
    /** Area or context this column belongs to. */
    area: string;

    [key: string]: any;
}

/** Represents a lookup item for column import mapping. */
export class ImportColumnSimplifiedItem implements IImportColumnSimplifiedItem {
    /** Original column name. */
    name!: string;
    /** Descriptive name of the column. */
    description!: string;
    /** Is Column required. */
    required!: boolean;

    [key: string]: any;

    constructor(data?: IImportColumnSimplifiedItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.description = _data["description"];
            this.required = _data["required"];
        }
    }

    static fromJS(data: any): ImportColumnSimplifiedItem {
        data = typeof data === 'object' ? data : {};
        let result = new ImportColumnSimplifiedItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["description"] = this.description;
        data["required"] = this.required;
        return data;
    }
}

/** Represents a lookup item for column import mapping. */
export interface IImportColumnSimplifiedItem {
    /** Original column name. */
    name: string;
    /** Descriptive name of the column. */
    description: string;
    /** Is Column required. */
    required: boolean;

    [key: string]: any;
}

export class PagingData implements IPagingData {
    pageNo!: number;
    pageSize!: number;
    pageCount!: number;
    recordCount!: number;
    sortDirection!: string;
    sortColumn!: string;

    [key: string]: any;

    constructor(data?: IPagingData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pageNo = _data["pageNo"];
            this.pageSize = _data["pageSize"];
            this.pageCount = _data["pageCount"];
            this.recordCount = _data["recordCount"];
            this.sortDirection = _data["sortDirection"];
            this.sortColumn = _data["sortColumn"];
        }
    }

    static fromJS(data: any): PagingData {
        data = typeof data === 'object' ? data : {};
        let result = new PagingData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pageNo"] = this.pageNo;
        data["pageSize"] = this.pageSize;
        data["pageCount"] = this.pageCount;
        data["recordCount"] = this.recordCount;
        data["sortDirection"] = this.sortDirection;
        data["sortColumn"] = this.sortColumn;
        return data;
    }
}

export interface IPagingData {
    pageNo: number;
    pageSize: number;
    pageCount: number;
    recordCount: number;
    sortDirection: string;
    sortColumn: string;

    [key: string]: any;
}

export class PagingInput implements IPagingInput {
    pagingData!: PagingData;
    filter!: string;

    [key: string]: any;

    constructor(data?: IPagingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pagingData = _data["pagingData"] ? PagingData.fromJS(_data["pagingData"]) : <any>undefined;
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): PagingInput {
        data = typeof data === 'object' ? data : {};
        let result = new PagingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pagingData"] = this.pagingData ? this.pagingData.toJSON() : <any>undefined;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IPagingInput {
    pagingData: PagingData;
    filter: string;

    [key: string]: any;
}

export class CreateResult implements ICreateResult {
    id!: number;

    [key: string]: any;

    constructor(data?: ICreateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateResult {
    id: number;

    [key: string]: any;
}

export class ImportCreateResult implements IImportCreateResult {
    id!: number;
    isCompleted!: boolean;
    /** Number of sheets in the uploaded workbook */
    sheetCount!: number;
    /** Names of sheets in the workbook */
    sheetNames!: string[];
    /** Whether workbook metadata was successfully cached */
    cached!: boolean;

    [key: string]: any;

    constructor(data?: IImportCreateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.isCompleted = _data["isCompleted"];
            this.sheetCount = _data["sheetCount"];
            if (Array.isArray(_data["sheetNames"])) {
                this.sheetNames = [] as any;
                for (let item of _data["sheetNames"])
                    this.sheetNames!.push(item);
            }
            this.cached = _data["cached"];
        }
    }

    static fromJS(data: any): ImportCreateResult {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCreateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["isCompleted"] = this.isCompleted;
        data["sheetCount"] = this.sheetCount;
        if (Array.isArray(this.sheetNames)) {
            data["sheetNames"] = [];
            for (let item of this.sheetNames)
                data["sheetNames"].push(item);
        }
        data["cached"] = this.cached;
        return data;
    }
}

export interface IImportCreateResult {
    id: number;
    isCompleted: boolean;
    /** Number of sheets in the uploaded workbook */
    sheetCount: number;
    /** Names of sheets in the workbook */
    sheetNames: string[];
    /** Whether workbook metadata was successfully cached */
    cached: boolean;

    [key: string]: any;
}

export class MatchingCreateResult implements IMatchingCreateResult {
    id!: number;
    isSourcesAvailable!: boolean;
    isSourcesCompleted!: boolean;

    [key: string]: any;

    constructor(data?: IMatchingCreateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.isSourcesAvailable = _data["isSourcesAvailable"];
            this.isSourcesCompleted = _data["isSourcesCompleted"];
        }
    }

    static fromJS(data: any): MatchingCreateResult {
        data = typeof data === 'object' ? data : {};
        let result = new MatchingCreateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["isSourcesAvailable"] = this.isSourcesAvailable;
        data["isSourcesCompleted"] = this.isSourcesCompleted;
        return data;
    }
}

export interface IMatchingCreateResult {
    id: number;
    isSourcesAvailable: boolean;
    isSourcesCompleted: boolean;

    [key: string]: any;
}

export class CreateTenantInput implements ICreateTenantInput {
    /** The name of the tenant */
    tenantName!: string;
    /** The email of the tenant manager */
    managerEmail!: string;
    /** ID of an existing database (optional) */
    databaseId!: number | undefined;
    /** Database details (always required) */
    database!: CreateDatabaseInput;

    [key: string]: any;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.database = new CreateDatabaseInput();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.tenantName = _data["tenantName"];
            this.managerEmail = _data["managerEmail"];
            this.databaseId = _data["databaseId"];
            this.database = _data["database"] ? CreateDatabaseInput.fromJS(_data["database"]) : new CreateDatabaseInput();
        }
    }

    static fromJS(data: any): CreateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["tenantName"] = this.tenantName;
        data["managerEmail"] = this.managerEmail;
        data["databaseId"] = this.databaseId;
        data["database"] = this.database ? this.database.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateTenantInput {
    /** The name of the tenant */
    tenantName: string;
    /** The email of the tenant manager */
    managerEmail: string;
    /** ID of an existing database (optional) */
    databaseId: number | undefined;
    /** Database details (always required) */
    database: CreateDatabaseInput;

    [key: string]: any;
}

export class TenantByIdResult implements ITenantByIdResult {
    id!: number;
    tenantName!: string;
    managerEmail!: string;
    database!: Database;

    [key: string]: any;

    constructor(data?: ITenantByIdResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.tenantName = _data["tenantName"];
            this.managerEmail = _data["managerEmail"];
            this.database = _data["database"] ? Database.fromJS(_data["database"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantByIdResult {
        data = typeof data === 'object' ? data : {};
        let result = new TenantByIdResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["tenantName"] = this.tenantName;
        data["managerEmail"] = this.managerEmail;
        data["database"] = this.database ? this.database.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITenantByIdResult {
    id: number;
    tenantName: string;
    managerEmail: string;
    database: Database;

    [key: string]: any;
}

export class FilteredTenantsResult extends PagingResult implements IFilteredTenantsResult {
    results!: FilteredTenantItem[];

    [key: string]: any;

    constructor(data?: IFilteredTenantsResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FilteredTenantItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FilteredTenantsResult {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredTenantsResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFilteredTenantsResult extends IPagingResult {
    results: FilteredTenantItem[];

    [key: string]: any;
}

export class FilteredTenantItem implements IFilteredTenantItem {
    id!: number;
    tenantName!: string;
    managerEmail!: string;
    catalog!: string;
    isActive!: boolean;

    [key: string]: any;

    constructor(data?: IFilteredTenantItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.tenantName = _data["tenantName"];
            this.managerEmail = _data["managerEmail"];
            this.catalog = _data["catalog"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): FilteredTenantItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredTenantItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["tenantName"] = this.tenantName;
        data["managerEmail"] = this.managerEmail;
        data["catalog"] = this.catalog;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IFilteredTenantItem {
    id: number;
    tenantName: string;
    managerEmail: string;
    catalog: string;
    isActive: boolean;

    [key: string]: any;
}

export class UpdateTenantInput implements IUpdateTenantInput {
    tenantName!: string;
    managerEmail!: string;
    database!: database;

    [key: string]: any;

    constructor(data?: IUpdateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.database = new database();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.tenantName = _data["tenantName"];
            this.managerEmail = _data["managerEmail"];
            this.database = _data["database"] ? database.fromJS(_data["database"]) : new database();
        }
    }

    static fromJS(data: any): UpdateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["tenantName"] = this.tenantName;
        data["managerEmail"] = this.managerEmail;
        data["database"] = this.database ? this.database.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateTenantInput {
    tenantName: string;
    managerEmail: string;
    database: database;

    [key: string]: any;
}

export class CreateUserRoleInput implements ICreateUserRoleInput {
    description!: string;

    [key: string]: any;

    constructor(data?: ICreateUserRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateUserRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateUserRoleInput {
    description: string;

    [key: string]: any;
}

export class CreateUserRolePermissionsInput implements ICreateUserRolePermissionsInput {
    permissions!: Permissions[];

    [key: string]: any;

    constructor(data?: ICreateUserRolePermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(Permissions.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUserRolePermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRolePermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateUserRolePermissionsInput {
    permissions: Permissions[];

    [key: string]: any;
}

export class AllUserRolesResult implements IAllUserRolesResult {
    results!: AllUserRoleItem[];

    [key: string]: any;

    constructor(data?: IAllUserRolesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AllUserRoleItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllUserRolesResult {
        data = typeof data === 'object' ? data : {};
        let result = new AllUserRolesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAllUserRolesResult {
    results: AllUserRoleItem[];

    [key: string]: any;
}

export class AllUserRoleItem implements IAllUserRoleItem {
    id!: number;
    description!: string;

    [key: string]: any;

    constructor(data?: IAllUserRoleItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AllUserRoleItem {
        data = typeof data === 'object' ? data : {};
        let result = new AllUserRoleItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface IAllUserRoleItem {
    id: number;
    description: string;

    [key: string]: any;
}

export class UserRoleByIdResult implements IUserRoleByIdResult {
    id!: number;
    description!: string;

    [key: string]: any;

    constructor(data?: IUserRoleByIdResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UserRoleByIdResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleByIdResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface IUserRoleByIdResult {
    id: number;
    description: string;

    [key: string]: any;
}

export class FilteredUserRolesResult extends PagingResult implements IFilteredUserRolesResult {
    results!: FilteredUserRoleItem[];

    [key: string]: any;

    constructor(data?: IFilteredUserRolesResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FilteredUserRoleItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FilteredUserRolesResult {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredUserRolesResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFilteredUserRolesResult extends IPagingResult {
    results: FilteredUserRoleItem[];

    [key: string]: any;
}

export class FilteredUserRoleItem implements IFilteredUserRoleItem {
    id!: number;
    description!: string;

    [key: string]: any;

    constructor(data?: IFilteredUserRoleItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FilteredUserRoleItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredUserRoleItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface IFilteredUserRoleItem {
    id: number;
    description: string;

    [key: string]: any;
}

export class UpdateUserRoleInput implements IUpdateUserRoleInput {
    description!: string;

    [key: string]: any;

    constructor(data?: IUpdateUserRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateUserRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateUserRoleInput {
    description: string;

    [key: string]: any;
}

export class CreateUserInput implements ICreateUserInput {
    id!: number;
    username!: string;
    firstname!: string;
    lastname!: string;
    employeeNumber!: string;
    country!: string;
    reviewerId!: number | undefined;
    isActive!: boolean;
    /** User classification - Internal or External */
    oktaGroup!: CreateUserInputOktaGroup;
    /** Array of role record IDs */
    roles!: number[];
    /** Array of tenant record IDs */
    tenants!: number[];

    [key: string]: any;

    constructor(data?: ICreateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.username = _data["username"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.employeeNumber = _data["employeeNumber"];
            this.country = _data["country"];
            this.reviewerId = _data["reviewerId"];
            this.isActive = _data["isActive"];
            this.oktaGroup = _data["oktaGroup"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["username"] = this.username;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["employeeNumber"] = this.employeeNumber;
        data["country"] = this.country;
        data["reviewerId"] = this.reviewerId;
        data["isActive"] = this.isActive;
        data["oktaGroup"] = this.oktaGroup;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item);
        }
        return data;
    }
}

export interface ICreateUserInput {
    id: number;
    username: string;
    firstname: string;
    lastname: string;
    employeeNumber: string;
    country: string;
    reviewerId: number | undefined;
    isActive: boolean;
    /** User classification - Internal or External */
    oktaGroup: CreateUserInputOktaGroup;
    /** Array of role record IDs */
    roles: number[];
    /** Array of tenant record IDs */
    tenants: number[];

    [key: string]: any;
}

export class GetUserRolesResult implements IGetUserRolesResult {
    results!: GetUserRoleItem[];

    [key: string]: any;

    constructor(data?: IGetUserRolesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(GetUserRoleItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserRolesResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserRolesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserRolesResult {
    results: GetUserRoleItem[];

    [key: string]: any;
}

export class GetUserRoleItem implements IGetUserRoleItem {
    id!: number;
    name!: string;
    isSelected!: boolean;

    [key: string]: any;

    constructor(data?: IGetUserRoleItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): GetUserRoleItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserRoleItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IGetUserRoleItem {
    id: number;
    name: string;
    isSelected: boolean;

    [key: string]: any;
}

export class GetUserTenantsResult implements IGetUserTenantsResult {
    results!: GetUserTenantItem[];

    [key: string]: any;

    constructor(data?: IGetUserTenantsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(GetUserTenantItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserTenantsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserTenantsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserTenantsResult {
    results: GetUserTenantItem[];

    [key: string]: any;
}

export class GetUserTenantItem implements IGetUserTenantItem {
    id!: number;
    name!: string;
    isSelected!: boolean;

    [key: string]: any;

    constructor(data?: IGetUserTenantItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): GetUserTenantItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserTenantItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IGetUserTenantItem {
    id: number;
    name: string;
    isSelected: boolean;

    [key: string]: any;
}

export class GetAssignedTenantsResult implements IGetAssignedTenantsResult {
    enabledTenantId!: number;
    enabledTenant!: string;
    userDisplayName!: string;
    results!: GetAssignedTenantsItem[];

    [key: string]: any;

    constructor(data?: IGetAssignedTenantsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.enabledTenantId = _data["enabledTenantId"];
            this.enabledTenant = _data["enabledTenant"];
            this.userDisplayName = _data["userDisplayName"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(GetAssignedTenantsItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAssignedTenantsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssignedTenantsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["enabledTenantId"] = this.enabledTenantId;
        data["enabledTenant"] = this.enabledTenant;
        data["userDisplayName"] = this.userDisplayName;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAssignedTenantsResult {
    enabledTenantId: number;
    enabledTenant: string;
    userDisplayName: string;
    results: GetAssignedTenantsItem[];

    [key: string]: any;
}

export class GetAssignedTenantsItem implements IGetAssignedTenantsItem {
    tenantId!: number;
    tenantName!: string;

    [key: string]: any;

    constructor(data?: IGetAssignedTenantsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
        }
    }

    static fromJS(data: any): GetAssignedTenantsItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssignedTenantsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        return data;
    }
}

export interface IGetAssignedTenantsItem {
    tenantId: number;
    tenantName: string;

    [key: string]: any;
}

export class AuthorizationResult implements IAuthorizationResult {
    id!: number;
    username!: string;
    isActive!: boolean;
    roles!: AuthorizationResultRole[];

    [key: string]: any;

    constructor(data?: IAuthorizationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.username = _data["username"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(AuthorizationResultRole.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthorizationResult {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["username"] = this.username;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAuthorizationResult {
    id: number;
    username: string;
    isActive: boolean;
    roles: AuthorizationResultRole[];

    [key: string]: any;
}

export class AuthorizationResultRole implements IAuthorizationResultRole {
    id!: number;
    description!: string;
    areas!: AuthorizationResultAreas[];

    [key: string]: any;

    constructor(data?: IAuthorizationResultRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.description = _data["description"];
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(AuthorizationResultAreas.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthorizationResultRole {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationResultRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["description"] = this.description;
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAuthorizationResultRole {
    id: number;
    description: string;
    areas: AuthorizationResultAreas[];

    [key: string]: any;
}

export class AuthorizationResultAreas implements IAuthorizationResultAreas {
    id!: number;
    area!: string;
    permissions!: string;

    [key: string]: any;

    constructor(data?: IAuthorizationResultAreas) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.area = _data["area"];
            this.permissions = _data["permissions"];
        }
    }

    static fromJS(data: any): AuthorizationResultAreas {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationResultAreas();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["area"] = this.area;
        data["permissions"] = this.permissions;
        return data;
    }
}

export interface IAuthorizationResultAreas {
    id: number;
    area: string;
    permissions: string;

    [key: string]: any;
}

export class UserByIdResult implements IUserByIdResult {
    id!: number;
    username!: string;
    firstname!: string;
    lastname!: string;
    employeeNumber!: string;
    countryName!: string;
    reviewerId!: number | undefined;
    isActive!: boolean;
    /** User classification - Internal or External */
    oktaGroup!: UserByIdResultOktaGroup | undefined;
    /** Array of active role objects */
    roles!: Roles[];
    /** Array of active tenant objects */
    tenants!: Tenants[];

    [key: string]: any;

    constructor(data?: IUserByIdResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.username = _data["username"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.employeeNumber = _data["employeeNumber"];
            this.countryName = _data["countryName"];
            this.reviewerId = _data["reviewerId"];
            this.isActive = _data["isActive"];
            this.oktaGroup = _data["oktaGroup"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(Roles.fromJS(item));
            }
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(Tenants.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserByIdResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserByIdResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["username"] = this.username;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["employeeNumber"] = this.employeeNumber;
        data["countryName"] = this.countryName;
        data["reviewerId"] = this.reviewerId;
        data["isActive"] = this.isActive;
        data["oktaGroup"] = this.oktaGroup;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserByIdResult {
    id: number;
    username: string;
    firstname: string;
    lastname: string;
    employeeNumber: string;
    countryName: string;
    reviewerId: number | undefined;
    isActive: boolean;
    /** User classification - Internal or External */
    oktaGroup: UserByIdResultOktaGroup | undefined;
    /** Array of active role objects */
    roles: Roles[];
    /** Array of active tenant objects */
    tenants: Tenants[];

    [key: string]: any;
}

export class FilteredUsersResult extends PagingResult implements IFilteredUsersResult {
    results!: FilteredUserItem[];

    [key: string]: any;

    constructor(data?: IFilteredUsersResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FilteredUserItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FilteredUsersResult {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredUsersResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFilteredUsersResult extends IPagingResult {
    results: FilteredUserItem[];

    [key: string]: any;
}

export class FilteredUserItem implements IFilteredUserItem {
    id!: number;
    username!: string;
    firstname!: string;
    lastname!: string;
    employeeNumber!: string;
    isActive!: boolean;
    userRole!: string;

    [key: string]: any;

    constructor(data?: IFilteredUserItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.username = _data["username"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.employeeNumber = _data["employeeNumber"];
            this.isActive = _data["isActive"];
            this.userRole = _data["userRole"];
        }
    }

    static fromJS(data: any): FilteredUserItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredUserItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["username"] = this.username;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["employeeNumber"] = this.employeeNumber;
        data["isActive"] = this.isActive;
        data["userRole"] = this.userRole;
        return data;
    }
}

export interface IFilteredUserItem {
    id: number;
    username: string;
    firstname: string;
    lastname: string;
    employeeNumber: string;
    isActive: boolean;
    userRole: string;

    [key: string]: any;
}

export class UpdateUserInput implements IUpdateUserInput {
    username!: string;
    firstname!: string;
    lastname!: string;
    country!: string;
    employeeNumber!: string;
    reviewerId!: number | undefined;
    isActive!: boolean;
    /** User classification - Internal or External */
    oktaGroup!: UpdateUserInputOktaGroup;
    /** Array of role record IDs */
    roles!: number[];
    /** Array of tenant record IDs */
    tenants!: number[];

    [key: string]: any;

    constructor(data?: IUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.username = _data["username"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.country = _data["country"];
            this.employeeNumber = _data["employeeNumber"];
            this.reviewerId = _data["reviewerId"];
            this.isActive = _data["isActive"];
            this.oktaGroup = _data["oktaGroup"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["username"] = this.username;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["country"] = this.country;
        data["employeeNumber"] = this.employeeNumber;
        data["reviewerId"] = this.reviewerId;
        data["isActive"] = this.isActive;
        data["oktaGroup"] = this.oktaGroup;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserInput {
    username: string;
    firstname: string;
    lastname: string;
    country: string;
    employeeNumber: string;
    reviewerId: number | undefined;
    isActive: boolean;
    /** User classification - Internal or External */
    oktaGroup: UpdateUserInputOktaGroup;
    /** Array of role record IDs */
    roles: number[];
    /** Array of tenant record IDs */
    tenants: number[];

    [key: string]: any;
}

export class WorksheetsResult implements IWorksheetsResult {
    results!: string[];

    [key: string]: any;

    constructor(data?: IWorksheetsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
        }
    }

    static fromJS(data: any): WorksheetsResult {
        data = typeof data === 'object' ? data : {};
        let result = new WorksheetsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        return data;
    }
}

export interface IWorksheetsResult {
    results: string[];

    [key: string]: any;
}

/** Represents the result of calculations performed on worksheet data. */
export class WorksheetCalculationResult implements IWorksheetCalculationResult {
    /** Object with column headers as keys and their numeric totals as values. */
    columnTotals!: { [key: string]: number; };
    /** The overall sum of all column totals. */
    totalBalance!: number;
    /** Total number of rows included in the calculations, excluding the header row. */
    totalRows!: number;

    [key: string]: any;

    constructor(data?: IWorksheetCalculationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["columnTotals"]) {
                this.columnTotals = {} as any;
                for (let key in _data["columnTotals"]) {
                    if (_data["columnTotals"].hasOwnProperty(key))
                        (<any>this.columnTotals)![key] = _data["columnTotals"][key];
                }
            }
            this.totalBalance = _data["totalBalance"];
            this.totalRows = _data["totalRows"];
        }
    }

    static fromJS(data: any): WorksheetCalculationResult {
        data = typeof data === 'object' ? data : {};
        let result = new WorksheetCalculationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.columnTotals) {
            data["columnTotals"] = {};
            for (let key in this.columnTotals) {
                if (this.columnTotals.hasOwnProperty(key))
                    (<any>data["columnTotals"])[key] = (<any>this.columnTotals)[key];
            }
        }
        data["totalBalance"] = this.totalBalance;
        data["totalRows"] = this.totalRows;
        return data;
    }
}

/** Represents the result of calculations performed on worksheet data. */
export interface IWorksheetCalculationResult {
    /** Object with column headers as keys and their numeric totals as values. */
    columnTotals: { [key: string]: number; };
    /** The overall sum of all column totals. */
    totalBalance: number;
    /** Total number of rows included in the calculations, excluding the header row. */
    totalRows: number;

    [key: string]: any;
}

/** Represents the result of counting rows in a worksheet. */
export class WorksheetRowCountResult implements IWorksheetRowCountResult {
    /** Name of the worksheet where rows were counted. */
    worksheetName!: string;
    /** Total number of rows counted in the worksheet, excluding the header row. */
    totalRows!: number;
    /** Index of the header row used during the row count. */
    headerRowIndex!: number;
    /** Index of the row where the counting started. */
    startRow!: number;
    /** Index of the row where the counting ended. */
    endRow!: number;

    [key: string]: any;

    constructor(data?: IWorksheetRowCountResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.worksheetName = _data["worksheetName"];
            this.totalRows = _data["totalRows"];
            this.headerRowIndex = _data["headerRowIndex"];
            this.startRow = _data["startRow"];
            this.endRow = _data["endRow"];
        }
    }

    static fromJS(data: any): WorksheetRowCountResult {
        data = typeof data === 'object' ? data : {};
        let result = new WorksheetRowCountResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["worksheetName"] = this.worksheetName;
        data["totalRows"] = this.totalRows;
        data["headerRowIndex"] = this.headerRowIndex;
        data["startRow"] = this.startRow;
        data["endRow"] = this.endRow;
        return data;
    }
}

/** Represents the result of counting rows in a worksheet. */
export interface IWorksheetRowCountResult {
    /** Name of the worksheet where rows were counted. */
    worksheetName: string;
    /** Total number of rows counted in the worksheet, excluding the header row. */
    totalRows: number;
    /** Index of the header row used during the row count. */
    headerRowIndex: number;
    /** Index of the row where the counting started. */
    startRow: number;
    /** Index of the row where the counting ended. */
    endRow: number;

    [key: string]: any;
}

export class WorksheetHeaderResult implements IWorksheetHeaderResult {
    headers!: WorksheetHeaderItem[];

    [key: string]: any;

    constructor(data?: IWorksheetHeaderResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["headers"])) {
                this.headers = [] as any;
                for (let item of _data["headers"])
                    this.headers!.push(WorksheetHeaderItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorksheetHeaderResult {
        data = typeof data === 'object' ? data : {};
        let result = new WorksheetHeaderResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWorksheetHeaderResult {
    headers: WorksheetHeaderItem[];

    [key: string]: any;
}

export class WorksheetHeaderItem implements IWorksheetHeaderItem {
    index!: number;
    label!: string;

    [key: string]: any;

    constructor(data?: IWorksheetHeaderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.index = _data["index"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): WorksheetHeaderItem {
        data = typeof data === 'object' ? data : {};
        let result = new WorksheetHeaderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["index"] = this.index;
        data["label"] = this.label;
        return data;
    }
}

export interface IWorksheetHeaderItem {
    index: number;
    label: string;

    [key: string]: any;
}

/** Represents the rows and headers read from the worksheet. */
export class WorksheetRowsResult implements IWorksheetRowsResult {
    /** Array of column headers extracted from the header row. */
    headers!: string[];
    /** Array of data rows, where keys are headers and values are the corresponding cell data. */
    dataRows!: { [key: string]: string; }[];

    [key: string]: any;

    constructor(data?: IWorksheetRowsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["headers"])) {
                this.headers = [] as any;
                for (let item of _data["headers"])
                    this.headers!.push(item);
            }
            if (Array.isArray(_data["dataRows"])) {
                this.dataRows = [] as any;
                for (let item of _data["dataRows"])
                    this.dataRows!.push(item);
            }
        }
    }

    static fromJS(data: any): WorksheetRowsResult {
        data = typeof data === 'object' ? data : {};
        let result = new WorksheetRowsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item);
        }
        if (Array.isArray(this.dataRows)) {
            data["dataRows"] = [];
            for (let item of this.dataRows)
                data["dataRows"].push(item);
        }
        return data;
    }
}

/** Represents the rows and headers read from the worksheet. */
export interface IWorksheetRowsResult {
    /** Array of column headers extracted from the header row. */
    headers: string[];
    /** Array of data rows, where keys are headers and values are the corresponding cell data. */
    dataRows: { [key: string]: string; }[];

    [key: string]: any;
}

export class WorksheetSampleResult implements IWorksheetSampleResult {
    firstTenRows!: WorksheetSampleItem[];
    lastTenRows!: WorksheetSampleItem[];

    [key: string]: any;

    constructor(data?: IWorksheetSampleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["firstTenRows"])) {
                this.firstTenRows = [] as any;
                for (let item of _data["firstTenRows"])
                    this.firstTenRows!.push(WorksheetSampleItem.fromJS(item));
            }
            if (Array.isArray(_data["lastTenRows"])) {
                this.lastTenRows = [] as any;
                for (let item of _data["lastTenRows"])
                    this.lastTenRows!.push(WorksheetSampleItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorksheetSampleResult {
        data = typeof data === 'object' ? data : {};
        let result = new WorksheetSampleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.firstTenRows)) {
            data["firstTenRows"] = [];
            for (let item of this.firstTenRows)
                data["firstTenRows"].push(item.toJSON());
        }
        if (Array.isArray(this.lastTenRows)) {
            data["lastTenRows"] = [];
            for (let item of this.lastTenRows)
                data["lastTenRows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWorksheetSampleResult {
    firstTenRows: WorksheetSampleItem[];
    lastTenRows: WorksheetSampleItem[];

    [key: string]: any;
}

export class WorksheetSampleItem implements IWorksheetSampleItem {
    rowNumber!: number;
    rowValues!: string[];

    [key: string]: any;

    constructor(data?: IWorksheetSampleItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.rowNumber = _data["rowNumber"];
            if (Array.isArray(_data["rowValues"])) {
                this.rowValues = [] as any;
                for (let item of _data["rowValues"])
                    this.rowValues!.push(item);
            }
        }
    }

    static fromJS(data: any): WorksheetSampleItem {
        data = typeof data === 'object' ? data : {};
        let result = new WorksheetSampleItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["rowNumber"] = this.rowNumber;
        if (Array.isArray(this.rowValues)) {
            data["rowValues"] = [];
            for (let item of this.rowValues)
                data["rowValues"].push(item);
        }
        return data;
    }
}

export interface IWorksheetSampleItem {
    rowNumber: number;
    rowValues: string[];

    [key: string]: any;
}

export class ImportInput implements IImportInput {
    headerIndex!: number;
    startIndex!: number;
    endIndex!: number;

    [key: string]: any;

    constructor(data?: IImportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.headerIndex = _data["headerIndex"];
            this.startIndex = _data["startIndex"];
            this.endIndex = _data["endIndex"];
        }
    }

    static fromJS(data: any): ImportInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["headerIndex"] = this.headerIndex;
        data["startIndex"] = this.startIndex;
        data["endIndex"] = this.endIndex;
        return data;
    }
}

export interface IImportInput {
    headerIndex: number;
    startIndex: number;
    endIndex: number;

    [key: string]: any;
}

export class ImportResult implements IImportResult {
    headerIndex!: number;
    headerValue!: string;
    columnId!: number;

    [key: string]: any;

    constructor(data?: IImportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.headerIndex = _data["headerIndex"];
            this.headerValue = _data["headerValue"];
            this.columnId = _data["columnId"];
        }
    }

    static fromJS(data: any): ImportResult {
        data = typeof data === 'object' ? data : {};
        let result = new ImportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["headerIndex"] = this.headerIndex;
        data["headerValue"] = this.headerValue;
        data["columnId"] = this.columnId;
        return data;
    }
}

export interface IImportResult {
    headerIndex: number;
    headerValue: string;
    columnId: number;

    [key: string]: any;
}

export class Body implements IBody {
    headerIndex!: number;
    startIndex!: number;
    endIndex!: number;

    [key: string]: any;

    constructor(data?: IBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.headerIndex = _data["headerIndex"];
            this.startIndex = _data["startIndex"];
            this.endIndex = _data["endIndex"];
        }
    }

    static fromJS(data: any): Body {
        data = typeof data === 'object' ? data : {};
        let result = new Body();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["headerIndex"] = this.headerIndex;
        data["startIndex"] = this.startIndex;
        data["endIndex"] = this.endIndex;
        return data;
    }
}

export interface IBody {
    headerIndex: number;
    startIndex: number;
    endIndex: number;

    [key: string]: any;
}

export enum SortDirection {
    Asc = "asc",
    Desc = "desc",
}

export class Body2 implements IBody2 {
    matchingBatchId!: number;
    searchValue!: string;
    searchAnnexuresValue!: string;
    searchAgeingsValue!: string;
    annexureSortBy!: string;
    annexureSortAsc!: boolean;
    ageingSortBy!: string;
    ageingSortAsc!: boolean;

    [key: string]: any;

    constructor(data?: IBody2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.matchingBatchId = _data["matchingBatchId"];
            this.searchValue = _data["searchValue"];
            this.searchAnnexuresValue = _data["searchAnnexuresValue"];
            this.searchAgeingsValue = _data["searchAgeingsValue"];
            this.annexureSortBy = _data["annexureSortBy"];
            this.annexureSortAsc = _data["annexureSortAsc"];
            this.ageingSortBy = _data["ageingSortBy"];
            this.ageingSortAsc = _data["ageingSortAsc"];
        }
    }

    static fromJS(data: any): Body2 {
        data = typeof data === 'object' ? data : {};
        let result = new Body2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["matchingBatchId"] = this.matchingBatchId;
        data["searchValue"] = this.searchValue;
        data["searchAnnexuresValue"] = this.searchAnnexuresValue;
        data["searchAgeingsValue"] = this.searchAgeingsValue;
        data["annexureSortBy"] = this.annexureSortBy;
        data["annexureSortAsc"] = this.annexureSortAsc;
        data["ageingSortBy"] = this.ageingSortBy;
        data["ageingSortAsc"] = this.ageingSortAsc;
        return data;
    }
}

export interface IBody2 {
    matchingBatchId: number;
    searchValue: string;
    searchAnnexuresValue: string;
    searchAgeingsValue: string;
    annexureSortBy: string;
    annexureSortAsc: boolean;
    ageingSortBy: string;
    ageingSortAsc: boolean;

    [key: string]: any;
}

export enum ExportType {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType2 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType3 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType4 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType5 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType6 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType7 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType8 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType9 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType10 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType11 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType12 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType13 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType14 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType15 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType16 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType17 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType18 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType19 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType20 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType21 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType22 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType23 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType24 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType25 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType26 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType27 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType28 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType29 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType30 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType31 {
    Pdf = "pdf",
    Excel = "excel",
}

export enum ExportType32 {
    Pdf = "pdf",
    Excel = "excel",
}

export class Body3 implements IBody3 {
    headerIndex!: number;
    startIndex!: number;
    endIndex!: number;

    [key: string]: any;

    constructor(data?: IBody3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.headerIndex = _data["headerIndex"];
            this.startIndex = _data["startIndex"];
            this.endIndex = _data["endIndex"];
        }
    }

    static fromJS(data: any): Body3 {
        data = typeof data === 'object' ? data : {};
        let result = new Body3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["headerIndex"] = this.headerIndex;
        data["startIndex"] = this.startIndex;
        data["endIndex"] = this.endIndex;
        return data;
    }
}

export interface IBody3 {
    headerIndex: number;
    startIndex: number;
    endIndex: number;

    [key: string]: any;
}

export class Anonymous implements IAnonymous {
    clientAreaIds!: number[];

    [key: string]: any;

    constructor(data?: IAnonymous) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["clientAreaIds"])) {
                this.clientAreaIds = [] as any;
                for (let item of _data["clientAreaIds"])
                    this.clientAreaIds!.push(item);
            }
        }
    }

    static fromJS(data: any): Anonymous {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.clientAreaIds)) {
            data["clientAreaIds"] = [];
            for (let item of this.clientAreaIds)
                data["clientAreaIds"].push(item);
        }
        return data;
    }
}

export interface IAnonymous {
    clientAreaIds: number[];

    [key: string]: any;
}

export class Anonymous2 implements IAnonymous2 {
    /** Number of rows successfully imported */
    totalImported!: number;
    /** Total number of rows processed */
    totalRows!: number;
    /** Array of import errors */
    errors!: any[];

    [key: string]: any;

    constructor(data?: IAnonymous2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalImported = _data["totalImported"];
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): Anonymous2 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalImported"] = this.totalImported;
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IAnonymous2 {
    /** Number of rows successfully imported */
    totalImported: number;
    /** Total number of rows processed */
    totalRows: number;
    /** Array of import errors */
    errors: any[];

    [key: string]: any;
}

export class Anonymous3 implements IAnonymous3 {
    /** Number of rows successfully imported */
    totalImported!: number;
    /** Total number of rows processed */
    totalRows!: number;
    /** Array of import errors */
    errors!: any[];

    [key: string]: any;

    constructor(data?: IAnonymous3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalImported = _data["totalImported"];
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): Anonymous3 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalImported"] = this.totalImported;
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IAnonymous3 {
    /** Number of rows successfully imported */
    totalImported: number;
    /** Total number of rows processed */
    totalRows: number;
    /** Array of import errors */
    errors: any[];

    [key: string]: any;
}

export class Anonymous4 implements IAnonymous4 {
    id!: number;
    name!: string;

    [key: string]: any;

    constructor(data?: IAnonymous4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Anonymous4 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAnonymous4 {
    id: number;
    name: string;

    [key: string]: any;
}

export class Anonymous5 implements IAnonymous5 {
    results!: Results[];

    [key: string]: any;

    constructor(data?: IAnonymous5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Results.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous5 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAnonymous5 {
    results: Results[];

    [key: string]: any;
}

export class Anonymous6 implements IAnonymous6 {
    message!: string;

    [key: string]: any;

    constructor(data?: IAnonymous6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): Anonymous6 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IAnonymous6 {
    message: string;

    [key: string]: any;
}

export class Anonymous7 implements IAnonymous7 {
    message!: string;

    [key: string]: any;

    constructor(data?: IAnonymous7) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): Anonymous7 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous7();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IAnonymous7 {
    message: string;

    [key: string]: any;
}

export class Anonymous8 implements IAnonymous8 {
    /** The page number where the record appears (1-indexed) */
    pageNumber!: number;
    /** All matched ageing IDs for the annexure */
    matchedAgeingIds!: number[];

    [key: string]: any;

    constructor(data?: IAnonymous8) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pageNumber = _data["pageNumber"];
            if (Array.isArray(_data["matchedAgeingIds"])) {
                this.matchedAgeingIds = [] as any;
                for (let item of _data["matchedAgeingIds"])
                    this.matchedAgeingIds!.push(item);
            }
        }
    }

    static fromJS(data: any): Anonymous8 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous8();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pageNumber"] = this.pageNumber;
        if (Array.isArray(this.matchedAgeingIds)) {
            data["matchedAgeingIds"] = [];
            for (let item of this.matchedAgeingIds)
                data["matchedAgeingIds"].push(item);
        }
        return data;
    }
}

export interface IAnonymous8 {
    /** The page number where the record appears (1-indexed) */
    pageNumber: number;
    /** All matched ageing IDs for the annexure */
    matchedAgeingIds: number[];

    [key: string]: any;
}

export class Anonymous9 implements IAnonymous9 {
    data!: any[];
    errors!: any[];

    [key: string]: any;

    constructor(data?: IAnonymous9) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): Anonymous9 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous9();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IAnonymous9 {
    data: any[];
    errors: any[];

    [key: string]: any;
}

export class Anonymous10 implements IAnonymous10 {
    noteId!: number;
    otherComments!: string;

    [key: string]: any;

    constructor(data?: IAnonymous10) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.noteId = _data["noteId"];
            this.otherComments = _data["otherComments"];
        }
    }

    static fromJS(data: any): Anonymous10 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous10();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["noteId"] = this.noteId;
        data["otherComments"] = this.otherComments;
        return data;
    }
}

export interface IAnonymous10 {
    noteId: number;
    otherComments: string;

    [key: string]: any;
}

export class Anonymous11 implements IAnonymous11 {
    /** Number of rows successfully imported */
    totalImported!: number;
    /** Total number of rows processed */
    totalRows!: number;
    /** Array of import errors */
    errors!: any[];

    [key: string]: any;

    constructor(data?: IAnonymous11) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalImported = _data["totalImported"];
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): Anonymous11 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous11();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalImported"] = this.totalImported;
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IAnonymous11 {
    /** Number of rows successfully imported */
    totalImported: number;
    /** Total number of rows processed */
    totalRows: number;
    /** Array of import errors */
    errors: any[];

    [key: string]: any;
}

export class Anonymous12 implements IAnonymous12 {
    success!: boolean;

    [key: string]: any;

    constructor(data?: IAnonymous12) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): Anonymous12 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous12();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["success"] = this.success;
        return data;
    }
}

export interface IAnonymous12 {
    success: boolean;

    [key: string]: any;
}

export class Anonymous13 implements IAnonymous13 {
    success!: boolean;
    popiReferenceId!: string;

    [key: string]: any;

    constructor(data?: IAnonymous13) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.success = _data["success"];
            this.popiReferenceId = _data["popiReferenceId"];
        }
    }

    static fromJS(data: any): Anonymous13 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous13();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["success"] = this.success;
        data["popiReferenceId"] = this.popiReferenceId;
        return data;
    }
}

export interface IAnonymous13 {
    success: boolean;
    popiReferenceId: string;

    [key: string]: any;
}

export class Anonymous14 implements IAnonymous14 {
    accessToken!: string;
    embedUrl!: string;
    id!: string;
    type!: string;

    [key: string]: any;

    constructor(data?: IAnonymous14) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.accessToken = _data["accessToken"];
            this.embedUrl = _data["embedUrl"];
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Anonymous14 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous14();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["accessToken"] = this.accessToken;
        data["embedUrl"] = this.embedUrl;
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }
}

export interface IAnonymous14 {
    accessToken: string;
    embedUrl: string;
    id: string;
    type: string;

    [key: string]: any;
}

export class Anonymous15 implements IAnonymous15 {
    accessToken!: string;
    embedUrl!: string;
    id!: string;
    type!: string;

    [key: string]: any;

    constructor(data?: IAnonymous15) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.accessToken = _data["accessToken"];
            this.embedUrl = _data["embedUrl"];
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Anonymous15 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous15();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["accessToken"] = this.accessToken;
        data["embedUrl"] = this.embedUrl;
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }
}

export interface IAnonymous15 {
    accessToken: string;
    embedUrl: string;
    id: string;
    type: string;

    [key: string]: any;
}

export class Anonymous16 implements IAnonymous16 {
    /** Number of rows successfully imported */
    totalImported!: number;
    /** Total number of rows processed */
    totalRows!: number;
    /** Array of import errors */
    errors!: any[];

    [key: string]: any;

    constructor(data?: IAnonymous16) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalImported = _data["totalImported"];
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): Anonymous16 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous16();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalImported"] = this.totalImported;
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IAnonymous16 {
    /** Number of rows successfully imported */
    totalImported: number;
    /** Total number of rows processed */
    totalRows: number;
    /** Array of import errors */
    errors: any[];

    [key: string]: any;
}

export class Anonymous17 implements IAnonymous17 {
    /** Number of rows successfully imported */
    totalImported!: number;
    /** Total number of rows processed */
    totalRows!: number;
    /** Array of import errors */
    errors!: any[];

    [key: string]: any;

    constructor(data?: IAnonymous17) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalImported = _data["totalImported"];
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): Anonymous17 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous17();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalImported"] = this.totalImported;
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IAnonymous17 {
    /** Number of rows successfully imported */
    totalImported: number;
    /** Total number of rows processed */
    totalRows: number;
    /** Array of import errors */
    errors: any[];

    [key: string]: any;
}

export class Anonymous18 implements IAnonymous18 {
    /** Number of rows successfully imported */
    totalImported!: number;
    /** Total number of rows processed */
    totalRows!: number;
    /** Array of import errors */
    errors!: any[];

    [key: string]: any;

    constructor(data?: IAnonymous18) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalImported = _data["totalImported"];
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): Anonymous18 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous18();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalImported"] = this.totalImported;
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IAnonymous18 {
    /** Number of rows successfully imported */
    totalImported: number;
    /** Total number of rows processed */
    totalRows: number;
    /** Array of import errors */
    errors: any[];

    [key: string]: any;
}

export class Anonymous19 implements IAnonymous19 {
    area!: string;
    permissions!: string;

    [key: string]: any;

    constructor(data?: IAnonymous19) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.area = _data["area"];
            this.permissions = _data["permissions"];
        }
    }

    static fromJS(data: any): Anonymous19 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous19();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["area"] = this.area;
        data["permissions"] = this.permissions;
        return data;
    }
}

export interface IAnonymous19 {
    area: string;
    permissions: string;

    [key: string]: any;
}

export class Anonymous20 implements IAnonymous20 {
    id!: number;
    name!: string;
    username!: string;

    [key: string]: any;

    constructor(data?: IAnonymous20) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): Anonymous20 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous20();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["username"] = this.username;
        return data;
    }
}

export interface IAnonymous20 {
    id: number;
    name: string;
    username: string;

    [key: string]: any;
}

export enum ExportRequestInputExportType {
    Ageing = "ageing",
    Annexure = "annexure",
}

export enum ExportRequestResultStatus {
    Pending = "pending",
    Processing = "processing",
    Completed = "completed",
    Failed = "failed",
}

export enum ExportStatusResultStatus {
    Pending = "pending",
    Processing = "processing",
    Completed = "completed",
    Failed = "failed",
}

export class Database implements IDatabase {
    id!: number;
    catalog!: string;
    host!: string;
    port!: number;
    trustCertificate!: boolean;
    integratedSecurity!: boolean;
    username!: string;
    password!: string;

    [key: string]: any;

    constructor(data?: IDatabase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.catalog = _data["catalog"];
            this.host = _data["host"];
            this.port = _data["port"];
            this.trustCertificate = _data["trustCertificate"];
            this.integratedSecurity = _data["integratedSecurity"];
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): Database {
        data = typeof data === 'object' ? data : {};
        let result = new Database();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["catalog"] = this.catalog;
        data["host"] = this.host;
        data["port"] = this.port;
        data["trustCertificate"] = this.trustCertificate;
        data["integratedSecurity"] = this.integratedSecurity;
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface IDatabase {
    id: number;
    catalog: string;
    host: string;
    port: number;
    trustCertificate: boolean;
    integratedSecurity: boolean;
    username: string;
    password: string;

    [key: string]: any;
}

export class database implements Idatabase {
    id!: number;
    databaseName!: string;
    host!: string;
    port!: number;
    catalog!: string;
    trustCertificate!: boolean;
    integratedSecurity!: boolean;
    username!: string | undefined;
    password!: string | undefined;

    [key: string]: any;

    constructor(data?: Idatabase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.databaseName = _data["databaseName"];
            this.host = _data["host"];
            this.port = _data["port"];
            this.catalog = _data["catalog"];
            this.trustCertificate = _data["trustCertificate"];
            this.integratedSecurity = _data["integratedSecurity"];
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): database {
        data = typeof data === 'object' ? data : {};
        let result = new database();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["databaseName"] = this.databaseName;
        data["host"] = this.host;
        data["port"] = this.port;
        data["catalog"] = this.catalog;
        data["trustCertificate"] = this.trustCertificate;
        data["integratedSecurity"] = this.integratedSecurity;
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface Idatabase {
    id: number;
    databaseName: string;
    host: string;
    port: number;
    catalog: string;
    trustCertificate: boolean;
    integratedSecurity: boolean;
    username: string | undefined;
    password: string | undefined;

    [key: string]: any;
}

export class Permissions implements IPermissions {
    area!: string;
    permissions!: string;

    [key: string]: any;

    constructor(data?: IPermissions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.area = _data["area"];
            this.permissions = _data["permissions"];
        }
    }

    static fromJS(data: any): Permissions {
        data = typeof data === 'object' ? data : {};
        let result = new Permissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["area"] = this.area;
        data["permissions"] = this.permissions;
        return data;
    }
}

export interface IPermissions {
    area: string;
    permissions: string;

    [key: string]: any;
}

export enum CreateUserInputOktaGroup {
    Internal = "Internal",
    External = "External",
}

export enum UserByIdResultOktaGroup {
    Internal = "Internal",
    External = "External",
}

export class Roles implements IRoles {
    id!: number;
    name!: string;
    isSelected!: boolean;

    [key: string]: any;

    constructor(data?: IRoles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): Roles {
        data = typeof data === 'object' ? data : {};
        let result = new Roles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IRoles {
    id: number;
    name: string;
    isSelected: boolean;

    [key: string]: any;
}

export class Tenants implements ITenants {
    id!: number;
    name!: string;
    isSelected!: boolean;

    [key: string]: any;

    constructor(data?: ITenants) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): Tenants {
        data = typeof data === 'object' ? data : {};
        let result = new Tenants();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface ITenants {
    id: number;
    name: string;
    isSelected: boolean;

    [key: string]: any;
}

export enum UpdateUserInputOktaGroup {
    Internal = "Internal",
    External = "External",
}

export class Results implements IResults {
    id!: number;
    name!: string;
    isSelected!: boolean;

    [key: string]: any;

    constructor(data?: IResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): Results {
        data = typeof data === 'object' ? data : {};
        let result = new Results();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IResults {
    id: number;
    name: string;
    isSelected: boolean;

    [key: string]: any;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}